import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@nuxtjs/composition-api';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _FieldSet: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};






export type AiAssistantInput = {
  /** Name for the assistant to use */
  assistant?: Maybe<BambeeAssistant>;
  /** ID for the assistant to use */
  assistantId?: Maybe<Scalars['String']>;
  /** Content for next message to add to thread */
  content?: Maybe<Scalars['String']>;
  /** files to upload to attach to the artifact */
  files?: Maybe<Array<UploadedFileCore>>;
  /** This is a spcial flag that will result in a hidden metadata value being added to the message. This allows the client to send information without it being displayed to the user */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Do not create a run; Do not send thread messages to be processed by model; Just return messages that exist on the thread */
  skipRun?: Maybe<Scalars['Boolean']>;
  /** ID for the current message thread */
  threadId?: Maybe<Scalars['String']>;
};

export type AiAssistantResponse = {
  __typename?: 'AIAssistantResponse';
  /** If artifacts were created from the thread they will be mapped to here */
  artifact?: Maybe<ChatArtifact>;
  /** Canonical name for the assistant last interacted with. To continue a converstation ensure you send your next message to the correct assistant and thread */
  assistant?: Maybe<Scalars['String']>;
  /** ID for the assistant last interacted with. To continue a converstation ensure you send your next message to the correct assistant and thread */
  assistantId?: Maybe<Scalars['String']>;
  /** All messages associated to the current thread */
  messages?: Maybe<Array<Maybe<AiMessageDto>>>;
  /** All messages associated to the current thread */
  next: NextMessage;
  /** ID for the last / current run. Useful for debugging runs stuck in unexpected states */
  runId: Scalars['String'];
  /** ID for the current message thread. To continue a converstation ensure you send your next message to the correct assistant and thread */
  threadId: Scalars['String'];
};

export type AiMessageDto = {
  __typename?: 'AIMessageDto';
  /** ID for the message */
  content: Array<MessageContentDto>;
  /** ID for the message */
  id: Scalars['String'];
  /** Metadata about the message */
  metadata: MessageMetaDataDto;
  /** ID for the message */
  role: Scalars['String'];
};

export type AiThread = {
  __typename?: 'AIThread';
  /** The archived at date of the thread, optional */
  archivedAt?: Maybe<Scalars['DateTime']>;
  /** The company id of the thread */
  companyId: Scalars['String'];
  /** The created at date of the thread */
  createdAt: Scalars['DateTime'];
  /** The id of the thread */
  id: Scalars['String'];
  /** The summary of the thread */
  summary?: Maybe<Scalars['String']>;
  /** The title of the thread */
  title?: Maybe<Scalars['String']>;
  /** The updated at date of the thread */
  updatedAt: Scalars['DateTime'];
  /** The user id of the thread */
  userId: Scalars['String'];
};

export type AcceptOfferInput = {
  /** When customer provides a customer reason for cancelling */
  clientOtherReasonNote?: Maybe<Scalars['String']>;
  /** The plan value to accept. */
  planValue: Scalars['String'];
  /** Reason Codes the customer wanted to cancel before accepting offer */
  reasonCodes?: Maybe<Array<Scalars['Float']>>;
  /** The cancellation request wizard session id */
  sessionId?: Maybe<Scalars['String']>;
};

export type AcceptRecommendationInput = {
  /** The id of the recommendation to be accepted. */
  recommendationId: Scalars['String'];
};

export type AcceptTrialOfferInput = {
  /** When customer provides a customer reason for cancelling */
  clientOtherReasonNote?: Maybe<Scalars['String']>;
  /** Reason Codes the customer wanted to cancel before accepting offer */
  reasonCodes?: Maybe<Array<Scalars['Float']>>;
  /** The cancellation request wizard session id */
  sessionId?: Maybe<Scalars['String']>;
  /** The date the trial should be extended to */
  trialEndDate: Scalars['DateTime'];
};

export type ActionPlanArtifact = {
  __typename?: 'ActionPlanArtifact';
  /** The download url for the action plan artifact */
  downloadUrl: Scalars['String'];
  /** The dto of the action plan */
  dto: Scalars['String'];
  /** The artifact renered as HTML */
  html: Scalars['String'];
  /** ID of the action plan that was created */
  id?: Maybe<Scalars['String']>;
  /** The status of the action plan artifact */
  status: Scalars['String'];
  /** Title of the action plan */
  title: Scalars['String'];
};

export type ActivateWizardGroupInput = {
  wizardGroupId: Scalars['ID'];
};

export type ActivationDeleteInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** The feature key to delete. */
  key: Scalars['String'];
};

export type ActivationFilterInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** Filter by enabled status. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Filter by specific feature key. */
  key?: Maybe<Scalars['String']>;
};

export type ActivationInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** Whether to enable this feature. */
  enabled?: Scalars['Boolean'];
  /** The feature key to activate. */
  key: Scalars['String'];
};

export type ActivationQueryInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** The feature key to find. */
  key: Scalars['String'];
};

export type ActivationToggleInput = {
  /** The company ID this activation is for. If not provided derived from user ctx */
  companyId?: Maybe<Scalars['String']>;
  /** Whether to enable or disable this feature. */
  enabled: Scalars['Boolean'];
  /** The feature key to toggle. */
  key: Scalars['String'];
};

export type ActivePlanFilters = {
  /** The billing periods to filter by */
  billingPeriods?: Maybe<Array<BillingPeriod>>;
  /** Include internal plans (defaults to false) */
  internal?: Maybe<Scalars['Boolean']>;
  /** The product keys to filter by */
  productKeys?: Maybe<Array<ProductKey>>;
};

export type AddCreditsInput = {
  chargeCustomer?: Maybe<Scalars['Boolean']>;
  companyId: Scalars['String'];
  creationDescription: Scalars['String'];
  creationReason: ProductCreditCreationReason;
  productKey: ProductKey;
  quantity: Scalars['Int'];
};

export type AddCreditsResult = {
  __typename?: 'AddCreditsResult';
  amountCharged?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  creditsCreated: Scalars['Int'];
  productKey: ProductKey;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
};

export type AddOnLine = {
  __typename?: 'AddOnLine';
  code: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  /** Recurly's tier type: flat, tiered, stairstep or volume. */
  tierType?: Maybe<Scalars['String']>;
  /** Flat add-on: the price per unit. Stairstep add-on (tierType "stairstep", e.g. the employee-count band): the price of the whole band the quantity falls in, not a per-unit price. Volume: the per-unit price of the tier the quantity falls in. */
  unitAmount: Money;
};

export type AddPaymentMethodInput = {
  companyId: Scalars['ID'];
  makePrimary?: Scalars['Boolean'];
  threeDSecureActionResultTokenId?: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

export type AddPaymentMethodResult = {
  __typename?: 'AddPaymentMethodResult';
  actionTokenId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
  requiresAction: Scalars['Boolean'];
};

export type AddRealTimeMessageInput = {
  /** Optional artifact ID if this message generated an artifact */
  artifactId?: Maybe<Scalars['ID']>;
  content?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['String']>;
  inputTokens?: Maybe<Scalars['Int']>;
  /** Whether this message is hidden from user UI */
  isHidden?: Maybe<Scalars['Boolean']>;
  messageType: RealTimeMessageType;
  openaiItemId?: Maybe<Scalars['String']>;
  openaiResponseId?: Maybe<Scalars['String']>;
  outputTokens?: Maybe<Scalars['Int']>;
  role: RealTimeMessageRole;
  threadId: Scalars['ID'];
  toolCallArguments?: Maybe<Scalars['JSON']>;
  toolCallName?: Maybe<Scalars['String']>;
  toolCallResult?: Maybe<Scalars['JSON']>;
  totalTokens?: Maybe<Scalars['Int']>;
};

export type AddSubscriptionInput = {
  billingPeriod?: Maybe<BillingPeriod>;
  chargeCustomer?: Maybe<Scalars['Boolean']>;
  companyId: Scalars['String'];
  creationDescription: Scalars['String'];
  creationReason: ProductCreditCreationReason;
  productKey: ProductKey;
};

export type AdvanceCoverageActivationInput = {
  events: Array<CoverageActivationEvent>;
};

export type AdvisorNextAvailableSlotInput = {
  /** The company identifier */
  companyId: Scalars['String'];
  /** The duration of the slot in minutes */
  duration: Scalars['Int'];
  /** The role for the company advisor */
  role: CompanyAdvisorRole;
};

export type AdvisorNextTimeSlot = {
  __typename?: 'AdvisorNextTimeSlot';
  /** The calendly slug for the advisor */
  calendlySlug?: Maybe<Scalars['String']>;
  /** The role for the advisor */
  role: CompanyAdvisorRole;
  /** The next available time slot for the advisor */
  slot?: Maybe<TimeSlot>;
  /** The advisor user identifier */
  userId: Scalars['String'];
};

export type AgentEmissionNode = {
  __typename?: 'AgentEmissionNode';
  agentType: Scalars['String'];
  agentVersionId: Scalars['String'];
  batchId: Scalars['String'];
  companyId: Scalars['String'];
  confidence?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  output: Scalars['JSON'];
  parentEmissionId?: Maybe<Scalars['String']>;
  processingCompletedAt?: Maybe<Scalars['DateTime']>;
  processingStartedAt?: Maybe<Scalars['DateTime']>;
  promptHash: Scalars['String'];
  sourceEventId: Scalars['String'];
  sourceEventTimestamp: Scalars['DateTime'];
  status: AgentEmissionStatus;
  userId?: Maybe<Scalars['String']>;
};

/** The processing status of an agent emission */
export enum AgentEmissionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type AgentEmissionsInput = {
  agentType?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
};

export type AiGenerated = {
  __typename?: 'AiGenerated';
  /** Extracted json parsed data generated by the AI */
  body?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** Raw response provided by AI */
  response: Scalars['JSON'];
};

/** The status of the prompt */
export enum AiGeneratedStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type AiOptionInput = {
  /** The user has opted in to or out of the AI assistant. This will be used to determine if the user should be routed to the AI assistant or not */
  optIn: Scalars['Boolean'];
};

export type AiPromptInput = {
  /** The prompts to send to OpenAI */
  prompts: Array<RawAiPrompt>;
  /** The side effects to trigger after the prompt is completed */
  sideEffects?: Maybe<Array<Maybe<AiPromptSideEffect>>>;
};

export type AiPromptResponse = {
  __typename?: 'AiPromptResponse';
  /** The id of the prompt */
  id: Scalars['String'];
  /** The status of the prompt */
  status: AiGeneratedStatus;
};

/** Side effects that can be triggered by an AI prompt completion */
export enum AiPromptSideEffect {
  CallTranscriptionSummary = 'CALL_TRANSCRIPTION_SUMMARY',
  SaveGeneratedTitleOnThread = 'SAVE_GENERATED_TITLE_ON_THREAD',
  SentimentAnalysis = 'SENTIMENT_ANALYSIS'
}

export type AnalyticEvent = {
  /** name or key of the event */
  event: Scalars['String'];
  /** The id of the analytic event */
  id: Scalars['ID'];
  /** additional properties associated with the event */
  properties?: Maybe<Scalars['JSONObject']>;
  /** the identity associated with the data */
  userId?: Maybe<Scalars['String']>;
};

export type AnalyticEventTracked = {
  __typename?: 'AnalyticEventTracked';
  /** name or key of the event */
  event: Scalars['String'];
  /** The id of the analytic event */
  id: Scalars['ID'];
  /** indicator if event was tracked successfully */
  success: Scalars['Boolean'];
  /** the identity associated with the data */
  userId?: Maybe<Scalars['String']>;
};

export type AnnotationDto = FileCitationAnnotationDto | FilePathAnnotationDto;

/** The result of the decision. */
export enum ApprovalResult {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ArchivePolicyInput = {
  policyId: Scalars['ID'];
};

export type ArtifactBatchError = {
  __typename?: 'ArtifactBatchError';
  /** Error code */
  code: Scalars['String'];
  /** Error message */
  message: Scalars['String'];
  /** Partial artifact ID if generation succeeded but finalization failed */
  partialArtifactId?: Maybe<Scalars['String']>;
  /** Index mapping to input array */
  requestIndex: Scalars['Int'];
  /** Stage where error occurred (GENERATION or FINALIZATION) */
  stage: Scalars['String'];
};

export type ArtifactBatchItem = {
  __typename?: 'ArtifactBatchItem';
  /** Generated artifact */
  artifact: ArtifactDto;
  /** Finalization result if auto-finalize was enabled */
  finalizeResult?: Maybe<SaveArtifactResultDto>;
  /** Index mapping to input array */
  requestIndex: Scalars['Int'];
};

export type ArtifactDraftRequest = {
  /** Artifact ID to refine */
  artifactId?: Maybe<Scalars['String']>;
  /** Artifact sub-type for specialized workflows */
  artifactSubType?: Maybe<Scalars['String']>;
  /** Artifact type to generate */
  artifactType: ArtifactType;
  /** Field data for artifact generation */
  fieldData?: Maybe<ArtifactFieldDataInput>;
  /** Type-specific finalization options (title, description, icon, etc.) */
  finalizeOptions?: Maybe<Scalars['JSONObject']>;
  /** Optional additional context for artifact generation. Templates are applied automatically. */
  instructions?: Maybe<Scalars['String']>;
  /** Optional conversation messages for this artifact. Overrides fetching from thread. */
  messages?: Maybe<Array<ConversationMessageInput>>;
  /** Template ID (only needed for POLICY type) */
  templateId?: Maybe<Scalars['String']>;
  /** Override shared threadId if needed for this specific artifact */
  threadId?: Maybe<Scalars['String']>;
};

export type ArtifactDto = {
  __typename?: 'ArtifactDto';
  /** Artifact sub-type for specialized workflows */
  artifactSubType?: Maybe<Scalars['String']>;
  /** Artifact type */
  artifactType: ArtifactType;
  /** Case ID if this artifact is linked to a Salesforce case */
  caseId?: Maybe<Scalars['String']>;
  /** AI confidence score (0-100) */
  confidence?: Maybe<Scalars['Float']>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime'];
  /** Creator user ID */
  createdBy: Scalars['String'];
  /** Description/summary */
  description?: Maybe<Scalars['String']>;
  /** S3 URL for downloadable PDF (if generated) */
  downloadUrl?: Maybe<Scalars['String']>;
  /** Finalized entity ID (e.g., policyId if finalized) */
  finalizedEntityId?: Maybe<Scalars['String']>;
  /** HR Request ID if this artifact is linked to an HR request */
  hrRequestId?: Maybe<Scalars['String']>;
  /** Generated/refined HTML content (lazy-loaded via field resolver) */
  html?: Maybe<Scalars['String']>;
  /** Artifact ID */
  id: Scalars['String'];
  /** Policy ID if this artifact is linked to a policy */
  policyId?: Maybe<Scalars['String']>;
  /** Previous version artifact ID (null for v1) */
  previousVersionId?: Maybe<Scalars['String']>;
  /** Status of the artifact */
  status: ArtifactStatus;
  /** Thread ID this artifact belongs to (optional) */
  threadId?: Maybe<Scalars['String']>;
  /** Title */
  title: Scalars['String'];
  /** Version number (1, 2, 3...) */
  version: Scalars['Int'];
};

export type ArtifactFieldDataInput = {
  /** Structured field values mapping to template requiredFields. Example: { "company.name": "Acme Corp", "company.state": "CA" } */
  structured?: Maybe<Scalars['JSONObject']>;
  /** Unstructured conversational context for AI to extract data from. Example: "We're a tech company in California with 50 employees" */
  unstructured?: Maybe<Scalars['String']>;
};

/** Status of the artifact in its lifecycle. */
export enum ArtifactStatus {
  /** Artifact is being created or refined */
  Draft = 'DRAFT',
  /** Artifact generation or finalization failed */
  Failed = 'FAILED',
  /** Artifact has been finalized and converted to a real entity */
  Finalized = 'FINALIZED'
}

/** Type of artifact being generated or finalized. Determines which AI workflow and finalization logic to use. */
export enum ArtifactType {
  /** Action plans and step-by-step guidance for HR scenarios */
  ActionPlan = 'ACTION_PLAN',
  /** Brief HR best practice summaries (~100 words) */
  BestPracticeSummary = 'BEST_PRACTICE_SUMMARY',
  /** Detailed multi-step HR guidance */
  ComprehensiveGuidance = 'COMPREHENSIVE_GUIDANCE',
  /** Implementation plans and HR practices guides for policies */
  ImplementationPlan = 'IMPLEMENTATION_PLAN',
  /** HR Policy documents */
  Policy = 'POLICY'
}

export type AskNicelySurveyInfo = {
  __typename?: 'AskNicelySurveyInfo';
  emailHash?: Maybe<Scalars['String']>;
  force: Scalars['Boolean'];
  show: Scalars['Boolean'];
};

export type AssignUserToPoliciesInput = {
  /** Company ID of the policy */
  companyId: Scalars['ID'];
  /** Employee ID to assign policy to */
  employeeId: Scalars['ID'];
  /** Policy IDs */
  policyIds: Array<Scalars['ID']>;
};

export type AssignUsersToPoliciesInput = {
  /** Company ID of the policy */
  companyId: Scalars['ID'];
  /** Employee IDs to assign policy to */
  employeeIds: Array<Scalars['ID']>;
  /** Policy IDs */
  policyIds: Array<Scalars['ID']>;
};

export type AssignWorkerRolesInput = {
  add?: Maybe<Array<CreateWorkerRoleInput>>;
  delete?: Maybe<Array<Scalars['ID']>>;
  update?: Maybe<Array<UpdateWorkerRoleInput>>;
  userId: Scalars['ID'];
};

export type AuthMfaChallenge = {
  __typename?: 'AuthMfaChallenge';
  deviceHeader: Scalars['String'];
  deviceId: Scalars['String'];
  expiration: Scalars['DateTime'];
  metadata?: Maybe<AuthMfaMetadata>;
  nonce: Scalars['String'];
};

export type AuthMfaChallengeResponseInput = {
  nonce: Scalars['String'];
  response: Scalars['String'];
};

export type AuthMfaConfig = {
  __typename?: 'AuthMfaConfig';
  /** When enrolling the first MFA device, a backup code will also be created and presented to the user. */
  backupCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastChallengedAt?: Maybe<Scalars['DateTime']>;
  lastDevice?: Maybe<Scalars['String']>;
  mfaType: AuthMfaType;
};

export type AuthMfaMetadata = {
  __typename?: 'AuthMfaMetadata';
  phoneLast4?: Maybe<Scalars['String']>;
};

export type AuthMfaSmsEnrollmentInput = {
  mfaType: AuthMfaType;
  phoneNumber: Scalars['String'];
};

export enum AuthMfaType {
  /** The backup code (which should be printed and securely stored!) in case the phone number becomes unavailable. */
  Backup = 'BACKUP',
  /** Certain challenges (like creating an MFA enrollment, or running a process without any other MFA) require using a password. */
  Password = 'PASSWORD',
  /** Perform MFA verification via SMS text message */
  Sms = 'SMS'
}

/** The user role of the decision maker. */
export enum AuthRole {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE'
}

export type AutoAssignHrManager = {
  __typename?: 'AutoAssignHrManager';
  coordinator: CoreUser;
  lastAssignedOn?: Maybe<Scalars['DateTime']>;
  stateGroup: Scalars['ID'];
  user: CoreUser;
};

export type AutoAssignHrManagerInput = {
  coordinatorUserId: Scalars['ID'];
  stateGroup: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AutoFinalizeInput = {
  /** Whether to create an HR Request when finalizing. Default: true */
  createHrRequest?: Maybe<Scalars['Boolean']>;
  /** Whether to auto-finalize generated artifacts */
  enabled: Scalars['Boolean'];
  /** Default finalization options for all artifacts (can be overridden per-artifact) */
  globalOptions?: Maybe<Scalars['JSONObject']>;
};

export type AvailableProduct = {
  __typename?: 'AvailableProduct';
  /** Number of credits provided on core subscription. Null if single purchase */
  allowance?: Maybe<Scalars['Int']>;
  /** Billing period of the product. Null if single purchase */
  billingPeriod?: Maybe<Scalars['String']>;
  /** One-time discounted price of product, if available. Null if subscription */
  discountedPrice?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  key: ProductKey;
  /** Number of credits provided per month, if applicable. Null if single purchase */
  monthlyAllowance?: Maybe<Scalars['Int']>;
  /** Name of product */
  name?: Maybe<Scalars['String']>;
  /** One-time price of product. Null if subscription */
  price?: Maybe<Scalars['Int']>;
  /** The price to subscribe, based on billing period. Null if single purchase */
  subscriptionPrice?: Maybe<Scalars['Int']>;
  /** Company tier */
  tier?: Maybe<Scalars['Int']>;
};

export type AvailableProducts = {
  __typename?: 'AvailableProducts';
  bundles: Array<BundleResponse>;
  id: Scalars['ID'];
  topics: Array<CourseTopic>;
};

export type BackfillBambeePlusTopicsInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicIds: Array<Scalars['String']>;
};

export enum BambeeAssistant {
  Brighten = 'Brighten',
  CompanyInfo = 'CompanyInfo',
  Compliance = 'Compliance',
  CorrectiveAction = 'CorrectiveAction',
  Editor = 'Editor',
  Gather = 'Gather',
  Guard = 'Guard',
  Guidance = 'Guidance',
  Incident = 'Incident',
  JobDescription = 'JobDescription',
  Policy = 'Policy',
  QnA = 'QnA',
  Router = 'Router',
  Sentiment = 'Sentiment'
}

/** A model representing a generic plan. */
export type BambeeGenericPlanModel = {
  __typename?: 'BambeeGenericPlanModel';
  /** Billing period for the plan. */
  billingPeriod: BillingPeriod;
  /** Name of the plan. */
  name: Scalars['String'];
  /** Total price of the plan. */
  price?: Maybe<Scalars['Float']>;
  /** Price identifier in Stripe. */
  priceId: Scalars['String'];
  /** The product key associated to the plan object (Lite, Dedicated, Plus, Elite). */
  productKey: ProductKey;
  /** The service key associated to the plan object (Core, Training, ...). */
  serviceKey: ServiceKey;
  /** Current status of the plan. */
  status: PlanStatuses;
  /** Value proposition of the plan. */
  value: Scalars['String'];
};

export type BambeePlus = {
  __typename?: 'BambeePlus';
  eligible: Scalars['Boolean'];
  hasExtendedOnboardingDeadline: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Late fee implementation price in units i.e $10.00 = 1000 */
  lateFeeImplementationPrice?: Maybe<Scalars['Float']>;
  onboardingDueDate?: Maybe<Scalars['DateTime']>;
  /** Price related to core subscription in units i.e $10.00 = 1000 */
  price?: Maybe<Scalars['Float']>;
  status: BambeePlusStatuses;
};

export enum BambeePlusStatuses {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Inactive = 'INACTIVE'
}

export type BaseTemplateDto = {
  __typename?: 'BaseTemplateDto';
  /** Indicates whether the final artifact is based on a Bambee template */
  isBambeeTemplateBase?: Maybe<Scalars['String']>;
};

export type BatchSummary = {
  __typename?: 'BatchSummary';
  /** Number of artifacts that failed */
  failed: Scalars['Int'];
  /** Number of artifacts successfully finalized */
  finalized: Scalars['Int'];
  /** Number of artifacts successfully generated */
  generated: Scalars['Int'];
  /** Total number of artifacts requested */
  total: Scalars['Int'];
};

export enum BestPracticeStatus {
  Accepted = 'accepted',
  Drafted = 'drafted',
  New = 'new'
}

export type BestPracticeSummaryArtifact = {
  __typename?: 'BestPracticeSummaryArtifact';
  /** The download url for the best practice summary artifact */
  downloadUrl: Scalars['String'];
  /** The download url for the best practice summary artifact */
  dto: Scalars['String'];
  /** The best practice summary rendered as HTML */
  html: Scalars['String'];
  /** The id of the best practice summary artifact */
  id: Scalars['String'];
  /** The status of the best practice summary artifact */
  status: BestPracticeStatus;
  /** The title of the best practice summary artifact */
  title: Scalars['String'];
};

export type BillingCredit = {
  __typename?: 'BillingCredit';
  consumedAt?: Maybe<Scalars['DateTime']>;
  consumedBy?: Maybe<Scalars['String']>;
  creditType: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  productKey: Scalars['String'];
};

export type BillingEventConnection = {
  __typename?: 'BillingEventConnection';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  nodes: Array<BillingEventModel>;
};

export type BillingEventModel = {
  __typename?: 'BillingEventModel';
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  occurredAt: Scalars['DateTime'];
  payload: Scalars['JSON'];
  processedAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
};

/** Billing feature */
export enum BillingFeature {
  Addon = 'ADDON',
  Plan = 'PLAN',
  Setup = 'SETUP'
}

export type BillingInfo = {
  __typename?: 'BillingInfo';
  addonSubscriptions: Array<SubscriptionModel>;
  coreSubscription?: Maybe<CoreSubscriptionModel>;
  id: Scalars['ID'];
  pause: Paused;
  paymentMethods: Array<BillingPaymentMethod>;
};

/** Coverage level of the SuperVision ladder a selection sits at. */
export enum BillingMigrationLevel {
  Management = 'MANAGEMENT',
  Observation = 'OBSERVATION',
  Supervision = 'SUPERVISION'
}

/** What plan a company is migrating to, and whether they actively chose it. Records intent only -- reading or writing one changes no subscription, price or entitlement. */
export type BillingMigrationRecord = {
  __typename?: 'BillingMigrationRecord';
  companyId: Scalars['String'];
  /** When the plan was actively chosen. Null when the company defaulted into it. */
  confirmedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /** The active staff count the band was derived from. */
  employeeCount: Scalars['Int'];
  id: Scalars['ID'];
  /** True when someone actively chose this plan, false when the company was defaulted onto the recommended one. Derived from confirmedAt. */
  isExplicitSelection: Scalars['Boolean'];
  /** Coverage level of the selected plan. */
  level: BillingMigrationLevel;
  /** Monthly price in integer cents, as shown to the customer at selection time. */
  monthlyAmount: Scalars['Int'];
  /** The plan the company is on today, before migrating. */
  originalProductKey: ProductKey;
  /** The plan identifier billing keys on (CorePlanModel.value). */
  planValue: Scalars['String'];
  /** The plan we recommend for this company. */
  recommendedProductKey: ProductKey;
  /** Who chose the plan. Null when the company defaulted into it -- a default has no chooser. */
  selectedByUserId?: Maybe<Scalars['String']>;
  /** The plan the company is migrating to. Defaults to the recommended plan; check isExplicitSelection to tell a real choice from that default. */
  selectedProductKey: ProductKey;
  source: BillingMigrationSelectionSource;
  /** Headcount band the price came from, 1-6. */
  tierNumber: Scalars['Int'];
};

/** Where a migration plan selection came from. */
export enum BillingMigrationSelectionSource {
  Admin = 'ADMIN',
  Advisor = 'ADVISOR',
  Default = 'DEFAULT',
  MigrationFlow = 'MIGRATION_FLOW'
}

export type BillingPaymentMethod = {
  __typename?: 'BillingPaymentMethod';
  default: Scalars['Boolean'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  issueReason?: Maybe<PaymentMethodIssueReason>;
  name: Scalars['String'];
  nextAction?: Maybe<PaymentMethodNextAction>;
  status: PaymentMethodStatus;
  type: PaymentMethodType;
};

/** Billing Period */
export enum BillingPeriod {
  HalfYear = 'HALF_YEAR',
  Month = 'MONTH',
  NineMonths = 'NINE_MONTHS',
  Quarter = 'QUARTER',
  ThreeYears = 'THREE_YEARS',
  TwoYears = 'TWO_YEARS',
  Year = 'YEAR'
}

export type BillingPlan = {
  __typename?: 'BillingPlan';
  code: Scalars['String'];
  interval: Scalars['String'];
  maxSize: Scalars['Int'];
  minSize: Scalars['Int'];
  price: Money;
  productKey: Scalars['String'];
  setupFee?: Maybe<Money>;
  status: Scalars['String'];
  tier: Scalars['Int'];
  totalBillingCycles?: Maybe<Scalars['Int']>;
  trialDays: Scalars['Int'];
  version: Scalars['String'];
};

/** The billing system a subscription is billed in. */
export enum BillingProvider {
  /** Billed in Recurly. */
  Recurly = 'RECURLY',
  /** Billed in Stripe. */
  Stripe = 'STRIPE'
}

export type BillingPurchaseInput = {
  companyId: Scalars['ID'];
  couponCodes?: Maybe<Array<Scalars['String']>>;
  items?: Maybe<Array<Scalars['String']>>;
  paymentMethodToken?: Maybe<Scalars['String']>;
  planCode: Scalars['String'];
  seats?: Maybe<Array<SeatQuantityInput>>;
  startsAt?: Maybe<Scalars['DateTime']>;
};

export type BillingPurchaseResult = {
  __typename?: 'BillingPurchaseResult';
  entitlementEventPending: Scalars['Boolean'];
  invoice?: Maybe<Invoice>;
  subscription: BillingSubscriptionModel;
};

export type BillingSubscriptionModel = {
  __typename?: 'BillingSubscriptionModel';
  addOns: Array<AddOnLine>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  companyId: Scalars['ID'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']>;
  currentTermEndsAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  externalSubscriptionId: Scalars['String'];
  id: Scalars['ID'];
  /** Recurly's estimate of the next bill for this subscription, tax included. An estimate, not an invoice. */
  nextBillEstimate?: Maybe<Money>;
  pausedAt?: Maybe<Scalars['DateTime']>;
  pendingChange?: Maybe<PendingChange>;
  planCode: Scalars['String'];
  planName?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  provider: BillingProvider;
  /** The Recurly admin page for this company account. Requires a Recurly login. */
  recurlyAccountUrl?: Maybe<Scalars['String']>;
  resumeAt?: Maybe<Scalars['DateTime']>;
  state: SubscriptionState;
  /** 1-based headcount band Recurly bills, from the employee-count add-on quantity. */
  tier?: Maybe<Scalars['Int']>;
  trialEnd?: Maybe<Scalars['DateTime']>;
  trialStart?: Maybe<Scalars['DateTime']>;
};

/** The category used in Brighten */
export enum BrightenCategory {
  Achievement = 'ACHIEVEMENT',
  CareerGrowth = 'CAREER_GROWTH',
  Coaching = 'COACHING',
  Compliance = 'COMPLIANCE',
  CorrectiveAction = 'CORRECTIVE_ACTION',
  Engagement = 'ENGAGEMENT',
  Misc = 'MISC',
  Misconduct = 'MISCONDUCT',
  TeamDevelopment = 'TEAM_DEVELOPMENT',
  TeamPerformance = 'TEAM_PERFORMANCE',
  TopPerformer = 'TOP_PERFORMER'
}

export type BulkActivationResult = {
  __typename?: 'BulkActivationResult';
  activations?: Maybe<Array<Maybe<CoreActivation>>>;
  errors?: Maybe<Array<Maybe<BulkActivationResultError>>>;
};

export type BulkActivationResultError = {
  __typename?: 'BulkActivationResultError';
  companyId: Scalars['String'];
  key: Scalars['String'];
  message: Scalars['String'];
};

export type BulkCompleteEnrollmentInput = {
  lmsCourseIds: Array<Scalars['Float']>;
  userIds: Array<Scalars['String']>;
};

export type BulkEnrollUsersInput = {
  companyId: Scalars['String'];
  enrollments: Array<EnrollmentInput>;
};

export type BulkEnrollUsersResponse = {
  __typename?: 'BulkEnrollUsersResponse';
  enrolledUsers: Array<EnrollUsersResponse>;
  errors: Array<EnrollUsersError>;
};

export type BulkMessageStaff = {
  active?: Maybe<Scalars['Boolean']>;
  signatureRequired?: Maybe<Scalars['Boolean']>;
  staffId: Scalars['ID'];
  status?: Maybe<StaffStatus>;
};

export type BulkMessageStaffError = {
  __typename?: 'BulkMessageStaffError';
  errorMsg: Scalars['String'];
  staffId: Scalars['ID'];
};

export type BulkMessageStaffInput = {
  messageBody: Scalars['String'];
  messageGroupType: MessageGroupType;
  messageType: MessageType;
  pageSource?: Maybe<Scalars['String']>;
  staff: Array<BulkMessageStaff>;
  textMessage?: Maybe<Scalars['Boolean']>;
};

export type BulkMessageStaffResult = {
  __typename?: 'BulkMessageStaffResult';
  errors: Array<Maybe<BulkMessageStaffError>>;
  successfulStaffIds: Array<Maybe<Scalars['ID']>>;
};

export type BulkPurchaseSeatsInput = {
  purchases: Array<Maybe<PurchaseSeatsInput>>;
};

export type BulkRequestResult = {
  __typename?: 'BulkRequestResult';
  errors?: Maybe<Array<Maybe<BulkRequestResultError>>>;
  requests?: Maybe<Array<Maybe<CoreRequest>>>;
};

export type BulkRequestResultError = {
  __typename?: 'BulkRequestResultError';
  message: Scalars['String'];
  requestId: Scalars['String'];
};

export type BulkUploadEmployeesResponse = {
  __typename?: 'BulkUploadEmployeesResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  userId?: Maybe<Scalars['String']>;
};

export type BundleResponse = {
  __typename?: 'BundleResponse';
  annualStripePriceId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  global: Scalars['Boolean'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  singleStripePriceId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  topics: Array<Maybe<CourseTopic>>;
  updatedAt: Scalars['DateTime'];
};

export type BusinessManager = {
  __typename?: 'BusinessManager';
  lastAssignedOn?: Maybe<Scalars['DateTime']>;
  tier: Scalars['Int'];
  user: CoreUser;
};

export type BusinessManagerForTierInput = {
  tier: Scalars['Int'];
  userId: Scalars['ID'];
};

export type Cadence = {
  __typename?: 'Cadence';
  value: Scalars['String'];
};

export type Calendly = {
  __typename?: 'Calendly';
  url: Scalars['String'];
};

export type CallAgent = {
  __typename?: 'CallAgent';
  avatarUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CallInformation = {
  /** The reason for requesting a new call */
  reasonForCall: Scalars['String'];
};

export type CallSummary = {
  __typename?: 'CallSummary';
  actionItems?: Maybe<Scalars['String']>;
  agent?: Maybe<CallAgent>;
  /** @deprecated Salesforce no longer tracks when a summary was approved. Always null. */
  approvedAt?: Maybe<Scalars['DateTime']>;
  callDurationInMinutes?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  followUps?: Maybe<Scalars['String']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isBambeeLiteCall: Scalars['Boolean'];
  summary?: Maybe<Scalars['String']>;
};

export type CanInitiateTrialInput = {
  companyId: Scalars['ID'];
};

export type CanInitiateTrialResult = {
  __typename?: 'CanInitiateTrialResult';
  blockingReasons: Array<TrialBlockingReason>;
  canInitiate: Scalars['Boolean'];
  eligible: Scalars['Boolean'];
  hasPaymentMethod: Scalars['Boolean'];
};

export enum CancelAt {
  Now = 'NOW',
  TermEnd = 'TERM_END'
}

export type CancelInput = {
  at: CancelAt;
  companyId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type CancelPremiumPeopleAddonInput = {
  /** Company to cancel the add-on for. Defaults to the caller's company when omitted. */
  companyId?: Maybe<Scalars['String']>;
};

export type CancelRecommendationInput = {
  /** The id of the recommendation to be canceled. */
  recommendationId: Scalars['String'];
};

export type CancelScheduledEventInput = {
  /** Scheduled Event ID */
  scheduledEventId: Scalars['String'];
};

export type CancelSubscriptionInput = {
  companyId: Scalars['String'];
  consumptionDescription: Scalars['String'];
  consumptionReason: ProductCreditConsumptionReason;
  productKey: ProductKey;
};

export type CancellationModel = {
  __typename?: 'CancellationModel';
  /** A note from the client */
  clientReasonNote: Scalars['String'];
  /** User who requested the cancellation */
  closedBy?: Maybe<Scalars['String']>;
  /** When was the cancellation closed */
  closedDate?: Maybe<Scalars['String']>;
  /** A final note when the cancellation request is closed by either confirming or rescueing it */
  closingNote: Scalars['String'];
  /** User who created the cancellation */
  createdBy: Scalars['String'];
  /** When was the cancellation created */
  createdDate: Scalars['String'];
  /** Numbers of months credited upon reinstatement */
  creditMonths: Scalars['Float'];
  /** If cancellation is confirmed, when is the subscription's effective last day */
  effectiveDate: Scalars['String'];
  /** Unique identifier for the cancellation */
  id: Scalars['String'];
  /** An internal note made by a Bambee user */
  internalReasonNote: Scalars['String'];
  /** Flag stating if company was in trial when cancellation was requested */
  isTrialCancellation: Scalars['Boolean'];
  netAmount: Scalars['Float'];
  /** List of reason codes specified by the user */
  reasonCodes: Array<Scalars['Float']>;
  rebuttalReasonCode: Scalars['String'];
  /** Recurly-billed companies only: the Recurly credit invoices refundAmount sums */
  recurlyRefundInvoiceIds?: Maybe<Array<Scalars['String']>>;
  /** Recurly-billed companies only: the refund Recurly actually gave. PRORATED only when a credit invoice was found */
  refund?: Maybe<CancellationRefund>;
  /** amount to be refunded */
  refundAmount: Scalars['Float'];
  /** Recurly-billed companies only: the currency of refundAmount */
  refundCurrency?: Maybe<Scalars['String']>;
  /** Set when a PRORATED refund was asked for but Recurly refunded nothing (or it could not be confirmed): refund by hand in Recurly */
  refundWarning?: Maybe<Scalars['String']>;
  /** Amount to be charged upon reinstatement */
  reinstatementAmount: Scalars['Float'];
  /** User who requested the cancellation, usually the company owner */
  requestedBy: Scalars['String'];
  /** When was the cancellation requested */
  requestedDate: Scalars['String'];
  /** The status of the cancellation */
  source: CancellationSource;
  /** The status of the cancellation */
  status: CancellationStatus;
  /** Recurly-billed companies only: the timeframe the effective date was taken from */
  timeframe?: Maybe<CancellationTimeframe>;
};

export type CancellationOffersModel = {
  __typename?: 'CancellationOffersModel';
  /** The downgrade plan available for the customer */
  downgradePlan?: Maybe<CorePlanModel>;
  /** The downgrade plans available for the customer */
  downgradePlans: Array<CorePlanModel>;
  /** The downgrade plan available for the customer */
  pausePlan?: Maybe<CorePlanModel>;
  /** The downgrade plan available for the customer */
  storagePlan?: Maybe<CorePlanModel>;
  /** Flag indicating if the customer can extend their trial */
  trialExtension: Scalars['Boolean'];
};

export type CancellationReasonGroupModel = {
  __typename?: 'CancellationReasonGroupModel';
  /** Identifier for the cancellation reason group */
  code: Scalars['String'];
  /** Text to be displayed in UI */
  externalText: Scalars['String'];
  /** List of cancellation reasons for the group */
  reasons: Array<CancellationReasonModel>;
};

export type CancellationReasonModel = {
  __typename?: 'CancellationReasonModel';
  /** Flag indicating whether or the reason is active */
  active: Scalars['Boolean'];
  /** Identifier for the cancellation reason */
  code: Scalars['Float'];
  /** Text to be displayed in UI */
  externalText: Scalars['String'];
  /** Flag indicating if reason should be displayed only to Bambee users in Honey */
  internalOnly: Scalars['Boolean'];
};

/** Whether an IMMEDIATE cancellation refunds the time left in the current bill cycle */
export enum CancellationRefund {
  None = 'NONE',
  Prorated = 'PRORATED'
}

export enum CancellationSource {
  Chat = 'CHAT',
  Email = 'EMAIL',
  Internal = 'INTERNAL',
  None = 'NONE',
  Phone = 'PHONE',
  Stripe = 'STRIPE',
  Web = 'WEB'
}

export enum CancellationStatus {
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rescued = 'RESCUED'
}

/** How a Recurly-billed company's subscriptions end: at term end, at the next bill date, or now */
export enum CancellationTimeframe {
  BillDate = 'BILL_DATE',
  Immediate = 'IMMEDIATE',
  TermEnd = 'TERM_END'
}

export enum CardVerificationStatus {
  Fail = 'FAIL',
  Pass = 'PASS',
  Unknown = 'UNKNOWN'
}

export enum CaseStage {
  Administration = 'ADMINISTRATION',
  AdministrationApproval = 'ADMINISTRATION_APPROVAL',
  Approved = 'APPROVED',
  AuditHrCompliance = 'AUDIT_HR_COMPLIANCE',
  Bambeedispute = 'BAMBEEDISPUTE',
  Bambeerefundapproved = 'BAMBEEREFUNDAPPROVED',
  Bambeerefunddeclined = 'BAMBEEREFUNDDECLINED',
  Bambeerefundprocessed = 'BAMBEEREFUNDPROCESSED',
  Bambeerefundsubmitted = 'BAMBEEREFUNDSUBMITTED',
  BambeePayrollActivationInProgress = 'BAMBEE_PAYROLL_ACTIVATION_IN_PROGRESS',
  BambeePlusSetupInProgress = 'BAMBEE_PLUS_SETUP_IN_PROGRESS',
  BuildEmployeeOnboardingKit = 'BUILD_EMPLOYEE_ONBOARDING_KIT',
  Certified = 'CERTIFIED',
  Diagnostic = 'DIAGNOSTIC',
  Execution = 'EXECUTION',
  ExecutionApproval = 'EXECUTION_APPROVAL',
  FirstCertification = 'FIRST_CERTIFICATION',
  FirstPayrollPaid = 'FIRST_PAYROLL_PAID',
  FirstPayrollPendingPay = 'FIRST_PAYROLL_PENDING_PAY',
  FounderInstallation = 'FOUNDER_INSTALLATION',
  FullActivation = 'FULL_ACTIVATION',
  Guidance = 'GUIDANCE',
  GuidanceApproval = 'GUIDANCE_APPROVAL',
  ImproveStaffCommunication = 'IMPROVE_STAFF_COMMUNICATION',
  IntroduceStaffToBambee = 'INTRODUCE_STAFF_TO_BAMBEE',
  MeetYourTeam = 'MEET_YOUR_TEAM',
  OnboardingComplete = 'ONBOARDING_COMPLETE',
  OperatingRhythm = 'OPERATING_RHYTHM',
  Outcome = 'OUTCOME',
  PendingApproval = 'PENDING_APPROVAL',
  ReadyToRunFirstPayroll = 'READY_TO_RUN_FIRST_PAYROLL',
  Reminder = 'REMINDER',
  Requested = 'REQUESTED',
  Revision = 'REVISION',
  Withdrawn = 'WITHDRAWN'
}

export enum CaseStatus {
  Backedout = 'BACKEDOUT',
  Blocked = 'BLOCKED',
  Blockedcheck = 'BLOCKEDCHECK',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Closederror = 'CLOSEDERROR',
  Closedinactive = 'CLOSEDINACTIVE',
  Confirmresolution = 'CONFIRMRESOLUTION',
  Contacting = 'CONTACTING',
  Customerreplied = 'CUSTOMERREPLIED',
  DoItMyself = 'DO_IT_MYSELF',
  Escalated = 'ESCALATED',
  InProgress = 'IN_PROGRESS',
  Merged = 'MERGED',
  Negotiationreview = 'NEGOTIATIONREVIEW',
  New = 'NEW',
  NewActionPlan = 'NEW_ACTION_PLAN',
  Onhold = 'ONHOLD',
  Pendingsummary = 'PENDINGSUMMARY',
  Reopened = 'REOPENED',
  ResponseReceived = 'RESPONSE_RECEIVED',
  Saved = 'SAVED',
  Selfservice = 'SELFSERVICE',
  Summaryreview = 'SUMMARYREVIEW',
  WithCustomer = 'WITH_CUSTOMER',
  Wontdo = 'WONTDO'
}

export enum CaseType {
  Adminsupport = 'ADMINSUPPORT',
  Bambeepayroll = 'BAMBEEPAYROLL',
  Brightensolutions = 'BRIGHTENSOLUTIONS',
  BusinessManagement = 'BUSINESS_MANAGEMENT',
  Callback = 'CALLBACK',
  Cancellationrequest = 'CANCELLATIONREQUEST',
  Compensationbenefits = 'COMPENSATIONBENEFITS',
  Compliance = 'COMPLIANCE',
  Customeractivation = 'CUSTOMERACTIVATION',
  Emailautoresponder = 'EMAILAUTORESPONDER',
  Employeefeedback = 'EMPLOYEEFEEDBACK',
  Employeerelations = 'EMPLOYEERELATIONS',
  Endingemployment = 'ENDINGEMPLOYMENT',
  Generalrequest = 'GENERALREQUEST',
  Guidance = 'GUIDANCE',
  Hiringonboarding = 'HIRINGONBOARDING',
  Hrmsupport = 'HRMSUPPORT',
  HrCoverage = 'HR_COVERAGE',
  Implementation = 'IMPLEMENTATION',
  Implementationplan = 'IMPLEMENTATIONPLAN',
  Issuereporting = 'ISSUEREPORTING',
  Laborlaws = 'LABORLAWS',
  Legacy = 'LEGACY',
  Misconduct = 'MISCONDUCT',
  Payrollonboarding = 'PAYROLLONBOARDING',
  Payrollsupport = 'PAYROLLSUPPORT',
  Performancemanagement = 'PERFORMANCEMANAGEMENT',
  Policies = 'POLICIES',
  Policyrequest = 'POLICYREQUEST',
  Service = 'SERVICE',
  Techsupport = 'TECHSUPPORT',
  Terminationrequest = 'TERMINATIONREQUEST',
  TopPerformer = 'TOP_PERFORMER',
  Trainingdevelopment = 'TRAININGDEVELOPMENT',
  Trainingenrollment = 'TRAININGENROLLMENT',
  Typebilling = 'TYPEBILLING',
  Unknownrequest = 'UNKNOWNREQUEST'
}

export type ChangeCancellationTimeframeInput = {
  /** The company ID */
  companyId: Scalars['String'];
  /** IMMEDIATE only: PRORATED refunds the time left in the current bill cycle. Defaults to NONE */
  refund?: Maybe<CancellationRefund>;
  /** The new timeframe; the effective date is read from the core subscription for it */
  timeframe: CancellationTimeframe;
};

export type ChangePlanInput = {
  companyId: Scalars['ID'];
  planCode: Scalars['String'];
  prorate?: Scalars['Boolean'];
  timeframe: ChangeTimeframe;
};

export type ChangePreview = {
  __typename?: 'ChangePreview';
  effectiveAt: Scalars['DateTime'];
  immediateCharge: Money;
  lines: Array<PreviewLine>;
  nextInvoiceTotal: Money;
  pendingChangePreserved: Scalars['Boolean'];
};

export type ChangeSeatsInput = {
  companyId: Scalars['ID'];
  seats: Array<SeatQuantityInput>;
  timeframe?: Maybe<ChangeTimeframe>;
};

export enum ChangeTimeframe {
  Now = 'NOW',
  Renewal = 'RENEWAL'
}

export type ChangeTrialEndDateForCoreSubscriptionInput = {
  companyId: Scalars['String'];
  trialEndDate: Scalars['DateTime'];
};

export type ChannelPartipants = {
  __typename?: 'ChannelPartipants';
  user: CoreUser;
};

export enum ChannelType {
  /** A channel representing a group of employees at a company. */
  Group = 'Group',
  /** A channel representing a one-on-one conversation at a company. */
  OneOnOne = 'OneOnOne'
}

export type ChatArtifact = {
  __typename?: 'ChatArtifact';
  /** The action plan that was generated */
  actionPlan?: Maybe<ActionPlanArtifact>;
  /** Information on the base template used to generate the artifact */
  baseTemplate?: Maybe<BaseTemplateDto>;
  /** The best practice summary that was generated */
  bestPracticeSummary?: Maybe<BestPracticeSummaryArtifact>;
  /** A company role that was added to the company */
  companyRole?: Maybe<CompanyRoleArtifact>;
  /** The comprehensive guidance that was generated */
  comprehensiveGuidance?: Maybe<ComprehensiveGuidanceArtifact>;
  /** The corrective action that was generated */
  correctiveAction?: Maybe<CorrectiveActionArtifact>;
  /** The document that was generated */
  document?: Maybe<DocumentArtifact>;
  /** The result of the guard */
  guard?: Maybe<GuardArtifact>;
  /** The hr practices artifact that was generated */
  hrPractices?: Maybe<HrPracticesArtifact>;
  /** The implementation plan that was generated */
  implementationPlan?: Maybe<ImplementationPlanArtifact>;
  /** The incident that was generated */
  incident?: Maybe<IncidentArtifact>;
  /** The job description that was generated */
  jobDescription?: Maybe<JobDescriptionArtifact>;
  /** The policy that was generated */
  policy?: Maybe<PolicyArtifact>;
  /** The intake summary that was generated */
  summary?: Maybe<SummaryArtifact>;
};

/** The role of the prompt */
export enum ChatCompletionRole {
  Assistant = 'assistant',
  Developer = 'developer',
  Function = 'function',
  System = 'system',
  Tool = 'tool',
  User = 'user'
}

export type ChatMessageInterface = {
  channelId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isThreadMessage: Scalars['Boolean'];
  isThreadParent: Scalars['Boolean'];
  rawType: SendbirdMessageType;
  /** Recipieint, if a one-on-one message */
  recipient?: Maybe<CoreUser>;
  sender: CoreUser;
  threadParentId?: Maybe<Scalars['ID']>;
  type: ChatMessageTypeEnum;
};

/** The message type as applicable to Bambee Chat */
export enum ChatMessageTypeEnum {
  /** This message represents a customized feedback item, containing a feedback value. */
  Feedback = 'Feedback',
  /** This message is just simple text and does not to be decoded or enriched. */
  Text = 'Text'
}

export type ChatTopicSuggestion = {
  __typename?: 'ChatTopicSuggestion';
  /** A list of CoreUsers that a suggested topic could be sent to. */
  recipients: Array<CoreUser>;
  type: Scalars['String'];
};

export type CloseCancellationRequestInput = {
  /** Optional text with details about the closing operation */
  closingNote?: Maybe<Scalars['String']>;
  /** The company ID */
  companyId: Scalars['String'];
  /** IMMEDIATE only: PRORATED refunds the time left in the current bill cycle. Defaults to NONE */
  refund?: Maybe<CancellationRefund>;
  /** How the Recurly subscriptions end; the effective date is read from the core subscription for it. Defaults to TERM_END */
  timeframe?: Maybe<CancellationTimeframe>;
};

export type CloseHrRequestInput = {
  caseId: Scalars['String'];
};

export type Company = {
  __typename?: 'Company';
  availableProducts: AvailableProducts;
  companyId?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated; Use companyId instead */
  companyMngId?: Maybe<Scalars['String']>;
  hasTraining: Scalars['Boolean'];
  id: Scalars['ID'];
  purchasedProducts: PurchasedProducts;
  seatsSummary: SeatsSummary;
  topics: Array<CourseTopic>;
  users: Array<User>;
};


export type CompanySeatsSummaryArgs = {
  data: GetCompanyInput;
};

export type CompanyAdvisorCalendlySlug = {
  __typename?: 'CompanyAdvisorCalendlySlug';
  /** The calendly slug for the advisor */
  calendlySlug?: Maybe<Scalars['String']>;
  /** The role for the advisor */
  role: CompanyAdvisorRole;
  /** The advisor user identifier */
  userId: Scalars['String'];
};

export type CompanyAdvisorCalendlySlugInput = {
  /** The company identifier */
  companyId: Scalars['String'];
  /** The role for the company advisor */
  role: CompanyAdvisorRole;
};

export enum CompanyAdvisorRole {
  AccountCoordinator = 'ACCOUNT_COORDINATOR',
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  BusinessManager = 'BUSINESS_MANAGER',
  HandbookSpecialist = 'HANDBOOK_SPECIALIST',
  HrCoordinator = 'HR_COORDINATOR',
  HrManager = 'HR_MANAGER',
  InsuranceSalesperson = 'INSURANCE_SALESPERSON',
  OnboardingCoordinator = 'ONBOARDING_COORDINATOR',
  OnboardingSpecialist = 'ONBOARDING_SPECIALIST',
  OpsManager = 'OPS_MANAGER',
  PayrollManager = 'PAYROLL_MANAGER'
}

export type CompanyAiProfile = {
  __typename?: 'CompanyAiProfile';
  /** Whether the company has opted in to AI */
  optIn?: Maybe<Scalars['Boolean']>;
};

export type CompanyChannel = {
  __typename?: 'CompanyChannel';
  channelUrl: Scalars['ID'];
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastMessage?: Maybe<ChatMessageInterface>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  messages: Array<ChatMessageInterface>;
  participants: Array<ChannelPartipants>;
  type: ChannelType;
  unreadMentionCount?: Maybe<Scalars['Int']>;
  unreadMessageCount?: Maybe<Scalars['Int']>;
};

export type CompanyContextDto = {
  __typename?: 'CompanyContextDto';
  /** Available policy templates that can be used to create new policies */
  availablePolicyTemplates?: Maybe<Array<PolicyTemplateDto>>;
  companyRoles?: Maybe<Array<EnhancedCompanyRoleDto>>;
  documents?: Maybe<Array<DocumentDto>>;
  employeeCount?: Maybe<Scalars['Int']>;
  /** Company goals with nested tasks */
  goals?: Maybe<Array<CoreGoalWithTasks>>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pips?: Maybe<Array<PipDto>>;
  policies?: Maybe<Array<PolicyDto>>;
  qnas?: Maybe<QnaDto>;
  roles?: Maybe<Array<DepartmentDto>>;
  search?: Maybe<SearchResultsDto>;
  staff?: Maybe<Array<UserContextDto>>;
  state?: Maybe<Scalars['String']>;
  stats?: Maybe<CompanyStatsDto>;
  tier?: Maybe<Scalars['Int']>;
  training?: Maybe<EnhancedTrainingProfileDto>;
  warnings?: Maybe<CompanyWarningsDto>;
  /** Company wizards */
  wizards?: Maybe<Array<WizardDto>>;
};


export type CompanyContextDtoAvailablePolicyTemplatesArgs = {
  filters?: Maybe<PolicyTemplateFiltersInput>;
};


export type CompanyContextDtoPipsArgs = {
  filters?: Maybe<CorrectiveActionFiltersInput>;
};


export type CompanyContextDtoSearchArgs = {
  input?: Maybe<SearchInput>;
};


export type CompanyContextDtoWarningsArgs = {
  filters?: Maybe<CorrectiveActionFiltersInput>;
};

export type CompanyCourseTopic = {
  __typename?: 'CompanyCourseTopic';
  enrollments: Array<CompanyTopicEnrollments>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CompanyDataFiltersInput = {
  /** Filters for corrective actions (PIPs, warnings) */
  correctiveActions?: Maybe<CorrectiveActionFiltersInput>;
  /** Include historical corrective action plans */
  includeHistoricalCAPs?: Maybe<Scalars['Boolean']>;
  /** Filters for policy templates */
  policies?: Maybe<PolicyTemplateFiltersInput>;
};

export type CompanyDelinquency = {
  __typename?: 'CompanyDelinquency';
  defaultCardVerificationStatus: CardVerificationStatus;
  delinquent: Scalars['Boolean'];
  delinquentAmount: Scalars['Float'];
  delinquentServices?: Maybe<Array<ServiceKey>>;
  /** The date customer was expected to pay the Core subscription */
  delinquentSince?: Maybe<Scalars['DateTime']>;
  lockout: Scalars['Boolean'];
  /** The original expected payment date for the Core subscription */
  originalPaymentDate?: Maybe<Scalars['DateTime']>;
};

export type CompanyRole = {
  __typename?: 'CompanyRole';
  /** Bambee Core Company Id */
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  /** Date of role deletion */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Bambee Core Company Role id */
  id: Scalars['ID'];
  /** Bambee Core Company Role title */
  title: Scalars['String'];
  workerRoles?: Maybe<Array<WorkerRole>>;
};

export type CompanyRoleArtifact = {
  __typename?: 'CompanyRoleArtifact';
  /** Id of the company role */
  id: Scalars['String'];
  /** Title of the company role  */
  title: Scalars['String'];
};

export type CompanySetting = {
  __typename?: 'CompanySetting';
  companyId: Scalars['String'];
  id: Scalars['Int'];
  key: CompanySettingKey;
  type: SettingType;
  value: Scalars['String'];
};

export enum CompanySettingKey {
  HrPracticeAuditActivated = 'HR_PRACTICE_AUDIT_ACTIVATED',
  HrPracticeAuditCadence = 'HR_PRACTICE_AUDIT_CADENCE',
  HrPracticeDocumentActivated = 'HR_PRACTICE_DOCUMENT_ACTIVATED',
  HrPracticeDocumentFilesUploaded = 'HR_PRACTICE_DOCUMENT_FILES_UPLOADED',
  HrPracticePayrollActivated = 'HR_PRACTICE_PAYROLL_ACTIVATED',
  HrPracticePayrollPurchase = 'HR_PRACTICE_PAYROLL_PURCHASE',
  HrPracticePolicyActivated = 'HR_PRACTICE_POLICY_ACTIVATED',
  HrPracticePolicyCadence = 'HR_PRACTICE_POLICY_CADENCE',
  HrPracticeReportCardActivated = 'HR_PRACTICE_REPORT_CARD_ACTIVATED',
  HrPracticeReportCardCadence = 'HR_PRACTICE_REPORT_CARD_CADENCE',
  HrPracticeTrainingActivated = 'HR_PRACTICE_TRAINING_ACTIVATED',
  HrPracticeTrainingPurchase = 'HR_PRACTICE_TRAINING_PURCHASE',
  HrPracticeVoicesActivated = 'HR_PRACTICE_VOICES_ACTIVATED',
  HrPracticeVoicesCadence = 'HR_PRACTICE_VOICES_CADENCE',
  HrPracticeVoicesManuallyDisabled = 'HR_PRACTICE_VOICES_MANUALLY_DISABLED'
}

export type CompanyStatsDto = {
  __typename?: 'CompanyStatsDto';
  activeEmployees: Scalars['Float'];
  totalDocuments: Scalars['Float'];
  totalEmployees: Scalars['Float'];
  totalFeedback: Scalars['Float'];
  totalPolicies: Scalars['Float'];
  totalTrainings: Scalars['Float'];
};

export type CompanyTopicEnrollments = {
  __typename?: 'CompanyTopicEnrollments';
  course: CourseEnrollmentDetails;
  user: CoreUser;
};

export type CompanyTrainingStatsDto = {
  __typename?: 'CompanyTrainingStatsDto';
  activeBundles: Array<TrainingBundleDto>;
  activeEnrollments: Scalars['Float'];
  certificatesIssued: Scalars['Float'];
  completedCourses: Scalars['Float'];
  completionRate: Scalars['Float'];
  topTopics: Array<Scalars['String']>;
  totalEnrollments: Scalars['Float'];
};

/** The type of the company */
export enum CompanyType {
  CCorp = 'CCorp',
  Llc = 'LLC',
  NonProfit = 'NonProfit',
  Other = 'Other',
  Partnership = 'Partnership',
  SCorp = 'SCorp',
  SoleProprietorship = 'SoleProprietorship'
}

export enum CompanyV1EmploymentType {
  /** default behavior is all */
  All = 'All',
  /** A 1099 contractor */
  Contractor = 'Contractor',
  /** A W2 employee */
  W2 = 'W2'
}

export type CompanyWarningsDto = {
  __typename?: 'CompanyWarningsDto';
  totalCount: Scalars['Int'];
  verbal: Array<VerbalWarningDto>;
  written: Array<WrittenWarningDto>;
};

export type CompleteCompanySurveyInput = {
  companyId: Scalars['String'];
  surveyId: Scalars['Float'];
};

export type CompleteGoalInput = {
  completionStatus: GoalCompletionStatus;
  id: Scalars['String'];
};

export type CompletePracticeInput = {
  companyId: Scalars['String'];
  practiceId: Scalars['String'];
};

/** Complete the Report Card for all employees, pending or not */
export type CompleteReportCardInput = {
  /** Report Card Id */
  reportCardId: Scalars['String'];
};

export type CompleteSolutionInput = {
  /** Optional comments about how the solution was resolved */
  resolutionComments?: Maybe<Scalars['String']>;
  /** The ID of the solution to mark as completed */
  solutionId: Scalars['ID'];
};

export type CompleteTaskInput = {
  completionStatus: TaskCompletionStatus;
  id: Scalars['ID'];
};

export type ComplianceDataWithSimilarity = {
  __typename?: 'ComplianceDataWithSimilarity';
  /** Chunk number for this content piece */
  chunk: Scalars['Float'];
  /** The compliance content text */
  content: Scalars['String'];
  /** Creation date */
  createdAt: Scalars['DateTime'];
  /** When the regulation takes effect */
  effectiveDate?: Maybe<Scalars['DateTime']>;
  /** Max employer size for applicability */
  employerSizeMax?: Maybe<Scalars['Float']>;
  /** Min employer size for applicability */
  employerSizeMin?: Maybe<Scalars['Float']>;
  /** When the regulation expires */
  expirationDate?: Maybe<Scalars['DateTime']>;
  /** Compliance data id */
  id: Scalars['ID'];
  /** Whether the source URL is still valid */
  isUrlValid?: Maybe<Scalars['Boolean']>;
  /** Jurisdiction level: federal, state, county, city */
  jurisdictionLevel?: Maybe<Scalars['String']>;
  /** City or county name for sub-state jurisdictions */
  jurisdictionLocality?: Maybe<Scalars['String']>;
  /** Two-letter US state code (e.g., CA, NY) */
  jurisdictionState?: Maybe<Scalars['String']>;
  /** When the content was last updated */
  lastUpdated: Scalars['DateTime'];
  /** Employer obligations */
  obligations?: Maybe<Array<Scalars['String']>>;
  /** Issuing/enforcing agency (e.g., DOL, EEOC) */
  regulationAgency?: Maybe<Scalars['String']>;
  /** Legal citation (e.g., 29 USC §2601) */
  regulationCitation?: Maybe<Scalars['String']>;
  /** Common name of the regulation (e.g., FMLA, ADA) */
  regulationName?: Maybe<Scalars['String']>;
  /** Similarity score (0-1, where 1 is identical) */
  similarity: Scalars['Float'];
  /** Source domain of the compliance content */
  source: Scalars['String'];
  /** Title of the compliance document */
  title: Scalars['String'];
  /** Compliance topic tags */
  topics?: Maybe<Array<Scalars['String']>>;
  /** Total number of chunks for this URL */
  totalChunks: Scalars['Float'];
  /** Source URL of the compliance content */
  url: Scalars['String'];
  /** When the URL was last validated */
  urlLastValidated?: Maybe<Scalars['DateTime']>;
};

export type ComprehensiveGuidanceArtifact = {
  __typename?: 'ComprehensiveGuidanceArtifact';
  /** The download url for the guidance artifact */
  downloadUrl: Scalars['String'];
  /** The download url for the guidance artifact */
  dto: Scalars['String'];
  /** The guidance rendered as HTML */
  html: Scalars['String'];
  /** The id of the guidance artifact */
  id: Scalars['String'];
  /** The status of the guidance artifact */
  status: BestPracticeStatus;
  /** The title of the guidance artifact */
  title: Scalars['String'];
};

export type ConditionalRequired = {
  __typename?: 'ConditionalRequired';
  condition: ConditionalRequiredOperator;
  fields: Array<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type ConditionalRequiredInput = {
  condition: ConditionalRequiredOperator;
  fields: Array<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** Operators for conditional required field validation */
export enum ConditionalRequiredOperator {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR'
}

export type ConfirmMicroDepositInput = {
  depositValues?: Maybe<Array<Scalars['Float']>>;
  descriptorCode?: Maybe<Scalars['String']>;
  paymentMethodId: Scalars['String'];
};

export type ConsumeCreditInput = {
  companyId: Scalars['ID'];
  consumedBy: Scalars['String'];
  productKey: Scalars['String'];
  subKey?: Maybe<Scalars['String']>;
};

export type ContextDto = {
  __typename?: 'ContextDto';
  self: UserContextDto;
  timestamp: Scalars['DateTime'];
};

export type ContextInput = {
  companyId?: Maybe<Scalars['ID']>;
  /** Filters for company data queries */
  filters?: Maybe<CompanyDataFiltersInput>;
  search?: Maybe<SearchInput>;
  userId?: Maybe<Scalars['ID']>;
};

/** User roles in the context system */
export enum ContextUserRole {
  BusinessManager = 'BusinessManager',
  CompanyOwner = 'CompanyOwner',
  CustomerSuccessRepresentative = 'CustomerSuccessRepresentative',
  Default = 'Default',
  Employee = 'Employee',
  ExternalCollaborator = 'ExternalCollaborator',
  God = 'God',
  HrCoordinator = 'HRCoordinator',
  HandbookSpecialist = 'HandbookSpecialist',
  HoneyAdmin = 'HoneyAdmin',
  HrManager = 'HrManager',
  Insurance = 'Insurance',
  OnboardingSpecialist = 'OnboardingSpecialist',
  Partner = 'Partner',
  Sales = 'Sales',
  SalesDevelopmentRepresentative = 'SalesDevelopmentRepresentative',
  User = 'User'
}

export type Conversation = {
  __typename?: 'Conversation';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inBound: Scalars['Boolean'];
  intercomConversationId: Scalars['String'];
  messages: Array<ConversationMessage>;
  subject: Scalars['String'];
};

export type ConversationHistoryInput = {
  afterId?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Int']>;
  userId: Scalars['ID'];
};

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  attachments?: Maybe<Array<ConversationMessageAttachment>>;
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  inBound: Scalars['Boolean'];
};

export type ConversationMessageAttachment = {
  __typename?: 'ConversationMessageAttachment';
  contentType: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ConversationMessageInput = {
  /** Message content */
  content: Scalars['String'];
  /** Message role (user or assistant) */
  role: Scalars['String'];
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  brief: Scalars['String'];
  detailed: Scalars['String'];
  generatedAt: Scalars['DateTime'];
  keyPoints: Array<Scalars['String']>;
  outcomes?: Maybe<Array<Scalars['String']>>;
};

export type CoreActivation = {
  __typename?: 'CoreActivation';
  /** The company ID this activation belongs to. */
  companyId: Scalars['String'];
  /** The date the activation was created. */
  createdAt: Scalars['DateTime'];
  /** Whether the feature is enabled for this company. */
  enabled: Scalars['Boolean'];
  /** The feature key of the activation. */
  key: Scalars['String'];
  /** The date the activation was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The user ID who last updated this activation. */
  updatedBy: Scalars['String'];
};

export type CoreAddress = {
  __typename?: 'CoreAddress';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreAddressInput = {
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreCompany = {
  __typename?: 'CoreCompany';
  address: CoreAddress;
  ai?: Maybe<CompanyAiProfile>;
  companyRoles?: Maybe<Array<CompanyRole>>;
  createdInHexagon: Scalars['Boolean'];
  dba?: Maybe<Scalars['String']>;
  documents: Array<CoreDocument>;
  employees: Array<CoreUser>;
  fein?: Maybe<Scalars['String']>;
  goals: Array<CoreGoal>;
  groups: Array<CoreUserGroup>;
  handsFreeActionItemActivatedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  legalAddress?: Maybe<CoreLegalAddress>;
  logoUrl?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<CoreMailingAddress>;
  name: Scalars['String'];
  numOfContractors?: Maybe<Scalars['Int']>;
  numOfFullTimeHourlyEmployees?: Maybe<Scalars['Int']>;
  numOfFullTimeSalaryEmployees?: Maybe<Scalars['Int']>;
  numOfPartTimeEmployees?: Maybe<Scalars['Int']>;
  onboarding?: Maybe<CoreOnboarding>;
  owner: CoreUser;
  paginatedEmployees: PaginatedCoreUsers;
  payDayOfMonth?: Maybe<Scalars['Int']>;
  payDayOfWeek?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  policies: Array<CorePolicy>;
  tasks: Array<CoreTask>;
  users: Array<CoreUser>;
  website?: Maybe<Scalars['String']>;
  whatBroughtYouToBambee?: Maybe<LeadReason>;
};


export type CoreCompanyEmployeesArgs = {
  active?: Maybe<Scalars['Boolean']>;
  employmentType?: Maybe<CompanyV1EmploymentType>;
};


export type CoreCompanyOnboardingArgs = {
  args: CoreOnboardingVersion;
};


export type CoreCompanyPaginatedEmployeesArgs = {
  active?: Maybe<Scalars['Boolean']>;
  employmentType?: Maybe<CompanyV1EmploymentType>;
  limit?: Scalars['Float'];
  page?: Scalars['Float'];
};


export type CoreCompanyPoliciesArgs = {
  isCPD?: Maybe<Scalars['Boolean']>;
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
  status?: Array<Scalars['String']>;
};


export type CoreCompanyUsersArgs = {
  active?: Maybe<Scalars['Boolean']>;
  employmentType?: Maybe<CompanyV1EmploymentType>;
};

export type CoreCompanyTraining = {
  __typename?: 'CoreCompanyTraining';
  enrolledTopics?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
};

export enum CoreContractorType {
  Business = 'Business',
  Individual = 'Individual'
}

export type CoreDocument = {
  __typename?: 'CoreDocument';
  id: Scalars['ID'];
  name: Scalars['String'];
  policy?: Maybe<CorePolicy>;
  reaffirmations?: Maybe<Array<Scalars['DateTime']>>;
  signature?: Maybe<CoreDocumentSignature>;
  signer?: Maybe<CoreUser>;
};

export type CoreDocumentSignature = {
  __typename?: 'CoreDocumentSignature';
  id: Scalars['ID'];
  requestedAt: Scalars['DateTime'];
  signedAt: Scalars['DateTime'];
  signer?: Maybe<CoreUser>;
  /** @deprecated In favor of signer CoreUser */
  signerId?: Maybe<Scalars['String']>;
  signingOrder?: Maybe<Scalars['Int']>;
};

export enum CoreEmployeeClassification {
  Exempt = 'Exempt',
  NonExempt = 'NonExempt'
}

export enum CoreEmployeePaytype {
  Contractor = 'Contractor',
  Hourly = 'Hourly',
  Salary = 'Salary'
}

export enum CoreEmployeeType {
  Contractor = 'Contractor',
  FullTime = 'FullTime',
  PartTime = 'PartTime'
}

export type CoreGoal = {
  __typename?: 'CoreGoal';
  assignedTo?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completionStatus?: Maybe<GoalCompletionStatus>;
  copy: CoreGoalCopy;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  /** @deprecated Use copy.description instead */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  name: GoalName;
  taskNames: Array<TaskName>;
  tasks: Array<CoreTask>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CoreGoalCopy = {
  __typename?: 'CoreGoalCopy';
  cta: Scalars['String'];
  description: Scalars['String'];
  estimated: Scalars['String'];
};

export type CoreGoalWithTasks = {
  __typename?: 'CoreGoalWithTasks';
  assignedTo?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completionStatus?: Maybe<GoalCompletionStatus>;
  copy: CoreGoalCopy;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  /** @deprecated Use copy.description instead */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  name: GoalName;
  taskNames: Array<TaskName>;
  tasks?: Maybe<Array<CoreTask>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CoreLegalAddress = {
  __typename?: 'CoreLegalAddress';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreLegalAddressInput = {
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreMailingAddress = {
  __typename?: 'CoreMailingAddress';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreMailingAddressInput = {
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CoreOnboarding = {
  __typename?: 'CoreOnboarding';
  /** Company ID of the user who created the Onboarding */
  companyId?: Maybe<Scalars['String']>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime'];
  /** Data for the Onboarding */
  data: CoreOnboardingData;
  /** Unique identifier for the Onboarding */
  id: Scalars['ID'];
  /** Status of the Onboarding */
  status: OnboardingStatus;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime'];
  /** The user who owns the onboarding */
  user: CoreUser;
  /** ID of the user who created the Onboarding */
  userId: Scalars['String'];
  /** The onboarding version */
  version: Scalars['Float'];
};

export type CoreOnboardingData = {
  __typename?: 'CoreOnboardingData';
  /** The company address */
  address?: Maybe<CoreAddress>;
  /** The ID of the call event */
  callEventId?: Maybe<Scalars['String']>;
  /** The legal name of the company */
  companyLegalName?: Maybe<Scalars['String']>;
  /** The name of the company */
  companyName?: Maybe<Scalars['String']>;
  /** The type of company */
  companyType?: Maybe<CompanyType>;
  /** The name of the company */
  discussionTopicDetails?: Maybe<Array<Maybe<DisucssionTopicDetail>>>;
  /** The name of the company */
  discussionTopics?: Maybe<Array<Maybe<DiscussionTopic>>>;
  /** The company FEIN */
  fein?: Maybe<Scalars['String']>;
  /** The company has remote employees */
  hasRemoteEmployees?: Maybe<Scalars['Boolean']>;
  /** The company has a scheduled call */
  hasScheduledCall?: Maybe<Scalars['Boolean']>;
  /** ID used for apollo caching; e.g. userId from parent object */
  id: Scalars['ID'];
  /** The company is incorporated in another state */
  incorporatedInOtherState?: Maybe<Scalars['Boolean']>;
  /** The state the company is incorporated in */
  incorporatedState?: Maybe<StateAbbreviation>;
  /** The user is the owner of the company */
  isOwner?: Maybe<Scalars['Boolean']>;
  /** The company needs help converting contractors */
  needsHelpConvertingContractors?: Maybe<Scalars['Boolean']>;
  /** The next action for the company */
  nextAction?: Maybe<NextOnboardingAction>;
  /** The company does not have an FEIN or does not know it */
  noFeinOrDoesNotKnow?: Maybe<Scalars['Boolean']>;
  /** The number of contractors in the company */
  numOfContractors?: Maybe<Scalars['Float']>;
  /** The number of employees in the company */
  numOfEmployees?: Maybe<Scalars['Float']>;
  /** The user is the primary contact for the company */
  primaryContact?: Maybe<Scalars['Boolean']>;
  /** The progress the company has made through onboarding */
  progress?: Maybe<Scalars['Float']>;
  /** The states the company has remote workers in */
  remoteWorkerStates?: Maybe<Array<Maybe<StateAbbreviation>>>;
  /** The company will have additional contacts */
  willHaveAdditionalContact?: Maybe<Scalars['Boolean']>;
};

export type CoreOnboardingDataInput = {
  /** The company address */
  address?: Maybe<CoreAddressInput>;
  /** The ID of the call event */
  callEventId?: Maybe<Scalars['String']>;
  /** The legal name of the company */
  companyLegalName?: Maybe<Scalars['String']>;
  /** The name of the company */
  companyName?: Maybe<Scalars['String']>;
  /** The type of company */
  companyType?: Maybe<CompanyType>;
  /** The name of the company */
  discussionTopicDetails?: Maybe<Array<Maybe<DisucssionTopicDetailInput>>>;
  /** The name of the company */
  discussionTopics?: Maybe<Array<Maybe<DiscussionTopic>>>;
  /** The company FEIN */
  fein?: Maybe<Scalars['String']>;
  /** The company has remote employees */
  hasRemoteEmployees?: Maybe<Scalars['Boolean']>;
  /** The company has a scheduled call */
  hasScheduledCall?: Maybe<Scalars['Boolean']>;
  /** ID used for apollo caching; e.g. userId from parent object */
  id?: Maybe<Scalars['ID']>;
  /** The company is incorporated in another state */
  incorporatedInOtherState?: Maybe<Scalars['Boolean']>;
  /** The state the company is incorporated in */
  incorporatedState?: Maybe<StateAbbreviation>;
  /** The user is the owner of the company */
  isOwner?: Maybe<Scalars['Boolean']>;
  /** The company needs help converting contractors */
  needsHelpConvertingContractors?: Maybe<Scalars['Boolean']>;
  /** The next action for the company */
  nextAction?: Maybe<NextOnboardingAction>;
  /** The company does not have an FEIN or does not know it */
  noFeinOrDoesNotKnow?: Maybe<Scalars['Boolean']>;
  /** The number of contractors in the company */
  numOfContractors?: Maybe<Scalars['Float']>;
  /** The number of employees in the company */
  numOfEmployees?: Maybe<Scalars['Float']>;
  /** The user is the primary contact for the company */
  primaryContact?: Maybe<Scalars['Boolean']>;
  /** The progress the company has made through onboarding */
  progress?: Maybe<Scalars['Float']>;
  /** The states the company has remote workers in */
  remoteWorkerStates?: Maybe<Array<Maybe<StateAbbreviation>>>;
  /** The company will have additional contacts */
  willHaveAdditionalContact?: Maybe<Scalars['Boolean']>;
};

export type CoreOnboardingInput = {
  /** Company ID of the user who created the Onboarding */
  companyId?: Maybe<Scalars['String']>;
  /** Data for the Onboarding */
  data: CoreOnboardingDataInput;
  /** Unique identifier for the Onboarding */
  id?: Maybe<Scalars['ID']>;
  /** Status of the Onboarding */
  status: OnboardingStatus;
  /** ID of the user who created the Onboarding */
  userId: Scalars['String'];
  /** The onboarding version */
  version: Scalars['Float'];
};

export type CoreOnboardingKeys = {
  /** ID of the user who created the Onboarding */
  userId: Scalars['String'];
  /** The onboarding version */
  version?: Maybe<Scalars['Float']>;
};

export type CoreOnboardingVersion = {
  /** The onboarding version */
  version: Scalars['Float'];
};

export type CorePageInfo = {
  __typename?: 'CorePageInfo';
  /** Cursor to continue from (null if no more pages) */
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type CorePlanChangeInvoice = {
  __typename?: 'CorePlanChangeInvoice';
  /** Tax amount charged for the invoice */
  tax: Scalars['Float'];
  /** Total amount charged for the invoice */
  total: Scalars['Float'];
};

/** A model representing the core plan details. */
export type CorePlanModel = {
  __typename?: 'CorePlanModel';
  /** Indicates if the plan is annual. */
  annual?: Maybe<Scalars['Boolean']>;
  /** The billing feature of the plan. */
  billingFeature?: Maybe<BillingFeature>;
  /** Billing period for the plan. */
  billingPeriod: BillingPeriod;
  /** Indicates if the plan is chat-only. */
  chatOnly?: Maybe<Scalars['Boolean']>;
  /** Indicates if the plan is configured to collect taxes. */
  collectTax: Scalars['Boolean'];
  /** Commitment term length in months, if any. */
  commitmentMonths?: Maybe<Scalars['Float']>;
  /** Contract period for the plan, if applicable. */
  contractPeriod?: Maybe<BillingPeriod>;
  /**
   * DRP (Disaster Recovery Plan) identifier, if applicable.
   * @deprecated Feature has been removed but we still support subscriptions with these plans
   */
  drp?: Maybe<Scalars['String']>;
  /** Mapping of the plan to the size of the employee base. */
  employeeSizeMapping?: Maybe<Scalars['String']>;
  /** Indicates if the plan is for internal use only. */
  internal: Scalars['Boolean'];
  legacyProductKey?: Maybe<ProductKey>;
  /** Maximum size of the employee base for this plan. */
  maxSize?: Maybe<Scalars['Float']>;
  /** Minimum size of the employee base for this plan. */
  minSize?: Maybe<Scalars['Float']>;
  /** Monthly price of the plan. */
  monthlyPrice: Scalars['Float'];
  /** Name of the plan. */
  name: Scalars['String'];
  /** Partner associated with the plan, if any. */
  partner?: Maybe<Scalars['String']>;
  /** Indicates if the plan can be paused. */
  pause?: Maybe<Scalars['Boolean']>;
  /** Plan follows the annual phased schedule. */
  phasedAnnual?: Maybe<Scalars['Boolean']>;
  /** Total price of the plan. */
  price: Scalars['Float'];
  /** Price identifier in Stripe. */
  priceId: Scalars['String'];
  /** The product key associated to the plan object (Lite, Dedicated, Plus, Elite). */
  productKey: ProductKey;
  /** Indicates if the plan is regulated. */
  regulated: Scalars['Boolean'];
  /** The service key associated to the plan object (always Core here). */
  serviceKey: ServiceKey;
  /** Initial setup fee for the plan. */
  setupFee?: Maybe<Scalars['Float']>;
  /** Discount on the setup fee, if applicable. */
  setupFeeDiscount?: Maybe<Scalars['Float']>;
  /** Current status of the plan. */
  status: PlanStatuses;
  /** Tier number of the plan. */
  tierNumber?: Maybe<Scalars['Float']>;
  /** Value proposition of the plan. */
  value: Scalars['String'];
  /** Version of the plan. */
  version: Scalars['String'];
  /** Indicates if the plan pricing is based on volume. */
  volumeBased?: Maybe<Scalars['Boolean']>;
};

export type CorePolicy = {
  __typename?: 'CorePolicy';
  /** Timestamp set when a policy is archived */
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  icon: Scalars['String'];
  id: Scalars['ID'];
  isCPD: Scalars['Boolean'];
  isContractor: Scalars['Boolean'];
  name: Scalars['String'];
  notSentTo: Array<CoreUser>;
  recipients: Array<CorePolicyRecipient>;
  status: Scalars['String'];
  step?: Maybe<PolicyStepNames>;
};

export type CorePolicyRecipient = {
  __typename?: 'CorePolicyRecipient';
  document: CoreDocument;
  employee: CoreUser;
  id: Scalars['ID'];
};

export type CoreRecommendation = {
  __typename?: 'CoreRecommendation';
  /** Permitted types of reactions */
  allowedReactions: Array<ReactionType>;
  /** ID of the company for which the recommendation is made */
  companyId?: Maybe<Scalars['String']>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime'];
  /** Demographic target of the recommendation */
  demographic?: Maybe<RecommendationDemographic>;
  /** Expiration timestamp */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the recommendation */
  id: Scalars['ID'];
  /** Note about the recommendation */
  note?: Maybe<Scalars['String']>;
  /** Roles allowed to react */
  reactorRoles: Array<Scalars['String']>;
  /** Timestamps of recommendation */
  recommendedAt: Array<Scalars['String']>;
  /** ID of the recommended resource */
  resourceId: Scalars['String'];
  /** Type of recommended resource */
  resourceType: Scalars['String'];
  /** The scope of the recommendation */
  scope: RecommendationScope;
  /** Status of the recommendation */
  status: RecommendationStatus;
  /** List of targets for the recommendation */
  targets: Array<Scalars['String']>;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime'];
  user: CoreUser;
  /** ID of the user who created the recommendation */
  userId: Scalars['String'];
};

export type CoreRequest = {
  __typename?: 'CoreRequest';
  /** The number of approvals required to approve the request. */
  approvalCriteria: Scalars['Int'];
  /** The roles of the decision makers. */
  approverRoles?: Maybe<Array<Maybe<AuthRole>>>;
  /** The company id of the employee requesting training. */
  companyId: Scalars['String'];
  /** The date the request was created. */
  createdAt: Scalars['DateTime'];
  decisions?: Maybe<Array<Maybe<CoreRequestDecision>>>;
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The date the request was expired. Null if the request does not expire */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** The id of the request. */
  id: Scalars['ID'];
  /** The number of rejections required to reject the request. */
  rejectionCriteria: Scalars['Int'];
  /** The dates the request was requested at. */
  requestedAt: Array<Scalars['DateTime']>;
  /** The id of the resource. */
  resourceId: Scalars['String'];
  /** The resource type of the request. */
  resourceType: RequestResourceType;
  /** The status of the request. */
  status: RequestStatus;
  /** The date the request was last updated. */
  updatedAt: Scalars['DateTime'];
  user: CoreUser;
  /** The user id of the employee requesting training. */
  userId: Scalars['String'];
};

export type CoreRequestDecision = {
  __typename?: 'CoreRequestDecision';
  /** The date the decision was created. */
  createdAt: Scalars['DateTime'];
  /** The id of the decision. */
  id: Scalars['ID'];
  /** The id of the request. */
  requestId: Scalars['String'];
  /** The result of the decision. */
  result: ApprovalResult;
  /** The role of the decision maker. */
  role: AuthRole;
  /** The date the decision was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The user id of the decision maker. */
  userId: Scalars['String'];
};

export type CoreSubscriptionModel = {
  __typename?: 'CoreSubscriptionModel';
  /** Subscription Status */
  active: Scalars['Boolean'];
  /** True when there is a pending cancellation request */
  cancellationRequested: Scalars['Boolean'];
  /** A scheduled date for when the subscription will be canceled */
  cancelsAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the subscription. */
  id: Scalars['ID'];
  /** Date when the current period will end */
  periodEndsAt: Scalars['DateTime'];
  plan: CorePlanModel;
  /** The billing system this core subscription is billed in: STRIPE or RECURLY. */
  provider: BillingProvider;
  /** The quantity of the plan to which the customer is subscribed to. */
  quantity?: Maybe<Scalars['Float']>;
  /** Scheduled plan change, if any. */
  scheduledPlanChange?: Maybe<ScheduledCorePlanChangeModel>;
  /** The core subscription's state, for example ACTIVE, PAST_DUE or PAUSED. Set for Recurly-billed subscriptions. Null for Stripe-billed subscriptions: use `active` and `trialing` for those. */
  state?: Maybe<SubscriptionState>;
  /** Date when the subscription trial will end */
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  /** True if they are actively trialing */
  trialing: Scalars['Boolean'];
};

export type CoreTask = {
  __typename?: 'CoreTask';
  assignedTo?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completionStatus?: Maybe<TaskCompletionStatus>;
  copy: CoreTaskCopy;
  /** @deprecated Tasks will not have descriptions. */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  name: TaskName;
  startedAt?: Maybe<Scalars['DateTime']>;
  startedBy?: Maybe<Scalars['String']>;
};

export type CoreTaskCopy = {
  __typename?: 'CoreTaskCopy';
  confirmCta?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  denyCta?: Maybe<Scalars['String']>;
  details?: Maybe<Array<CoreTaskCopyDetails>>;
  estimated?: Maybe<Scalars['String']>;
};

export type CoreTaskCopyDetails = {
  __typename?: 'CoreTaskCopyDetails';
  items: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type CoreUser = {
  __typename?: 'CoreUser';
  active: Scalars['Boolean'];
  chat: CoreUserChatConfig;
  company?: Maybe<CoreCompany>;
  createdAt: Scalars['DateTime'];
  documents?: Maybe<Array<CoreDocument>>;
  employment?: Maybe<CoreUserEmployment>;
  feedback: Array<FeedbackHistory>;
  groups: Array<CoreUserGroup>;
  id: Scalars['ID'];
  permissions?: Maybe<CoreUserPermissions>;
  profile?: Maybe<CoreUserProfile>;
  role: Scalars['String'];
  roles: Array<Scalars['String']>;
  settings?: Maybe<CoreUserSettings>;
  states?: Maybe<CoreUserStates>;
  timeZone: Scalars['String'];
  training?: Maybe<CoreUserTraining>;
};


export type CoreUserFeedbackArgs = {
  count?: Maybe<Scalars['Int']>;
};

export type CoreUserChatConfig = {
  __typename?: 'CoreUserChatConfig';
  token?: Maybe<Scalars['String']>;
};

export type CoreUserEmployment = {
  __typename?: 'CoreUserEmployment';
  classification?: Maybe<CoreEmployeeClassification>;
  contractorBusinessName?: Maybe<Scalars['String']>;
  contractorType?: Maybe<CoreContractorType>;
  directReports: Array<CoreUser>;
  employeeType?: Maybe<CoreEmployeeType>;
  hoursPerWeek?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isContractor?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<CoreUser>;
  payDay?: Maybe<Scalars['String']>;
  payFrequency?: Maybe<Scalars['String']>;
  payRate?: Maybe<Scalars['String']>;
  payType?: Maybe<CoreEmployeePaytype>;
  startDate?: Maybe<Scalars['String']>;
  stateWorksIn?: Maybe<Scalars['String']>;
  supervisor: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  workerRoles: Array<WorkerRole>;
};


export type CoreUserEmploymentWorkerRolesArgs = {
  showDeleted?: Maybe<Scalars['Boolean']>;
};

export type CoreUserEmploymentInput = {
  classification?: Maybe<CoreEmployeeClassification>;
  contractorBusinessName?: Maybe<Scalars['String']>;
  contractorType?: Maybe<CoreContractorType>;
  employeeType?: Maybe<CoreEmployeeType>;
  hoursPerWeek?: Maybe<Scalars['String']>;
  isContractor?: Maybe<Scalars['Boolean']>;
  payDay?: Maybe<Scalars['String']>;
  payFrequency?: Maybe<Scalars['String']>;
  payRate?: Maybe<Scalars['String']>;
  payType?: Maybe<CoreEmployeePaytype>;
  startDate?: Maybe<Scalars['DateTime']>;
  stateWorksIn?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CoreUserGroup = {
  __typename?: 'CoreUserGroup';
  id: Scalars['ID'];
  members: Array<CoreUser>;
  name: Scalars['String'];
  ownerId?: Maybe<Scalars['ID']>;
  type: CoreUserGroupType;
};

export enum CoreUserGroupType {
  Admin = 'Admin',
  Contractors = 'Contractors',
  Custom = 'Custom',
  Employees = 'Employees',
  Managers = 'Managers',
  ManagersWithReports = 'ManagersWithReports'
}

export type CoreUserPermissions = {
  __typename?: 'CoreUserPermissions';
  approver: Scalars['Boolean'];
  canCancelAccount: Scalars['Boolean'];
  canEditGlobalPolicies: Scalars['Boolean'];
  canRetractSignedPolicies: Scalars['Boolean'];
  canViewPayrollTab: Scalars['Boolean'];
  id: Scalars['ID'];
  manager: Scalars['Boolean'];
};

export type CoreUserProfile = {
  __typename?: 'CoreUserProfile';
  address?: Maybe<CoreAddress>;
  avatarUrl?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emergencyContact?: Maybe<CoreUserProfileEmergencyContact>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  topPerformer?: Maybe<TopPerformer>;
};

export type CoreUserProfileEmergencyContact = {
  __typename?: 'CoreUserProfileEmergencyContact';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};

export type CoreUserProfileEmergencyContactInput = {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};

export type CoreUserProfileInput = {
  address?: Maybe<CoreAddressInput>;
  dob?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<CoreUserProfileEmergencyContactInput>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  topPerformer?: Maybe<TopPerformerInput>;
};

export type CoreUserSettings = {
  __typename?: 'CoreUserSettings';
  calendlySlug?: Maybe<Scalars['String']>;
  hrEmailAlias?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intercomEmail?: Maybe<Scalars['String']>;
  intercomUserId?: Maybe<Scalars['Int']>;
  pandaContactId?: Maybe<Scalars['String']>;
  salesforceContactId?: Maybe<Scalars['String']>;
  salesforceUserId?: Maybe<Scalars['String']>;
  slackUserId?: Maybe<Scalars['String']>;
  vonageExtension?: Maybe<Scalars['String']>;
  vonageNumber?: Maybe<Scalars['String']>;
  zendeskEmail?: Maybe<Scalars['String']>;
  zendeskOrgMembershipId?: Maybe<Scalars['Int']>;
  zendeskUserId?: Maybe<Scalars['Int']>;
};

export type CoreUserStates = {
  __typename?: 'CoreUserStates';
  emailNotification: Scalars['Boolean'];
  id: Scalars['ID'];
  interestedInPersonalInsurance: Scalars['Boolean'];
  onboardRequest: Scalars['Boolean'];
  onboarded: Scalars['Boolean'];
  resignationLastDate?: Maybe<Scalars['DateTime']>;
  resignationStatus?: Maybe<Scalars['String']>;
  selfSignupActivated: Scalars['Boolean'];
  selfSignupRegistered: Scalars['Boolean'];
  terminated: Scalars['Boolean'];
  terminationRequest: Scalars['Boolean'];
  viewedBciToHrPracticeModal: Scalars['Boolean'];
  viewedBciToHrPracticeReportCardModal: Scalars['Boolean'];
  viewedCovid: Scalars['Boolean'];
  viewedInAppUpgradeModal: Scalars['Boolean'];
  viewedInsuranceIntroduction: Scalars['Boolean'];
  viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>;
  viewedPersonalInsurance: Scalars['Boolean'];
  viewedTaskCenter: Scalars['Boolean'];
  viewedVideoTourBusinessHealth: Scalars['Boolean'];
  viewedVideoTourCabinet: Scalars['Boolean'];
  viewedVideoTourPolicy: Scalars['Boolean'];
  viewedVideoTourReportCards: Scalars['Boolean'];
  viewedVideoTourStaffFolder: Scalars['Boolean'];
};

export type CoreUserStatesInput = {
  emailNotification?: Maybe<Scalars['Boolean']>;
  interestedInPersonalInsurance?: Maybe<Scalars['Boolean']>;
  onboardRequest?: Maybe<Scalars['Boolean']>;
  onboarded?: Maybe<Scalars['Boolean']>;
  resignationLastDate?: Maybe<Scalars['DateTime']>;
  resignationStatus?: Maybe<Scalars['String']>;
  selfSignupActivated?: Maybe<Scalars['Boolean']>;
  selfSignupRegistered?: Maybe<Scalars['Boolean']>;
  terminated?: Maybe<Scalars['Boolean']>;
  terminationRequest?: Maybe<Scalars['Boolean']>;
  viewedBciToHrPracticeModal?: Maybe<Scalars['Boolean']>;
  viewedBciToHrPracticeReportCardModal?: Maybe<Scalars['Boolean']>;
  viewedCovid?: Maybe<Scalars['Boolean']>;
  viewedInAppUpgradeModal?: Maybe<Scalars['Boolean']>;
  viewedInsuranceIntroduction?: Maybe<Scalars['Boolean']>;
  viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>;
  viewedPersonalInsurance?: Maybe<Scalars['Boolean']>;
  viewedTaskCenter?: Maybe<Scalars['Boolean']>;
  viewedVideoTourBusinessHealth?: Maybe<Scalars['Boolean']>;
  viewedVideoTourCabinet?: Maybe<Scalars['Boolean']>;
  viewedVideoTourPolicy?: Maybe<Scalars['Boolean']>;
  viewedVideoTourReportCards?: Maybe<Scalars['Boolean']>;
  viewedVideoTourStaffFolder?: Maybe<Scalars['Boolean']>;
};

export type CoreUserTraining = {
  __typename?: 'CoreUserTraining';
  enrolledTopics: Array<UserCourseTopic>;
  id?: Maybe<Scalars['ID']>;
};

export enum CoreUserViewedOnboardingInstructions {
  FirstTime = 'FirstTime',
  LastTime = 'LastTime'
}

export type CorrectiveActionArtifact = {
  __typename?: 'CorrectiveActionArtifact';
  /** The ID of the salesforce case associated with the corrective action */
  caseId: Scalars['String'];
  /** The ID of the document associated with the corrective action */
  documentId: Scalars['String'];
  /** The ID of the employee the corrective action is for */
  employeeId: Scalars['String'];
  /** The name of the employee the corrective action is for */
  employeeName: Scalars['String'];
  /** The corrective action render as a rich HTML document. */
  html: Scalars['String'];
  /** The id of the corrective action after accepted and persisted into the system. */
  id?: Maybe<Scalars['String']>;
  /** Whether this is a final written warning */
  isFinal: Scalars['Boolean'];
  /** The status of the corrective action */
  status: BestPracticeStatus;
  /** The title of the document */
  title: Scalars['String'];
  /** The type of corrective action */
  type: CorrectiveActionType;
};

export type CorrectiveActionFiltersInput = {
  /** Limit number of results */
  limit?: Maybe<Scalars['Int']>;
  /** Filter by creation date - return items created after this date */
  since?: Maybe<Scalars['DateTime']>;
  /** Filter by status (e.g., active, completed, archived) */
  status?: Maybe<Scalars['String']>;
  /** Filter by type (e.g., pip, verbal_warning, written_warning) */
  type?: Maybe<Scalars['String']>;
};

export enum CorrectiveActionType {
  PerformanceImprovementPlan = 'performanceImprovementPlan',
  Unknown = 'unknown',
  VerbalWarning = 'verbalWarning',
  WrittenWarning = 'writtenWarning'
}

export type CourseEnrollmentDetails = {
  __typename?: 'CourseEnrollmentDetails';
  courseId: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  ticketId: Scalars['ID'];
};

export enum CourseRole {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type CourseTopic = {
  __typename?: 'CourseTopic';
  /** The topic description */
  description?: Maybe<Scalars['String']>;
  /** The topic duration e.g. play time */
  duration?: Maybe<Scalars['Int']>;
  /** Helpers for fields that will commonly be used for filtering topics */
  filterHelpers?: Maybe<CourseTopicFilterHelpers>;
  /** The topic id */
  id: Scalars['String'];
  /** The topic image url */
  imageUrl?: Maybe<Scalars['String']>;
  /** List of industries */
  industries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The topic key used to sync with external systems */
  key: Scalars['String'];
  /** The topic name */
  name: Scalars['String'];
  /** The topic price */
  price?: Maybe<Scalars['Float']>;
  /** List of roles with specific course content for the topic */
  roles?: Maybe<Array<Maybe<CourseRole>>>;
  /**
   * deprecated search tag
   * @deprecated use key instead
   */
  searchTag?: Maybe<Scalars['String']>;
  /** List of states that the topic has state specific course content */
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of search tags */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CourseTopicFilterHelpers = {
  __typename?: 'CourseTopicFilterHelpers';
  /** Whether this topic offers a manager specific course */
  hasManagerCourse?: Maybe<Scalars['Boolean']>;
  /** Whether this topic offers a course version in Spanish */
  hasSpanish?: Maybe<Scalars['Boolean']>;
  /** States for which this topic offers a specific course for */
  states?: Maybe<Array<Scalars['String']>>;
};

export enum CoverageActivationEvent {
  Adopted = 'ADOPTED',
  AuditCompleted = 'AUDIT_COMPLETED',
  BuildShown = 'BUILD_SHOWN',
  CheckoutSettled = 'CHECKOUT_SETTLED',
  ChoseHandbook = 'CHOSE_HANDBOOK',
  ChosePaid = 'CHOSE_PAID',
  Finished = 'FINISHED',
  InvitesHandled = 'INVITES_HANDLED',
  InviteSkipped = 'INVITE_SKIPPED',
  Provisioned = 'PROVISIONED',
  RevealSeen = 'REVEAL_SEEN',
  TeamConfirmed = 'TEAM_CONFIRMED',
  UpgradeDecided = 'UPGRADE_DECIDED'
}

export type CoverageActivationSnapshot = {
  __typename?: 'CoverageActivationSnapshot';
  state: CoverageActivationState;
  upgradeDecided: Scalars['Boolean'];
  variant: CoverageActivationVariant;
};

export enum CoverageActivationState {
  Audit = 'AUDIT',
  Checkout = 'CHECKOUT',
  Completed = 'COMPLETED',
  Done = 'DONE',
  HandbookBuilding = 'HANDBOOK_BUILDING',
  HandbookReview = 'HANDBOOK_REVIEW',
  Invite = 'INVITE',
  Plans = 'PLANS',
  Provisioning = 'PROVISIONING',
  Results = 'RESULTS',
  Reveal = 'REVEAL',
  TeamConfirm = 'TEAM_CONFIRM'
}

export enum CoverageActivationVariant {
  EliteMigration = 'ELITE_MIGRATION',
  LegacyMigration = 'LEGACY_MIGRATION',
  PremiumTrial = 'PREMIUM_TRIAL',
  Standard = 'STANDARD'
}

export type CreateBundleInput = {
  /** Core Company ID to associate with the bundle. If not provided, the bundle will be global */
  companyId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  name: Scalars['String'];
  topicIds: Array<Scalars['String']>;
};

export type CreateCancellationRequestInput = {
  /** A list of plan values that were offered in order to prevent the cancellation (downgrade, pause, storage) */
  cancellationOffers?: Maybe<Array<Scalars['String']>>;
  /** Additional details if "Other" reason is chosen */
  clientOtherReasonNote?: Maybe<Scalars['String']>;
  /** A note from the client about why they requested the cancellation */
  clientReasonNote?: Maybe<Scalars['String']>;
  /** The company ID */
  companyId: Scalars['String'];
  /** A note from a Bambee user about */
  internalReasonNote?: Maybe<Scalars['String']>;
  /** The list of reason codes chosen by the requestor */
  reasonCodes: Array<Scalars['Float']>;
  /** Actual user requesting the cancellation, usually the company owner */
  requestedBy: Scalars['String'];
  /** When the cancellation request was made, defaults to "now" */
  requestedDate?: Maybe<Scalars['DateTime']>;
  /** Send email about the cancellation request */
  requestedEmail?: Maybe<Scalars['Boolean']>;
  /** The cancellation wizard session ID */
  sessionId?: Maybe<Scalars['String']>;
  /** The company ID */
  source?: Maybe<CancellationSource>;
};

export type CreateCompanyCpDsInput = {
  /** Company ID to create CPDs for */
  companyId: Scalars['ID'];
};

export type CreateEmployeeInput = {
  companyId?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  isContractor?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  payAmount: Scalars['Float'];
  payType: CoreEmployeePaytype;
  phone?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  stateWorkIn?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateHrRequestByInternalUserInput = {
  autoRespond?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  description: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  origin?: Maybe<HrRequestOrigin>;
  originFeature?: Maybe<Scalars['String']>;
  subType?: Maybe<HrRequestSubType>;
  subject: Scalars['String'];
  type: HrRequestType;
};

export type CreateHrRequestFromSalesforceCaseInput = {
  message?: Maybe<Scalars['String']>;
  salesforceCaseId: Scalars['String'];
};

export type CreateHrRequestInput = {
  aiArtifacts?: Maybe<Array<Scalars['String']>>;
  aiGenerated?: Maybe<Scalars['Boolean']>;
  answers?: Maybe<Scalars['String']>;
  autoRespond?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  chatNow: Scalars['Boolean'];
  description: Scalars['String'];
  origin?: Maybe<HrRequestOrigin>;
  originFeature?: Maybe<Scalars['String']>;
  subType?: Maybe<HrRequestSubType>;
  subject: Scalars['String'];
  /** ID of the Assistants API thread used to generate the Policy HR Request */
  threadId?: Maybe<Scalars['String']>;
  type: HrRequestType;
};

export type CreateHrRequestsFromIntercomConversationsInput = {
  intercomConversationIds: Array<Scalars['String']>;
};

export type CreateImageReferenceBatchInput = {
  /** Array of images to create in batch */
  images: Array<CreateImageReferenceInput>;
};

export type CreateImageReferenceInput = {
  /** Base64 encoded image file */
  base64: Scalars['String'];
  /** Description of the image */
  description: Scalars['String'];
  /** File name */
  fileName: Scalars['String'];
  /** MIME type of the file */
  fileType: Scalars['String'];
  /** Keywords for searching */
  keywords: Array<Scalars['String']>;
  /** Logical name of the image */
  name: Scalars['String'];
  /** Use cases for the image */
  useCases: Array<Scalars['String']>;
  /** Version of the image set (e.g., "v1", "v2", "holiday-2024") */
  version?: Scalars['String'];
};

export type CreateImageReferenceMetadataBatchInput = {
  /** Array of image metadata to create in batch */
  images: Array<CreateImageReferenceMetadataInput>;
  /** Update existing records if name/version combination already exists */
  upsert?: Scalars['Boolean'];
};

export type CreateImageReferenceMetadataInput = {
  /** Description of the image */
  description: Scalars['String'];
  /** File size in bytes */
  fileSize?: Maybe<Scalars['Int']>;
  /** MIME type of the file */
  fileType: Scalars['String'];
  /** Keywords for searching */
  keywords: Array<Scalars['String']>;
  /** Logical name of the image */
  name: Scalars['String'];
  /** S3 bucket name (DEPRECATED: Bucket is determined by environment) */
  s3Bucket?: Maybe<Scalars['String']>;
  /** S3 key where image is already stored (DEPRECATED: This will be auto-generated) */
  s3Key: Scalars['String'];
  /** Use cases for the image */
  useCases: Array<Scalars['String']>;
  /** Version of the image set (e.g., "v1", "v2", "holiday-2024") */
  version?: Scalars['String'];
};

export type CreateJobDescriptionInput = {
  body: Scalars['JSON'];
  title: Scalars['String'];
};

export type CreateManyNoticesInput = {
  /** Array of notices to create */
  notices: Array<CreateNoticeInput>;
};

export type CreateMultipleRolesForCompanyInput = {
  /** Bambee Core Company id */
  companyId: Scalars['ID'];
  /** Bambee Core Company Role title */
  titles: Array<Scalars['String']>;
};

export type CreateNoticeInput = {
  badge?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  headline?: Maybe<Scalars['String']>;
  version?: Scalars['String'];
  visualization?: Maybe<VisualizationDataInput>;
};

export type CreatePlanLockInput = {
  active: Scalars['Boolean'];
  companyId: Scalars['String'];
  couponId: Scalars['String'];
  plan: Scalars['String'];
  setupFee: Scalars['Float'];
  trialDuration: Scalars['Float'];
};

export type CreatePremiumPeopleAddonInput = {
  /** Company to create the add-on for. Defaults to the caller's company when omitted. */
  companyId?: Maybe<Scalars['String']>;
  /** Number of free trial days before the first add-on invoice. Bills immediately when omitted. */
  trialPeriodDays?: Maybe<Scalars['Int']>;
};

export type CreateProductInterestInput = {
  productKey: ProductKey;
  productSubKey?: Maybe<ProductSubKey>;
};

export type CreateQuestionStoreBatchInput = {
  /** Array of questions to create in batch */
  questions: Array<CreateQuestionStoreInput>;
};

export type CreateQuestionStoreInput = {
  /** The answer text */
  answer?: Maybe<Scalars['String']>;
  /** Role of the user who answered (owner, admin, employee) */
  answeredByRole?: Maybe<Scalars['String']>;
  /** Date after which the question can be asked again */
  askAfter?: Maybe<Scalars['DateTime']>;
  /** Company id */
  companyId: Scalars['ID'];
  /** Date when the question was answered */
  dateAnswered: Scalars['DateTime'];
  /** The question text */
  question: Scalars['String'];
  /** Source of the question (app, intercom, phone) */
  source?: Maybe<Scalars['String']>;
  /** User id who answered the question */
  userId?: Maybe<Scalars['ID']>;
};

export type CreateRealTimeThreadInput = {
  /** Owning assistant (BambeeAssistant name) for AI-chat threads; used to route unnamed continues */
  assistant?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  threadType?: Maybe<ThreadType>;
  title?: Maybe<Scalars['String']>;
  voiceType?: Maybe<Scalars['String']>;
};

export type CreateReportCardInput = {
  companyId: Scalars['String'];
};

/** Open a ResolutionCycle from Talk-to-Bambee Send Request (BIO-575). Spins up a Salesforce Case and persists the cycle so the Smart Resolution surface can render it. */
export type CreateResolutionCycleInput = {
  /** Modal intake answers serialized as a JSON string */
  answers?: Maybe<Scalars['String']>;
  /** Optional category tag from the Request Modal (card.id) for SF routing/analytics */
  category?: Maybe<Scalars['String']>;
  /** Override target company id — only honored for Bambee internal users */
  companyId?: Maybe<Scalars['String']>;
  /** Salesforce Case description (user-entered body, may include intake answers) */
  description: Scalars['String'];
  /** Client-supplied idempotency key. Reusing it on a retry/double-submit returns the existing cycle instead of creating a duplicate HR Request + cycle. */
  idempotencyKey?: Maybe<Scalars['String']>;
  /** Optional HrRequestSubType for the HR Request */
  subType?: Maybe<Scalars['String']>;
  /** Salesforce Case subject (typically the Request Modal card title) */
  subject: Scalars['String'];
  /** HrRequestType for the HR Request task-service will create (e.g. EMPLOYEE_RELATIONS) */
  type: Scalars['String'];
};

export type CreateRoleForCompanyInput = {
  /** Bambee Core Company id */
  companyId: Scalars['ID'];
  /** Bambee Core Company Role title */
  title: Scalars['String'];
};

export type CreateVoicesFeedbackInput = {
  anonymous: Scalars['Boolean'];
  feedback: Scalars['String'];
  satisfactionRatingOfFive?: Maybe<Scalars['Float']>;
};

export type CreateWizardGroupInput = {
  /** Internal description for Honey users */
  description: Scalars['String'];
  /** Customer-facing description */
  displayDescription: Scalars['String'];
  /** Customer-facing title */
  displayTitle: Scalars['String'];
  /** Internal name for Honey users */
  name: Scalars['String'];
};

export type CreateWizardInput = {
  allowBack: Scalars['Boolean'];
  companyId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  destination: WizardDestination;
  errorMessage?: Maybe<Scalars['String']>;
  progressType: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
  showProgress: Scalars['Boolean'];
  source: WizardSource;
  steps: Array<WizardStepInput>;
  successMessage?: Maybe<Scalars['String']>;
  successTitle?: Maybe<Scalars['String']>;
  threadId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<WizardType>;
  userId?: Maybe<Scalars['String']>;
  version: Scalars['String'];
  voiceInteraction?: Maybe<Scalars['Boolean']>;
};

export type CreateWizardTemplateInput = {
  /** Description for the wizard */
  description?: Maybe<Scalars['String']>;
  /** Optional destination for the wizard */
  destination?: Maybe<WizardDestination>;
  /** Error message shown on wizard error */
  errorMessage?: Maybe<Scalars['String']>;
  /** Optional prompt for AI generation */
  prompt?: Maybe<Scalars['String']>;
  questions: Array<CreateWizardTemplateQuestionInput>;
  role: WizardRole;
  /** Success message shown after wizard completion */
  successMessage?: Maybe<Scalars['String']>;
  /** Success title shown after wizard completion */
  successTitle?: Maybe<Scalars['String']>;
  /** Title for the wizard */
  title?: Maybe<Scalars['String']>;
  /** Complete wizard template data */
  wizardData?: Maybe<Scalars['JSON']>;
  wizardGroupId: Scalars['ID'];
};

export type CreateWizardTemplateQuestionInput = {
  question: Scalars['String'];
  type: QuestionType;
};

export type CreateWizardWithResponsesInput = {
  /** Optional starting step ID (calculated if not provided) */
  currentStepId?: Maybe<Scalars['String']>;
  /** Optional initial responses keyed by question name */
  initialResponses?: Maybe<Scalars['JSON']>;
  /** Whether to validate responses against wizard structure */
  validateResponses?: Scalars['Boolean'];
  wizard: CreateWizardInput;
};

export type CreateWorkerRoleInput = {
  companyRoleId?: Maybe<Scalars['ID']>;
  isPrimary: Scalars['Boolean'];
  newCompanyRole?: Maybe<CreateRoleForCompanyInput>;
  payRate: Scalars['Float'];
  payType: WorkerRolePaytype;
  /** Bambee Core User id */
  userId: Scalars['ID'];
};

export type Credit = {
  __typename?: 'Credit';
  companyId: Scalars['String'];
  consumedAt?: Maybe<Scalars['DateTime']>;
  consumedBy?: Maybe<Scalars['String']>;
  consumptionDescription?: Maybe<Scalars['String']>;
  consumptionReason?: Maybe<ProductCreditConsumptionReason>;
  /** Subkey of the product, if consuming managed service credit */
  consumptionSubKey?: Maybe<Scalars['String']>;
  consumptionType?: Maybe<ProductCreditConsumptionType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  creationDescription?: Maybe<Scalars['String']>;
  creationReason?: Maybe<ProductCreditCreationReason>;
  creditType: ProductCreditType;
  id: Scalars['ID'];
  productKey: ProductKey;
  stripeCreditNoteId?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
};

export type CreditBalance = {
  __typename?: 'CreditBalance';
  available: Scalars['Int'];
  expiringWithin30Days: Scalars['Int'];
  nextGrantAt?: Maybe<Scalars['DateTime']>;
  productKey: Scalars['String'];
};


export type DeactivateWizardGroupInput = {
  wizardGroupId: Scalars['ID'];
};

export type DeclineRecommendationInput = {
  /** The id of the recommendation to be declined. */
  recommendationId: Scalars['String'];
};

export type DefaultMigrationPlanInput = {
  companyId: Scalars['String'];
  /** Monthly price in integer cents for the recommended plan. */
  monthlyAmount: Scalars['Int'];
  /** The plan the company is on today. */
  originalProductKey: ProductKey;
  /** The plan identifier billing keys on (CorePlanModel.value). */
  planValue: Scalars['String'];
  /** The plan we recommend, which the company is seeded onto. */
  recommendedProductKey: ProductKey;
};

export type DelegateSolutionInput = {
  /** Set to true to delegate to Bambee team (creates Salesforce case). Exactly one of userId or delegateToBambee must be provided. */
  delegateToBambee?: Maybe<Scalars['Boolean']>;
  /** The ID of the solution to delegate */
  solutionId: Scalars['ID'];
  /** Company user ID to delegate to (for internal delegation). Exactly one of userId or delegateToBambee must be provided. */
  userId?: Maybe<Scalars['String']>;
};

export type DeleteBundleInput = {
  /** Core Company ID to associate with the bundle. If not provided, the bundle will be global */
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteBundleResponse = {
  __typename?: 'DeleteBundleResponse';
  deleted: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteCompanyRolesInput = {
  /** Bambee Core Company id */
  companyId: Scalars['ID'];
  /** Bambee Core Company Role title */
  roleIds: Array<Scalars['String']>;
};

export type DepartmentDto = {
  __typename?: 'DepartmentDto';
  name: Scalars['String'];
  staff?: Maybe<Array<UserContextDto>>;
  staffCount: Scalars['Float'];
};

/** The discussion topics for the Onboarding */
export enum DiscussionTopic {
  CreatingCompanyPolicies = 'CreatingCompanyPolicies',
  EnsuringMyBusinessIsCompliant = 'EnsuringMyBusinessIsCompliant',
  EstablishingANewBusiness = 'EstablishingANewBusiness',
  ExpandingMyBusiness = 'ExpandingMyBusiness',
  ManagingAnActiveHrIssue = 'ManagingAnActiveHRIssue',
  ManagingEmployees = 'ManagingEmployees',
  SomethingElse = 'SomethingElse'
}

export type DisucssionTopicDetail = {
  __typename?: 'DisucssionTopicDetail';
  /** The details of the discussion topic */
  detail: Scalars['String'];
  /** The discussion topic */
  topic: DiscussionTopic;
};

export type DisucssionTopicDetailInput = {
  /** The details of the discussion topic */
  detail: Scalars['String'];
  /** The discussion topic */
  topic: DiscussionTopic;
};

export type DocumentArtifact = {
  __typename?: 'DocumentArtifact';
  /** The html of the document */
  html: Scalars['String'];
  /** The id of the document */
  id: Scalars['String'];
  /** The status of the document */
  status: DocumentStatus;
};

export type DocumentDto = {
  __typename?: 'DocumentDto';
  category?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSigned: Scalars['Boolean'];
  requiresSignature: Scalars['Boolean'];
  signedAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export enum DocumentStatus {
  Accepted = 'accepted',
  Editing = 'editing'
}

export type DuplicateWizardTemplateInput = {
  role: WizardRole;
};

export type DuplicatedPolicyDocumentResult = {
  __typename?: 'DuplicatedPolicyDocumentResult';
  /** Company ID for which duplicated policy documents have been removed */
  companyId: Scalars['ID'];
  failureCount: Scalars['Float'];
  successCount: Scalars['Float'];
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};

export type EmittableEvent = {
  company?: Maybe<Scalars['String']>;
  /** Context in which the event occurred */
  context?: Maybe<EventContextInput>;
  event?: Maybe<Scalars['String']>;
  /** The id of the event */
  id?: Maybe<Scalars['ID']>;
  /** Event payload data */
  payload?: Maybe<Scalars['JSON']>;
  /** Priority level for event processing */
  priority?: Maybe<EventPriority>;
  properties?: Maybe<Scalars['JSON']>;
  /** Source of the event (what emitted it) */
  source?: Maybe<EventSourceInput>;
  /** Subject of the event (what the event is about) */
  subject?: Maybe<EventSubjectInput>;
  /** Type/name of the event */
  type: Scalars['String'];
  /** [DEPRECATED] Use context.userId instead */
  userId?: Maybe<Scalars['String']>;
};

export enum EmployeeClassification {
  Empty = 'empty',
  Exempt = 'exempt',
  Nonexempt = 'nonexempt'
}

export type EmployeeJobDescription = {
  __typename?: 'EmployeeJobDescription';
  createdAt: Scalars['DateTime'];
  documentId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobDescription: JobDescription;
  signedAt?: Maybe<Scalars['DateTime']>;
};

export type EmployeeLocationInput = {
  count?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};

export enum EmployeeServiceContractorType {
  Business = 'business',
  Empty = 'empty',
  Individual = 'individual'
}

export enum EmployeeServiceEmployeeType {
  Contractor = 'contractor',
  Empty = 'empty',
  Fulltime = 'fulltime',
  Parttime = 'parttime'
}

export type EmploymentDto = {
  __typename?: 'EmploymentDto';
  employmentType?: Maybe<Scalars['String']>;
  hireDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type EnhancedCompanyRoleDto = {
  __typename?: 'EnhancedCompanyRoleDto';
  name: Scalars['String'];
  staff?: Maybe<Array<UserContextDto>>;
  staffCount: Scalars['Int'];
  workerRoles: Array<WorkerRoleDto>;
};

export type EnhancedTrainingProfileDto = {
  __typename?: 'EnhancedTrainingProfileDto';
  certificates: Array<TrainingCertificateDto>;
  enrollments: EnrollmentCategoryDto;
  totalCertificatesEarned: Scalars['Int'];
  totalCoursesCompleted: Scalars['Int'];
  upcomingRenewals?: Maybe<Array<TrainingRenewalDto>>;
};

export type EnhancedTranscript = {
  __typename?: 'EnhancedTranscript';
  formatted: Scalars['String'];
  metadata: TranscriptMetadata;
  raw: Scalars['String'];
};

export type EnqueueHotlineCallInput = {
  /** Additional information associated to the call that is being requested */
  information: CallInformation;
  /** An arbitrary string specifying where the request was originated */
  origin: Scalars['String'];
};

export type EnrollUserResponse = {
  __typename?: 'EnrollUserResponse';
  enrolled: Scalars['Boolean'];
  enrollments?: Maybe<EnrollUserTicket>;
  errors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
};

export type EnrollUserTicket = {
  __typename?: 'EnrollUserTicket';
  bundleId?: Maybe<Scalars['ID']>;
  courseId: Scalars['ID'];
  ticketId: Scalars['ID'];
  topicId?: Maybe<Scalars['ID']>;
};

export type EnrollUsersError = {
  __typename?: 'EnrollUsersError';
  bundleId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
  userIds?: Maybe<Array<Scalars['String']>>;
};

export type EnrollUsersInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
  users: Array<UserInput>;
};

export type EnrollUsersResponse = {
  __typename?: 'EnrollUsersResponse';
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  enrolled: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  topicId?: Maybe<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type EnrolledUser = {
  __typename?: 'EnrolledUser';
  id: Scalars['String'];
  language?: Maybe<Language>;
  role?: Maybe<UserRole>;
  state?: Maybe<State>;
  /** @deprecated Use id instead */
  userId: Scalars['String'];
};

export type EnrollmentCategoryDto = {
  __typename?: 'EnrollmentCategoryDto';
  all: Array<TrainingDto>;
  completed: Array<TrainingDto>;
  inProgress: Array<TrainingDto>;
  notStarted: Array<TrainingDto>;
};

export type EnrollmentCompleted = {
  __typename?: 'EnrollmentCompleted';
  completedUserIds: Array<Maybe<Scalars['String']>>;
  errors: Array<Maybe<Scalars['String']>>;
  id: Scalars['ID'];
};

export type EnrollmentInput = {
  bundleId?: Maybe<Scalars['String']>;
  topicId?: Maybe<Scalars['String']>;
  users: Array<UserInput>;
};

/** Status of a training enrollment */
export enum EnrollmentStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type Entitlement = {
  __typename?: 'Entitlement';
  accountCode: Scalars['String'];
  addOns: Array<Scalars['String']>;
  companyId: Scalars['ID'];
  currentPeriodEnd: Scalars['DateTime'];
  headcount?: Maybe<Scalars['Int']>;
  maxSize?: Maybe<Scalars['Int']>;
  minSize?: Maybe<Scalars['Int']>;
  pastDue: Scalars['Boolean'];
  pastDueSince?: Maybe<Scalars['DateTime']>;
  pendingPlanCode?: Maybe<Scalars['String']>;
  planCode: Scalars['String'];
  productKey: Scalars['String'];
  provider: BillingProvider;
  seats: Array<SeatEntitlement>;
  state: SubscriptionState;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionUpdatedAt?: Maybe<Scalars['DateTime']>;
  trialEnd?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  updatedFromEventId: Scalars['String'];
};

/** Types of entities that can be searched */
export enum EntityType {
  Compliance = 'COMPLIANCE',
  Documents = 'DOCUMENTS',
  Pips = 'PIPS',
  Policies = 'POLICIES',
  ReportCards = 'REPORT_CARDS',
  Staff = 'STAFF',
  Training = 'TRAINING',
  VerbalWarnings = 'VERBAL_WARNINGS',
  WrittenWarnings = 'WRITTEN_WARNINGS'
}

export type EoEHrRequestAnswer = {
  __typename?: 'EoEHrRequestAnswer';
  answers?: Maybe<Scalars['JSON']>;
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  refId: Scalars['String'];
  sfSubType?: Maybe<Scalars['String']>;
  sfType?: Maybe<Scalars['String']>;
  type: EoeHrRequestType;
};

export enum EoeHrRequestType {
  HrRequest = 'HR_REQUEST',
  Resignation = 'RESIGNATION',
  Termination = 'TERMINATION'
}

export type EscalationTarget = {
  __typename?: 'EscalationTarget';
  context?: Maybe<Scalars['String']>;
  persona: Scalars['String'];
  reason: Scalars['String'];
};

export type EventContextInput = {
  /** Additional context-specific data */
  additionalData?: Maybe<Scalars['JSON']>;
  /** Company in which the action occurred */
  companyId?: Maybe<Scalars['String']>;
  /** IP address of the user */
  ipAddress?: Maybe<Scalars['String']>;
  /** Request ID associated with the action */
  requestId?: Maybe<Scalars['String']>;
  /** User agent of the client */
  userAgent?: Maybe<Scalars['String']>;
  /** User who performed the action */
  userId?: Maybe<Scalars['String']>;
};

export type EventContextOutput = {
  __typename?: 'EventContextOutput';
  /** Additional context-specific data */
  additionalData?: Maybe<Scalars['JSON']>;
  /** Company in which the action occurred */
  companyId?: Maybe<Scalars['String']>;
  /** IP address of the user */
  ipAddress?: Maybe<Scalars['String']>;
  /** Request ID associated with the action */
  requestId?: Maybe<Scalars['String']>;
  /** User agent of the client */
  userAgent?: Maybe<Scalars['String']>;
  /** User who performed the action */
  userId?: Maybe<Scalars['String']>;
};

export type EventEmitted = {
  __typename?: 'EventEmitted';
  /** Context in which the event occurred */
  context?: Maybe<EventContextOutput>;
  /** Correlation ID for tracking related events */
  correlationId: Scalars['String'];
  /** The id of the event */
  id: Scalars['ID'];
  /** Event payload data */
  payload?: Maybe<Scalars['JSON']>;
  /** Priority level for event processing */
  priority?: Maybe<EventPriority>;
  /** Source of the event (what emitted it) */
  source?: Maybe<EventSourceOutput>;
  /** Subject of the event (what the event is about) */
  subject: EventSubjectOutput;
  /** Indicator if event was emitted successfully */
  success: Scalars['Boolean'];
  /** Type/name of the event */
  type: Scalars['String'];
};

/** Priority level for event processing */
export enum EventPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type EventSourceInput = {
  /** How the event was captured */
  captureMethod?: Maybe<Scalars['String']>;
  /** Component within the system */
  component?: Maybe<Scalars['String']>;
  /** Method or function that generated the event */
  method?: Maybe<Scalars['String']>;
  /** System that generated the event */
  system: Scalars['String'];
};

export type EventSourceOutput = {
  __typename?: 'EventSourceOutput';
  /** How the event was captured */
  captureMethod?: Maybe<Scalars['String']>;
  /** Component within the system */
  component?: Maybe<Scalars['String']>;
  /** Method or function that generated the event */
  method?: Maybe<Scalars['String']>;
  /** System that generated the event */
  system: Scalars['String'];
};

export type EventSubjectInput = {
  /** Additional attributes about the subject */
  attributes?: Maybe<Scalars['JSON']>;
  /** ID of the subject */
  id: Scalars['String'];
  /** Type of subject (USER, COMPANY, DOCUMENT, etc.) */
  type: Scalars['String'];
};

export type EventSubjectOutput = {
  __typename?: 'EventSubjectOutput';
  /** Additional attributes about the subject */
  attributes?: Maybe<Scalars['JSON']>;
  /** ID of the subject */
  id: Scalars['String'];
  /** Type of subject (USER, COMPANY, DOCUMENT, etc.) */
  type: Scalars['String'];
};

export type ExtendBambeePlusOnboardingToSpecificDate = {
  companyId: Scalars['String'];
  newDeadline: Scalars['DateTime'];
};

export type ExtendTrialInput = {
  companyId: Scalars['ID'];
  trialEndsAt: Scalars['DateTime'];
};

export type Feed = {
  __typename?: 'Feed';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user: CoreUser;
};

export type FeedbackDto = {
  __typename?: 'FeedbackDto';
  anonymous: Scalars['Boolean'];
  companyPersonId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  feedback: Scalars['String'];
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeedbackHistory = {
  __typename?: 'FeedbackHistory';
  byUser: CoreUser;
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  message: FeedbackMessage;
  value: FeedbackValue;
};

export type FeedbackMessage = ChatMessageInterface & {
  __typename?: 'FeedbackMessage';
  channelId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  feedbackId: Scalars['ID'];
  id: Scalars['ID'];
  isThreadMessage: Scalars['Boolean'];
  isThreadParent: Scalars['Boolean'];
  message: Scalars['String'];
  rawType: SendbirdMessageType;
  /** Recipieint, if a one-on-one message */
  recipient?: Maybe<CoreUser>;
  sender: CoreUser;
  threadParentId?: Maybe<Scalars['ID']>;
  type: ChatMessageTypeEnum;
  value: FeedbackValue;
};

export type FeedbackMessageInput = {
  message: Scalars['String'];
  value: FeedbackValue;
};

/** A representation of feedback values */
export enum FeedbackValue {
  AboveExpectations = 'AboveExpectations',
  BelowExpectations = 'BelowExpectations',
  MeetsExpectations = 'MeetsExpectations'
}

export type FileCitationAnnotationDto = {
  __typename?: 'FileCitationAnnotationDto';
  end_index: Scalars['Int'];
  file_citation: FileCitationDto;
  start_index: Scalars['Int'];
  text: Scalars['String'];
  type: Scalars['String'];
};

export type FileCitationDto = {
  __typename?: 'FileCitationDto';
  file_id: Scalars['String'];
};

export type FilePathAnnotationDto = {
  __typename?: 'FilePathAnnotationDto';
  end_index: Scalars['Int'];
  file_path: FilePathDto;
  start_index: Scalars['Int'];
  text: Scalars['String'];
  type: Scalars['String'];
};

export type FilePathDto = {
  __typename?: 'FilePathDto';
  file_id: Scalars['String'];
};

export type FileStackInput = {
  filename?: Scalars['String'];
  id?: Scalars['String'];
  mimetype?: Scalars['String'];
  name?: Scalars['String'];
  size?: Scalars['Int'];
  uploaded_date?: Maybe<Scalars['DateTime']>;
  url?: Scalars['String'];
};

export type FileStackModel = {
  __typename?: 'FileStackModel';
  filename: Scalars['String'];
  id: Scalars['String'];
  mimetype: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['Int'];
  uploaded_date?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type FindSimilarComplianceInput = {
  /** Exclude compliance data from invalid URLs (default false) */
  excludeInvalidUrls?: Maybe<Scalars['Boolean']>;
  /** Maximum number of results to return (default 5, max 20) */
  limit?: Maybe<Scalars['Float']>;
  /** Query text to find similar compliance content for */
  query: Scalars['String'];
};

export type FindSimilarImagesInput = {
  /** Only return active images */
  activeOnly?: Scalars['Boolean'];
  /** Maximum number of results */
  limit?: Maybe<Scalars['Int']>;
  /** Text to search for similar images */
  searchText: Scalars['String'];
  /** Similarity threshold (0-1) */
  similarityThreshold?: Maybe<Scalars['Float']>;
  /** Filter by specific version */
  version?: Maybe<Scalars['String']>;
};

export type FindSimilarQuestionsInput = {
  /** Company id to search within */
  companyId: Scalars['ID'];
  /** Double-check similarity with OpenAI (default false) */
  doubleCheckSimilarity?: Maybe<Scalars['Boolean']>;
  /** Maximum number of results to return (default 5) */
  limit?: Maybe<Scalars['Float']>;
  /** Question text to find similar questions for */
  questionText: Scalars['String'];
  /** Similarity threshold (0-1, default 0.85) */
  similarityThreshold?: Maybe<Scalars['Float']>;
};

export type GenerateAiJobDescriptionInput = {
  employeeType?: Maybe<JobDescriptionEmployeePayType>;
  employmentPayRate?: Maybe<JobDescriptionEmploymentPayRate>;
  employmentTaxType?: Maybe<JobDescriptionEmploymentTaxType>;
  industry: Scalars['String'];
  jobTitle: Scalars['String'];
  location?: Maybe<JobDescriptionLocation>;
  travelRequirements?: Maybe<Scalars['String']>;
  workingSchedule?: Maybe<Array<WorkingSchedule>>;
};

/** Generate AI job description attatching it to user */
export type GenerateAiJobDescriptionInputV2 = {
  employeeType?: Maybe<JobDescriptionEmployeePayType>;
  employmentPayRate?: Maybe<JobDescriptionEmploymentPayRate>;
  employmentTaxType?: Maybe<JobDescriptionEmploymentTaxType>;
  industry: Scalars['String'];
  /** Allows the AI generation process to use an existing job description */
  jobDescriptionId?: Maybe<Scalars['String']>;
  jobTitle: Scalars['String'];
  location?: Maybe<JobDescriptionLocation>;
  travelRequirements?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  workingSchedule?: Maybe<Array<WorkingSchedule>>;
};

export type GenerateArtifactDraftInput = {
  /** Artifact ID to refine/iterate on an existing draft. Mutually exclusive with templateId. When provided, creates a new version with modifications specified in instructions. */
  artifactId?: Maybe<Scalars['String']>;
  /** Artifact sub-type for specialized workflows */
  artifactSubType?: Maybe<Scalars['String']>;
  /** Artifact type to generate. Determines which AI workflow to use. */
  artifactType: ArtifactType;
  /** Optional structured/unstructured data to provide additional context. Useful for all generation modes: template-based (fill placeholders), refinement (add context), or custom (guide creation). Example: { structured: { "company.name": "Acme Corp", "pto.days": "15" } } */
  fieldData?: Maybe<ArtifactFieldDataInput>;
  /** Optional instructions to guide AI generation. For POLICY artifacts: customize/modify the template. For guidance artifacts (BEST_PRACTICE_SUMMARY, COMPREHENSIVE_GUIDANCE, ACTION_PLAN): provide additional context beyond the conversation. Templates are automatically applied. Examples: "Make this more casual", "Focus on remote work considerations", "Consider our startup culture" */
  instructions?: Maybe<Scalars['String']>;
  /** Optional conversation messages array. Use this to avoid race conditions where thread may not be fully up to date. If not provided, messages will be fetched from threadId. */
  messages?: Maybe<Array<ConversationMessageInput>>;
  /** Template ID to start from an existing template. Mutually exclusive with artifactId. When provided, generates a new artifact based on the template + instructions. */
  templateId?: Maybe<Scalars['String']>;
  /** Optional thread ID to associate this artifact with a conversation/workspace. If not provided, messages must be provided. */
  threadId?: Maybe<Scalars['String']>;
};

export type GenerateArtifactDraftsInput = {
  /** Array of artifacts to generate (min: 1, max: 10) */
  artifacts: Array<ArtifactDraftRequest>;
  /** Optional auto-finalization configuration */
  autoFinalize?: Maybe<AutoFinalizeInput>;
  /** Shared thread ID for all artifacts (can be overridden per-artifact) */
  threadId?: Maybe<Scalars['String']>;
};

export type GenerateArtifactDraftsResult = {
  __typename?: 'GenerateArtifactDraftsResult';
  /** Successfully generated artifacts */
  artifacts: Array<ArtifactBatchItem>;
  /** Shared Salesforce Case ID if auto-finalized (same for all artifacts) */
  caseId?: Maybe<Scalars['String']>;
  /** Errors encountered during generation or finalization */
  errors: Array<ArtifactBatchError>;
  /** Shared HR Request ID if auto-finalized (same for all artifacts) */
  hrRequestId?: Maybe<Scalars['String']>;
  /** Overall success (true if no errors) */
  success: Scalars['Boolean'];
  /** Summary statistics */
  summary: BatchSummary;
};

export type GenerateWizardTemplateInput = {
  prompt?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Scalars['String']>>;
};

export type GetArtifactsInput = {
  /** Filter by artifact type (optional). If not provided, returns all types */
  artifactType?: Maybe<ArtifactType>;
  /** Filter by case ID (optional) */
  caseId?: Maybe<Scalars['String']>;
  /** Filter by latest version only (default: false) */
  latestOnly?: Maybe<Scalars['Boolean']>;
  /** Filter by policy ID (optional) */
  policyId?: Maybe<Scalars['String']>;
  /** Filter by thread ID (optional) */
  threadId?: Maybe<Scalars['String']>;
};

export type GetAskNicelyWebSurveyInfoInput = {
  /** Whether to always provide the email hash. */
  provideHash?: Maybe<Scalars['Boolean']>;
  /** ID of user to get NPS survey info for. */
  userId: Scalars['String'];
};

export type GetAvailableProductsInput = {
  companyId: Scalars['String'];
};

export type GetBillingInfoInput = {
  companyId: Scalars['String'];
};

export type GetBusinessManagerCalendlyUrlInput = {
  tierNumber: Scalars['Int'];
};

export type GetCalendlyRescheduleLinkInput = {
  /** Scheduled Event ID */
  scheduledEventId: Scalars['String'];
};

export type GetCompanyCreditsInputV2 = {
  active?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['String']>;
  consumed?: Maybe<Scalars['Boolean']>;
  creditType?: Maybe<ProductCreditType>;
  productKey?: Maybe<ProductKey>;
  refundable?: Maybe<Scalars['Boolean']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
};

export type GetCompanyDelinquency = {
  companyId: Scalars['String'];
};

export type GetCompanyInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
};

export type GetCompanyPaymentSources = {
  companyId: Scalars['String'];
};

export type GetCompanyProductsInput = {
  companyId: Scalars['String'];
};

export type GetCompanySubscriptionsInput = {
  productCode?: Maybe<ProductKey>;
  stripeCustomerId: Scalars['String'];
};

export type GetCompanySurveyAnswerInput = {
  companyId: Scalars['ID'];
  key: SurveyQuestionKey;
  type: Scalars['String'];
};

export type GetCompanySurveyInput = {
  companyId: Scalars['String'];
  type: Scalars['String'];
};

export type GetCompanySurveyListInput = {
  companyId: Scalars['String'];
};

export type GetCompanyUpcomingBillingChangesInput = {
  companyId: Scalars['String'];
  /** Tier number the company will upgrade to */
  tierNumber: Scalars['Float'];
};

export type GetConversationByIntercomIdInput = {
  fetchAsHtml?: Maybe<Scalars['Boolean']>;
  intercomConversationId: Scalars['String'];
};

export type GetCoreUpgradeOptionsInput = {
  companyId: Scalars['String'];
};

export type GetCouponInput = {
  couponId: Scalars['String'];
};

export type GetEntityInput = {
  id: Scalars['String'];
};

export type GetEoeHrRequestInput = {
  companyId: Scalars['String'];
  refId: Scalars['String'];
  type: EoeHrRequestType;
};

export type GetExistingResignationByEmployeeInput = {
  employeeId: Scalars['String'];
};

export type GetExistingTerminationByEmployeeInput = {
  employeeId: Scalars['String'];
};

export type GetHrRequestByIdInput = {
  /** ID of the HR Request */
  id: Scalars['String'];
};

export type GetHrRequestBySalesforceCaseIdInput = {
  salesforceCaseId: Scalars['String'];
};

export type GetHrRequestExtendedDetailByIdInput = {
  /** SF case ID */
  caseId: Scalars['String'];
};

export type GetPolicy = {
  policyId: Scalars['ID'];
};

export type GetPracticeInput = {
  companyId: Scalars['String'];
  practiceId: Scalars['String'];
};

export type GetProductInterestInput = {
  productKey?: Maybe<ProductKey>;
  productSubKey?: Maybe<ProductSubKey>;
};

export type GetRecommendedPolicyTemplateInput = {
  messages?: Maybe<Array<PolicyRecommendationMessageInput>>;
  threadId?: Maybe<Scalars['ID']>;
};

export type GetRecommendedPolicyTemplatesInput = {
  /** Maximum number of templates to return (1-20) */
  limit?: Maybe<Scalars['Int']>;
  messages?: Maybe<Array<PolicyRecommendationMessageInput>>;
  /** Minimum confidence threshold (0-100) */
  minConfidence?: Maybe<Scalars['Float']>;
  threadId?: Maybe<Scalars['ID']>;
};

export type GetReportCardInput = {
  /** employee id */
  employeeId?: Maybe<Scalars['String']>;
  reportCardId: Scalars['String'];
};

export type GetResignationHrRequestInput = {
  hrRequestId: Scalars['String'];
};

export type GetResignationInput = {
  resignationId: Scalars['String'];
};

export type GetResignationsInput = {
  companyId?: Maybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  status?: Maybe<ResignationStatus>;
};

export type GetSalesforceCasesForNewPolicyRequestInput = {
  companyId: Scalars['String'];
  excludedHrRequestIds: Array<Scalars['String']>;
};

export type GetScheduledEventsForUserInput = {
  /** User ID */
  userId?: Maybe<Scalars['String']>;
};

export type GetSmartCabinetDownloadUrlInput = {
  documentId: Scalars['ID'];
};

export type GetSolutionDelegationHistoryInput = {
  /** The solution ID to retrieve delegation history for */
  solutionId: Scalars['ID'];
};

export type GetSolutionInput = {
  /** The Salesforce case ID associated with the solution */
  caseId?: Maybe<Scalars['String']>;
  /** The ID of the solution to retrieve */
  solutionId?: Maybe<Scalars['ID']>;
};

export type GetSolutionsInput = {
  /** Filter by destination(s). Can filter by one or more destinations (e.g., [SOLUTION_FEED, OPERATING_INTRO]). If not provided, returns all destinations. */
  destinations?: Maybe<Array<SolutionDestination>>;
  /** Number of solutions to return (default: 10) */
  limit?: Maybe<Scalars['Int']>;
  /** Offset for pagination (default: 0) */
  offset?: Maybe<Scalars['Int']>;
  /** Scope of solutions to retrieve */
  scope: SolutionScope;
  /** User ID for user-specific solutions (required when scope is USER) */
  userId?: Maybe<Scalars['String']>;
};

export type GetSolutionsWithCursorInput = {
  /** Filter by category/categories. Can filter by one or more categories (e.g., [COMPLIANCE, MISCONDUCT]). If not provided, returns all categories. */
  categories?: Maybe<Array<BrightenCategory>>;
  /** Cursor for pagination (null means start from beginning) */
  cursor?: Maybe<Scalars['String']>;
  /** Filter by delegation authorship. True = solutions I delegated (delegatedBy=me), False = solutions NOT delegated by me (delegatedBy is null or !=me), null/undefined = no filter. Combine with status filters for queries like "solutions I delegated that are completed" (delegatedByMe:true + statuses:[COMPLETED]) */
  delegatedByMe?: Maybe<Scalars['Boolean']>;
  /** Filter for solutions delegated to a specific user ID */
  delegatedToUserId?: Maybe<Scalars['String']>;
  /** Filter by destination(s). Can filter by one or more destinations (e.g., [SOLUTION_FEED, OPERATING_INTRO]). If not provided, returns all destinations. */
  destinations?: Maybe<Array<SolutionDestination>>;
  /** Number of solutions to return (default: 20, max: 100) */
  limit?: Maybe<Scalars['Int']>;
  /** Filter for solutions owned by BAMBEE (has caseId). True = BAMBEE-owned only, False = not BAMBEE-owned, null/undefined = all solutions */
  ownedByBambee?: Maybe<Scalars['Boolean']>;
  /** Scope of solutions to retrieve. If not provided: admins get both company and user solutions, regular users get only their own solutions */
  scope?: Maybe<SolutionScope>;
  /** Search query to filter solutions. Searches across solution ID, slug, description, tags, type, and category. */
  search?: Maybe<Scalars['String']>;
  /** Filter by status(es). Can be [NOT_STARTED], [IN_PROGRESS], [BLOCKED], [COMPLETED], [CLOSED], or any combination. If not provided, returns all statuses. */
  statuses?: Maybe<Array<SolutionStatus>>;
  /** Filter by solution type(s). Can filter by one or more types (e.g., [NEW_POLICY, NEW_CAP]). If not provided, returns all types. */
  types?: Maybe<Array<SolutionType>>;
  /** User ID for user-specific solutions (required when scope is USER) */
  userId?: Maybe<Scalars['String']>;
};

export type GetTerminationHrRequestInput = {
  hrRequestId: Scalars['String'];
};

export type GetTerminationInput = {
  terminationId: Scalars['String'];
};

export type GetTerminationsInput = {
  companyId?: Maybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  status?: Maybe<TerminationStatus>;
};

export type GetUserCoursesInput = {
  userId?: Maybe<Scalars['String']>;
};

export type GetUserWarningDocumentsInput = {
  employeeId: Scalars['String'];
};

export type GetVoicesFeedbackListInput = {
  companyId: Scalars['String'];
};

/** The completion status of the goal */
export enum GoalCompletionStatus {
  Automatic = 'Automatic',
  Cancelled = 'Cancelled',
  Manual = 'Manual',
  Skipped = 'Skipped'
}

/** The name of the goal */
export enum GoalName {
  BambeePlusSetup = 'BambeePlusSetup',
  EmployeeOnboardingKit = 'EmployeeOnboardingKit',
  GetReadyToGetPaid = 'GetReadyToGetPaid',
  GettingReadyToHire = 'GettingReadyToHire',
  HiringKit = 'HiringKit',
  HrAudit = 'HrAudit',
  ImproveStaffCommunication = 'ImproveStaffCommunication',
  IntroduceStaffToBambee = 'IntroduceStaffToBambee',
  MeetYourTeam = 'MeetYourTeam',
  PayrollOnboarding = 'PayrollOnboarding',
  SendJobOffer = 'SendJobOffer',
  WorkplaceViolenceCaHrmFollowUp = 'WorkplaceViolenceCaHrmFollowUp'
}

export type GrantCreditsInput = {
  amount: Scalars['Int'];
  companyId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  productKey: Scalars['String'];
  reason: Scalars['String'];
};

export enum GroupView {
  Default = 'Default',
  IAmMember = 'IAmMember',
  ICanSee = 'ICanSee',
  ThatIOwn = 'ThatIOwn'
}

export type GuardArtifact = {
  __typename?: 'GuardArtifact';
  /** The name of the guard */
  name: Scalars['String'];
  /** The result of the guard */
  result: GuardResultDto;
};

export type GuardResultDto = {
  __typename?: 'GuardResultDto';
  /** Whether or not the user was allowed to pass the guard */
  allowed: Scalars['Boolean'];
  /** The reason why the guard choice was made */
  reason: Scalars['Boolean'];
};

/** One keyed answer to a pending guidance question (BIO-1395) */
export type GuidanceAnswerInput = {
  /** The pending question key this answer belongs to */
  key: Scalars['String'];
  /** The customer's answer */
  value: Scalars['String'];
};

/** Outcome of the latest guidance generation attempt (BIO-1395). INSUFFICIENT_CONTEXT is a normal state (questions pending), not a failure. Null on cycles generated before the feature: the read derives null + prose present as OK. */
export enum GuidanceOutcome {
  Failed = 'FAILED',
  InsufficientContext = 'INSUFFICIENT_CONTEXT',
  Ok = 'OK'
}

/** One question blocking guidance generation (BIO-1395): key is the stable identity answers are matched on, question is the customer-facing text */
export type GuidanceQuestion = {
  __typename?: 'GuidanceQuestion';
  /** Stable key answers are matched on (aligned to intake fields where one applies) */
  key: Scalars['String'];
  /** Customer-facing question text */
  question: Scalars['String'];
};

export type HotlineCall = {
  __typename?: 'HotlineCall';
  agent?: Maybe<HotlineCallAgent>;
  callDuration?: Maybe<Scalars['Float']>;
  callPlacedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  status: HotlineCallStatus;
  summary?: Maybe<Scalars['String']>;
};

export type HotlineCallAgent = {
  __typename?: 'HotlineCallAgent';
  avatarUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export enum HotlineCallStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Missed = 'MISSED',
  Pending = 'PENDING'
}

export type HrPracticesArtifact = {
  __typename?: 'HrPracticesArtifact';
  /** The ID of the salesforce case on the HR request backing the hr practices artifact */
  caseId?: Maybe<Scalars['String']>;
  /** The download url for the hr practices artifact */
  downloadUrl: Scalars['String'];
  /** The dto of the hr practices artifact */
  dto: Scalars['String'];
  /** The ID of the HR request backing the hr practices artifact */
  hrRequestId?: Maybe<Scalars['String']>;
  /** The artifact renered as HTML */
  html: Scalars['String'];
  /** ID of the hr practices artifact that was created */
  id?: Maybe<Scalars['String']>;
  /** The status of the hr practices artifact */
  status: Scalars['String'];
  /** Title of the hr practices artifact */
  title: Scalars['String'];
};

export type HrRequest = {
  __typename?: 'HrRequest';
  /** list of artifacts created by ai workflows */
  aiArtifacts?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether this HR Request originated from an AI request */
  aiGenerated?: Maybe<Scalars['String']>;
  /** Salesforce ID of the HR Request */
  caseId: Scalars['String'];
  conversation?: Maybe<Conversation>;
  /** Intercom conversation ID */
  conversationId?: Maybe<Scalars['String']>;
  /** Date the HR Request was created */
  createdAt: Scalars['DateTime'];
  /** Company ID of the customer */
  customerCompanyId: Scalars['String'];
  /** Bambee ID of the HR Request */
  id: Scalars['String'];
  intercomConversationId?: Maybe<Scalars['String']>;
  /** ID of the Assistants API thread used to generate the Policy HR Request */
  threadId?: Maybe<Scalars['String']>;
};

export enum HrRequestAudience {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE'
}

export type HrRequestDetail = {
  __typename?: 'HrRequestDetail';
  /** AI metadata of the HR request */
  aiMetadata?: Maybe<Scalars['String']>;
  caseId: Scalars['String'];
  caseNumber?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expectationDate?: Maybe<Scalars['DateTime']>;
  hrRequestSurveyAnswers?: Maybe<Scalars['JSON']>;
  intercomId?: Maybe<Scalars['String']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']>;
  stage?: Maybe<CaseStage>;
  status: CaseStatus;
  subType?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<CaseType>;
};

export type HrRequestExpectation = {
  __typename?: 'HrRequestExpectation';
  cycleTime: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type HrRequestExtendedDetail = {
  __typename?: 'HrRequestExtendedDetail';
  /** Action items captured on the HR request */
  actionItems?: Maybe<Scalars['String']>;
  /** AI generated action plan */
  actionPlan?: Maybe<Scalars['String']>;
  /** Bambee agent who is assigned to the HR request */
  agent?: Maybe<CallAgent>;
  /** AI metadata of the HR request */
  aiMetadata?: Maybe<Scalars['String']>;
  /** Present if HR request went through AI Assistant flow */
  aiSummary?: Maybe<Scalars['String']>;
  /** AI generated best practice summary */
  bestPractices?: Maybe<Scalars['String']>;
  caseId: Scalars['String'];
  caseNumber?: Maybe<Scalars['String']>;
  /** Company ID of the HR request */
  companyId: Scalars['String'];
  completionDate?: Maybe<Scalars['DateTime']>;
  /** AI generated comprehensive guidance */
  comprehensiveGuidance?: Maybe<Scalars['String']>;
  /** Created by user ID */
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expectationDate?: Maybe<Scalars['DateTime']>;
  /** Follow-ups captured on the HR request */
  followUps?: Maybe<Scalars['String']>;
  /** AI generated HR practices */
  hrPractices?: Maybe<Scalars['String']>;
  hrRequestSurveyAnswers?: Maybe<Scalars['JSON']>;
  intercomId?: Maybe<Scalars['String']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']>;
  /** Owner ID of the HR request (Bambee rep) */
  ownerId?: Maybe<Scalars['String']>;
  /** Policies related to the HR request */
  policies?: Maybe<Array<HrRequestPolicy>>;
  /** Cases related to the HR request */
  relatedCases?: Maybe<Array<RelatedCase>>;
  /** Scheduled events for the HR request */
  scheduledEvents: Array<ScheduledEvent>;
  stage?: Maybe<CaseStage>;
  status: CaseStatus;
  subType?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  /** AI generated summary of the HR request */
  summary?: Maybe<Scalars['String']>;
  /** False when the HR Manager has not reviewed the summary yet, so it may contain errors */
  summaryApproved?: Maybe<Scalars['Boolean']>;
  /** AI Assistant thread ID, if available */
  threadId?: Maybe<Scalars['String']>;
  /** Timeline of events for the HR request */
  timeline: Array<TimelineItem>;
  type?: Maybe<CaseType>;
};

export type HrRequestGroup = {
  __typename?: 'HrRequestGroup';
  icon: Scalars['String'];
  key: HrRequestGroupKey;
  title: Scalars['String'];
};

export enum HrRequestGroupKey {
  EmployeeFeedback = 'EMPLOYEE_FEEDBACK',
  EmployeeIssues = 'EMPLOYEE_ISSUES',
  EndingEmployment = 'ENDING_EMPLOYMENT',
  HiringOnboarding = 'HIRING_ONBOARDING',
  IssueReporting = 'ISSUE_REPORTING',
  PayBenefits = 'PAY_BENEFITS',
  Policies = 'POLICIES',
  Support = 'SUPPORT',
  TimeOff = 'TIME_OFF'
}

export type HrRequestOption = {
  __typename?: 'HrRequestOption';
  audience: Array<HrRequestAudience>;
  category?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  expectation?: Maybe<HrRequestExpectation>;
  groupKey: HrRequestGroupKey;
  keywords: Array<Scalars['String']>;
  popular?: Maybe<HrRequestOptionPopular>;
  requiresPrimaryHrm: Scalars['Boolean'];
  slug: HrRequestSlug;
  subType?: Maybe<HrRequestSubType>;
  title: Scalars['String'];
  type: HrRequestType;
  unlisted?: Maybe<Scalars['Boolean']>;
};

export type HrRequestOptionPopular = {
  __typename?: 'HrRequestOptionPopular';
  description?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
};

export type HrRequestOptionsResponse = {
  __typename?: 'HrRequestOptionsResponse';
  groups: Array<HrRequestGroup>;
  options: Array<HrRequestOption>;
};

export enum HrRequestOrigin {
  Ai = 'AI',
  Api1 = 'API1',
  Api2 = 'API2',
  App = 'APP',
  Call = 'CALL',
  EliteMailbox = 'ELITE_MAILBOX',
  Email = 'EMAIL',
  Hexagon = 'HEXAGON',
  Honey = 'HONEY',
  Intercom = 'INTERCOM',
  MobileApp = 'MOBILE_APP',
  Payrollservice = 'PAYROLLSERVICE',
  Phone = 'PHONE',
  RequestsMailbox = 'REQUESTS_MAILBOX',
  Salesforceautomation = 'SALESFORCEAUTOMATION',
  Salesforcemanualinput = 'SALESFORCEMANUALINPUT',
  Taskservice = 'TASKSERVICE',
  Truly = 'TRULY',
  Webform = 'WEBFORM',
  Zapier = 'ZAPIER'
}

export type HrRequestPolicy = {
  __typename?: 'HrRequestPolicy';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['String'];
  kind: PolicyKind;
  name: Scalars['String'];
  status: PolicyStatus;
  step: Scalars['String'];
};

export enum HrRequestSlug {
  AdminSupport = 'ADMIN_SUPPORT',
  BillingIssue = 'BILLING_ISSUE',
  BillingPayments = 'BILLING_PAYMENTS',
  BonusesCommission = 'BONUSES_COMMISSION',
  DisabilityAccomodation = 'DISABILITY_ACCOMODATION',
  EmployeeBenefits = 'EMPLOYEE_BENEFITS',
  EmployeeChat = 'EMPLOYEE_CHAT',
  EmployeeCompliants = 'EMPLOYEE_COMPLIANTS',
  FinalPay = 'FINAL_PAY',
  FiringTermination = 'FIRING_TERMINATION',
  Guidance = 'GUIDANCE',
  HrTeamIssue = 'HR_TEAM_ISSUE',
  I9EmploymentEligibility = 'I9_EMPLOYMENT_ELIGIBILITY',
  Incident = 'INCIDENT',
  JobDescription = 'JOB_DESCRIPTION',
  Layoff = 'LAYOFF',
  LeaveOfAbsence = 'LEAVE_OF_ABSENCE',
  MealAndRestBreaks = 'MEAL_AND_REST_BREAKS',
  NewPolicy = 'NEW_POLICY',
  OtherIssue = 'OTHER_ISSUE',
  Overtime = 'OVERTIME',
  PaidTimeOff = 'PAID_TIME_OFF',
  Payroll = 'PAYROLL',
  PayrollEmployee = 'PAYROLL_EMPLOYEE',
  PayrollImplementation = 'PAYROLL_IMPLEMENTATION',
  PerformanceDisciplinaryAction = 'PERFORMANCE_DISCIPLINARY_ACTION',
  PreEmployment = 'PRE_EMPLOYMENT',
  Resignation = 'RESIGNATION',
  SickLeave = 'SICK_LEAVE',
  TechnologyIssue = 'TECHNOLOGY_ISSUE',
  Tips = 'TIPS',
  TravelTime = 'TRAVEL_TIME',
  UnemploymentClaims = 'UNEMPLOYMENT_CLAIMS',
  WebsiteAppHelp = 'WEBSITE_APP_HELP',
  WorkplacePosting = 'WORKPLACE_POSTING',
  WorkInjury = 'WORK_INJURY'
}

export enum HrRequestSubType {
  ActionPlan = 'ACTION_PLAN',
  AdaAccommodation = 'ADA_ACCOMMODATION',
  AdaAccommodations = 'ADA_ACCOMMODATIONS',
  AdjustApprovedPayroll = 'ADJUST_APPROVED_PAYROLL',
  AppHelp = 'APP_HELP',
  BackgroundScreening = 'BACKGROUND_SCREENING',
  BambeePlusOfferQuestion = 'BAMBEE_PLUS_OFFER_QUESTION',
  BenefitsCompliance = 'BENEFITS_COMPLIANCE',
  BestPracticeSummary = 'BEST_PRACTICE_SUMMARY',
  BillingIssue = 'BILLING_ISSUE',
  BonusCommission = 'BONUS_COMMISSION',
  BullyingPrevention = 'BULLYING_PREVENTION',
  CompensationDesign = 'COMPENSATION_DESIGN',
  ComplianceTraining = 'COMPLIANCE_TRAINING',
  ComprehensiveGuidance = 'COMPREHENSIVE_GUIDANCE',
  ConflictManagement = 'CONFLICT_MANAGEMENT',
  CultureBuilding = 'CULTURE_BUILDING',
  DeiPromotion = 'DEI_PROMOTION',
  EeoCompliance = 'EEO_COMPLIANCE',
  EmergencyPlanning = 'EMERGENCY_PLANNING',
  EmployeeBenefits = 'EMPLOYEE_BENEFITS',
  EmployeeChat = 'EMPLOYEE_CHAT',
  EmployeeIncident = 'EMPLOYEE_INCIDENT',
  EmployeeIssue = 'EMPLOYEE_ISSUE',
  EmployeeOnboarding = 'EMPLOYEE_ONBOARDING',
  EmployeePerformance = 'EMPLOYEE_PERFORMANCE',
  EmployeeRecognition = 'EMPLOYEE_RECOGNITION',
  EmployeeRequest = 'EMPLOYEE_REQUEST',
  EndingEmploymentEmergency = 'ENDING_EMPLOYMENT_EMERGENCY',
  EndingEmploymentLayoff = 'ENDING_EMPLOYMENT_LAYOFF',
  EndingEmploymentResignation = 'ENDING_EMPLOYMENT_RESIGNATION',
  EngagementMeasurement = 'ENGAGEMENT_MEASUREMENT',
  EngagementTracking = 'ENGAGEMENT_TRACKING',
  ErgonomicSupport = 'ERGONOMIC_SUPPORT',
  ExitInterviews = 'EXIT_INTERVIEWS',
  FinalPay = 'FINAL_PAY',
  FinalPaychecks = 'FINAL_PAYCHECKS',
  FiringTermination = 'FIRING_TERMINATION',
  FmlaCompliance = 'FMLA_COMPLIANCE',
  General = 'GENERAL',
  GoalSetting = 'GOAL_SETTING',
  GrievanceResolution = 'GRIEVANCE_RESOLUTION',
  HarassmentPrevention = 'HARASSMENT_PREVENTION',
  HiringOnboardingPreEmployment = 'HIRING_ONBOARDING_PRE_EMPLOYMENT',
  HrPractice = 'HR_PRACTICE',
  HrTeamIssue = 'HR_TEAM_ISSUE',
  I9EmploymentEligibilityForm = 'I9_EMPLOYMENT_ELIGIBILITY_FORM',
  InclusionTraining = 'INCLUSION_TRAINING',
  InitialHrRequest = 'INITIAL_HR_REQUEST',
  InterviewDesign = 'INTERVIEW_DESIGN',
  JobDescription = 'JOB_DESCRIPTION',
  JobDescriptions = 'JOB_DESCRIPTIONS',
  JobInterviewing = 'JOB_INTERVIEWING',
  LayoffManagement = 'LAYOFF_MANAGEMENT',
  LeadershipTraining = 'LEADERSHIP_TRAINING',
  LeaveAbsence = 'LEAVE_ABSENCE',
  MissedPayroll = 'MISSED_PAYROLL',
  NewCustomPolicy = 'NEW_CUSTOM_POLICY',
  NewPolicy = 'NEW_POLICY',
  OnboardingPractices = 'ONBOARDING_PRACTICES',
  OshaCompliance = 'OSHA_COMPLIANCE',
  OtherIssue = 'OTHER_ISSUE',
  OvertimeCompliance = 'OVERTIME_COMPLIANCE',
  PayrollImplementation = 'PAYROLL_IMPLEMENTATION',
  PayEquity = 'PAY_EQUITY',
  PerformanceImprovement = 'PERFORMANCE_IMPROVEMENT',
  PerformanceReviews = 'PERFORMANCE_REVIEWS',
  PtoPolicies = 'PTO_POLICIES',
  Resignation = 'RESIGNATION',
  RetaliationManagement = 'RETALIATION_MANAGEMENT',
  RetentionTracking = 'RETENTION_TRACKING',
  SalaryBenchmarking = 'SALARY_BENCHMARKING',
  SatisfactionSurveys = 'SATISFACTION_SURVEYS',
  SettingUpBambeePayroll = 'SETTING_UP_BAMBEE_PAYROLL',
  SickLeave = 'SICK_LEAVE',
  StaffComplaint = 'STAFF_COMPLAINT',
  TaxAmendment = 'TAX_AMENDMENT',
  TaxQuestion = 'TAX_QUESTION',
  TechnologyIssue = 'TECHNOLOGY_ISSUE',
  TerminationRisk = 'TERMINATION_RISK',
  TimeAndAttendance = 'TIME_AND_ATTENDANCE',
  TrainingDevelopment = 'TRAINING_DEVELOPMENT',
  TrainingScheduling = 'TRAINING_SCHEDULING',
  UnemploymentClaims = 'UNEMPLOYMENT_CLAIMS',
  WageHour = 'WAGE_HOUR',
  WellnessPrograms = 'WELLNESS_PROGRAMS',
  WorkersCompensation = 'WORKERS_COMPENSATION',
  WorkerClassification = 'WORKER_CLASSIFICATION',
  WorklifeBalance = 'WORKLIFE_BALANCE',
  WorkplacePosting = 'WORKPLACE_POSTING'
}

export enum HrRequestType {
  AdminSupport = 'ADMIN_SUPPORT',
  BambeePayroll = 'BAMBEE_PAYROLL',
  Billing = 'BILLING',
  CompensationBenefits = 'COMPENSATION_BENEFITS',
  CustomerActivation = 'CUSTOMER_ACTIVATION',
  EmailAutoresponder = 'EMAIL_AUTORESPONDER',
  EmployeeFeedback = 'EMPLOYEE_FEEDBACK',
  EmployeeRelations = 'EMPLOYEE_RELATIONS',
  EndingEmployment = 'ENDING_EMPLOYMENT',
  Guidance = 'GUIDANCE',
  HiringOnboarindg = 'HIRING_ONBOARINDG',
  ImplementationPlan = 'IMPLEMENTATION_PLAN',
  IssueReporting = 'ISSUE_REPORTING',
  LaborLaws = 'LABOR_LAWS',
  PayrollSupport = 'PAYROLL_SUPPORT',
  PerformanceManagement = 'PERFORMANCE_MANAGEMENT',
  Policies = 'POLICIES',
  Service = 'SERVICE',
  TechSupport = 'TECH_SUPPORT',
  TrainingDevelopment = 'TRAINING_DEVELOPMENT',
  UnknownRequest = 'UNKNOWN_REQUEST'
}

export enum HrScore {
  Fail = 'FAIL',
  Fair = 'FAIR',
  Good = 'GOOD',
  Great = 'GREAT',
  Poor = 'POOR'
}

export type ImageReference = {
  __typename?: 'ImageReference';
  /** Creation date */
  createdAt: Scalars['DateTime'];
  /** Description of the image */
  description: Scalars['String'];
  /** File size in bytes */
  fileSize?: Maybe<Scalars['Int']>;
  /** MIME type of the file */
  fileType: Scalars['String'];
  /** ImageReference id */
  id: Scalars['ID'];
  /** Whether this image is active */
  isActive: Scalars['Boolean'];
  /** Keywords for searching */
  keywords: Array<Scalars['String']>;
  /** Logical name of the image */
  name: Scalars['String'];
  /** S3 bucket name */
  s3Bucket: Scalars['String'];
  /** S3 key for the image */
  s3Key: Scalars['String'];
  /** Full S3 URL for the image */
  s3Url: Scalars['String'];
  /** Last update date */
  updatedAt: Scalars['DateTime'];
  /** Use cases for the image */
  useCases: Array<Scalars['String']>;
  /** Version of the image set */
  version: Scalars['String'];
};

export type ImageReferenceWithSimilarity = {
  __typename?: 'ImageReferenceWithSimilarity';
  /** Creation date */
  createdAt: Scalars['DateTime'];
  /** Description of the image */
  description: Scalars['String'];
  /** File size in bytes */
  fileSize?: Maybe<Scalars['Int']>;
  /** MIME type of the file */
  fileType: Scalars['String'];
  /** ImageReference id */
  id: Scalars['ID'];
  /** Whether this image is active */
  isActive: Scalars['Boolean'];
  /** Keywords for searching */
  keywords: Array<Scalars['String']>;
  /** Logical name of the image */
  name: Scalars['String'];
  /** S3 bucket name */
  s3Bucket: Scalars['String'];
  /** S3 key for the image */
  s3Key: Scalars['String'];
  /** Full S3 URL for the image */
  s3Url: Scalars['String'];
  /** Similarity score (0-1, where 1 is identical) */
  similarity: Scalars['Float'];
  /** Last update date */
  updatedAt: Scalars['DateTime'];
  /** Use cases for the image */
  useCases: Array<Scalars['String']>;
  /** Version of the image set */
  version: Scalars['String'];
};

export type ImplementationPlanArtifact = {
  __typename?: 'ImplementationPlanArtifact';
  /** The ID of the salesforce case on the HR request backing the implementation plan artifact */
  caseId?: Maybe<Scalars['String']>;
  /** The download url for the hr practices artifact */
  downloadUrl: Scalars['String'];
  /** The dto of the hr practices artifact */
  dto: Scalars['String'];
  /** The ID of the HR request backing the implementation plan artifact */
  hrRequestId?: Maybe<Scalars['String']>;
  /** The artifact renered as HTML */
  html: Scalars['String'];
  /** ID of the hr practices artifact that was created */
  id?: Maybe<Scalars['String']>;
  /** The status of the hr practices artifact */
  status: Scalars['String'];
  /** Title of the hr practices artifact */
  title: Scalars['String'];
};

export type IncidentArtifact = {
  __typename?: 'IncidentArtifact';
  /** The ID of the salesforce case associated with the incident */
  caseId: Scalars['String'];
  /** The url to download the artifact */
  downloadUrl: Scalars['String'];
  /** The summary render as a rich HTML document. */
  html: Scalars['String'];
  /** The id of the incident after accepted and persisted into the system. */
  id?: Maybe<Scalars['String']>;
  /** The parties involved with the incident */
  involved: Array<InvolvedPartyArtifact>;
  /** The status of the incident artifact */
  status: BestPracticeStatus;
  /** The title of the incident */
  title: Scalars['String'];
};

export type InitializeCoverageActivationInput = {
  variant: CoverageActivationVariant;
};

export type InsightAction = {
  __typename?: 'InsightAction';
  label: Scalars['String'];
  target?: Maybe<Scalars['String']>;
  type: InsightActionType;
};

/** The type of action in an insight response */
export enum InsightActionType {
  Escalation = 'ESCALATION',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type InsightResponse = {
  __typename?: 'InsightResponse';
  actions: Array<InsightAction>;
  analysis: Scalars['String'];
  assessment: Scalars['String'];
  confidence: Scalars['Float'];
  domain: Scalars['String'];
  escalation?: Maybe<EscalationTarget>;
  evaluation?: Maybe<Scalars['String']>;
  headline: Scalars['String'];
  severity: NoticeSeverity;
  signalPills: Array<SignalPill>;
  sources: Array<Scalars['String']>;
  subject: Scalars['String'];
};

export type Invoice = {
  __typename?: 'Invoice';
  balance?: Maybe<Money>;
  closedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dueAt?: Maybe<Scalars['DateTime']>;
  hasMoreLines?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lines?: Maybe<Array<InvoiceLine>>;
  number: Scalars['String'];
  paid?: Maybe<Money>;
  paidAt?: Maybe<Scalars['DateTime']>;
  /** Path of the PDF download, relative to the billing-service base URL: GET /billing/v2/companies/{companyId}/invoices/{invoiceId}/pdf with the caller's bearer token. */
  pdfUrl: Scalars['String'];
  state: Scalars['String'];
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  total: Money;
  type?: Maybe<Scalars['String']>;
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  nodes: Array<Invoice>;
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  addOnCode?: Maybe<Scalars['String']>;
  amount: Money;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  planCode?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  subtotal?: Maybe<Money>;
  type?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Money>;
};

export type InvolvedPartyArtifact = {
  __typename?: 'InvolvedPartyArtifact';
  /** The id of the party involved with the incident, if an employee */
  id?: Maybe<Scalars['String']>;
  /** The name of the party involved with the incident */
  name: Scalars['String'];
  /** The role of the party involved with the incident */
  role: InvolvedPartyRole;
};

export enum InvolvedPartyRole {
  Accused = 'ACCUSED',
  Reporter = 'REPORTER',
  Subject = 'SUBJECT',
  Witness = 'WITNESS'
}

export type IsEventScheduledForUser = {
  __typename?: 'IsEventScheduledForUser';
  /** The invitee email */
  email: Scalars['String'];
  /** The event slug to check */
  eventSlug: Scalars['String'];
  id: Scalars['ID'];
  /** True if event type has already been scheduled for the email. False otherwise. */
  isScheduled: Scalars['Boolean'];
};

export type IsEventScheduledForUserInput = {
  /** The invitee email */
  email: Scalars['String'];
  /** The event slug to check */
  eventSlug: Scalars['String'];
};



export type JobDescription = {
  __typename?: 'JobDescription';
  aiGenerated?: Maybe<AiGenerated>;
  aiGeneratedId?: Maybe<Scalars['String']>;
  /** Number of employees this job description is assigned to */
  assignmentCount?: Maybe<Scalars['Float']>;
  body: Scalars['JSON'];
  completedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type JobDescriptionArtifact = {
  __typename?: 'JobDescriptionArtifact';
  /** The ID of the salesforce case associated with the job description */
  caseId: Scalars['String'];
  /** The job description dto */
  dto: JobDescriptionDto;
  /** The summary render as a rich HTML document. */
  html: Scalars['String'];
  /** The id of the job description after accepted and persisted into the system. */
  id?: Maybe<Scalars['String']>;
  /** The gather summary status */
  status: JobDescriptionStatus;
  /** The title the job description */
  title?: Maybe<Scalars['String']>;
};

export type JobDescriptionDto = {
  __typename?: 'JobDescriptionDto';
  employeeType?: Maybe<JobDescriptionEmployeePayType>;
  employmentPayRate?: Maybe<JobDescriptionEmploymentPayRate>;
  employmentTaxType?: Maybe<JobDescriptionEmploymentTaxType>;
  industry: Scalars['String'];
  jobTitle: Scalars['String'];
  location?: Maybe<JobDescriptionLocation>;
  travelRequirements?: Maybe<Scalars['String']>;
  workingSchedule?: Maybe<Array<WorkingSchedule>>;
};

export enum JobDescriptionEmployeePayType {
  FullTime = 'FullTime',
  PartTime = 'PartTime'
}

export enum JobDescriptionEmploymentPayRate {
  Hourly = 'Hourly',
  Salary = 'Salary'
}

export enum JobDescriptionEmploymentTaxType {
  Report_1099 = 'REPORT_1099',
  ReportW2 = 'REPORT_W2'
}

export enum JobDescriptionLocation {
  Hybrid = 'Hybrid',
  InPerson = 'InPerson',
  Remote = 'Remote'
}

export enum JobDescriptionStatus {
  Accepted = 'accepted',
  Assigned = 'assigned',
  Drafted = 'drafted',
  New = 'new'
}

/** Size of question labels */
export enum LabelSize {
  Base = 'BASE',
  Lg = 'LG',
  Sm = 'SM',
  Xl = 'XL',
  Xxl = 'XXL',
  Xxxl = 'XXXL'
}

/** Weight of question labels */
export enum LabelWeight {
  Bold = 'BOLD',
  Medium = 'MEDIUM',
  Normal = 'NORMAL',
  Semibold = 'SEMIBOLD'
}

export enum Language {
  En = 'EN',
  Es = 'ES'
}

/** The reason the company was brought to Bambee */
export enum LeadReason {
  ActiveHrIssue = 'ACTIVE_HR_ISSUE',
  CompliancePolicies = 'COMPLIANCE_POLICIES',
  EeOnboardingTraining = 'EE_ONBOARDING_TRAINING',
  General = 'GENERAL',
  Other = 'OTHER',
  PerformanceManagement = 'PERFORMANCE_MANAGEMENT',
  RecruitingHiring = 'RECRUITING_HIRING',
  Terminations = 'TERMINATIONS',
  Wages = 'WAGES'
}

/** The type of internal link for LINK action types */
export enum LinkType {
  Cap = 'CAP',
  Document = 'DOCUMENT',
  EmployeeDetail = 'EMPLOYEE_DETAIL',
  Eoe = 'EOE',
  Guidance = 'GUIDANCE',
  GuidanceDetail = 'GUIDANCE_DETAIL',
  JobDescription = 'JOB_DESCRIPTION',
  NoticeDetail = 'NOTICE_DETAIL',
  Pip = 'PIP',
  Policy = 'POLICY',
  Staff = 'STAFF',
  Training = 'TRAINING',
  WrittenWarning = 'WRITTEN_WARNING'
}

export type ListHrRequestDetails = {
  __typename?: 'ListHrRequestDetails';
  hrRequests: Array<Maybe<HrRequestDetail>>;
};

export type ListHrRequestsResponse = {
  __typename?: 'ListHrRequestsResponse';
  hrRequests: Array<Maybe<HrRequest>>;
};

export type ListReportCardsInput = {
  companyId: Scalars['String'];
  employeeId?: Maybe<Scalars['String']>;
};

export type ListSalesforceCasesResponse = {
  __typename?: 'ListSalesforceCasesResponse';
  cases: Array<Maybe<SalesforceCase>>;
};

export type ListTicketsInput = {
  companyId: Scalars['String'];
};

export type ListTicketsResponse = {
  __typename?: 'ListTicketsResponse';
  id: Scalars['ID'];
  tickets: Array<Maybe<Ticket>>;
  totalTickets: Scalars['Int'];
};

export type ManagedReport = {
  __typename?: 'ManagedReport';
  employees: Array<CoreUser>;
  /** Manager Employee Id */
  id: Scalars['ID'];
  manager: CoreUser;
};

export type MarkAsUnhelpfulInput = {
  /** Array of notice IDs to mark as unhelpful */
  noticesArray?: Maybe<Array<Scalars['ID']>>;
  /** Array of solution IDs to mark as unhelpful */
  solutionsArray?: Maybe<Array<Scalars['ID']>>;
};

export type MarkAsUnhelpfulResponse = {
  __typename?: 'MarkAsUnhelpfulResponse';
  noticesMarked: Scalars['Int'];
  solutionsMarked: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type MessageContentDto = {
  __typename?: 'MessageContentDto';
  /** image content */
  image_file?: Maybe<Scalars['String']>;
  /** image content */
  image_url?: Maybe<Scalars['String']>;
  /** refusal content */
  refusal?: Maybe<Scalars['String']>;
  /** text content */
  text?: Maybe<TextContentBlock>;
  /** Type of content */
  type: Scalars['String'];
};

export enum MessageGroupType {
  Custom = 'CUSTOM',
  Inactive = 'INACTIVE',
  SignatureRequired = 'SIGNATURE_REQUIRED'
}

export type MessageMetaDataDto = {
  __typename?: 'MessageMetaDataDto';
  /** Indicates the message represents an artifact. Use the artifact object to retreive values instead of message content */
  artifact?: Maybe<Scalars['String']>;
  /** The name of the assistant */
  assistant?: Maybe<Scalars['String']>;
  /** The id of the assistant */
  assistantId?: Maybe<Scalars['String']>;
  /** Indicates the message should not be displayed to the user */
  hidden?: Maybe<Scalars['String']>;
  /** Indicates the message was injected by the backend. Regardless of the role. */
  injected?: Maybe<Scalars['String']>;
  /** Indicates whether the base policy template is from our existing database */
  isBambeeTemplateBase?: Maybe<Scalars['String']>;
  /** Metadata type */
  type?: Maybe<Scalars['String']>;
  /** Metadata value */
  value?: Maybe<Scalars['String']>;
};

export enum MessageOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  SequenceAsc = 'SEQUENCE_ASC',
  SequenceDesc = 'SEQUENCE_DESC'
}

export enum MessageType {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export type MinimalViableUserInput = {
  companyId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  stateWorkIn?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topPerformer?: Maybe<TopPerformerInput>;
};

export enum MissedCallFeeStatus {
  Charged = 'CHARGED',
  Warned = 'WARNED'
}

export type Money = {
  __typename?: 'Money';
  amount: Scalars['String'];
  currency: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept a cancellation offer */
  acceptOffer: Scalars['Boolean'];
  /** Attempts to accept a recommendation. If the acceptr meets the criteria, the recommendation is acceptd, setting the status to ACCEPTED. */
  acceptRecommendation: CoreRecommendation;
  /** Accept a cancellation trial offer */
  acceptTrialOffer: Scalars['Boolean'];
  activateHandsFreeActionItem: Scalars['Boolean'];
  /** Activate a wizard group for a customer */
  activateWizardGroup: WizardGroupActivationResult;
  addAutoassignHrManagerConfiguration: Array<AutoAssignHrManager>;
  addBusinessManagerConfiguration: Array<BusinessManager>;
  addCredits: AddCreditsResult;
  addPaymentMethod: AddPaymentMethodResult;
  addQuestionBatchToStore: Array<QuestionStore>;
  addQuestionToStore: QuestionStore;
  addRealTimeMessage: RealTimeMessage;
  addSubscription: AddCreditsResult;
  adminEnqueueTicketForSync: Scalars['Boolean'];
  advanceCoverageActivation: CoverageActivationSnapshot;
  aiOptIn: Scalars['Boolean'];
  /** Attempts to approve a request. If the approver meets the criteria, the request is approved, setting the status to APPROVED. */
  approveRequest: CoreRequest;
  /** Approve the stage a resolution cycle is held on (GuidanceApproval / AdministrationApproval / ExecutionApproval). The `stage` is the stage the caller expects to approve; the mutation rejects if the cycle is no longer on it. Advances the stage on the Salesforce case (SF owns the stage) and returns the cycle already on the released stage. Fires the corresponding Segment event. */
  approveResolutionCycleStage: ResolutionCycle;
  archiveAiThread: AiThread;
  archiveCompanyPolicy?: Maybe<CorePolicy>;
  archivePolicy?: Maybe<CorePolicy>;
  archiveRealTimeThread?: Maybe<RealTimeThread>;
  assignUserToPolicies: Array<CoreDocument>;
  assignUsersToPolicies: Array<CoreUser>;
  assignWorkerRoles: CoreUser;
  attachResignationFiles: Resignation;
  attachTerminationFiles: Termination;
  backfillBambeePlusTopics: Scalars['Boolean'];
  /** Attempts to bulk approve requests. If the approver meets the criteria, the requests are approved, setting their statuses to APPROVED.If an approval fails, the operation continues and the error is returned in the response. */
  bulkApproveRequests: BulkRequestResult;
  /** Attempts to bulk cancel requests. If a cancellation fails, the operation continues and the error is returned in the response. */
  bulkCancelRequests: BulkRequestResult;
  bulkCompleteEnrollments: EnrollmentCompleted;
  bulkEnrollUsers: BulkEnrollUsersResponse;
  bulkMessageStaff: BulkMessageStaffResult;
  bulkPurchaseSeats: Array<PurchaseSeatsResponse>;
  /** Attempts to bulk reject requests. If the rejector meets the criteria, the requests are rejected, setting their statuses to REJECTED.If a rejection fails, the operation continues and the error is returned in the response. */
  bulkRejectRequests: BulkRequestResult;
  /** Toggles multiple activations at once */
  bulkToggleActivations: BulkActivationResult;
  bulkUploadEmployeesThroughCsv: Array<BulkUploadEmployeesResponse>;
  cancelBambeePlus: BambeePlus;
  cancelNectarSubscription: Product;
  cancelPendingHotlineCall: Scalars['Boolean'];
  /** Cancel the standalone Premium People add-on subscription immediately. */
  cancelPremiumPeopleAddonSubscription: Subscription;
  /** Attempts to cancel a recommendation. If canceler is the user who created the recommendation, the recommendation is cancelled, setting the status to CANCELLED. */
  cancelRecommendation: CoreRecommendation;
  /** Attempts to cancel a request. If canceler is the user who created the request, the request is cancelled, setting the status to CANCELLED. */
  cancelRequest: CoreRequest;
  cancelResignation: Resignation;
  cancelScheduledEvent: ScheduledEvent;
  cancelSubscription: BillingSubscriptionModel;
  cancelTermination: Termination;
  /** Move a pending, or closed but not yet effective, cancellation for a Recurly-billed company to another timeframe */
  changeCancellationTimeframe: CancellationModel;
  /** Change a company core plan immediately without creating any proration credit or charge. The company keeps the period it already paid for; the new price is billed in full at the next renewal. Company owners may only do this while trialing and only onto Premium People; honey roles are unrestricted. */
  changeCorePlanWithoutProration: Subscription;
  changePlan: BillingSubscriptionModel;
  changeSeats: BillingSubscriptionModel;
  changeTrialEndDateForCoreSubscription: Subscription;
  chatWithAssistant: AiAssistantResponse;
  /** Record that a user clicked on an action */
  clickedOnNotificationAction: Scalars['Boolean'];
  /** Close a pending cancellation request for a Recurly-billed company */
  closeCancellationRequest: CancellationModel;
  closeHrRequest: HrRequest;
  completeCompanyPractice: Practice;
  completeCompanySurvey: Survey;
  completeGoal: CoreGoal;
  /** Completes a job description. Will no longer be editable. */
  completeJobDescription: JobDescription;
  completeRealTimeThread?: Maybe<RealTimeThread>;
  completeReportCard: ReportCard;
  /** Mark a solution as completed */
  completeSolution: Solution;
  completeTask?: Maybe<CoreTask>;
  confirmMicroDeposit: BillingPaymentMethod;
  confirmResignation: Resignation;
  confirmTermination: Termination;
  confirmUserMfaEnrollment: AuthMfaConfig;
  /** Service to service. */
  consumeCredit: BillingCredit;
  /** Creates or updates an activation for a feature key for a company */
  createActivation: CoreActivation;
  createBundle: BundleResponse;
  createCancellationRequest: CancellationModel;
  createChallenge: AuthMfaChallenge;
  /** Create Core Protective Documents (CPDs) for a company. Use for backfilling existing customers. */
  createCompanyCPDs: Scalars['Boolean'];
  createCompanyRoles: Array<CompanyRole>;
  createEmployee: UserCreatedResult;
  createHrRequest: HrRequest;
  createHrRequestByInternalUser: HrRequest;
  createHrRequestFromSalesforceCase: HrRequest;
  createHrRequestsFromIntercomConversations: ListHrRequestsResponse;
  /** Create or update image references for existing S3 images */
  createImageReferenceMetadataBatch: Array<ImageReference>;
  /** Creates a new job description */
  createJobDescription: JobDescription;
  /** Create multiple notices at once */
  createManyNotices: Array<Notice>;
  createMinimumViableUser: UserCreatedResult;
  /** Create a new notice */
  createNotice: Notice;
  createPlanLock: PlanLock;
  /** Create the standalone Premium People add-on (a second Stripe subscription). */
  createPremiumPeopleAddonSubscription: Subscription;
  createProductInterest: ProductInterest;
  createRealTimeThread: RealTimeThread;
  createReportCard: NewReportCard;
  createResignation: Resignation;
  /** Open a ResolutionCycle from Talk-to-Bambee Send Request: creates the SF Case and persists the cycle with no upstream notice (BIO-575). */
  createResolutionCycle: ResolutionCycle;
  createTermination: Termination;
  createVoicesFeedback: VoicesFeedback;
  createWizard: Wizard;
  /** Create a new wizard group */
  createWizardGroup: WizardGroup;
  /** Create a new wizard template */
  createWizardTemplate: WizardTemplate;
  createWizardWithResponses: Wizard;
  /** Deactivate a wizard group for a customer */
  deactivateWizardGroup: WizardGroupActivationResult;
  /** Attempts to decline a recommendation. If the declineor meets the criteria, the recommendation is declined, setting the status to DECLINED. */
  declineRecommendation: CoreRecommendation;
  /** Seed a company onto the plan we recommend without claiming they chose it. The resulting record has isExplicitSelection false and no chooser. */
  defaultMigrationPlan: BillingMigrationRecord;
  /** Delegate a solution to a company user or Bambee team */
  delegateSolution: Solution;
  /** Deletes an activation */
  deleteActivation: CoreActivation;
  deleteBundle: DeleteBundleResponse;
  deleteCompanyRolesById?: Maybe<Array<CompanyRole>>;
  /** Delete an image reference */
  deleteImageReference: Scalars['Boolean'];
  /** Soft delete a job description. Will throw an error if the job description is assigned to any employees. */
  deleteJobDescription: JobDescription;
  deleteQuestionFromStore: Scalars['Boolean'];
  deleteRealTimeThread: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  deleteWizard: Scalars['Boolean'];
  /** Soft delete a wizard group */
  deleteWizardGroup: Scalars['Boolean'];
  /** Delete a wizard template */
  deleteWizardTemplate: Scalars['Boolean'];
  disableMfaEnrollment: Array<AuthMfaConfig>;
  /** Dismiss a notice */
  dismissNotice: Scalars['Boolean'];
  /** Dismiss a notification */
  dismissNotification: Notification;
  /** Duplicate a wizard template to a different role */
  duplicateWizardTemplate: WizardTemplate;
  editResignationDetails: Resignation;
  editTerminationDetails: Termination;
  emit: EventEmitted;
  enqueueHotlineCall: Scalars['Boolean'];
  enrollMfaDevice: AuthMfaChallenge;
  enrollUsers: EnrollUsersResponse;
  extendBambeePlusOnboardingDueDate: BambeePlus;
  extendBambeePlusOnboardingWithSpecificDate: BambeePlus;
  extendTrial: BillingSubscriptionModel;
  forceInitializeUserGroups: Scalars['Boolean'];
  /** Calls our ai provider to generate a job description powered by AI taking user input into consideration */
  generateAiJobDescription: JobDescription;
  /** Kicks off the AI generation process in the background returning quickly with a partial job description */
  generateAiJobDescriptionV2: JobDescription;
  /** Generate or refine an artifact draft. Routes to type-specific AI workflows based on artifactType. */
  generateArtifactDraft: ArtifactDto;
  /** Generate multiple artifact drafts in parallel with optional auto-finalization. Supports partial success - some artifacts may succeed while others fail. */
  generateArtifactDrafts: GenerateArtifactDraftsResult;
  generateRealTimeThreadTitle?: Maybe<RealTimeThread>;
  /** Generate wizard template data using AI */
  generateWizardTemplate: Scalars['JSON'];
  /** Staff only. */
  grantCredits: Array<BillingCredit>;
  initializeCoverageActivation: CoverageActivationSnapshot;
  makeUserAdmin: Scalars['Boolean'];
  /** Mark notices and/or solutions as unhelpful (soft-deletes with unhelpful flag) */
  markAsUnhelpful: MarkAsUnhelpfulResponse;
  markCourseTicketAsIncomplete: Ticket;
  migrateUsersToMultiplePayRates: Scalars['Boolean'];
  pauseSubscription: BillingSubscriptionModel;
  /** Start a resolution cycle for a notice and move the notice to PROCESSED */
  processNotice: ResolutionCycle;
  productInterestNotificationDismissedInApp: ProductInterest;
  purchase: BillingPurchaseResult;
  purchaseCredits: PurchaseResult;
  purchaseCreditsV2: BillingPurchaseResult;
  purchaseSeats: PurchaseSeatsResponse;
  /** @deprecated Use `purchaseSeats` mutation instead */
  purchaseSeatsForBundle: PurchaseSeatsResponse;
  purchaseSubscription: PurchaseResult;
  /** @deprecated Use `purchaseSeats` mutation instead */
  purchaseTickets: PurchaseTicketsResponse;
  qaMutateDocumentAsUnsigned?: Maybe<CoreDocument>;
  qaMutateFeedsForCurrentDocumentStatus: Array<Feed>;
  qaMutatePolicyIncomplete?: Maybe<CorePolicy>;
  qaMutateRemoveManagerFeedsForDocument: Array<Feed>;
  /** Query the QnA assistant for structured HR insights */
  qnaQuery: InsightResponse;
  /** Rate a notice as helpful or not helpful */
  rateNotice?: Maybe<Notice>;
  /** A generic reaction to a recommendation. If the reactor meets the criteria, the reaction is recorded and the recommendation status may be updated */
  reactToRecommendation: CoreRecommendation;
  reactivatePausedCompany: Scalars['Boolean'];
  reaffirmDocument: CoreDocument;
  /** Reassign a delegated solution to yourself (reclaim from Bambee or another user) */
  reassignSolutionToSelf: Solution;
  /** Reclaim a solution delegated to a manager, clearing the delegation and returning it to not-started */
  reclaimSolution: Solution;
  /** Creates a generic recommendation based on the input provided. This is a raw recommendation and does not have any business logic applied to it. Admins only */
  recommendation: CoreRecommendation;
  refundCreditPurchase: RefundResult;
  /** Regenerate the guidance of a cycle (BIO-1395 / HEX-US-16/17). Runs the same generation path as creation, synchronously. Input: answers (sufficiency loop) XOR revisionNote (request changes) XOR neither (retry, only after FAILED). Typed conflicts: STAGE_CONFLICT (cycle past the guidance phase or the SF case moved) and GENERATION_IN_FLIGHT (an attempt is already running). */
  regenerateGuidance: ResolutionCycle;
  reinstateEmployee: Resignation;
  /** Attempts to reject a request. If the rejector meets the criteria, the request is rejected, setting the status to REJECTED. */
  rejectRequest: CoreRequest;
  remove: RemoveCompanyTrainingResponse;
  removeActiveCredits: Array<Credit>;
  removeBusinessManagerConfiguration: Array<BusinessManager>;
  removeCourseCertificate?: Maybe<QaTrainingCertificates>;
  removeDuplicatedPolicyDocuments: DuplicatedPolicyDocumentResult;
  removePaymentMethod: Scalars['Boolean'];
  removePaymentMethodV2: Scalars['Boolean'];
  removeS3fileFromCourseCertificate?: Maybe<QaTrainingCertificates>;
  removeSeatWaiver: SeatWaiverResult;
  removeSeats: RemoveSeatsResponse;
  /** @deprecated Use `removeSeats` mutation instead */
  removeSeatsFromBundle: RemoveSeatsResponse;
  removeUserAdmin: Scalars['Boolean'];
  reopenRealTimeThread?: Maybe<RealTimeThread>;
  replyToConversation: Conversation;
  replyToHrRequestAsAdmin: HrRequest;
  /** Creates a generic request based on the input provided. This is a raw request and does not have any business logic applied to it. Admins only */
  request: CoreRequest;
  resendChallenge: AuthMfaChallenge;
  /** Reset a solution to not started (clears all status timestamps) */
  resetSolution: Solution;
  resumeSubscription: BillingSubscriptionModel;
  /** Reverse a pending or not yet effective cancellation for a Recurly-billed company */
  reverseCancellation: CancellationModel;
  /** Finalize an artifact and create the corresponding entity */
  saveArtifact: SaveArtifactResultDto;
  saveCompanyAnswer: Survey;
  saveCompanySetting: CompanySetting;
  /** Saves job description latest state associating to an employee if not already associated */
  saveJobDescriptionOnEmployee: EmployeeJobDescription;
  scratchToggleServiceAddon: ScratchServiceAddonsModel;
  /** Record the plan a company actively chose. Safe to call twice with the same payload -- an unchanged selection returns the existing record rather than writing a duplicate. */
  selectMigrationPlan: BillingMigrationRecord;
  selfUnenrollRetired: UnenrolledUsers;
  sendFeedbackMessage: ChatMessageInterface;
  /** Finalizes a job description and sends it for acknowledgment to an employee */
  sendJobDescriptionToEmployee: EmployeeJobDescription;
  sendMagicLinkForEmail: Scalars['Boolean'];
  sendMessageToUser: ChatMessageInterface;
  sendReplyToUserThread: ChatMessageInterface;
  setAddOn: BillingSubscriptionModel;
  setCaseStatus: HrRequest;
  setDefaultPaymentMethod: BillingPaymentMethod;
  /** Set policy reaffirmation cadence. Creates survey answer if needed. */
  setPolicyCadence: Survey;
  setPrimaryPaymentMethod: PaymentMethod;
  setSeatWaiver: SeatWaiverResult;
  /** User acknowleges the job description sent by employer */
  signEmployeeJobDescription: EmployeeJobDescription;
  startTask: CoreTask;
  /** Customer-initiated trial on a paid Hexagon plan (BIO-150). */
  startTrialOnCorePlan: Subscription;
  submitAiPrompt: AiPromptResponse;
  sync: SyncResponse;
  syncDocuments?: Maybe<Array<CoreDocument>>;
  syncUserEnrollments: SyncUserEnrollmentsResponse;
  syncWorkerRoles: Scalars['Boolean'];
  /** Toggles an activation (enables or disables it) */
  toggleActivation: CoreActivation;
  track: AnalyticEventTracked;
  trackProductInterest: Scalars['String'];
  /** Creates a training recommendation based on the input provided */
  trainingRecommendation: CoreRecommendation;
  /** Creates a training request based on the input provided */
  trainingRequest: CoreRequest;
  triggerFixUserBundleEnrollments: EnrollUserResponse;
  /** Undismiss a notice */
  undismissNotice: Scalars['Boolean'];
  unenrollCompanyBundle: Scalars['Boolean'];
  unenrollUsers: UnenrolledUsers;
  /** @deprecated use unenrollUsers */
  unenrollUsersFromBundle: UnenrolledUsers;
  /** Unmark notices and/or solutions as unhelpful (restores soft-deleted content) */
  unmarkAsUnhelpful: MarkAsUnhelpfulResponse;
  updateCompanyRoles: Array<CompanyRole>;
  updateCoreCompany: CoreCompany;
  updateCoreUserEmployment: CoreUserEmployment;
  updateCoreUserProfile: CoreUserProfile;
  updateCoreUserState: CoreUserStates;
  /** Edit one generated Execution document before the Execution sign-off (BIO-2078): customer edits the generated documents and the PDFs are made from the approved version. Company owner/admin only, scoped to the JWT company. Valid only while the cycle is at Execution / ExecutionApproval — locked after (STAGE_CONFLICT). The generated original is kept next to the edit (generatedBody / editedAt / editedByUserId on the document); re-saving the generated text restores the original and clears the edit markers. */
  updateExecutionDocument: ResolutionCycle;
  /** Update an existing image reference */
  updateImageReference: ImageReference;
  /** Updates the title and body of a job description that is still in draft mode. */
  updateJobDescription: JobDescription;
  /** Update an existing notice */
  updateNotice?: Maybe<Notice>;
  updatePaymentSourceBillingAddress: PaymentSource;
  updatePlanLock: PlanLock;
  updateQuestionInStore: QuestionStore;
  updateRealTimeThread?: Maybe<RealTimeThread>;
  updateReportCard: ReportCard;
  updateWizard: Wizard;
  /** Update an existing wizard group */
  updateWizardGroup: WizardGroup;
  updateWizardResponse: Wizard;
  /** Update an existing wizard template */
  updateWizardTemplate: WizardTemplate;
  /** Upgrade a company subscription from one plan to another one. */
  upgradeCorePlan: Subscription;
  uploadFilesToConversation: Conversation;
  /** Upload a new image reference */
  uploadImageReference: ImageReference;
  /** Upload multiple image references in batch */
  uploadImageReferencesBatch: Array<ImageReference>;
  /** Creates a generic onboarding based on the input provided. This is a raw onboarding and does not have any business logic applied to it. Admins only */
  upsertOnboarding: CoreOnboarding;
  /** Staff only. */
  voidCredits: Array<BillingCredit>;
};


export type MutationAcceptOfferArgs = {
  input: AcceptOfferInput;
};


export type MutationAcceptRecommendationArgs = {
  data: AcceptRecommendationInput;
};


export type MutationAcceptTrialOfferArgs = {
  input: AcceptTrialOfferInput;
};


export type MutationActivateWizardGroupArgs = {
  customerId: Scalars['ID'];
  input: ActivateWizardGroupInput;
};


export type MutationAddAutoassignHrManagerConfigurationArgs = {
  input: AutoAssignHrManagerInput;
};


export type MutationAddBusinessManagerConfigurationArgs = {
  input: BusinessManagerForTierInput;
};


export type MutationAddCreditsArgs = {
  data: AddCreditsInput;
};


export type MutationAddPaymentMethodArgs = {
  input: AddPaymentMethodInput;
};


export type MutationAddQuestionBatchToStoreArgs = {
  data: CreateQuestionStoreBatchInput;
};


export type MutationAddQuestionToStoreArgs = {
  data: CreateQuestionStoreInput;
};


export type MutationAddRealTimeMessageArgs = {
  input: AddRealTimeMessageInput;
};


export type MutationAddSubscriptionArgs = {
  data: AddSubscriptionInput;
};


export type MutationAdminEnqueueTicketForSyncArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationAdvanceCoverageActivationArgs = {
  input: AdvanceCoverageActivationInput;
};


export type MutationAiOptInArgs = {
  data: AiOptionInput;
};


export type MutationApproveRequestArgs = {
  data: RequestApprovalInput;
};


export type MutationApproveResolutionCycleStageArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  stage: ResolutionCycleStage;
};


export type MutationArchiveAiThreadArgs = {
  threadId: Scalars['String'];
};


export type MutationArchiveCompanyPolicyArgs = {
  input: ArchivePolicyInput;
};


export type MutationArchivePolicyArgs = {
  input: ArchivePolicyInput;
};


export type MutationArchiveRealTimeThreadArgs = {
  id: Scalars['ID'];
};


export type MutationAssignUserToPoliciesArgs = {
  data: AssignUserToPoliciesInput;
};


export type MutationAssignUsersToPoliciesArgs = {
  data: AssignUsersToPoliciesInput;
};


export type MutationAssignWorkerRolesArgs = {
  input: AssignWorkerRolesInput;
};


export type MutationAttachResignationFilesArgs = {
  data: ResignationAttachInput;
};


export type MutationAttachTerminationFilesArgs = {
  data: TerminationAttachInput;
};


export type MutationBackfillBambeePlusTopicsArgs = {
  input: BackfillBambeePlusTopicsInput;
};


export type MutationBulkApproveRequestsArgs = {
  data: Array<RequestApprovalInput>;
};


export type MutationBulkCancelRequestsArgs = {
  data: Array<RequestCancelInput>;
};


export type MutationBulkCompleteEnrollmentsArgs = {
  data: BulkCompleteEnrollmentInput;
};


export type MutationBulkEnrollUsersArgs = {
  data: BulkEnrollUsersInput;
};


export type MutationBulkMessageStaffArgs = {
  data: BulkMessageStaffInput;
};


export type MutationBulkPurchaseSeatsArgs = {
  data: BulkPurchaseSeatsInput;
};


export type MutationBulkRejectRequestsArgs = {
  data: Array<RequestRejectionInput>;
};


export type MutationBulkToggleActivationsArgs = {
  data: Array<ActivationToggleInput>;
};


export type MutationBulkUploadEmployeesThroughCsvArgs = {
  base64: Scalars['String'];
};


export type MutationCancelBambeePlusArgs = {
  input: PurchaseBambeePlusInput;
};


export type MutationCancelNectarSubscriptionArgs = {
  data: CancelSubscriptionInput;
};


export type MutationCancelPremiumPeopleAddonSubscriptionArgs = {
  data: CancelPremiumPeopleAddonInput;
};


export type MutationCancelRecommendationArgs = {
  data: CancelRecommendationInput;
};


export type MutationCancelRequestArgs = {
  data: RequestCancelInput;
};


export type MutationCancelResignationArgs = {
  data: ResignationCancelInput;
};


export type MutationCancelScheduledEventArgs = {
  input: CancelScheduledEventInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelInput;
};


export type MutationCancelTerminationArgs = {
  data: TerminationCancelInput;
};


export type MutationChangeCancellationTimeframeArgs = {
  input: ChangeCancellationTimeframeInput;
};


export type MutationChangeCorePlanWithoutProrationArgs = {
  input: UpgradeCorePlanInput;
};


export type MutationChangePlanArgs = {
  input: ChangePlanInput;
};


export type MutationChangeSeatsArgs = {
  input: ChangeSeatsInput;
};


export type MutationChangeTrialEndDateForCoreSubscriptionArgs = {
  data: ChangeTrialEndDateForCoreSubscriptionInput;
};


export type MutationChatWithAssistantArgs = {
  data: AiAssistantInput;
};


export type MutationClickedOnNotificationActionArgs = {
  actionId: Scalars['String'];
};


export type MutationCloseCancellationRequestArgs = {
  input: CloseCancellationRequestInput;
};


export type MutationCloseHrRequestArgs = {
  input: CloseHrRequestInput;
};


export type MutationCompleteCompanyPracticeArgs = {
  data: CompletePracticeInput;
};


export type MutationCompleteCompanySurveyArgs = {
  data: CompleteCompanySurveyInput;
};


export type MutationCompleteGoalArgs = {
  data: CompleteGoalInput;
};


export type MutationCompleteJobDescriptionArgs = {
  id: Scalars['String'];
};


export type MutationCompleteRealTimeThreadArgs = {
  id: Scalars['ID'];
};


export type MutationCompleteReportCardArgs = {
  data: CompleteReportCardInput;
};


export type MutationCompleteSolutionArgs = {
  input: CompleteSolutionInput;
};


export type MutationCompleteTaskArgs = {
  data: CompleteTaskInput;
};


export type MutationConfirmMicroDepositArgs = {
  input: ConfirmMicroDepositInput;
};


export type MutationConfirmResignationArgs = {
  data: ResignationConfirmationInput;
};


export type MutationConfirmTerminationArgs = {
  data: TerminationConfirmationInput;
};


export type MutationConfirmUserMfaEnrollmentArgs = {
  input: AuthMfaChallengeResponseInput;
};


export type MutationConsumeCreditArgs = {
  input: ConsumeCreditInput;
};


export type MutationCreateActivationArgs = {
  data: ActivationInput;
};


export type MutationCreateBundleArgs = {
  data: CreateBundleInput;
};


export type MutationCreateCancellationRequestArgs = {
  input: CreateCancellationRequestInput;
};


export type MutationCreateChallengeArgs = {
  reason: Scalars['String'];
  type: AuthMfaType;
};


export type MutationCreateCompanyCpDsArgs = {
  data: CreateCompanyCpDsInput;
};


export type MutationCreateCompanyRolesArgs = {
  data: CreateMultipleRolesForCompanyInput;
};


export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};


export type MutationCreateHrRequestArgs = {
  input: CreateHrRequestInput;
};


export type MutationCreateHrRequestByInternalUserArgs = {
  input: CreateHrRequestByInternalUserInput;
};


export type MutationCreateHrRequestFromSalesforceCaseArgs = {
  input: CreateHrRequestFromSalesforceCaseInput;
};


export type MutationCreateHrRequestsFromIntercomConversationsArgs = {
  input: CreateHrRequestsFromIntercomConversationsInput;
};


export type MutationCreateImageReferenceMetadataBatchArgs = {
  input: CreateImageReferenceMetadataBatchInput;
};


export type MutationCreateJobDescriptionArgs = {
  data: CreateJobDescriptionInput;
};


export type MutationCreateManyNoticesArgs = {
  input: CreateManyNoticesInput;
};


export type MutationCreateMinimumViableUserArgs = {
  input: MinimalViableUserInput;
};


export type MutationCreateNoticeArgs = {
  input: CreateNoticeInput;
};


export type MutationCreatePlanLockArgs = {
  input: CreatePlanLockInput;
};


export type MutationCreatePremiumPeopleAddonSubscriptionArgs = {
  data: CreatePremiumPeopleAddonInput;
};


export type MutationCreateProductInterestArgs = {
  input: CreateProductInterestInput;
};


export type MutationCreateRealTimeThreadArgs = {
  input: CreateRealTimeThreadInput;
};


export type MutationCreateReportCardArgs = {
  data: CreateReportCardInput;
};


export type MutationCreateResignationArgs = {
  data: ResignationCreateInput;
};


export type MutationCreateResolutionCycleArgs = {
  input: CreateResolutionCycleInput;
};


export type MutationCreateTerminationArgs = {
  data: TerminationCreateInput;
};


export type MutationCreateVoicesFeedbackArgs = {
  input: CreateVoicesFeedbackInput;
};


export type MutationCreateWizardArgs = {
  input: CreateWizardInput;
};


export type MutationCreateWizardGroupArgs = {
  input: CreateWizardGroupInput;
};


export type MutationCreateWizardTemplateArgs = {
  input: CreateWizardTemplateInput;
};


export type MutationCreateWizardWithResponsesArgs = {
  input: CreateWizardWithResponsesInput;
};


export type MutationDeactivateWizardGroupArgs = {
  customerId: Scalars['ID'];
  input: DeactivateWizardGroupInput;
};


export type MutationDeclineRecommendationArgs = {
  data: DeclineRecommendationInput;
};


export type MutationDefaultMigrationPlanArgs = {
  input: DefaultMigrationPlanInput;
};


export type MutationDelegateSolutionArgs = {
  input: DelegateSolutionInput;
};


export type MutationDeleteActivationArgs = {
  data: ActivationDeleteInput;
};


export type MutationDeleteBundleArgs = {
  data: DeleteBundleInput;
};


export type MutationDeleteCompanyRolesByIdArgs = {
  data: DeleteCompanyRolesInput;
};


export type MutationDeleteImageReferenceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteJobDescriptionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteQuestionFromStoreArgs = {
  id: Scalars['String'];
};


export type MutationDeleteRealTimeThreadArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWizardArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationDeleteWizardGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWizardTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDisableMfaEnrollmentArgs = {
  authId?: Maybe<Scalars['ID']>;
  enrollmentId: Scalars['ID'];
};


export type MutationDismissNoticeArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationDismissNotificationArgs = {
  id: Scalars['String'];
};


export type MutationDuplicateWizardTemplateArgs = {
  id: Scalars['ID'];
  input: DuplicateWizardTemplateInput;
};


export type MutationEditResignationDetailsArgs = {
  data: ResignationEditDetailsInput;
};


export type MutationEditTerminationDetailsArgs = {
  data: TerminationEditDetailsInput;
};


export type MutationEmitArgs = {
  data: EmittableEvent;
};


export type MutationEnqueueHotlineCallArgs = {
  data: EnqueueHotlineCallInput;
};


export type MutationEnrollMfaDeviceArgs = {
  input: AuthMfaSmsEnrollmentInput;
};


export type MutationEnrollUsersArgs = {
  data: EnrollUsersInput;
};


export type MutationExtendBambeePlusOnboardingDueDateArgs = {
  input: PurchaseBambeePlusInput;
};


export type MutationExtendBambeePlusOnboardingWithSpecificDateArgs = {
  input: ExtendBambeePlusOnboardingToSpecificDate;
};


export type MutationExtendTrialArgs = {
  input: ExtendTrialInput;
};


export type MutationGenerateAiJobDescriptionArgs = {
  data: GenerateAiJobDescriptionInput;
};


export type MutationGenerateAiJobDescriptionV2Args = {
  data: GenerateAiJobDescriptionInputV2;
};


export type MutationGenerateArtifactDraftArgs = {
  input: GenerateArtifactDraftInput;
};


export type MutationGenerateArtifactDraftsArgs = {
  input: GenerateArtifactDraftsInput;
};


export type MutationGenerateRealTimeThreadTitleArgs = {
  id: Scalars['ID'];
};


export type MutationGenerateWizardTemplateArgs = {
  input: GenerateWizardTemplateInput;
};


export type MutationGrantCreditsArgs = {
  input: GrantCreditsInput;
};


export type MutationInitializeCoverageActivationArgs = {
  input: InitializeCoverageActivationInput;
};


export type MutationMakeUserAdminArgs = {
  userId: Scalars['ID'];
};


export type MutationMarkAsUnhelpfulArgs = {
  input: MarkAsUnhelpfulInput;
};


export type MutationMarkCourseTicketAsIncompleteArgs = {
  id: Scalars['String'];
};


export type MutationPauseSubscriptionArgs = {
  input: PauseInput;
};


export type MutationProcessNoticeArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationProductInterestNotificationDismissedInAppArgs = {
  input: UpdateProductInterestWasAppNotificationDismissedInput;
};


export type MutationPurchaseArgs = {
  input: BillingPurchaseInput;
};


export type MutationPurchaseCreditsArgs = {
  data: PurchaseInput;
};


export type MutationPurchaseCreditsV2Args = {
  input: PurchaseCreditsInput;
};


export type MutationPurchaseSeatsArgs = {
  data: PurchaseSeatsInput;
};


export type MutationPurchaseSeatsForBundleArgs = {
  data: PurchaseBundleSeatsInput;
};


export type MutationPurchaseSubscriptionArgs = {
  data: PurchaseSubscriptionInput;
};


export type MutationPurchaseTicketsArgs = {
  data: TicketsInput;
};


export type MutationQaMutateDocumentAsUnsignedArgs = {
  documentId: Scalars['ID'];
  who?: QaPolicyViewer;
};


export type MutationQaMutateFeedsForCurrentDocumentStatusArgs = {
  documentId: Scalars['ID'];
};


export type MutationQaMutatePolicyIncompleteArgs = {
  policyId: Scalars['ID'];
};


export type MutationQaMutateRemoveManagerFeedsForDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationQnaQueryArgs = {
  input: QnAQueryInput;
};


export type MutationRateNoticeArgs = {
  input: RateNoticeInput;
};


export type MutationReactToRecommendationArgs = {
  data: RecommendationReactionInput;
};


export type MutationReactivatePausedCompanyArgs = {
  input: ReactivatePausedCompanyInput;
};


export type MutationReaffirmDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationReassignSolutionToSelfArgs = {
  input: ReassignSolutionToSelfInput;
};


export type MutationReclaimSolutionArgs = {
  input: ReclaimSolutionInput;
};


export type MutationRecommendationArgs = {
  data: RecommendationInput;
};


export type MutationRefundCreditPurchaseArgs = {
  data: RefundCreditsInput;
};


export type MutationRegenerateGuidanceArgs = {
  companyId?: Maybe<Scalars['String']>;
  input: RegenerateGuidanceInput;
};


export type MutationReinstateEmployeeArgs = {
  data: ReinstateEmployeeInput;
};


export type MutationRejectRequestArgs = {
  data: RequestRejectionInput;
};


export type MutationRemoveArgs = {
  data: RemoveCompanyTrainingInput;
};


export type MutationRemoveActiveCreditsArgs = {
  data: RemoveCreditsInput;
};


export type MutationRemoveBusinessManagerConfigurationArgs = {
  input: BusinessManagerForTierInput;
};


export type MutationRemoveCourseCertificateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveDuplicatedPolicyDocumentsArgs = {
  id: Scalars['ID'];
};


export type MutationRemovePaymentMethodArgs = {
  input: RemovePaymentMethodInput;
};


export type MutationRemovePaymentMethodV2Args = {
  input: PaymentMethodRef;
};


export type MutationRemoveS3fileFromCourseCertificateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveSeatWaiverArgs = {
  companyId: Scalars['String'];
  productKey: SeatKind;
  syncNow?: Maybe<Scalars['Boolean']>;
};


export type MutationRemoveSeatsArgs = {
  data: RemoveSeatsInput;
};


export type MutationRemoveSeatsFromBundleArgs = {
  data: RemoveBundleSeatsInput;
};


export type MutationRemoveUserAdminArgs = {
  userId: Scalars['ID'];
};


export type MutationReopenRealTimeThreadArgs = {
  id: Scalars['ID'];
};


export type MutationReplyToConversationArgs = {
  input: ReplyToConversationInput;
};


export type MutationReplyToHrRequestAsAdminArgs = {
  input: ReplyToHrRequestAsAdminInput;
};


export type MutationRequestArgs = {
  data: RequestInput;
};


export type MutationResendChallengeArgs = {
  nonceId: Scalars['String'];
  reason: Scalars['String'];
  type: AuthMfaType;
};


export type MutationResetSolutionArgs = {
  input: ResetSolutionInput;
};


export type MutationResumeSubscriptionArgs = {
  companyId: Scalars['ID'];
};


export type MutationReverseCancellationArgs = {
  input: ReverseCancellationInput;
};


export type MutationSaveArtifactArgs = {
  input: SaveArtifactInput;
};


export type MutationSaveCompanyAnswerArgs = {
  data: SaveCompanyAnswerInput;
};


export type MutationSaveCompanySettingArgs = {
  input: SaveCompanySettingInput;
};


export type MutationSaveJobDescriptionOnEmployeeArgs = {
  data: SaveJobDescriptionOnEmployeeInput;
};


export type MutationScratchToggleServiceAddonArgs = {
  input: ScratchToggleServiceAddonInput;
};


export type MutationSelectMigrationPlanArgs = {
  input: SelectMigrationPlanInput;
};


export type MutationSelfUnenrollRetiredArgs = {
  data: SelfUnenrollRetiredInput;
};


export type MutationSendFeedbackMessageArgs = {
  id: Scalars['ID'];
  message: FeedbackMessageInput;
};


export type MutationSendJobDescriptionToEmployeeArgs = {
  data: SendJobDescriptionToEmployeeInput;
};


export type MutationSendMagicLinkForEmailArgs = {
  input: SendMagicLinkForEmailInput;
};


export type MutationSendMessageToUserArgs = {
  id: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationSendReplyToUserThreadArgs = {
  message: Scalars['String'];
  parentId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationSetAddOnArgs = {
  input: SetAddOnInput;
};


export type MutationSetCaseStatusArgs = {
  input: SetCaseStatusInput;
};


export type MutationSetDefaultPaymentMethodArgs = {
  input: SetDefaultPaymentMethodInput;
};


export type MutationSetPolicyCadenceArgs = {
  data: SetPolicyCadenceInput;
};


export type MutationSetPrimaryPaymentMethodArgs = {
  input: PaymentMethodRef;
};


export type MutationSetSeatWaiverArgs = {
  input: SetSeatWaiverInput;
};


export type MutationSignEmployeeJobDescriptionArgs = {
  id: Scalars['String'];
};


export type MutationStartTaskArgs = {
  id: Scalars['String'];
};


export type MutationStartTrialOnCorePlanArgs = {
  input: StartTrialOnCorePlanInput;
};


export type MutationSubmitAiPromptArgs = {
  data: AiPromptInput;
};


export type MutationSyncDocumentsArgs = {
  input: PandadocDocumentSyncInput;
};


export type MutationSyncUserEnrollmentsArgs = {
  data: SyncUserEnrollmentInput;
};


export type MutationToggleActivationArgs = {
  data: ActivationToggleInput;
};


export type MutationTrackArgs = {
  data: AnalyticEvent;
};


export type MutationTrackProductInterestArgs = {
  data: ProductInterestInput;
};


export type MutationTrainingRecommendationArgs = {
  data: TrainingRecommendationInput;
};


export type MutationTrainingRequestArgs = {
  data: TrainingRequestInput;
};


export type MutationTriggerFixUserBundleEnrollmentsArgs = {
  userId: Scalars['ID'];
};


export type MutationUndismissNoticeArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationUnenrollCompanyBundleArgs = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationUnenrollUsersArgs = {
  data: UnenrollUsersInput;
};


export type MutationUnenrollUsersFromBundleArgs = {
  data: UnenrollUsersFromBundleInput;
};


export type MutationUnmarkAsUnhelpfulArgs = {
  input: MarkAsUnhelpfulInput;
};


export type MutationUpdateCompanyRolesArgs = {
  data: UpdateMultipleRolesForCompanyInput;
};


export type MutationUpdateCoreCompanyArgs = {
  data: UpdateCoreCompanyInput;
};


export type MutationUpdateCoreUserEmploymentArgs = {
  id: Scalars['ID'];
  input: CoreUserEmploymentInput;
};


export type MutationUpdateCoreUserProfileArgs = {
  id: Scalars['ID'];
  input: CoreUserProfileInput;
};


export type MutationUpdateCoreUserStateArgs = {
  input: CoreUserStatesInput;
};


export type MutationUpdateExecutionDocumentArgs = {
  companyId?: Maybe<Scalars['String']>;
  input: UpdateExecutionDocumentInput;
};


export type MutationUpdateImageReferenceArgs = {
  id: Scalars['String'];
  input: UpdateImageReferenceInput;
};


export type MutationUpdateJobDescriptionArgs = {
  data: UpdateJobDescriptionInput;
};


export type MutationUpdateNoticeArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  input: UpdateNoticeInput;
};


export type MutationUpdatePaymentSourceBillingAddressArgs = {
  input: UpdatePaymentSourceBillingAddress;
};


export type MutationUpdatePlanLockArgs = {
  input: UpdatePlanLockInput;
};


export type MutationUpdateQuestionInStoreArgs = {
  data: UpdateQuestionStoreInput;
  id: Scalars['String'];
};


export type MutationUpdateRealTimeThreadArgs = {
  id: Scalars['ID'];
  input: UpdateRealTimeThreadInput;
};


export type MutationUpdateReportCardArgs = {
  data: UpdateReportCardInput;
};


export type MutationUpdateWizardArgs = {
  id: Scalars['String'];
  input: UpdateWizardInput;
};


export type MutationUpdateWizardGroupArgs = {
  id: Scalars['ID'];
  input: UpdateWizardGroupInput;
};


export type MutationUpdateWizardResponseArgs = {
  input: WizardResponseUpdateInput;
  wizardId: Scalars['String'];
};


export type MutationUpdateWizardTemplateArgs = {
  id: Scalars['ID'];
  input: UpdateWizardTemplateInput;
};


export type MutationUpgradeCorePlanArgs = {
  input: UpgradeCorePlanInput;
};


export type MutationUploadFilesToConversationArgs = {
  input: UploadFilesToConversationInput;
};


export type MutationUploadImageReferenceArgs = {
  input: CreateImageReferenceInput;
};


export type MutationUploadImageReferencesBatchArgs = {
  input: CreateImageReferenceBatchInput;
};


export type MutationUpsertOnboardingArgs = {
  data: CoreOnboardingInput;
};


export type MutationVoidCreditsArgs = {
  input: VoidCreditsInput;
};

export type MyRecommendationFilterInput = {
  /** The target demographic of the recommendation */
  demographic?: Maybe<RecommendationDemographic>;
  /** The description of the recommendation. */
  note?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The resource type of the recommendation. */
  resourceType?: Maybe<RequestResourceType>;
  /** The scope of the recommendation */
  scope?: Maybe<RecommendationScope>;
  /** The status of the recommendation. */
  status?: Maybe<RecommendationStatus>;
  /** The targets of the recommendation */
  targets?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MyRequestFilterInput = {
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The resource type of the request. */
  resourceType?: Maybe<RequestResourceType>;
  /** The status of the request. */
  status?: Maybe<RequestStatus>;
};

export type MyTrainingRecommendationFilterInput = {
  /** The target demographic of the recommendation */
  demographic?: Maybe<RecommendationDemographic>;
  /** The description of the recommendation. */
  note?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The status of the recommendation. */
  status?: Maybe<RecommendationStatus>;
  /** The targets of the recommendation */
  targets?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MyTrainingRequestFilterInput = {
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The status of the request. */
  status?: Maybe<RequestStatus>;
};

export type NewReportCard = {
  __typename?: 'NewReportCard';
  /** new report created when is false */
  existing: Scalars['Boolean'];
  report: ReportCard;
};

export type NextMessage = {
  __typename?: 'NextMessage';
  /** Affirmation of the last user message otherwise empty */
  affirmation?: Maybe<Scalars['String']>;
  /** Context for the message or additional guidance like: you can select multiple options */
  context?: Maybe<Scalars['String']>;
  /** Next message to the user */
  message?: Maybe<Scalars['String']>;
  /** Multiple choice options for the user to select from if the message requires it. MUST Provide multiple-choice options labeled A, B, C, etc */
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** An example response to the content */
  sample?: Maybe<Scalars['String']>;
};

/** The next action for onboarding */
export enum NextOnboardingAction {
  ExploreOnYourOwn = 'EXPLORE_ON_YOUR_OWN',
  MeetHrManager = 'MEET_HR_MANAGER',
  ScheduleConsultation = 'SCHEDULE_CONSULTATION'
}

export type Notice = {
  __typename?: 'Notice';
  badge?: Maybe<Scalars['String']>;
  category: BrightenCategory;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  detail?: Maybe<NoticeDetail>;
  dismissedAt?: Maybe<Scalars['DateTime']>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  links?: Maybe<Array<NoticeLink>>;
  markedUnhelpful?: Maybe<Scalars['Boolean']>;
  markedUnhelpfulAt?: Maybe<Scalars['DateTime']>;
  markedUnhelpfulBy?: Maybe<Scalars['String']>;
  /** notice metadata */
  metadata?: Maybe<Scalars['JSONObject']>;
  /** Full solution entities with complete data (type, category, tags, action, etc.) */
  noticeSolutions: Array<Solution>;
  recommendationId?: Maybe<Scalars['String']>;
  /** Notice-to-case routing decision (null when not yet routed) */
  routing?: Maybe<NoticeRouting>;
  severity: NoticeSeverity;
  /** @deprecated Use noticeSolutions instead for full solution data including type, category, tags, and action */
  solutions: Array<NoticeSolution>;
  status: NoticeStatus;
  /** User feedback for this notice */
  userFeedback?: Maybe<NoticeFeedback>;
  version: Scalars['String'];
  visualization?: Maybe<VisualizationData>;
};

/** The color of notice action buttons */
export enum NoticeActionColor {
  Neutral = 'NEUTRAL',
  Primary = 'PRIMARY'
}

/** The type of action for notice links */
export enum NoticeActionType {
  Chat = 'CHAT',
  ComplianceAlert = 'COMPLIANCE_ALERT',
  Dismiss = 'DISMISS',
  EmployeeVoice = 'EMPLOYEE_VOICE',
  ExternalLink = 'EXTERNAL_LINK',
  JournalEntry = 'JOURNAL_ENTRY',
  Link = 'LINK',
  NewCap = 'NEW_CAP',
  NewGuidance = 'NEW_GUIDANCE',
  NewIncident = 'NEW_INCIDENT',
  NewJobDescription = 'NEW_JOB_DESCRIPTION',
  NewPolicy = 'NEW_POLICY',
  PolicyUpdate = 'POLICY_UPDATE',
  RequestTraining = 'REQUEST_TRAINING',
  TrainingRecommendation = 'TRAINING_RECOMMENDATION'
}

/** The variant of notice action buttons */
export enum NoticeActionVariant {
  Outline = 'OUTLINE',
  Solid = 'SOLID'
}

export type NoticeDetail = {
  __typename?: 'NoticeDetail';
  sections: Array<TopicDetailSection>;
};

export type NoticeFeedback = {
  __typename?: 'NoticeFeedback';
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  helpful: Scalars['Boolean'];
  noticeId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type NoticeLink = {
  __typename?: 'NoticeLink';
  color?: Maybe<NoticeActionColor>;
  handler: NoticeLinkHandler;
  label: Scalars['String'];
  priority: Scalars['Float'];
  variant?: Maybe<NoticeActionVariant>;
};

export type NoticeLinkHandler = {
  __typename?: 'NoticeLinkHandler';
  actionType: NoticeActionType;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  linkType?: Maybe<LinkType>;
  linkUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

/** Notice-to-case route, derived server-side at decision time (consumers never re-apply the rule) */
export enum NoticeRoute {
  RegularCase = 'regular_case',
  ResolutionCycle = 'resolution_cycle'
}

export type NoticeRouting = {
  __typename?: 'NoticeRouting';
  /** Classifier confidence (0 to 1); null when the decision record is absent or a different schema */
  confidence?: Maybe<Scalars['Float']>;
  /** When the decision was made; null when the decision record is absent or a different schema */
  decidedAt?: Maybe<Scalars['DateTime']>;
  /** Classifier's rationale for the decision; null when the decision record is absent or a different schema */
  rationale?: Maybe<Scalars['String']>;
  /** Derived route: resolution_cycle or regular_case */
  route: NoticeRoute;
  /** Classified service type, or null when none applies */
  serviceType?: Maybe<ServiceType>;
};

/** The severity of the notice */
export enum NoticeSeverity {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type NoticeSolution = {
  __typename?: 'NoticeSolution';
  caseId?: Maybe<Scalars['String']>;
  color?: Maybe<NoticeActionColor>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  delegatedAt?: Maybe<Scalars['DateTime']>;
  delegatedBy?: Maybe<Scalars['String']>;
  delegatedTo?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  handler: NoticeSolutionHandler;
  id: Scalars['ID'];
  label: Scalars['String'];
  markedUnhelpful?: Maybe<Scalars['Boolean']>;
  markedUnhelpfulAt?: Maybe<Scalars['DateTime']>;
  markedUnhelpfulBy?: Maybe<Scalars['String']>;
  priority: Scalars['Float'];
  threadId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  variant?: Maybe<NoticeActionVariant>;
};

export type NoticeSolutionHandler = {
  __typename?: 'NoticeSolutionHandler';
  actionType: SolutionType;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  prompt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
};

/** The status of the notice */
export enum NoticeStatus {
  Active = 'ACTIVE',
  Dismissed = 'DISMISSED',
  Processed = 'PROCESSED'
}

/** Tag for the type of notice detail section */
export enum NoticeTag {
  Detail = 'DETAIL',
  Overview = 'OVERVIEW',
  RecommendedActions = 'RECOMMENDED_ACTIONS',
  Solve = 'SOLVE',
  SummaryOfIncident = 'SUMMARY_OF_INCIDENT',
  TeamLeadershipInsight = 'TEAM_LEADERSHIP_INSIGHT',
  WhatYouCanDo = 'WHAT_YOU_CAN_DO'
}

export type NoticesBySeverityPaginationInput = {
  /** Filter notices by badge */
  badge?: Maybe<Scalars['String']>;
  /** Filter notices by category. Can filter by one or more categories (e.g., [COMPLIANCE, MISCONDUCT]). If not provided, returns notices of all categories. */
  categories?: Maybe<Array<BrightenCategory>>;
  /** Filter notices by company ID */
  companyId?: Maybe<Scalars['String']>;
  /** Cursor for pagination (null means start from beginning) */
  cursor?: Maybe<Scalars['String']>;
  /** Filter by user feedback (true = show only helpful notices, false = show only unhelpful notices, null/undefined = show all notices) */
  helpful?: Maybe<Scalars['Boolean']>;
  /** Number of items per page (max 100) */
  limit?: Scalars['Int'];
  /** Sort order for notices (default: DESC for newest first) */
  order?: SortOrder;
  /** Search term to filter notices by headline, description, or detail content */
  search?: Maybe<Scalars['String']>;
  /** Filter notices by severity level(s). Can filter by one or more severities (e.g., [HIGH, MEDIUM]). If not provided, returns notices of all severities. */
  severities?: Maybe<Array<NoticeSeverity>>;
  /** Filter by status(es). Can be ["ACTIVE"], ["DISMISSED"], or ["ACTIVE", "DISMISSED"]. Defaults to ["ACTIVE"] if not provided. */
  statuses?: Maybe<Array<Scalars['String']>>;
};

export type NoticesPaginationInput = {
  /** Filter notices by badge */
  badge?: Maybe<Scalars['String']>;
  /** Filter notices by category. Can filter by one or more categories (e.g., [COMPLIANCE, MISCONDUCT]). If not provided, returns notices of all categories. */
  categories?: Maybe<Array<BrightenCategory>>;
  /** Filter notices by company ID */
  companyId?: Maybe<Scalars['String']>;
  /** Cursor for pagination (null means start from beginning) */
  cursor?: Maybe<Scalars['String']>;
  /** Number of items per page (max 100) */
  limit?: Scalars['Int'];
  /** Search term to filter notices by headline, description, or detail content */
  search?: Maybe<Scalars['String']>;
  /** Whether to include dismissed notices (default: false) */
  showDismissed?: Scalars['Boolean'];
};

export type Notification = {
  __typename?: 'Notification';
  actions?: Maybe<Array<NotificationAction>>;
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dismissedAt?: Maybe<Scalars['DateTime']>;
  dismissedBy?: Maybe<Scalars['String']>;
  dismissible: Scalars['Boolean'];
  id: Scalars['ID'];
  level: NotificationLevel;
  metadata?: Maybe<Scalars['JSON']>;
  subject?: Maybe<Scalars['String']>;
  targets: Array<NotificationTarget>;
  userId: Scalars['String'];
};

export type NotificationAction = {
  __typename?: 'NotificationAction';
  id: Scalars['ID'];
  label: Scalars['String'];
  type: NotificationActionType;
  value: Scalars['String'];
};

export enum NotificationActionType {
  Event = 'EVENT',
  Link = 'LINK'
}

export enum NotificationLevel {
  Error = 'ERROR',
  Notice = 'NOTICE',
  Warning = 'WARNING'
}

export type NotificationTarget = {
  __typename?: 'NotificationTarget';
  id: Scalars['ID'];
  type: NotificationTargetType;
};

export enum NotificationTargetType {
  Dashboard = 'DASHBOARD',
  Global = 'GLOBAL'
}

export type OnboardingCalendlyConfig = {
  __typename?: 'OnboardingCalendlyConfig';
  link: Scalars['String'];
  tierNumber: Scalars['Float'];
  zone: SchedulerZone;
};

export type OnboardingCalendlyConfigInput = {
  tierNumber: Scalars['Float'];
  zip: Scalars['String'];
};

export type OnboardingFilesAnalysis = {
  __typename?: 'OnboardingFilesAnalysis';
  /** The files that were acquired */
  acquired: Array<Maybe<Scalars['String']>>;
  /** The files that are missing */
  missing: Array<Maybe<Scalars['String']>>;
};

/** The status of the Onboarding */
export enum OnboardingStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type PaginatedCoreUsers = {
  __typename?: 'PaginatedCoreUsers';
  id: Scalars['ID'];
  /** Page number to be used for pagination */
  page: Scalars['Float'];
  /** Actual list of users */
  result: Array<CoreUser>;
  /** Total count of all users */
  totalCount: Scalars['Float'];
  /** Total number of pages based on limit passed */
  totalPages: Scalars['Float'];
};

export type PaginatedNoticesResponse = {
  __typename?: 'PaginatedNoticesResponse';
  corePageInfo: CorePageInfo;
  notices: Array<Notice>;
  totalCount: Scalars['Int'];
};

export type PaginatedSolutionsResponse = {
  __typename?: 'PaginatedSolutionsResponse';
  corePageInfo: CorePageInfo;
  solutions: Array<Solution>;
  totalCount: Scalars['Int'];
};

export type PandadocDocumentSyncInput = {
  documentIds: Array<Scalars['ID']>;
};

export type PauseInput = {
  companyId: Scalars['ID'];
  cycles: Scalars['Int'];
};

export type Paused = {
  __typename?: 'Paused';
  id: Scalars['ID'];
  isPaused: Scalars['Boolean'];
  reactivatesOn?: Maybe<Scalars['DateTime']>;
};

export enum PayType {
  Contractor = 'contractor',
  Empty = 'empty',
  Hourly = 'hourly',
  Salary = 'salary'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  accountType?: Maybe<Scalars['String']>;
  backup: Scalars['Boolean'];
  bankName?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  kind: PaymentMethodKind;
  last4: Scalars['String'];
  primary: Scalars['Boolean'];
  verificationStatus?: Maybe<Scalars['String']>;
};

export enum PaymentMethodIssueReason {
  DefaultAchTransfer = 'DEFAULT_ACH_TRANSFER',
  DefaultDebitCard = 'DEFAULT_DEBIT_CARD',
  DefaultExpired = 'DEFAULT_EXPIRED',
  DefaultInvalid = 'DEFAULT_INVALID',
  DefaultUpcomingExpiration = 'DEFAULT_UPCOMING_EXPIRATION',
  Other = 'OTHER'
}

export enum PaymentMethodKind {
  BankAccount = 'BANK_ACCOUNT',
  Card = 'CARD'
}

export enum PaymentMethodNextAction {
  MicroDepositValidation = 'MICRO_DEPOSIT_VALIDATION',
  MicroDepositValidationDescriptor = 'MICRO_DEPOSIT_VALIDATION_DESCRIPTOR'
}

export type PaymentMethodRef = {
  companyId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
};

export enum PaymentMethodStatus {
  ActionRequired = 'ACTION_REQUIRED',
  Active = 'ACTIVE'
}

export enum PaymentMethodType {
  BankAccount = 'BANK_ACCOUNT',
  Card = 'CARD',
  Unknown = 'UNKNOWN'
}

export type PaymentSource = {
  __typename?: 'PaymentSource';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  cvcCheck?: Maybe<Scalars['String']>;
  default: Scalars['Boolean'];
  dynamicLast4?: Maybe<Scalars['String']>;
  expMonth: Scalars['Float'];
  expYear: Scalars['Float'];
  funding?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PaymentSources = {
  __typename?: 'PaymentSources';
  companyId: Scalars['String'];
  sources: Array<PaymentSource>;
};

export type PendingChange = {
  __typename?: 'PendingChange';
  activateAt: Scalars['DateTime'];
  addOns: Array<AddOnLine>;
  planCode?: Maybe<Scalars['String']>;
};

export type PermissionsDto = {
  __typename?: 'PermissionsDto';
  advisor: Scalars['Boolean'];
  bambeeStaff: Scalars['Boolean'];
  companyOwner: Scalars['Boolean'];
  hrAdmin: Scalars['Boolean'];
  manager: Scalars['Boolean'];
};

export type PipDto = {
  __typename?: 'PipDto';
  createdAt: Scalars['DateTime'];
  duration: Scalars['Float'];
  endsAt: Scalars['DateTime'];
  followupSchedule: Scalars['String'];
  id: Scalars['ID'];
  performanceConcernsInfo: Scalars['String'];
  performanceConcernsType: Scalars['String'];
  performanceExpectations?: Maybe<Array<Scalars['String']>>;
  pipSentAt?: Maybe<Scalars['DateTime']>;
  startsAt: Scalars['DateTime'];
  status: Scalars['String'];
  suggestedStrategies?: Maybe<Array<Scalars['String']>>;
};

export type PipelineExecution = {
  __typename?: 'PipelineExecution';
  companyId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emissions: Array<AgentEmissionNode>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  pipelineTrack: Scalars['String'];
  priority: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type PipelineExecutionInput = {
  batchId: Scalars['String'];
  companyId?: Maybe<Scalars['String']>;
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PlanCoupon = {
  __typename?: 'PlanCoupon';
  amountOff: Scalars['Float'];
  appliesToPlans: Array<Plan>;
  id: Scalars['String'];
  name: Scalars['String'];
  percentOff?: Maybe<Scalars['Float']>;
  setupFeeOff: Scalars['Float'];
};

export type PlanFilter = {
  interval?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  status?: Scalars['String'];
  tier?: Maybe<Scalars['Int']>;
};

export type PlanLock = {
  __typename?: 'PlanLock';
  active: Scalars['Boolean'];
  couponId?: Maybe<Scalars['String']>;
  plan: Scalars['String'];
  setupFee: Scalars['Float'];
  trialDuration: Scalars['Float'];
};

/** A model representing a generic plan. */
export type PlanModel = {
  __typename?: 'PlanModel';
  /** Indicates if the plan is annual. */
  annual?: Maybe<Scalars['Boolean']>;
  /** Billing period for the plan. */
  billingPeriod: BillingPeriod;
  /** Indicates if the plan is chat-only. */
  chatOnly?: Maybe<Scalars['Boolean']>;
  /** Indicates if the plan is configured to collect taxes. */
  collectTax?: Maybe<Scalars['Boolean']>;
  /** Contract period for the plan, if applicable. */
  contractPeriod?: Maybe<BillingPeriod>;
  /**
   * DRP (Disaster Recovery Plan) identifier, if applicable.
   * @deprecated Feature has been removed but we still support subscriptions with these plans
   */
  drp?: Maybe<Scalars['String']>;
  /** Mapping of the plan to the size of the employee base. */
  employeeSizeMapping?: Maybe<Scalars['String']>;
  /** Indicates if the plan is for internal use only. */
  internal?: Maybe<Scalars['Boolean']>;
  /** Maximum size of the employee base for this plan. */
  maxSize?: Maybe<Scalars['Float']>;
  /** Minimum size of the employee base for this plan. */
  minSize?: Maybe<Scalars['Float']>;
  /** Monthly price of the plan. */
  monthlyPrice?: Maybe<Scalars['Float']>;
  /** Name of the plan. */
  name: Scalars['String'];
  /** Partner associated with the plan, if any. */
  partner?: Maybe<Scalars['String']>;
  /** Indicates if the plan can be paused. */
  pause?: Maybe<Scalars['Boolean']>;
  /** Total price of the plan. */
  price?: Maybe<Scalars['Float']>;
  /** Price identifier in Stripe. */
  priceId: Scalars['String'];
  /** The product key associated to the plan object (Lite, Dedicated, Plus, Elite). */
  productKey: ProductKey;
  /** Indicates if the plan is regulated. */
  regulated?: Maybe<Scalars['Boolean']>;
  /** The service key associated to the plan object (Core, Training, ...). */
  serviceKey: ServiceKey;
  /** Initial setup fee for the plan. */
  setupFee?: Maybe<Scalars['Float']>;
  /** Discount on the setup fee, if applicable. */
  setupFeeDiscount?: Maybe<Scalars['Float']>;
  /** Current status of the plan. */
  status: PlanStatuses;
  /** Tier number of the plan. */
  tierNumber?: Maybe<Scalars['Float']>;
  /** Value proposition of the plan. */
  value: Scalars['String'];
  /** Version of the plan. */
  version?: Maybe<Scalars['String']>;
  /** Indicates if the plan pricing is based on volume. */
  volumeBased?: Maybe<Scalars['Boolean']>;
};

/** Plan statuses */
export enum PlanStatuses {
  Active = 'ACTIVE',
  Deprecated = 'DEPRECATED',
  Inactive = 'INACTIVE'
}

export type PolicyArtifact = {
  __typename?: 'PolicyArtifact';
  /** Confidence score between 0 and 100 */
  confidence?: Maybe<Scalars['Float']>;
  /** The policy draft render as a rich HTML document. */
  html?: Maybe<Scalars['String']>;
  /** The id of the policy after accepted and persisted into the system. */
  id?: Maybe<Scalars['String']>;
  /** Indicates whether the base policy template is from our existing database */
  isBambeeTemplateBase?: Maybe<Scalars['String']>;
  /** The policy draft render as a rich HTML document. */
  status: BestPracticeStatus;
  /** The policy draft title. */
  title?: Maybe<Scalars['String']>;
};

export type PolicyDto = {
  __typename?: 'PolicyDto';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  version?: Maybe<Scalars['Float']>;
};

export enum PolicyKind {
  Bambee = 'BAMBEE',
  Draft = 'DRAFT',
  Panda = 'PANDA'
}

export type PolicyRecommendationMessageInput = {
  content: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  role: RealTimeMessageRole;
};

export enum PolicyStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Declined = 'DECLINED',
  InProgress = 'IN_PROGRESS',
  Qa = 'QA',
  Ready = 'READY',
  Sent = 'SENT',
  Uploaded = 'UPLOADED'
}

export enum PolicyStepNames {
  Created = 'CREATED',
  Implemented = 'IMPLEMENTED',
  Ready = 'READY',
  Requested = 'REQUESTED',
  Sent = 'SENT',
  Unknown = 'UNKNOWN'
}

export type PolicyTemplateDto = {
  __typename?: 'PolicyTemplateDto';
  /** Whether the template is currently active */
  active: Scalars['Boolean'];
  /** Template description */
  description?: Maybe<Scalars['String']>;
  /** Display name for the template */
  displayName?: Maybe<Scalars['String']>;
  /** Full HTML template content - only loaded when explicitly requested */
  html?: Maybe<Scalars['String']>;
  /** Icon path for the template */
  icon?: Maybe<Scalars['String']>;
  /** Template ID */
  id: Scalars['ID'];
  /** Template name */
  name: Scalars['String'];
  /** Template metadata and required fields */
  tags?: Maybe<PolicyTemplateTagsDto>;
  /** Template type: "bambee" or "panda" */
  type: Scalars['String'];
};

export type PolicyTemplateFiltersInput = {
  /** Include full HTML template content (expensive) */
  includeHtml?: Maybe<Scalars['Boolean']>;
  /** Fuzzy search across name, displayName, description, type, and tags.typeTag */
  query?: Maybe<Scalars['String']>;
  /** Filter by specific template ID - returns only that template */
  templateId?: Maybe<Scalars['ID']>;
};

export type PolicyTemplateRecommendation = {
  __typename?: 'PolicyTemplateRecommendation';
  confidence: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  excludedStateTags?: Maybe<Array<Scalars['String']>>;
  isCPD: Scalars['Boolean'];
  isContractor?: Maybe<Scalars['Boolean']>;
  policyName: Scalars['String'];
  requiredQuestions: Array<Scalars['String']>;
  stateTags?: Maybe<Array<Scalars['String']>>;
  templateId?: Maybe<Scalars['ID']>;
  typeTag?: Maybe<Scalars['String']>;
};

export type PolicyTemplateTagsDto = {
  __typename?: 'PolicyTemplateTagsDto';
  /** States where this policy should be excluded */
  excludedStateTags?: Maybe<Array<Scalars['String']>>;
  /** Whether this is a California Privacy Document */
  isCPD?: Maybe<Scalars['Boolean']>;
  /** Required fields that need to be filled (e.g., "company.name") */
  requiredFields?: Maybe<Array<Scalars['String']>>;
  /** State tags for state-specific policies (e.g., ["CA", "NY"]) */
  stateTags?: Maybe<Array<Scalars['String']>>;
  /** Type tag for categorization (e.g., "attendance", "harassment") */
  typeTag?: Maybe<Scalars['String']>;
};

export type Practice = {
  __typename?: 'Practice';
  companyId: Scalars['String'];
  description: Scalars['String'];
  iconUrl: Scalars['String'];
  id: Scalars['String'];
  illustrationUrl: Scalars['String'];
  introDescription: Scalars['String'];
  outroIllustrationUrl: Scalars['String'];
  setupProgress: PracticeSetupProgress;
  shortDescription: Scalars['String'];
  shortName: Scalars['String'];
  state: PracticeState;
  status: PracticeStatuses;
  successOutroTitle: Scalars['String'];
  survey: Survey;
  title: Scalars['String'];
};

export enum PracticeCadenceValue {
  Annually = 'ANNUALLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Weekly = 'WEEKLY'
}

export enum PracticeSetupProgress {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export enum PracticeState {
  Activated = 'ACTIVATED',
  NotActivated = 'NOT_ACTIVATED'
}

export enum PracticeStatuses {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export type PreviewCorePlanChangeModel = {
  __typename?: 'PreviewCorePlanChangeModel';
  /** Details for the following invoice after the upcoming one */
  next: CorePlanChangeInvoice;
  /** The core plan for the upgrade calculation */
  plan: CorePlanModel;
  /** Proration date considered for this plan change */
  prorationDate: Scalars['DateTime'];
  /** Details for the upcoming invoice if plan is applied */
  upcoming: UpcomingCorePlanChangeInvoice;
};

export type PreviewLine = {
  __typename?: 'PreviewLine';
  amount: Money;
  description: Scalars['String'];
};

export type PreviewSeatChangeInput = {
  companyId: Scalars['String'];
  execSeats?: Scalars['Int'];
  managerSeats?: Scalars['Int'];
};

export type PricingPackage = {
  __typename?: 'PricingPackage';
  /** The pricing plans available for the package */
  plans: Array<Maybe<CorePlanModel>>;
  /** The product key of the package */
  productKey: ProductKey;
  /**
   * The type of the package
   * @deprecated Use productKey instead. Derived from productKey for backward compatibility (ENG-983).
   */
  type: PricingPackageType;
};

export type PricingPackageFilterInput = {
  /** The billing period */
  billingPeriod?: Maybe<Scalars['String']>;
  /** The company ID */
  companyId: Scalars['ID'];
  /** The number of employees */
  employeeCount?: Maybe<Scalars['Float']>;
  /** Include internal plans ( defaults to external only ) */
  includeInternal?: Maybe<Scalars['Boolean']>;
  /** The partner */
  partner?: Maybe<Scalars['String']>;
  /** The status of the plan e.g. active, inactive etc.  */
  statuses?: Maybe<Array<PlanStatuses>>;
};

export type PricingPackageResponse = {
  __typename?: 'PricingPackageResponse';
  /** The pricing packages */
  packages: Array<PricingPackage>;
};

/** Pricing package type */
export enum PricingPackageType {
  Business = 'BUSINESS',
  Elite = 'ELITE',
  Elite2 = 'ELITE2',
  Elite3 = 'ELITE3',
  Lite = 'LITE',
  Pause = 'PAUSE',
  Plus = 'PLUS',
  Storage = 'STORAGE'
}

export type Product = {
  __typename?: 'Product';
  activeSubscription?: Maybe<Scalars['Boolean']>;
  /** Number of credits provided on core subscription. Null if single purchase */
  allowance?: Maybe<Scalars['Int']>;
  /** Billing period of the product. Null if single purchase */
  billingPeriod?: Maybe<Scalars['String']>;
  creditBalance: Scalars['Float'];
  /** One-time discounted price of product, if available. Null if subscription */
  discountedPrice?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  key: ProductKey;
  /** Number of credits provided per month, if applicable. Null if single purchase */
  monthlyAllowance?: Maybe<Scalars['Int']>;
  /** Name of product */
  name?: Maybe<Scalars['String']>;
  /** One-time price of product. Null if subscription */
  price?: Maybe<Scalars['Int']>;
  /** The price to subscribe, based on billing period. Null if single purchase */
  subscriptionPrice?: Maybe<Scalars['Int']>;
  /** Company tier */
  tier?: Maybe<Scalars['Int']>;
};

export enum ProductCreditConsumptionReason {
  CustomerSatisfaction = 'CUSTOMER_SATISFACTION',
  HumanError = 'HUMAN_ERROR',
  Other = 'OTHER',
  ProcessRelated = 'PROCESS_RELATED',
  TechError = 'TECH_ERROR',
  UpsellingCustomer = 'UPSELLING_CUSTOMER'
}

export enum ProductCreditConsumptionType {
  Expiration = 'EXPIRATION',
  Manual = 'MANUAL',
  Refund = 'REFUND',
  Usage = 'USAGE',
  Void = 'VOID'
}

export enum ProductCreditCreationReason {
  CustomerSatisfaction = 'CUSTOMER_SATISFACTION',
  HumanError = 'HUMAN_ERROR',
  Other = 'OTHER',
  ProcessRelated = 'PROCESS_RELATED',
  TechError = 'TECH_ERROR',
  UpsellingCustomer = 'UPSELLING_CUSTOMER'
}

export enum ProductCreditType {
  Allowance = 'ALLOWANCE',
  Manual = 'MANUAL',
  OnetimeTransaction = 'ONETIME_TRANSACTION',
  SubscriptionRefillAdditional = 'SUBSCRIPTION_REFILL_ADDITIONAL',
  SubscriptionRefillLimit = 'SUBSCRIPTION_REFILL_LIMIT',
  SubscriptionUnlimited = 'SUBSCRIPTION_UNLIMITED'
}

export type ProductInterest = {
  __typename?: 'ProductInterest';
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  productKey: ProductKey;
  productSubKey?: Maybe<ProductSubKey>;
  userId: Scalars['String'];
  /** Whether the user has dismissed the app notification for this product interest */
  wasAppNotificationDismissed: Scalars['Boolean'];
};

export type ProductInterestInput = {
  companyId: Scalars['String'];
  interests: Scalars['JSON'];
  origin: Scalars['String'];
};

export enum ProductKey {
  Advisor = 'ADVISOR',
  BambeePlus = 'BAMBEE_PLUS',
  Bolt = 'BOLT',
  Business = 'BUSINESS',
  CompanyObservation = 'COMPANY_OBSERVATION',
  Core = 'CORE',
  Dedicated = 'DEDICATED',
  Elite = 'ELITE',
  Elite2 = 'ELITE2',
  Elite3 = 'ELITE3',
  ExecSeats = 'EXEC_SEATS',
  ExternalSeats = 'EXTERNAL_SEATS',
  Guidance = 'GUIDANCE',
  JobDescription = 'JOB_DESCRIPTION',
  JobDescriptionAi = 'JOB_DESCRIPTION_AI',
  Lite = 'LITE',
  ManagedHrServices = 'MANAGED_HR_SERVICES',
  ManagerSeats = 'MANAGER_SEATS',
  MissedCall = 'MISSED_CALL',
  NewPolicy = 'NEW_POLICY',
  OrganizationalMatterManagement = 'ORGANIZATIONAL_MATTER_MANAGEMENT',
  Pause = 'PAUSE',
  Payroll = 'PAYROLL',
  PayrollBasic = 'PAYROLL_BASIC',
  PayrollPremium = 'PAYROLL_PREMIUM',
  Plus = 'PLUS',
  PracticeSupervision = 'PRACTICE_SUPERVISION',
  PremiumPeople = 'PREMIUM_PEOPLE',
  StandardSupervision = 'STANDARD_SUPERVISION',
  Storage = 'STORAGE',
  TimeAttendance = 'TIME_ATTENDANCE',
  Training = 'TRAINING',
  WebinarWorkplaceViolence = 'WEBINAR_WORKPLACE_VIOLENCE',
  WorkforceObservation = 'WORKFORCE_OBSERVATION',
  WorkforcePracticeManagement = 'WORKFORCE_PRACTICE_MANAGEMENT'
}

export enum ProductSubKey {
  BenefitsAdministration = 'BENEFITS_ADMINISTRATION',
  CorrectiveActions = 'CORRECTIVE_ACTIONS',
  EmployeeSupport = 'EMPLOYEE_SUPPORT',
  HiringGuidance = 'HIRING_GUIDANCE',
  HrPolicies = 'HR_POLICIES',
  ImmigrationConsultation = 'IMMIGRATION_CONSULTATION',
  JobDescriptions = 'JOB_DESCRIPTIONS',
  LeaveOfAbsenceStrategy = 'LEAVE_OF_ABSENCE_STRATEGY',
  ManagedTermination = 'MANAGED_TERMINATION',
  ManagerLiveSupport = 'MANAGER_LIVE_SUPPORT',
  OrgDesignConsultation = 'ORG_DESIGN_CONSULTATION',
  SettingUpHrInvestigations = 'SETTING_UP_HR_INVESTIGATIONS'
}

export type PurchaseBambeePlusInput = {
  companyId: Scalars['String'];
};

export type PurchaseBundleSeatsInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipPayment?: Maybe<Scalars['Boolean']>;
};

export type PurchaseCreditsInput = {
  companyId: Scalars['ID'];
  itemCode: Scalars['String'];
  quantity?: Scalars['Int'];
};

export type PurchaseInput = {
  productKey: ProductKey;
  quantity: Scalars['Float'];
};

export type PurchaseResult = {
  __typename?: 'PurchaseResult';
  createdAt: Scalars['DateTime'];
  creditsPurchased: Scalars['Int'];
  id: Scalars['ID'];
  productKey: ProductKey;
  status: StatementStatus;
  totalAmount: Scalars['Int'];
};

export type PurchaseSeatsInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipPayment?: Maybe<Scalars['Boolean']>;
  topicId?: Maybe<Scalars['String']>;
};

export type PurchaseSeatsResponse = {
  __typename?: 'PurchaseSeatsResponse';
  bundleId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numPurchased: Scalars['Int'];
  topicId?: Maybe<Scalars['String']>;
  totalSeats: Scalars['Int'];
};

export type PurchaseSubscriptionInput = {
  billingPeriod?: Maybe<BillingPeriod>;
  companyId?: Maybe<Scalars['String']>;
  productKey: ProductKey;
};

export type PurchaseTicketsResponse = {
  __typename?: 'PurchaseTicketsResponse';
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numPurchased: Scalars['Int'];
  totalTickets: Scalars['Int'];
};

export type PurchasedBundle = {
  __typename?: 'PurchasedBundle';
  /** @deprecated Use bundleId instead */
  bundleId: Scalars['String'];
  counts: UserCounts;
  description?: Maybe<Scalars['String']>;
  global: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  topics: Array<Maybe<PurchasedTopic>>;
  totalSeats: Scalars['Float'];
  unfilledSeats: Scalars['Float'];
};

export type PurchasedProducts = {
  __typename?: 'PurchasedProducts';
  bundles: Array<Maybe<PurchasedBundle>>;
  id: Scalars['ID'];
  topics: Array<Maybe<PurchasedTopic>>;
};

export type PurchasedTopic = {
  __typename?: 'PurchasedTopic';
  counts?: Maybe<UserCounts>;
  enrollments: Array<Maybe<TopicEnrolledTickets>>;
  id: Scalars['String'];
  isRetired: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated Use id instead */
  topicId: Scalars['String'];
  totalSeats?: Maybe<Scalars['Float']>;
  unfilledSeats?: Maybe<Scalars['Float']>;
};

export enum QaPolicyViewer {
  /** employee */
  Employee = 'Employee',
  /** manager */
  Manager = 'Manager'
}

export type QaTrainingCertificates = {
  __typename?: 'QaTrainingCertificates';
  id: Scalars['ID'];
  s3FileName?: Maybe<Scalars['String']>;
};

export type QnAQueryInput = {
  query: Scalars['String'];
  sessionId?: Maybe<Scalars['String']>;
};

export type QnaAnswerDto = {
  __typename?: 'QnaAnswerDto';
  answer: Scalars['String'];
  author?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  question: Scalars['String'];
  similar?: Maybe<Array<QnaSimilarDto>>;
  tags?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type QnaDto = {
  __typename?: 'QnaDto';
  answers: Array<QnaAnswerDto>;
  questions: Array<QnaQuestionDto>;
};

export type QnaQuestionDto = {
  __typename?: 'QnaQuestionDto';
  answer: Scalars['String'];
  author?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  question: Scalars['String'];
  similar?: Maybe<Array<QnaSimilarDto>>;
  tags?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type QnaSimilarDto = {
  __typename?: 'QnaSimilarDto';
  content: Scalars['String'];
  id: Scalars['ID'];
  similarity: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  /** Gets a specific activation by key for current user's company */
  activation?: Maybe<CoreActivation>;
  /** Gets all activations for current user's company with optional filtering */
  activations?: Maybe<Array<CoreActivation>>;
  activeCancellationReasonGroups: Array<CancellationReasonGroupModel>;
  advisorNextAvailableSlot: AdvisorNextTimeSlot;
  /** Get agent emissions filtered by company and optional agent type */
  agentEmissions: Array<AgentEmissionNode>;
  availableCadence: Array<Cadence>;
  availableSettings: Array<Setting>;
  /** The event log. Staff only. */
  billingEvents: BillingEventConnection;
  /** The plan this company is migrating to. Null when they have no record yet. Check isExplicitSelection to tell an active choice from the recommended default. */
  billingMigrationRecord?: Maybe<BillingMigrationRecord>;
  /** Every migration plan selection this company has made, newest first. */
  billingMigrationRecordHistory: Array<BillingMigrationRecord>;
  billingSubscription?: Maybe<BillingSubscriptionModel>;
  canInitiateTrial: CanInitiateTrialResult;
  cancellationOffers: CancellationOffersModel;
  cancellationReasonGroups: Array<CancellationReasonGroupModel>;
  company: Company;
  companyAdvisorCalendlySlug?: Maybe<CompanyAdvisorCalendlySlug>;
  companyQuestionsAnsweredByUser: Array<QuestionStore>;
  /** The company's HR Requests (plain Salesforce cases that are not Resolution Cycles), newest first */
  companyServiceCases: Array<SalesforceCaseInfo>;
  companySubscriptions: Array<Subscription>;
  companySurvey: Survey;
  companySurveyAnswer: SurveyAnswer;
  companySurveyList: Array<Survey>;
  context: ContextDto;
  coreCompany: CoreCompany;
  coreUpgradeOptions: Array<PreviewCorePlanChangeModel>;
  coupon: PlanCoupon;
  couponList: Array<PlanCoupon>;
  coverageActivationSnapshot?: Maybe<CoverageActivationSnapshot>;
  creditBalance: CreditBalance;
  credits: Array<BillingCredit>;
  /** Get all wizard groups for a specific customer with activation status */
  customerWizardGroups: Array<WizardGroup>;
  entitlement: Entitlement;
  /** Fetches onboarding for the user and version provided if it exists */
  findOnboarding?: Maybe<CoreOnboarding>;
  findSimilarCompliance: Array<ComplianceDataWithSimilarity>;
  /** Find images similar to the search text */
  findSimilarImages: Array<ImageReferenceWithSimilarity>;
  findSimilarQuestions: Array<QuestionStoreWithSimilarity>;
  getAdminCompanyGoals: Array<CoreGoal>;
  getAdminCompanyTasks: Array<CoreTask>;
  getAiGeneratedById: AiGenerated;
  getAiThread: AiThread;
  getAiThreadsForUser: Array<AiThread>;
  /** Get a single artifact by ID with permission checks */
  getArtifact?: Maybe<ArtifactDto>;
  /** Get multiple artifacts with optional filtering by thread, type, and version */
  getArtifacts: Array<ArtifactDto>;
  getAskNicelyWebSurveyInfo: AskNicelySurveyInfo;
  getAvailableProducts: Array<AvailableProduct>;
  getBambeePlusInfo: BambeePlus;
  /** Lists statements submitted to a company */
  getBillingHistory: Array<Statement>;
  getBillingInfo: BillingInfo;
  getBundle: BundleResponse;
  getBusinessManagerCalendly: Calendly;
  getChannelHistory: Array<ChatMessageInterface>;
  getCompanyChannels: Array<CompanyChannel>;
  getCompanyCreditsV2: Array<Credit>;
  getCompanyDelinquency: CompanyDelinquency;
  getCompanyProducts: Array<Product>;
  getCompanySettings: Array<CompanySetting>;
  getCompanySources: PaymentSources;
  getConversationByIntercomId: Conversation;
  getConversationHistory: Array<ChatMessageInterface>;
  /** @deprecated Use coreCompany instead */
  getCoreCompany: CoreCompany;
  getCoreUserById: CoreUser;
  getDocumentById: CoreDocument;
  /** Retrieves one job description assigned to an employee */
  getEmployeeJobDescription?: Maybe<EmployeeJobDescription>;
  getEoeHrRequestAnswer?: Maybe<EoEHrRequestAnswer>;
  getHrRequestBySalesforceCaseId?: Maybe<HrRequest>;
  getHrRequestOptions: HrRequestOptionsResponse;
  getHrRequests: ListHrRequestsResponse;
  getHrScore: HrScore;
  /** Get a specific image reference by ID */
  getImageReference?: Maybe<ImageReference>;
  /** Get image references with optional filters */
  getImageReferences: Array<ImageReference>;
  /** Get all available image versions */
  getImageVersions: Array<Scalars['String']>;
  /** Get a job description by ID, including its assignment count */
  getJobDescriptionById: JobDescription;
  getLatestPricingPackagesForTier: PricingPackageResponse;
  getMyChatRecipients: Array<CoreUser>;
  getMyCompanyChannels: Array<CompanyChannel>;
  getMyCompanyGoals: Array<CoreGoal>;
  getMyCompanyTasks: Array<CoreTask>;
  getMyCompanyVoicesFeedbackList: Array<VoicesFeedback>;
  getMyCoreUser: CoreUser;
  getMyMfaEnrollments: Array<AuthMfaConfig>;
  getMySuggestedTopics: Array<ChatTopicSuggestion>;
  getMyVoicesFeedbackList: Array<VoicesFeedback>;
  getNonCoreSubscriptionBillingChanges: Array<UpcomingNonCoreSubscriptionBillingChange>;
  getOnboardingCalendlyConfig: OnboardingCalendlyConfig;
  getPlanLock: PlanLock;
  getPolicy?: Maybe<CorePolicy>;
  getPractice: Practice;
  getPricingPackages: PricingPackageResponse;
  getQuestionFromStore?: Maybe<QuestionStore>;
  /** Get recommended policy template based on real-time conversation thread or messages */
  getRecommendedPolicyTemplate: PolicyTemplateRecommendation;
  /** Get multiple recommended policy templates based on real-time conversation thread or messages */
  getRecommendedPolicyTemplates: Array<PolicyTemplateRecommendation>;
  getReportCard: ReportCard;
  getRescheduleLink: Scalars['String'];
  getResignationByHrRequest: Resignation;
  getSalesforceCasesForNewPolicyRequest: ListSalesforceCasesResponse;
  getScheduledEventsForUser: Array<ScheduledEvent>;
  /** Get a single solution by solution ID or case ID */
  getSolution?: Maybe<Solution>;
  /** Get the full delegation audit trail for a solution, with actor profiles resolved */
  getSolutionDelegationHistory: Array<SolutionDelegationHistoryEntry>;
  /** Get solutions by scope (company-level or user-specific) */
  getSolutions: Array<Solution>;
  /** Get paginated solutions with cursor-based pagination and advanced filtering */
  getSolutionsWithCursor: PaginatedSolutionsResponse;
  getSystemConfiguration: SystemConfiguration;
  getTerminationByHrRequest: Termination;
  getThreadHistory: Array<ChatMessageInterface>;
  getTickets: ListTicketsResponse;
  getTopic?: Maybe<CourseTopic>;
  getTopics: Array<CourseTopic>;
  getTrainingPrices: TrainingPricesResponse;
  /** @deprecated Use `user.training.courses` query instead */
  getUserCourses: Array<UserCourse>;
  getUserMfaEnrollments: Array<AuthMfaConfig>;
  getVoicesFeedbackList: Array<VoicesFeedback>;
  geyMyGroups: Array<CoreUserGroup>;
  hotlineCalls: Array<HotlineCall>;
  hrRequest: HrRequest;
  hrRequestExtendedDetail: HrRequestExtendedDetail;
  hrRequestList: ListHrRequestDetails;
  invoices: InvoiceConnection;
  isEventScheduledForUser: IsEventScheduledForUser;
  /** Lists the job descriptions created by a company with their assignment counts */
  jobDescriptions: Array<JobDescription>;
  listPractice: Array<Practice>;
  listReportCards: Array<ReportCard>;
  /** Lists notification for a user */
  myNotifications: Array<Notification>;
  myProducts: Array<Product>;
  /** Gets all recommendations for current user with optional filtering */
  myRecommendations?: Maybe<Array<CoreRecommendation>>;
  /** Gets all requests for current user with optional filtering */
  myRequests?: Maybe<Array<CoreRequest>>;
  /** Gets all training recommendations for current user with optional filtering; Aggregates training recommendations from all scopes ( SYSTEM, COMPANY, EMPLOYEE) */
  myTrainingRecommendations?: Maybe<Array<CoreRecommendation>>;
  /** Gets all training requests for current user with optional filtering */
  myTrainingRequests?: Maybe<Array<CoreRequest>>;
  /** Get a specific notice by ID */
  notice?: Maybe<Notice>;
  /** Get paginated notices for the current user or company */
  notices: PaginatedNoticesResponse;
  /** Get paginated notices by severity for the current user or company */
  noticesBySeverity: PaginatedNoticesResponse;
  onboardingFileAnalysis: OnboardingFilesAnalysis;
  paymentMethods: Array<PaymentMethod>;
  pendingHotlineCall?: Maybe<HotlineCall>;
  /** Get a pipeline execution batch with all associated agent emissions */
  pipelineExecution?: Maybe<PipelineExecution>;
  planForCompany: BillingPlan;
  plans: Array<BillingPlan>;
  /** Returns the Premium People add-on plan matching the company's core tier. */
  premiumPeopleAddonPlanForCompany: BambeeGenericPlanModel;
  /** Returns the available Premium People add-on plans (catalog). */
  premiumPeopleAddonPlans: Array<BambeeGenericPlanModel>;
  /** Returns the available Premium People Core plans (catalog) — the plans a company subscribes to directly, not the add-on. Independent of the company's current subscription, so it also serves companies with no paid plan. */
  premiumPeopleCorePlans: Array<CorePlanModel>;
  previewChange: ChangePreview;
  previewSeatChange: SeatChangePreview;
  previewSeatChangeV2: ChangePreview;
  productInterest: Array<ProductInterest>;
  qaQueryTrainingCertificates: Array<QaTrainingCertificates>;
  queryEnrolledTopics: Array<CompanyCourseTopic>;
  questionStoreByCompany: Array<QuestionStore>;
  questionStoreByCompanyAndUser: Array<QuestionStore>;
  realTimeThread?: Maybe<RealTimeThread>;
  realTimeThreads: RealTimeThreadConnection;
  /** Gets all recommendations for provided query */
  recommendations?: Maybe<Array<CoreRecommendation>>;
  removeSeatsInfo: RemoveSeatsInfoResponse;
  /** Gets all requests for current user's company with optional filtering */
  requests?: Maybe<Array<CoreRequest>>;
  resignationDownload: ResignationDownload;
  resignationExists: ResignationExist;
  resignationInfo: Resignation;
  resignationList: Array<Resignation>;
  /** Get a single resolution cycle by id */
  resolutionCycle?: Maybe<ResolutionCycle>;
  /** Get a single resolution cycle (incl. its Guidance Output) by the originating solutionId or its Salesforce caseId. Read-only; scoped to the caller's company (company-data readers / Bambee staff may read across companies). Returns null when no cycle matches. */
  resolutionCycleByKey?: Maybe<ResolutionCycle>;
  /** List resolution cycles for the current company (Smart Resolution) */
  resolutionCycles: Array<ResolutionCycle>;
  scratchListServiceAddons: Array<ScratchServiceAddonsModel>;
  searchRealTimeMessages: Array<RealTimeMessageWithSimilarity>;
  searchRealTimeThreads: Array<RealTimeThreadWithSimilarity>;
  seatWaiver?: Maybe<SeatWaiver>;
  seatWaivers: Array<SeatWaiver>;
  smartCabinetDocuments: Array<SmartCabinetDocument>;
  smartCabinetDownloadUrl: SmartCabinetDownloadTicket;
  staffSeatBilling: StaffSeatBilling;
  terminationDownload: TerminationDownload;
  terminationExists: TerminationExist;
  terminationInfo: Termination;
  terminationList: Array<Termination>;
  /** Get enhanced transcript for a thread */
  threadEnhancedTranscript?: Maybe<EnhancedTranscript>;
  /** Get structured summary for a thread */
  threadStructuredSummary?: Maybe<ConversationSummary>;
  user: User;
  /** @deprecated Use `user.training.courses` query instead */
  userCourses: Array<UserCourse>;
  warningDocuments: Array<WarningDocument>;
  wizard?: Maybe<Wizard>;
  /** Get a single wizard group by ID with optional activation status */
  wizardGroup?: Maybe<WizardGroup>;
  /** Get all wizard groups with optional activation status for a specific customer */
  wizardGroups: Array<WizardGroup>;
  /** Get a single wizard template by ID */
  wizardTemplate?: Maybe<WizardTemplate>;
  /** Get all wizard templates for a wizard group */
  wizardTemplatesByWizardGroup: Array<WizardTemplate>;
  wizards: Array<Wizard>;
};


export type QueryActivationArgs = {
  data: ActivationQueryInput;
};


export type QueryActivationsArgs = {
  data?: Maybe<ActivationFilterInput>;
};


export type QueryAdvisorNextAvailableSlotArgs = {
  input: AdvisorNextAvailableSlotInput;
};


export type QueryAgentEmissionsArgs = {
  input: AgentEmissionsInput;
};


export type QueryBillingEventsArgs = {
  after?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  first?: Scalars['Int'];
  types?: Maybe<Array<Scalars['String']>>;
};


export type QueryBillingMigrationRecordArgs = {
  companyId: Scalars['String'];
};


export type QueryBillingMigrationRecordHistoryArgs = {
  companyId: Scalars['String'];
};


export type QueryBillingSubscriptionArgs = {
  companyId: Scalars['ID'];
};


export type QueryCanInitiateTrialArgs = {
  input: CanInitiateTrialInput;
};


export type QueryCompanyArgs = {
  data: GetCompanyInput;
};


export type QueryCompanyAdvisorCalendlySlugArgs = {
  input: CompanyAdvisorCalendlySlugInput;
};


export type QueryCompanyQuestionsAnsweredByUserArgs = {
  companyId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryCompanyServiceCasesArgs = {
  companyId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryCompanySubscriptionsArgs = {
  data: GetCompanySubscriptionsInput;
};


export type QueryCompanySurveyArgs = {
  data: GetCompanySurveyInput;
};


export type QueryCompanySurveyAnswerArgs = {
  data: GetCompanySurveyAnswerInput;
};


export type QueryCompanySurveyListArgs = {
  input: GetCompanySurveyListInput;
};


export type QueryContextArgs = {
  input?: Maybe<ContextInput>;
};


export type QueryCoreCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryCoreUpgradeOptionsArgs = {
  input: GetCoreUpgradeOptionsInput;
};


export type QueryCouponArgs = {
  data: GetCouponInput;
};


export type QueryCreditBalanceArgs = {
  companyId: Scalars['ID'];
  productKey: Scalars['String'];
};


export type QueryCreditsArgs = {
  companyId: Scalars['ID'];
  includeConsumed?: Scalars['Boolean'];
  productKey?: Maybe<Scalars['String']>;
};


export type QueryCustomerWizardGroupsArgs = {
  customerId: Scalars['ID'];
  search?: Maybe<Scalars['String']>;
};


export type QueryEntitlementArgs = {
  companyId: Scalars['ID'];
};


export type QueryFindOnboardingArgs = {
  data: CoreOnboardingKeys;
};


export type QueryFindSimilarComplianceArgs = {
  input: FindSimilarComplianceInput;
};


export type QueryFindSimilarImagesArgs = {
  input: FindSimilarImagesInput;
};


export type QueryFindSimilarQuestionsArgs = {
  input: FindSimilarQuestionsInput;
};


export type QueryGetAdminCompanyGoalsArgs = {
  companyId: Scalars['String'];
};


export type QueryGetAdminCompanyTasksArgs = {
  companyId: Scalars['String'];
};


export type QueryGetAiGeneratedByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetAiThreadArgs = {
  threadId: Scalars['String'];
};


export type QueryGetAiThreadsForUserArgs = {
  userId: Scalars['String'];
};


export type QueryGetArtifactArgs = {
  id: Scalars['String'];
};


export type QueryGetArtifactsArgs = {
  input: GetArtifactsInput;
};


export type QueryGetAskNicelyWebSurveyInfoArgs = {
  input: GetAskNicelyWebSurveyInfoInput;
};


export type QueryGetAvailableProductsArgs = {
  data: GetAvailableProductsInput;
};


export type QueryGetBambeePlusInfoArgs = {
  input: PurchaseBambeePlusInput;
};


export type QueryGetBillingHistoryArgs = {
  companyId: Scalars['String'];
};


export type QueryGetBillingInfoArgs = {
  input: GetBillingInfoInput;
};


export type QueryGetBundleArgs = {
  data: GetEntityInput;
};


export type QueryGetBusinessManagerCalendlyArgs = {
  input: GetBusinessManagerCalendlyUrlInput;
};


export type QueryGetChannelHistoryArgs = {
  afterId?: Maybe<Scalars['ID']>;
  channelId: Scalars['ID'];
};


export type QueryGetCompanyChannelsArgs = {
  companyId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};


export type QueryGetCompanyCreditsV2Args = {
  data: GetCompanyCreditsInputV2;
};


export type QueryGetCompanyDelinquencyArgs = {
  data: GetCompanyDelinquency;
};


export type QueryGetCompanyProductsArgs = {
  data: GetCompanyProductsInput;
};


export type QueryGetCompanySettingsArgs = {
  companyId: Scalars['String'];
};


export type QueryGetCompanySourcesArgs = {
  data: GetCompanyPaymentSources;
};


export type QueryGetConversationByIntercomIdArgs = {
  input: GetConversationByIntercomIdInput;
};


export type QueryGetConversationHistoryArgs = {
  input: ConversationHistoryInput;
};


export type QueryGetCoreCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryGetCoreUserByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDocumentByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetEmployeeJobDescriptionArgs = {
  id: Scalars['String'];
};


export type QueryGetEoeHrRequestAnswerArgs = {
  data: GetEoeHrRequestInput;
};


export type QueryGetHrRequestBySalesforceCaseIdArgs = {
  input: GetHrRequestBySalesforceCaseIdInput;
};


export type QueryGetHrScoreArgs = {
  companyId: Scalars['String'];
};


export type QueryGetImageReferenceArgs = {
  id: Scalars['String'];
};


export type QueryGetImageReferencesArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};


export type QueryGetJobDescriptionByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetLatestPricingPackagesForTierArgs = {
  input: ActivePlanFilters;
  tierNumber: Scalars['Float'];
};


export type QueryGetMyMfaEnrollmentsArgs = {
  includeUnconfirmed?: Maybe<Scalars['Boolean']>;
};


export type QueryGetNonCoreSubscriptionBillingChangesArgs = {
  data: GetCompanyUpcomingBillingChangesInput;
};


export type QueryGetOnboardingCalendlyConfigArgs = {
  input: OnboardingCalendlyConfigInput;
};


export type QueryGetPlanLockArgs = {
  companyId: Scalars['String'];
};


export type QueryGetPolicyArgs = {
  input: GetPolicy;
};


export type QueryGetPracticeArgs = {
  input: GetPracticeInput;
};


export type QueryGetPricingPackagesArgs = {
  input: PricingPackageFilterInput;
};


export type QueryGetQuestionFromStoreArgs = {
  id: Scalars['String'];
};


export type QueryGetRecommendedPolicyTemplateArgs = {
  input: GetRecommendedPolicyTemplateInput;
};


export type QueryGetRecommendedPolicyTemplatesArgs = {
  input: GetRecommendedPolicyTemplatesInput;
};


export type QueryGetReportCardArgs = {
  data: GetReportCardInput;
};


export type QueryGetRescheduleLinkArgs = {
  input: GetCalendlyRescheduleLinkInput;
};


export type QueryGetResignationByHrRequestArgs = {
  data: GetResignationHrRequestInput;
};


export type QueryGetSalesforceCasesForNewPolicyRequestArgs = {
  input: GetSalesforceCasesForNewPolicyRequestInput;
};


export type QueryGetScheduledEventsForUserArgs = {
  input: GetScheduledEventsForUserInput;
};


export type QueryGetSolutionArgs = {
  input: GetSolutionInput;
};


export type QueryGetSolutionDelegationHistoryArgs = {
  input: GetSolutionDelegationHistoryInput;
};


export type QueryGetSolutionsArgs = {
  input: GetSolutionsInput;
};


export type QueryGetSolutionsWithCursorArgs = {
  input: GetSolutionsWithCursorInput;
};


export type QueryGetTerminationByHrRequestArgs = {
  data: GetTerminationHrRequestInput;
};


export type QueryGetThreadHistoryArgs = {
  input: ThreadHistoryInput;
};


export type QueryGetTicketsArgs = {
  data: ListTicketsInput;
};


export type QueryGetTopicArgs = {
  data: GetEntityInput;
};


export type QueryGetUserCoursesArgs = {
  data: GetUserCoursesInput;
};


export type QueryGetUserMfaEnrollmentsArgs = {
  authId: Scalars['String'];
  includeUnconfirmed?: Maybe<Scalars['Boolean']>;
};


export type QueryGetVoicesFeedbackListArgs = {
  input: GetVoicesFeedbackListInput;
};


export type QueryGeyMyGroupsArgs = {
  view?: GroupView;
};


export type QueryHrRequestArgs = {
  input: GetHrRequestByIdInput;
};


export type QueryHrRequestExtendedDetailArgs = {
  input: GetHrRequestExtendedDetailByIdInput;
};


export type QueryInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  first?: Scalars['Int'];
};


export type QueryIsEventScheduledForUserArgs = {
  input: IsEventScheduledForUserInput;
};


export type QueryListPracticeArgs = {
  companyId: Scalars['String'];
};


export type QueryListReportCardsArgs = {
  data: ListReportCardsInput;
};


export type QueryMyRecommendationsArgs = {
  data: MyRecommendationFilterInput;
};


export type QueryMyRequestsArgs = {
  data: MyRequestFilterInput;
};


export type QueryMyTrainingRecommendationsArgs = {
  data: MyTrainingRecommendationFilterInput;
};


export type QueryMyTrainingRequestsArgs = {
  data: MyTrainingRequestFilterInput;
};


export type QueryNoticeArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type QueryNoticesArgs = {
  pagination?: Maybe<NoticesPaginationInput>;
};


export type QueryNoticesBySeverityArgs = {
  pagination: NoticesBySeverityPaginationInput;
};


export type QueryOnboardingFileAnalysisArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentMethodsArgs = {
  companyId: Scalars['ID'];
};


export type QueryPipelineExecutionArgs = {
  input: PipelineExecutionInput;
};


export type QueryPlanForCompanyArgs = {
  companyId: Scalars['ID'];
  interval: Scalars['String'];
  productKey: Scalars['String'];
};


export type QueryPlansArgs = {
  filter?: Maybe<PlanFilter>;
};


export type QueryPremiumPeopleAddonPlanForCompanyArgs = {
  companyId?: Maybe<Scalars['String']>;
};


export type QueryPremiumPeopleCorePlansArgs = {
  companyId?: Maybe<Scalars['ID']>;
};


export type QueryPreviewChangeArgs = {
  input: ChangePlanInput;
};


export type QueryPreviewSeatChangeArgs = {
  input: PreviewSeatChangeInput;
};


export type QueryPreviewSeatChangeV2Args = {
  input: ChangeSeatsInput;
};


export type QueryProductInterestArgs = {
  input: GetProductInterestInput;
};


export type QueryQaQueryTrainingCertificatesArgs = {
  courseTicketId: Scalars['String'];
};


export type QueryQueryEnrolledTopicsArgs = {
  companyId: Scalars['String'];
};


export type QueryQuestionStoreByCompanyArgs = {
  companyId: Scalars['String'];
};


export type QueryQuestionStoreByCompanyAndUserArgs = {
  companyId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryRealTimeThreadArgs = {
  id: Scalars['ID'];
};


export type QueryRealTimeThreadsArgs = {
  input?: Maybe<RealTimeThreadsQueryInput>;
};


export type QueryRecommendationsArgs = {
  data: RecommendationFilterInput;
};


export type QueryRemoveSeatsInfoArgs = {
  data: RemoveSeatsInfoInput;
};


export type QueryRequestsArgs = {
  data: RequestFilterInput;
};


export type QueryResignationDownloadArgs = {
  data: GetResignationInput;
};


export type QueryResignationExistsArgs = {
  data: GetExistingResignationByEmployeeInput;
};


export type QueryResignationInfoArgs = {
  data: GetResignationInput;
};


export type QueryResignationListArgs = {
  data: GetResignationsInput;
};


export type QueryResolutionCycleArgs = {
  companyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type QueryResolutionCycleByKeyArgs = {
  input: ResolutionCycleInput;
};


export type QueryResolutionCyclesArgs = {
  companyId?: Maybe<Scalars['String']>;
};


export type QueryScratchListServiceAddonsArgs = {
  input: ScratchServiceAddonListInput;
};


export type QuerySearchRealTimeMessagesArgs = {
  input: SearchRealTimeMessagesInput;
};


export type QuerySearchRealTimeThreadsArgs = {
  input: SearchRealTimeThreadsInput;
};


export type QuerySeatWaiverArgs = {
  companyId: Scalars['String'];
  productKey: SeatKind;
};


export type QuerySeatWaiversArgs = {
  companyId: Scalars['String'];
};


export type QuerySmartCabinetDownloadUrlArgs = {
  input: GetSmartCabinetDownloadUrlInput;
};


export type QueryStaffSeatBillingArgs = {
  companyId: Scalars['String'];
};


export type QueryTerminationDownloadArgs = {
  data: GetTerminationInput;
};


export type QueryTerminationExistsArgs = {
  data: GetExistingTerminationByEmployeeInput;
};


export type QueryTerminationInfoArgs = {
  data: GetTerminationInput;
};


export type QueryTerminationListArgs = {
  data: GetTerminationsInput;
};


export type QueryThreadEnhancedTranscriptArgs = {
  threadId: Scalars['ID'];
};


export type QueryThreadStructuredSummaryArgs = {
  threadId: Scalars['ID'];
};


export type QueryUserArgs = {
  data: UserQueryInput;
};


export type QueryUserCoursesArgs = {
  data: UserCoursesInput;
};


export type QueryWarningDocumentsArgs = {
  data: GetUserWarningDocumentsInput;
};


export type QueryWizardArgs = {
  id: Scalars['String'];
};


export type QueryWizardGroupArgs = {
  customerId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type QueryWizardGroupsArgs = {
  customerId?: Maybe<Scalars['String']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type QueryWizardTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryWizardTemplatesByWizardGroupArgs = {
  wizardGroupId: Scalars['ID'];
};


export type QueryWizardsArgs = {
  filter?: Maybe<WizardFilterInput>;
};

export type QuestionGroupConfig = {
  __typename?: 'QuestionGroupConfig';
  addButtonText: Scalars['String'];
  groupTitle: Scalars['String'];
  groupValidation?: Maybe<Array<ValidationRule>>;
  maxInstances: Scalars['Int'];
  minInstances: Scalars['Int'];
  questions: Array<WizardQuestion>;
  removeButtonText: Scalars['String'];
};

export type QuestionGroupConfigInput = {
  addButtonText: Scalars['String'];
  groupTitle: Scalars['String'];
  groupValidation?: Maybe<Array<ValidationRuleInput>>;
  maxInstances: Scalars['Int'];
  minInstances: Scalars['Int'];
  questions: Array<QuestionInput>;
  removeButtonText: Scalars['String'];
};

export type QuestionInput = {
  /** Number of columns this question should span */
  columnCount?: Maybe<Scalars['Int']>;
  conditionalRequired?: Maybe<ConditionalRequiredInput>;
  /** Question-specific configuration based on type */
  config?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  /** Configuration for question groups (only applicable for QUESTION_GROUP type) */
  groupConfig?: Maybe<QuestionGroupConfigInput>;
  label: Scalars['String'];
  labelSize?: Maybe<LabelSize>;
  labelWeight?: Maybe<LabelWeight>;
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  showIf?: Maybe<Array<ShowIfConditionInput>>;
  type: QuestionType;
  validation?: Maybe<Array<ValidationRuleInput>>;
};

export type QuestionStore = {
  __typename?: 'QuestionStore';
  /** The latest answer text (computed from answers array) */
  answer?: Maybe<Scalars['String']>;
  /** Historical answers for this question */
  answers: Array<QuestionStoreAnswer>;
  /** Date after which the question can be asked again */
  askAfter?: Maybe<Scalars['DateTime']>;
  /** Company id */
  companyId: Scalars['ID'];
  /** Creation date */
  createdAt: Scalars['DateTime'];
  /** Date when the question was answered */
  dateAnswered: Scalars['DateTime'];
  /** QuestionStore id */
  id: Scalars['ID'];
  /** Date when the latest answer was created (computed) */
  lastAnsweredOn?: Maybe<Scalars['DateTime']>;
  /** The question text */
  question: Scalars['String'];
  /** Source of the question (app, intercom, phone) */
  source?: Maybe<Scalars['String']>;
  /** Last update date */
  updatedAt: Scalars['DateTime'];
  /** User id who answered the question */
  userId?: Maybe<Scalars['ID']>;
};

export type QuestionStoreAnswer = {
  __typename?: 'QuestionStoreAnswer';
  /** The answer text */
  answer: Scalars['String'];
  /** Role of the user who answered (owner, admin, employee) */
  answeredByRole?: Maybe<Scalars['String']>;
  /** Creation date */
  createdAt: Scalars['DateTime'];
  /** Answer id */
  id: Scalars['ID'];
  /** User id who provided this answer */
  userId?: Maybe<Scalars['ID']>;
};

export type QuestionStoreWithSimilarity = {
  __typename?: 'QuestionStoreWithSimilarity';
  /** The latest answer text (computed from answers array) */
  answer?: Maybe<Scalars['String']>;
  /** Historical answers for this question */
  answers: Array<QuestionStoreAnswer>;
  /** Date after which the question can be asked again */
  askAfter?: Maybe<Scalars['DateTime']>;
  /** Company id */
  companyId: Scalars['ID'];
  /** Creation date */
  createdAt: Scalars['DateTime'];
  /** Date when the question was answered */
  dateAnswered: Scalars['DateTime'];
  /** QuestionStore id */
  id: Scalars['ID'];
  /** Date when the latest answer was created (computed) */
  lastAnsweredOn?: Maybe<Scalars['DateTime']>;
  /** Whether there was an error during OpenAI verification */
  openAiError?: Maybe<Scalars['Boolean']>;
  /** Whether OpenAI verified this as a similar question */
  openAiVerified?: Maybe<Scalars['Boolean']>;
  /** The question text */
  question: Scalars['String'];
  /** Similarity score (0-1, where 1 is identical) */
  similarity: Scalars['Float'];
  /** Source of the question (app, intercom, phone) */
  source?: Maybe<Scalars['String']>;
  /** Last update date */
  updatedAt: Scalars['DateTime'];
  /** User id who answered the question */
  userId?: Maybe<Scalars['ID']>;
};

/** Type of input for questions */
export enum QuestionType {
  Boolean = 'BOOLEAN',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Email = 'EMAIL',
  FileUpload = 'FILE_UPLOAD',
  Matrix = 'MATRIX',
  Number = 'NUMBER',
  Phone = 'PHONE',
  QuestionGroup = 'QUESTION_GROUP',
  Radio = 'RADIO',
  Rating = 'RATING',
  Select = 'SELECT',
  Slider = 'SLIDER',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Time = 'TIME'
}

export type RateNoticeInput = {
  /** Whether the notice was helpful (true) or not helpful (false) */
  helpful: Scalars['Boolean'];
  /** The ID of the notice being rated */
  noticeId: Scalars['ID'];
};

export type RawAiPrompt = {
  /** The text of the prompt, optionally included, containing questions, statements, or relevant information for the chat interaction. */
  content?: Maybe<Scalars['String']>;
  /** An optional identifier for the prompt, used for reference or categorization within the chat framework. */
  name?: Maybe<Scalars['String']>;
  /** Defines the prompt's function within the chat, such as initiating a request or guiding the conversation, based on ChatCompletionRequestMessageRoleEnum. */
  role: ChatCompletionRole;
};

/** Type of reaction to a recommendation. */
export enum ReactionType {
  Accept = 'ACCEPT',
  Decline = 'DECLINE'
}

export type ReactivatePausedCompanyInput = {
  companyId: Scalars['String'];
};

export type RealTimeMessage = {
  __typename?: 'RealTimeMessage';
  /** Resolved artifact data (HTML is lazy-loaded, only fetched when explicitly requested) */
  artifact?: Maybe<ArtifactDto>;
  /** Artifact ID if this message generated or references an artifact */
  artifactId?: Maybe<Scalars['ID']>;
  content?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inputTokens?: Maybe<Scalars['Int']>;
  /** Whether this message is hidden from the user UI */
  isHidden: Scalars['Boolean'];
  messageType: RealTimeMessageType;
  openaiItemId?: Maybe<Scalars['String']>;
  openaiResponseId?: Maybe<Scalars['String']>;
  outputTokens?: Maybe<Scalars['Int']>;
  role: RealTimeMessageRole;
  sequenceNumber: Scalars['Int'];
  threadId: Scalars['ID'];
  toolCallArguments?: Maybe<Scalars['JSON']>;
  toolCallName?: Maybe<Scalars['String']>;
  toolCallResult?: Maybe<Scalars['JSON']>;
  totalTokens?: Maybe<Scalars['Int']>;
};

export enum RealTimeMessageRole {
  Assistant = 'ASSISTANT',
  Tool = 'TOOL',
  User = 'USER'
}

export enum RealTimeMessageType {
  Text = 'TEXT',
  ToolCall = 'TOOL_CALL',
  ToolResult = 'TOOL_RESULT'
}

export type RealTimeMessageWithSimilarity = {
  __typename?: 'RealTimeMessageWithSimilarity';
  message: RealTimeMessage;
  similarity: Scalars['Float'];
};

export type RealTimeThread = {
  __typename?: 'RealTimeThread';
  anonymizedSummary?: Maybe<Scalars['String']>;
  /** Associated Case ID from task service */
  caseId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lastActivityAt: Scalars['DateTime'];
  messageCount: Scalars['Int'];
  messages: Array<RealTimeMessage>;
  model?: Maybe<Scalars['String']>;
  status: RealTimeThreadStatus;
  summary?: Maybe<Scalars['String']>;
  threadType?: Maybe<ThreadType>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
  voiceType?: Maybe<Scalars['String']>;
};


export type RealTimeThreadMessagesArgs = {
  input?: Maybe<RealTimeThreadMessagesInput>;
};

export type RealTimeThreadConnection = {
  __typename?: 'RealTimeThreadConnection';
  hasMore: Scalars['Boolean'];
  nodes: Array<RealTimeThread>;
  totalCount: Scalars['Int'];
};

export type RealTimeThreadMessagesInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<MessageOrderBy>;
};

export enum RealTimeThreadStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED'
}

export type RealTimeThreadWithSimilarity = {
  __typename?: 'RealTimeThreadWithSimilarity';
  similarity: Scalars['Float'];
  thread: RealTimeThread;
};

export type RealTimeThreadsQueryInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<ThreadOrderBy>;
  status?: Maybe<RealTimeThreadStatus>;
  threadType?: Maybe<ThreadType>;
};

export type ReassignSolutionToSelfInput = {
  /** The ID of the solution to reassign to yourself (reclaim from Bambee or another user) */
  solutionId: Scalars['ID'];
};

export type ReclaimSolutionInput = {
  /** The ID of the solution to reclaim (clears delegation and returns to not-started) */
  solutionId: Scalars['ID'];
};

/** The demographic target of the recommendation. */
export enum RecommendationDemographic {
  Id = 'ID',
  Industry = 'INDUSTRY',
  Role = 'ROLE',
  State = 'STATE',
  Tier = 'TIER'
}

export type RecommendationFilterInput = {
  /** The id of the company to fetch recommendations for. */
  companyId?: Maybe<Scalars['String']>;
  /** The target demographic of the recommendation */
  demographic?: Maybe<RecommendationDemographic>;
  /** The description of the recommendation. */
  note?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The resource type of the recommendation. */
  resourceType?: Maybe<RequestResourceType>;
  /** The scope of the recommendation */
  scope: RecommendationScope;
  /** The status of the recommendation. */
  status?: Maybe<RecommendationStatus>;
  /** The targets of the recommendation */
  targets?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The user id of the employee to fetch recommendations for. */
  userId?: Maybe<Scalars['String']>;
};

export type RecommendationInput = {
  /** The types of reactions allowed. */
  allowedReactions?: Maybe<Array<Maybe<ReactionType>>>;
  /** The company id of the employee recommending training. */
  companyId: Scalars['String'];
  /** The target demographic of the recommendation */
  demographic: RecommendationDemographic;
  /** The description of the recommendation. */
  note?: Maybe<Scalars['String']>;
  /** The roles of the users allowed to react. */
  reactorRoles?: Maybe<Array<Maybe<AuthRole>>>;
  /** The id of the resource. */
  resourceId: Scalars['String'];
  /** The resource type of the recommendation. */
  resourceType: RequestResourceType;
  /** The scope of the recommendation */
  scope: RecommendationScope;
  /** The targets of the recommendation */
  targets: Array<Scalars['String']>;
  /** The user id of the employee recommending training. */
  userId: Scalars['String'];
};

export type RecommendationReactionInput = {
  /** The reaction type */
  reaction: ReactionType;
  /** The id of the recommendation to be reacted to. */
  recommendationId: Scalars['String'];
};

/** The scope of the recommendation. */
export enum RecommendationScope {
  Company = 'COMPANY',
  Employee = 'EMPLOYEE',
  System = 'SYSTEM'
}

/** The status of the recommendation. */
export enum RecommendationStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type RefundCreditsInput = {
  companyId: Scalars['String'];
  consumptionDescription: Scalars['String'];
  consumptionReason: ProductCreditConsumptionReason;
  productKey: ProductKey;
  stripeInvoiceId: Scalars['String'];
};

export type RefundInvoiceItem = {
  __typename?: 'RefundInvoiceItem';
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  refund: Scalars['Float'];
  unitPrice: Scalars['Float'];
};

export type RefundResult = {
  __typename?: 'RefundResult';
  creditsRefunded?: Maybe<Array<Credit>>;
  id: Scalars['ID'];
  totalRefunded: Scalars['Int'];
};

/** Regenerate the guidance of a cycle (BIO-1395). At most one of answers / revisionNote per call; BOTH absent is a pure retry, valid only when the latest outcome is FAILED — it re-runs the failed attempt in full off the server-held form state (intake + accumulated answers + active revision note). */
export type RegenerateGuidanceInput = {
  /** Answers to the pending questions (the HEX-US-16 sufficiency loop) */
  answers?: Maybe<Array<GuidanceAnswerInput>>;
  /** The resolution cycle to regenerate */
  cycleId: Scalars['ID'];
  /** The customer's request-changes reason (the HEX-US-17 revision); required non-empty when present */
  revisionNote?: Maybe<Scalars['String']>;
};

export type ReinstateEmployeeInput = {
  employeeId: Scalars['String'];
};

export type RelatedCase = {
  __typename?: 'RelatedCase';
  /** Salesforce ID of the related case */
  caseId: Scalars['String'];
  /** Subject of the related case */
  subject: Scalars['String'];
};

export type RemoveBundleSeatsInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipRefund?: Maybe<Scalars['Boolean']>;
};

export type RemoveCompanyTrainingInput = {
  companyId: Scalars['String'];
};

export type RemoveCompanyTrainingResponse = {
  __typename?: 'RemoveCompanyTrainingResponse';
  id: Scalars['ID'];
};

export type RemoveCreditsInput = {
  companyId: Scalars['String'];
  consumptionDescription: Scalars['String'];
  consumptionReason: ProductCreditConsumptionReason;
  /** Subkey of the product, if consuming managed service credit */
  consumptionSubKey?: Maybe<ProductSubKey>;
  productKey: ProductKey;
  quantity: Scalars['Int'];
};

export type RemovePaymentMethodInput = {
  companyId: Scalars['String'];
  paymentMethodId: Scalars['String'];
};

export type RemoveSeatsInfoInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipRefund?: Maybe<Scalars['Boolean']>;
  topicId?: Maybe<Scalars['String']>;
};

export type RemoveSeatsInfoResponse = {
  __typename?: 'RemoveSeatsInfoResponse';
  id: Scalars['ID'];
  invoices: Array<RefundInvoiceItem>;
  refund: Scalars['Float'];
  seats: Scalars['Int'];
};

export type RemoveSeatsInput = {
  billingPeriod?: Maybe<TrainingBillingPeriod>;
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  numSeats: Scalars['Int'];
  skipRefund?: Maybe<Scalars['Boolean']>;
  topicId?: Maybe<Scalars['String']>;
};

export type RemoveSeatsResponse = {
  __typename?: 'RemoveSeatsResponse';
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numRemoved: Scalars['Int'];
  totalSeats: Scalars['Int'];
};

export type ReplyToConversationInput = {
  intercomConversationId: Scalars['String'];
  message: Scalars['String'];
};

export type ReplyToHrRequestAsAdminInput = {
  hrRequestId: Scalars['String'];
  message: Scalars['String'];
};

export type ReportCard = {
  __typename?: 'ReportCard';
  /** frequency of being created */
  cadence: Scalars['String'];
  company: CoreCompany;
  createdAt: Scalars['DateTime'];
  createdBy: CoreUser;
  directReports?: Maybe<Array<CoreUser>>;
  employees: Array<ReportCardEmployeeGrade>;
  /** ReportCardId */
  id: Scalars['ID'];
  managerReports?: Maybe<Array<ManagedReport>>;
  status: ReportCardStatusValues;
  updateHistory: Array<Maybe<ReportCardEmployeeGradeHistory>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** A keyed 1–5 sub-rating on an employee grade */
export type ReportCardDimensionRating = {
  __typename?: 'ReportCardDimensionRating';
  /** Dimension key, e.g. role_performance */
  key: Scalars['String'];
  /** 1–5 rating for the dimension */
  value: Scalars['Int'];
};

export type ReportCardDimensionRatingInput = {
  /** Dimension key, e.g. role_performance */
  key: Scalars['String'];
  /** 1–5 rating for the dimension */
  value: Scalars['Int'];
};

export type ReportCardEmployeeGrade = {
  __typename?: 'ReportCardEmployeeGrade';
  /** Keyed 1–5 sub-ratings — private to manager + HR */
  dimensions: Array<ReportCardDimensionRating>;
  employee: CoreUser;
  /** Contributing-factor keys — private to manager + HR */
  factors: Array<Scalars['String']>;
  /** External / public to employee feedback */
  feedback: Scalars['String'];
  /** Employee Grade */
  grade: Scalars['String'];
  /** The person who graded this report card */
  gradedBy: CoreUser;
  /** Unique Report Card Grade Id */
  id: Scalars['ID'];
  /** Owner / Manager Internal Employee Note */
  note: Scalars['String'];
  /** Grade significance — private to manager + HR */
  significance?: Maybe<ReportCardSignificanceValues>;
  /** Status of employee grade filled out */
  status: Scalars['String'];
};

export type ReportCardEmployeeGradeHistory = {
  __typename?: 'ReportCardEmployeeGradeHistory';
  /** Keyed 1–5 sub-ratings — private to manager + HR */
  dimensions: Array<ReportCardDimensionRating>;
  employee: CoreUser;
  /** Contributing-factor keys — private to manager + HR */
  factors: Array<Scalars['String']>;
  /** External / public to employee feedback */
  feedback: Scalars['String'];
  /** Employee Grade */
  grade: Scalars['String'];
  gradedBy: CoreUser;
  /** Unique Report Card Grade History Id */
  id: Scalars['ID'];
  /** Owner / Manager Internal Employee Note */
  note: Scalars['String'];
  /** Grade significance — private to manager + HR */
  significance?: Maybe<ReportCardSignificanceValues>;
};

export enum ReportCardGradeValues {
  A = 'A',
  B = 'B',
  C = 'C',
  Pending = 'PENDING',
  Skip = 'SKIP'
}

export enum ReportCardSignificanceValues {
  BigDeal = 'BIG_DEAL',
  Matters = 'MATTERS',
  Mild = 'MILD'
}

export enum ReportCardStatusValues {
  Completed = 'COMPLETED',
  Created = 'CREATED'
}

export type RequestApprovalInput = {
  /** The id of the request. */
  requestId: Scalars['String'];
};

export type RequestCancelInput = {
  /** The id of the request. */
  requestId: Scalars['String'];
};

export type RequestFilterInput = {
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The id of the resource. */
  resourceId?: Maybe<Scalars['String']>;
  /** The resource type of the request. */
  resourceType?: Maybe<RequestResourceType>;
  /** The status of the request. */
  status?: Maybe<RequestStatus>;
  /** The user id of the employee requesting training. */
  userId?: Maybe<Scalars['String']>;
};

export type RequestInput = {
  /** The number of approvals required to approve the request. */
  approvalCriteria: Scalars['Int'];
  /** The roles of the decision makers. */
  approverRoles?: Maybe<Array<Maybe<AuthRole>>>;
  /** The company id of the employee requesting training. */
  companyId: Scalars['String'];
  /** The description of the request. */
  description?: Maybe<Scalars['String']>;
  /** The number of rejections required to reject the request. */
  rejectionCriteria: Scalars['Int'];
  /** The id of the resource. */
  resourceId: Scalars['String'];
  /** The resource type of the request. */
  resourceType: RequestResourceType;
  /** The user id of the employee requesting training. */
  userId: Scalars['String'];
};

export type RequestRejectionInput = {
  /** The id of the request. */
  requestId: Scalars['String'];
};

/** The resource type of the request. */
export enum RequestResourceType {
  TrainingBundle = 'TRAINING_BUNDLE',
  TrainingTopic = 'TRAINING_TOPIC'
}

/** The status of the request. */
export enum RequestStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ResetSolutionInput = {
  /** The ID of the solution to reset to not started */
  solutionId: Scalars['ID'];
};

export type Resignation = {
  __typename?: 'Resignation';
  complete: Scalars['Boolean'];
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  employee: User;
  employeeId: Scalars['String'];
  hrRequestId?: Maybe<Scalars['String']>;
  hrRequestVersion: Scalars['Boolean'];
  isLegacy: Scalars['Boolean'];
  manager: User;
  resignationDate?: Maybe<Scalars['DateTime']>;
  resignationId: Scalars['String'];
  resignationState?: Maybe<Scalars['String']>;
  selfService: Scalars['Boolean'];
  signedFiles: Array<FileStackModel>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: ResignationStatus;
  step: ResignationStep;
  user: User;
  userId: Scalars['String'];
};

export type ResignationAttachInput = {
  files: Array<FileStackInput>;
  resignationId: Scalars['String'];
};

export type ResignationCancelInput = {
  resignationId: Scalars['String'];
};

export type ResignationConfirmationInput = {
  resignationDate: Scalars['String'];
  resignationId: Scalars['String'];
  userId: Scalars['String'];
};

export type ResignationCreateInput = {
  answers?: Maybe<Scalars['JSON']>;
  employeeId: Scalars['String'];
  hrRequestId?: Maybe<Scalars['String']>;
  resignationDate?: Maybe<Scalars['String']>;
  selfService?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
  userId: Scalars['String'];
};

export type ResignationDownload = {
  __typename?: 'ResignationDownload';
  file: Scalars['String'];
  resignationId: Scalars['String'];
};

export type ResignationEditDetailsInput = {
  resignationDate: Scalars['String'];
  resignationId: Scalars['String'];
  selfService?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type ResignationExist = {
  __typename?: 'ResignationExist';
  exists: Scalars['Boolean'];
  resignationId?: Maybe<Scalars['String']>;
};

export enum ResignationStatus {
  AwaitingAcknowledgement = 'AWAITING_ACKNOWLEDGEMENT',
  AwaitingAproval = 'AWAITING_APROVAL',
  AwaitingSignature = 'AWAITING_SIGNATURE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  HrComplete = 'HR_COMPLETE',
  SelfService = 'SELF_SERVICE',
  Started = 'STARTED'
}

export enum ResignationStep {
  None = 'NONE',
  Print = 'PRINT',
  Requested = 'REQUESTED',
  UploadSigned = 'UPLOAD_SIGNED'
}

/** A resolution cycle backed by a Salesforce Case */
export type ResolutionCycle = {
  __typename?: 'ResolutionCycle';
  /** The customer's rejection note while a revision is active (cleared when an attempt lands OK) — drives the revision-loop copy after a reload and allows re-showing the saved note */
  activeRevisionNote?: Maybe<Scalars['String']>;
  /** True when the last administration generation failed (raw agent-error reason never exposed) */
  administrationFailed?: Maybe<Scalars['Boolean']>;
  /** One-line framing for the Administration plan */
  administrationHeadline?: Maybe<Scalars['String']>;
  /** The plan: blank-line-separated prose blocks, one owner each — "Who Handles What" */
  administrationOwnershipSplit?: Maybe<Scalars['String']>;
  /** When administration generation was last requested (drives the CTA staleness read) */
  administrationRequestedAt?: Maybe<Scalars['DateTime']>;
  /** Why administration generation was skipped before starting (`not_entitled` / `env_off`); set only on a deliberate skip, never on a failure */
  administrationSkipReason?: Maybe<Scalars['String']>;
  /** RETIRED pre-BIO-1368 shape, no longer written; dropped by a follow-up once no deployed Hexagon selects it */
  administrationSteps?: Maybe<Scalars['JSON']>;
  /** Two-sentence frame of the plan — customer label "What Happens Next" */
  administrationSummary?: Maybe<Scalars['String']>;
  /** The founder's single next action — "What We Need From You" */
  administrationYourNextStep?: Maybe<Scalars['String']>;
  /** When guidance was approved (BIO-953; null until then) */
  approvedAt?: Maybe<Scalars['DateTime']>;
  /** Our read of what happened and why it matters */
  assessment?: Maybe<Scalars['String']>;
  /** Salesforce case id (contract case_id; alias of salesforceCaseId) */
  caseId?: Maybe<Scalars['String']>;
  /** Category tag captured at creation (e.g. "mediation"). Present for notice-less cycles; for notice-backed cycles it mirrors the notice category. */
  category?: Maybe<Scalars['String']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** When guidance was delivered (BIO-953/961; null until then) */
  deliveredAt?: Maybe<Scalars['DateTime']>;
  /** Generated documents, each { templateKey, title, body, generatedBody, editedAt, editedByUserId, smartCabinetDocumentId }; title/generatedBody/editedAt/editedByUserId/smartCabinetDocumentId may be null. body is the display text (the customer-edited version once edited); generatedBody is the model original kept for the audit trail (BIO-2078); smartCabinetDocumentId lands once the Execution approval archives the approved PDF to the Smart Cabinet (BIO-2079) */
  executionDocuments?: Maybe<Scalars['JSON']>;
  /** True when the last execution generation failed (raw agent-error reason never exposed) */
  executionFailed?: Maybe<Scalars['Boolean']>;
  /** One-line framing for the Execution deliverables */
  executionHeadline?: Maybe<Scalars['String']>;
  /** When execution generation was last requested (drives the CTA staleness read) */
  executionRequestedAt?: Maybe<Scalars['DateTime']>;
  /** Why execution generation was skipped before starting (`not_entitled` / `env_off`); set only on a deliberate skip, never on a failure */
  executionSkipReason?: Maybe<Scalars['String']>;
  /** When guidance was generated/persisted */
  generatedAt?: Maybe<Scalars['DateTime']>;
  /** True while a guidance attempt is running — lets reloads and other viewers disable the actions with visible status instead of discovering the conflict on click */
  generationInFlight?: Maybe<Scalars['Boolean']>;
  /** Total guidance generation attempts for this cycle (only fetched when selected) */
  guidanceAttemptCount?: Maybe<Scalars['Int']>;
  /** Outcome of the latest guidance attempt. Legacy cycles (pre-feature) read null + prose as OK; the failure reason behind FAILED stays internal. */
  guidanceOutcome?: Maybe<GuidanceOutcome>;
  /** One-line framing for the GuidancePanel */
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initiatedBy: Scalars['String'];
  /** The notice this cycle was opened against */
  notice?: Maybe<ResolutionCycleNotice>;
  /** Originating notice id, null for Talk-to-Bambee cycles */
  noticeId?: Maybe<Scalars['ID']>;
  /** Questions blocking generation. Set by an INSUFFICIENT_CONTEXT attempt and cleared by an OK one; they deliberately survive a FAILED retry so the form the customer was answering stays on screen */
  pendingQuestions?: Maybe<Array<GuidanceQuestion>>;
  /** The single recommended way forward (contract recommended_action) */
  recommendedAction?: Maybe<Scalars['String']>;
  /** Live Salesforce Case details (only fetched when selected) */
  salesforceCase?: Maybe<SalesforceCaseInfo>;
  salesforceCaseId?: Maybe<Scalars['String']>;
  /** Guidance contract version, e.g. "smart_resolution_v1" */
  schemaVersion?: Maybe<Scalars['String']>;
  /** Matter classification (contract service_type) */
  serviceType?: Maybe<ServiceType>;
  /** Loose link to the originating Solution */
  solutionId?: Maybe<Scalars['ID']>;
  /** Current stage */
  stage?: Maybe<ResolutionCycleStage>;
  /** Current status */
  status?: Maybe<ResolutionCycleStatus>;
  /** The committed result we are aiming for */
  targetOutcome?: Maybe<Scalars['String']>;
};

/** Look up a single ResolutionCycle by its loose solutionId or its Salesforce caseId */
export type ResolutionCycleInput = {
  /** The Salesforce case id associated with the cycle (contract case_id) */
  caseId?: Maybe<Scalars['String']>;
  /** The originating Solution id (loose link on the cycle) */
  solutionId?: Maybe<Scalars['ID']>;
};

/** Originating notice summary for a resolution cycle card */
export type ResolutionCycleNotice = {
  __typename?: 'ResolutionCycleNotice';
  category: BrightenCategory;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  severity: NoticeSeverity;
};

/** Canonical stages a resolution cycle moves through */
export enum ResolutionCycleStage {
  Administration = 'Administration',
  AdministrationApproval = 'AdministrationApproval',
  Certified = 'Certified',
  Diagnostic = 'Diagnostic',
  Execution = 'Execution',
  ExecutionApproval = 'ExecutionApproval',
  Guidance = 'Guidance',
  GuidanceApproval = 'GuidanceApproval',
  Outcome = 'Outcome'
}

/** Tracked statuses for a resolution cycle */
export enum ResolutionCycleStatus {
  Blocked = 'Blocked',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  DoItMyself = 'DO_IT_MYSELF',
  InProgress = 'In_Progress',
  Merged = 'Merged',
  NewActionPlan = 'NEW_ACTION_PLAN',
  New = 'New',
  Reopened = 'Reopened',
  ResponseReceived = 'Response_Received',
  Saved = 'Saved',
  Transferred = 'Transferred',
  WithCustomer = 'With_Customer',
  BackedOut = 'backed_out',
  ClosedError = 'closed_error',
  ClosedInactive = 'closed_inactive',
  ConfirmResolution = 'confirm_resolution',
  CustomerReplied = 'customer_replied',
  Escalated = 'escalated',
  SelfService = 'self_service',
  WontDo = 'wont_do'
}

export type ReverseCancellationInput = {
  /** The company ID */
  companyId: Scalars['String'];
};

export type SalesforceCase = {
  __typename?: 'SalesforceCase';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  hrRequestId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status?: Maybe<CaseStatus>;
  subType?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<CaseType>;
};

/** Salesforce Case details backing a resolution cycle */
export type SalesforceCaseInfo = {
  __typename?: 'SalesforceCaseInfo';
  /** Case.actionPlan__c — HRM-authored execution task line */
  actionPlan?: Maybe<Scalars['String']>;
  caseNumber?: Maybe<Scalars['String']>;
  /** Case closed date (certification record) */
  closedAt?: Maybe<Scalars['DateTime']>;
  /** Case.comprehensiveGuidance__c — the guidance assessment prose */
  comprehensiveGuidance?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /** HR Account Manager display name (SF formula field) */
  hrAccountManager?: Maybe<Scalars['String']>;
  /** Case.HR_Category__c — the intake category (e.g. termination, loa) */
  hrCategory?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Case.Recommended_Action__c — the plan recommended action */
  recommendedAction?: Maybe<Scalars['String']>;
  /** Raw Salesforce case stage */
  stage?: Maybe<Scalars['String']>;
  /** Raw Salesforce case status */
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  /** Case.Targeted_Outcome__c — the plan targeted outcome */
  targetedOutcome?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SaveArtifactInput = {
  /** Artifact ID to finalize */
  artifactId: Scalars['String'];
  /** Optional: Override description */
  description?: Maybe<Scalars['String']>;
  /** Optional: Override display name */
  displayName?: Maybe<Scalars['String']>;
  /** Optional: Icon path */
  icon?: Maybe<Scalars['String']>;
  /** Type-specific finalization options. Structure depends on artifact type. Example for Policy: { createHrRequest: true, hrRequestSubject: "...", hrRequestDescription: "..." } */
  options?: Maybe<Scalars['JSONObject']>;
  /** Optional: Override title from artifact */
  title?: Maybe<Scalars['String']>;
};

export type SaveArtifactResultDto = {
  __typename?: 'SaveArtifactResultDto';
  /** The finalized artifact ID */
  artifactId: Scalars['String'];
  /** Artifact type that was finalized */
  artifactType: ArtifactType;
  /** Type-specific entity ID (e.g., policyId for Policy artifacts) */
  entityId?: Maybe<Scalars['String']>;
  /** HR Request ID if applicable */
  hrRequestId?: Maybe<Scalars['String']>;
  /** Type-specific metadata (e.g., hrRequestId for policies) */
  metadata?: Maybe<Scalars['JSONObject']>;
};

export type SaveCompanyAnswerInput = {
  companyId: Scalars['String'];
  key: Scalars['String'];
  surveyId: Scalars['Float'];
  value: Scalars['String'];
};

export type SaveCompanySettingInput = {
  boolValue?: Maybe<Scalars['Boolean']>;
  cadenceValue?: Maybe<PracticeCadenceValue>;
  companyId: Scalars['String'];
  key: CompanySettingKey;
  type?: Maybe<SettingType>;
  value?: Maybe<Scalars['String']>;
};

export type SaveJobDescriptionOnEmployeeInput = {
  jobDescriptionId: Scalars['String'];
  update?: Maybe<UpdateJobDescriptionInput>;
  userId: Scalars['String'];
};

export type ScheduledCorePlanChangeModel = {
  __typename?: 'ScheduledCorePlanChangeModel';
  effectiveOn: Scalars['DateTime'];
  /** The ID of the scheduled plan change. */
  id: Scalars['ID'];
  newPlan: CorePlanModel;
};

export type ScheduledEvent = {
  __typename?: 'ScheduledEvent';
  /** The Bambee agent associated with this scheduled event */
  agent?: Maybe<CallAgent>;
  /** Email addresses of attendees as provided by Calendly */
  attendeeEmails?: Maybe<Array<Scalars['String']>>;
  /** Unique Calendly Event ID */
  calendlyEventId: Scalars['String'];
  /** The invitee ID from Calendly */
  calendlyInviteeId: Scalars['String'];
  /** Call summaries for the event */
  callSummaries: Array<CallSummary>;
  /** If the event was cancelled */
  cancelled?: Maybe<Scalars['Boolean']>;
  /** End time of the scheduled event */
  endTime: Scalars['DateTime'];
  /** Event type */
  eventLocation: SchedulerEventLocation;
  id: Scalars['ID'];
  kind: Scalars['String'];
  /** Missed Call Fee Status */
  missedCallFeeStatus?: Maybe<MissedCallFeeStatus>;
  /** The Contacts Phone number that was defined as part of the scheduled event */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Start time of the scheduled event */
  startTime: Scalars['DateTime'];
  /** Calendly Event Name + x */
  title: Scalars['String'];
  /** Transaction ID */
  transactionId?: Maybe<Scalars['String']>;
  /** The video conference link (zoom) */
  videoConferenceLink?: Maybe<Scalars['String']>;
};

export type ScheduledPlanChangeModel = {
  __typename?: 'ScheduledPlanChangeModel';
  effectiveOn: Scalars['DateTime'];
  /** The ID of the scheduled plan change. */
  id: Scalars['ID'];
  newPlan: PlanModel;
};

export enum SchedulerEventLocation {
  Phone = 'PHONE',
  Unknown = 'UNKNOWN',
  Video = 'VIDEO'
}

export enum SchedulerZone {
  East = 'EAST',
  West = 'WEST'
}

export type ScratchServiceAddonListInput = {
  companyId?: Maybe<Scalars['String']>;
};

export type ScratchServiceAddonsModel = {
  __typename?: 'ScratchServiceAddonsModel';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  key: Scalars['String'];
  label: Scalars['String'];
  priceLabel: Scalars['String'];
};

export type ScratchToggleServiceAddonInput = {
  companyId: Scalars['String'];
  id: Scalars['String'];
};

export type SearchHit = {
  __typename?: 'SearchHit';
  description?: Maybe<Scalars['String']>;
  highlight?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  score: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type SearchInput = {
  companyId?: Maybe<Scalars['String']>;
  domains?: Maybe<Array<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  query: Scalars['String'];
  searchType?: Maybe<Scalars['String']>;
  threshold?: Maybe<Scalars['Float']>;
  types?: Maybe<Array<EntityType>>;
  useVectorSearch?: Maybe<Scalars['Boolean']>;
};

export type SearchRealTimeMessagesInput = {
  limit?: Maybe<Scalars['Int']>;
  query: Scalars['String'];
  similarityThreshold?: Maybe<Scalars['Float']>;
  threadId?: Maybe<Scalars['ID']>;
};

export type SearchRealTimeThreadsInput = {
  limit?: Maybe<Scalars['Int']>;
  query: Scalars['String'];
  similarityThreshold?: Maybe<Scalars['Float']>;
  threadType?: Maybe<ThreadType>;
};

export type SearchResultsDto = {
  __typename?: 'SearchResultsDto';
  all?: Maybe<Array<SearchHit>>;
  compliance?: Maybe<Array<SearchHit>>;
  documents?: Maybe<Array<SearchHit>>;
  /** @deprecated Use staff instead */
  employees?: Maybe<Array<SearchHit>>;
  feedback?: Maybe<Array<SearchHit>>;
  pips?: Maybe<Array<SearchHit>>;
  policies?: Maybe<Array<SearchHit>>;
  query: Scalars['String'];
  reportCards?: Maybe<Array<SearchHit>>;
  staff?: Maybe<Array<SearchHit>>;
  totalResults: Scalars['Float'];
  training?: Maybe<Array<SearchHit>>;
  verbalWarnings?: Maybe<Array<SearchHit>>;
  writtenWarnings?: Maybe<Array<SearchHit>>;
};

export type SeatChangePreview = {
  __typename?: 'SeatChangePreview';
  amountDue: Scalars['Int'];
  amountDueDecimal: Scalars['Float'];
  chargeable: Scalars['Boolean'];
  currency: Scalars['String'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  lines: Array<SeatChangePreviewLine>;
  nextInvoiceTotal: Scalars['Int'];
  prorationDate: Scalars['DateTime'];
  reason?: Maybe<Scalars['String']>;
  tax: Scalars['Int'];
};

export type SeatChangePreviewLine = {
  __typename?: 'SeatChangePreviewLine';
  amount: Scalars['Int'];
  currentQuantity: Scalars['Int'];
  freeSeats: Scalars['Int'];
  previewedQuantity: Scalars['Int'];
  productKey: SeatKind;
  requestedSeats: Scalars['Int'];
  unitAmount?: Maybe<Scalars['Int']>;
};

export type SeatEntitlement = {
  __typename?: 'SeatEntitlement';
  billed: Scalars['Int'];
  counted: Scalars['Int'];
  kind: SeatKind;
  waived: Scalars['Int'];
};

/** A kind of staff seat that can be waived */
export enum SeatKind {
  ExecSeats = 'EXEC_SEATS',
  ManagerSeats = 'MANAGER_SEATS'
}

export type SeatQuantityInput = {
  kind: SeatKind;
  quantity: Scalars['Int'];
};

export type SeatWaiver = {
  __typename?: 'SeatWaiver';
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  productKey: SeatKind;
  quantity: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SeatWaiverResult = {
  __typename?: 'SeatWaiverResult';
  billableSeats: Scalars['Int'];
  countedSeats: Scalars['Int'];
  synced: Scalars['Boolean'];
  waivedSeats: Scalars['Int'];
  waiver?: Maybe<SeatWaiver>;
};

export type SeatsSummary = {
  __typename?: 'SeatsSummary';
  enrolledUsers: Array<EnrolledUser>;
  id: Scalars['ID'];
  totalSeats: Scalars['Float'];
  unfilledSeats: Scalars['Float'];
};

export type SelectMigrationPlanInput = {
  companyId: Scalars['String'];
  /** Monthly price in integer cents, exactly as shown on screen. */
  monthlyAmount: Scalars['Int'];
  /** The plan the company is on today. */
  originalProductKey: ProductKey;
  /** The plan identifier billing keys on (CorePlanModel.value). */
  planValue: Scalars['String'];
  /** The plan we recommended for this company. */
  recommendedProductKey: ProductKey;
  /** The plan the company is migrating to. */
  selectedProductKey: ProductKey;
};

export type SelfUnenrollRetiredInput = {
  companyId: Scalars['String'];
  topicId: Scalars['String'];
};

export type SendJobDescriptionToEmployeeInput = {
  jobDescriptionId: Scalars['String'];
  userId: Scalars['String'];
};

export type SendMagicLinkForEmailInput = {
  email: Scalars['String'];
};

/** The type of message according to sendbird */
export enum SendbirdMessageType {
  /** Not currently in use */
  Admin = 'Admin',
  /** A binary file, such as an image or other downloadable content. */
  File = 'File',
  /** A text message.  This can be a standard message of just text, or a serialized payload for Bambee customized messages */
  Message = 'Message'
}

export enum ServiceKey {
  Addons = 'ADDONS',
  AutoCompliance = 'AUTO_COMPLIANCE',
  BambeePlus = 'BAMBEE_PLUS',
  Calls = 'CALLS',
  Core = 'CORE',
  Elite = 'ELITE',
  ExecSeats = 'EXEC_SEATS',
  ManagerSeats = 'MANAGER_SEATS',
  Nectar = 'NECTAR',
  Payroll = 'PAYROLL',
  PremiumPeople = 'PREMIUM_PEOPLE',
  TimeAttendance = 'TIME_ATTENDANCE',
  Training = 'TRAINING'
}

/** Smart Resolution matter classification (agent I/O contract service_type) */
export enum ServiceType {
  AdaAccommodation = 'ADA_ACCOMMODATION',
  CorrectiveAction = 'CORRECTIVE_ACTION',
  Investigation = 'INVESTIGATION',
  LeaveOfAbsence = 'LEAVE_OF_ABSENCE',
  Mediation = 'MEDIATION',
  Termination = 'TERMINATION'
}

export type SetAddOnInput = {
  code: Scalars['String'];
  companyId: Scalars['ID'];
  quantity: Scalars['Int'];
  timeframe: ChangeTimeframe;
};

export type SetCaseStatusInput = {
  caseId: Scalars['String'];
  status: CaseStatus;
};

export type SetDefaultPaymentMethodInput = {
  companyId: Scalars['String'];
  paymentMethodId: Scalars['String'];
};

export type SetPolicyCadenceInput = {
  /** Cadence for policy reaffirmation: annual, semi-annual, quarterly */
  cadence: Scalars['String'];
  companyId: Scalars['String'];
};

export type SetSeatWaiverInput = {
  companyId: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  productKey: SeatKind;
  quantity: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  syncNow?: Maybe<Scalars['Boolean']>;
};

export type Setting = {
  __typename?: 'Setting';
  defaultValue: Scalars['String'];
  key: CompanySettingKey;
  type: SettingType;
};

export enum SettingType {
  BooleanType = 'BooleanType',
  StringType = 'StringType'
}

export type ShowIfCondition = {
  __typename?: 'ShowIfCondition';
  operator: ShowIfOperator;
  questionId: Scalars['String'];
  value: Scalars['JSON'];
};

export type ShowIfConditionInput = {
  operator: ShowIfOperator;
  questionId: Scalars['String'];
  value: Scalars['JSON'];
};

/** Operators for show if conditions */
export enum ShowIfOperator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  InArray = 'IN_ARRAY',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS'
}

export type SignalPill = {
  __typename?: 'SignalPill';
  label: Scalars['String'];
  severity: NoticeSeverity;
  source?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Pre-designed Smart Cabinet document categories (uploaded files only) */
export enum SmartCabinetCategory {
  Disciplinary = 'DISCIPLINARY',
  EmploymentAgreement = 'EMPLOYMENT_AGREEMENT',
  HandbookAcknowledgment = 'HANDBOOK_ACKNOWLEDGMENT',
  I9 = 'I9',
  Nda = 'NDA',
  Other = 'OTHER',
  PerformanceReview = 'PERFORMANCE_REVIEW',
  W4 = 'W4'
}

export type SmartCabinetDocument = {
  __typename?: 'SmartCabinetDocument';
  /** User-driven soft archive. Hidden from list by default; distinct from deletion tombstone. */
  archivedAt?: Maybe<Scalars['DateTime']>;
  /** Employee userIds with read access. Empty = owners/managers only. */
  assignedToIds: Array<Scalars['ID']>;
  /** Only populated for type=UPLOADED_FILE; null otherwise */
  category?: Maybe<SmartCabinetCategory>;
  companyId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  /** Signature state — present when the document requires or has captured a signature */
  signature?: Maybe<SmartCabinetSignature>;
  /** Size in bytes — populated after finalize */
  size?: Maybe<Scalars['Int']>;
  /** Provenance for non-uploaded types (GENERATED_POLICY, VISA, GENERATED_DOCUMENT, migrated legacy docs) */
  source?: Maybe<SmartCabinetSource>;
  status: SmartCabinetDocumentStatus;
  type: SmartCabinetDocumentType;
  updatedAt: Scalars['DateTime'];
  uploaderId: Scalars['ID'];
};

/** Lifecycle status of a Smart Cabinet document */
export enum SmartCabinetDocumentStatus {
  Archived = 'ARCHIVED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

/** Content type discriminator for Smart Cabinet documents */
export enum SmartCabinetDocumentType {
  GeneratedDocument = 'GENERATED_DOCUMENT',
  GeneratedPolicy = 'GENERATED_POLICY',
  SignedDocument = 'SIGNED_DOCUMENT',
  UploadedFile = 'UPLOADED_FILE',
  Visa = 'VISA'
}

export type SmartCabinetDownloadTicket = {
  __typename?: 'SmartCabinetDownloadTicket';
  /** Presigned GET URL (5 min TTL) */
  url: Scalars['String'];
};

export type SmartCabinetSignature = {
  __typename?: 'SmartCabinetSignature';
  required: Scalars['Boolean'];
  signedAt?: Maybe<Scalars['DateTime']>;
  /** Employee userId who signed */
  signedBy?: Maybe<Scalars['ID']>;
};

export type SmartCabinetSource = {
  __typename?: 'SmartCabinetSource';
  /** Upstream mongoose model name (e.g., Policy, Visa, LegacyFolder) */
  model: Scalars['String'];
  /** Upstream document _id */
  refId: Scalars['ID'];
};

export type Solution = {
  __typename?: 'Solution';
  action?: Maybe<Scalars['JSON']>;
  caseId?: Maybe<Scalars['String']>;
  caseStatus?: Maybe<Scalars['String']>;
  /** Salesforce case subtype for routing (e.g., corrective-action, new-policy) */
  caseSubtype?: Maybe<Scalars['String']>;
  /** Salesforce case type for routing (e.g., performance-management, policies) */
  caseType?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  companyId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  delegatedAt?: Maybe<Scalars['DateTime']>;
  delegatedBy?: Maybe<Scalars['String']>;
  delegatedTo?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  /** Longer explanation of why this solution is needed and how it is important */
  description: Scalars['String'];
  destination: Scalars['String'];
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Flag indicating if solution is delegated to Bambee vs internal company user */
  isDelegatedToBambee: Scalars['Boolean'];
  /** Short call-to-action (2-3 words) */
  label?: Maybe<Scalars['String']>;
  markedUnhelpful?: Maybe<Scalars['Boolean']>;
  markedUnhelpfulAt?: Maybe<Scalars['DateTime']>;
  markedUnhelpfulBy?: Maybe<Scalars['String']>;
  /** All notices that reference this solution */
  notices?: Maybe<Array<Notice>>;
  realtimeThreadId?: Maybe<Scalars['String']>;
  /** Comments about how the solution was resolved */
  resolutionComments?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  /** Computed status based on timestamps and case status */
  status: SolutionStatus;
  tags: Array<Scalars['String']>;
  threadId?: Maybe<Scalars['String']>;
  /** Descriptive sentence of what the solution is */
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** Resolved user info for a delegation history actor */
export type SolutionDelegationHistoryActor = {
  __typename?: 'SolutionDelegationHistoryActor';
  avatarUrl?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

/** A single entry in the audit trail of solution delegation changes */
export type SolutionDelegationHistoryEntry = {
  __typename?: 'SolutionDelegationHistoryEntry';
  /** Action performed: DELEGATE, REASSIGN, RECLAIM */
  actionType: Scalars['String'];
  caseId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** User ID who performed this action */
  delegatedBy: Scalars['String'];
  /** Role of the actor: ADMIN, MANAGER, SYSTEM */
  delegatedByRole: Scalars['String'];
  /** Resolved profile of who performed this action */
  delegatedByUser?: Maybe<SolutionDelegationHistoryActor>;
  /** User ID of the previous owner (null on first delegation) */
  delegatedFrom?: Maybe<Scalars['String']>;
  /** Resolved profile of the previous owner */
  delegatedFromUser?: Maybe<SolutionDelegationHistoryActor>;
  /** User ID of the new owner (or BAMBEE sentinel) */
  delegatedTo: Scalars['String'];
  /** Target type: COMPANY_USER, BAMBEE_TEAM */
  delegatedToType: Scalars['String'];
  /** Resolved profile of who the solution was delegated to */
  delegatedToUser?: Maybe<SolutionDelegationHistoryActor>;
  id: Scalars['ID'];
  solutionId: Scalars['String'];
};

/** The destination where solutions appear - SOLUTION_FEED, OPERATING_FEED, or OPERATING_INTRO */
export enum SolutionDestination {
  OperatingFeed = 'OPERATING_FEED',
  OperatingIntro = 'OPERATING_INTRO',
  SolutionFeed = 'SOLUTION_FEED'
}

/** The scope of solutions - COMPANY for company-level solutions, USER for user-specific solutions */
export enum SolutionScope {
  Company = 'COMPANY',
  User = 'USER'
}

/** The status of a solution - NOT_STARTED (not completed or delegated), IN_PROGRESS (delegated but not completed), BLOCKED (awaiting user approval or action), COMPLETED (completed), CLOSED (case closed/inactive/error in Salesforce) */
export enum SolutionStatus {
  Blocked = 'BLOCKED',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

/** The type of solution (from Prisma) - master enum containing all solution types */
export enum SolutionType {
  CompleteReportCard = 'COMPLETE_REPORT_CARD',
  CreatePip = 'CREATE_PIP',
  CreateVerbalWarning = 'CREATE_VERBAL_WARNING',
  CreateWrittenWarning = 'CREATE_WRITTEN_WARNING',
  EmployeeVoice = 'EMPLOYEE_VOICE',
  ExternalAction = 'EXTERNAL_ACTION',
  JournalEntry = 'JOURNAL_ENTRY',
  NewCap = 'NEW_CAP',
  NewGuidance = 'NEW_GUIDANCE',
  NewIncident = 'NEW_INCIDENT',
  NewJobDescription = 'NEW_JOB_DESCRIPTION',
  NewPolicy = 'NEW_POLICY',
  NewTraining = 'NEW_TRAINING',
  RequestTraining = 'REQUEST_TRAINING',
  SystemAction = 'SYSTEM_ACTION',
  UserAction = 'USER_ACTION',
  Wizard = 'WIZARD'
}

/** Sort order for notices (ASC = oldest first, DESC = newest first) */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StaffSeatBilling = {
  __typename?: 'StaffSeatBilling';
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  discountCouponId?: Maybe<Scalars['String']>;
  lines: Array<StaffSeatBillingLine>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
};

export type StaffSeatBillingLine = {
  __typename?: 'StaffSeatBillingLine';
  billableSeats: Scalars['Int'];
  countedSeats: Scalars['Int'];
  inSync: Scalars['Boolean'];
  priceId?: Maybe<Scalars['String']>;
  productKey: SeatKind;
  subscriptionQuantity?: Maybe<Scalars['Int']>;
  unitAmount?: Maybe<Scalars['Int']>;
  usageType?: Maybe<Scalars['String']>;
  waivedSeats: Scalars['Int'];
};

export enum StaffStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  SignatureRequired = 'SIGNATURE_REQUIRED'
}

export type StartTrialOnCorePlanInput = {
  companyId: Scalars['ID'];
  newPlanId: Scalars['String'];
};

export enum State {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** The abbreviation of the US state or territory. */
export enum StateAbbreviation {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type Statement = {
  __typename?: 'Statement';
  amount: Scalars['Float'];
  attemptCount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  hostedUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastAttemptError?: Maybe<Scalars['Float']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  pdfUrl?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['DateTime']>;
  periodStart?: Maybe<Scalars['DateTime']>;
  productKey?: Maybe<ProductKey>;
  quantity?: Maybe<Scalars['Float']>;
  serviceKey?: Maybe<ServiceKey>;
  statementType: StatementType;
  status: StatementStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
};

export enum StatementStatus {
  Failed = 'FAILED',
  Issued = 'ISSUED',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Voided = 'VOIDED'
}

export enum StatementType {
  CreditNote = 'CREDIT_NOTE',
  Invoice = 'INVOICE'
}

/** Layout type for wizard steps */
export enum StepLayoutType {
  SingleColumn = 'SINGLE_COLUMN',
  SingleQuestion = 'SINGLE_QUESTION',
  SingleVisual = 'SINGLE_VISUAL',
  TextAndVisual = 'TEXT_AND_VISUAL',
  TwoColumn = 'TWO_COLUMN',
  TwoColumnWithVisual = 'TWO_COLUMN_WITH_VISUAL',
  TwoColumnWithVisualHeaderOnLeft = 'TWO_COLUMN_WITH_VISUAL_HEADER_ON_LEFT',
  TwoColumnWithVisualReversed = 'TWO_COLUMN_WITH_VISUAL_REVERSED',
  TwoColumnWithVisualReversedHeaderOnRight = 'TWO_COLUMN_WITH_VISUAL_REVERSED_HEADER_ON_RIGHT'
}

export type Subscription = {
  __typename?: 'Subscription';
  amount: Scalars['Int'];
  coupon?: Maybe<PlanCoupon>;
  createdAt: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  isDrp: Scalars['Boolean'];
  name: Scalars['String'];
  planValue: Scalars['String'];
  productCode: ProductKey;
  serviceKey: ServiceKey;
  startDate: Scalars['DateTime'];
  status: SubscriptionStatus;
  stripeId: Scalars['String'];
  stripePriceId: Scalars['String'];
};

export type SubscriptionModel = {
  __typename?: 'SubscriptionModel';
  /** Subscription Status */
  active: Scalars['Boolean'];
  /** True when there is a pending cancellation request */
  cancellationRequested: Scalars['Boolean'];
  /** A scheduled date for when the subscription will be canceled */
  cancelsAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the subscription. */
  id: Scalars['ID'];
  /** Date when the current period will end */
  periodEndsAt: Scalars['DateTime'];
  plan: PlanModel;
  /** The quantity of the plan to which the customer is subscribed to. */
  quantity?: Maybe<Scalars['Float']>;
  /** Scheduled plan change, if any. */
  scheduledPlanChange?: Maybe<ScheduledPlanChangeModel>;
  /** Date when the subscription trial will end */
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  /** True if they are actively trialing */
  trialing: Scalars['Boolean'];
};

/** Bambee's state for a subscription. ACTIVE, CANCELED, EXPIRED, FAILED, FUTURE and PAUSED are Recurly's subscription states; TRIALING and PAST_DUE are Bambee's own, because Recurly's subscription states include neither. CANCELED means the subscription runs to the end of its current period; EXPIRED means it has ended. */
export enum SubscriptionState {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Future = 'FUTURE',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING'
}

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  Trialing = 'TRIALING'
}

export type SummaryArtifact = {
  __typename?: 'SummaryArtifact';
  /** The summary render as a rich HTML document. */
  html: Scalars['String'];
  /** The gather summary status */
  status: Scalars['String'];
};

export type Survey = {
  __typename?: 'Survey';
  answers: Scalars['JSON'];
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  questions: Scalars['JSON'];
  type: Scalars['String'];
};

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  /** The id of the survey that contains the answer */
  id: Scalars['ID'];
  /** The key of the survey answer */
  key: Scalars['String'];
  /** The value of the survey answer */
  value?: Maybe<Scalars['String']>;
};

export enum SurveyQuestionKey {
  HrAuditBenefitsInterest_1 = 'HR_AUDIT_BENEFITS_INTEREST_1',
  HrAuditBenefitsInterest_2 = 'HR_AUDIT_BENEFITS_INTEREST_2',
  HrAuditPayrollInterest = 'HR_AUDIT_PAYROLL_INTEREST',
  HrAuditPayrollProvider = 'HR_AUDIT_PAYROLL_PROVIDER',
  HrAuditSelfServiceFullAudit = 'HR_AUDIT_SELF_SERVICE_FULL_AUDIT',
  HrPracticePayrollPrePurchased = 'HR_PRACTICE_PAYROLL_PRE_PURCHASED',
  HrPracticeTrainingPrePurchased = 'HR_PRACTICE_TRAINING_PRE_PURCHASED'
}

export type SyncAdded = {
  __typename?: 'SyncAdded';
  courses: Scalars['Int'];
  topics: Scalars['Int'];
};

export type SyncResponse = {
  __typename?: 'SyncResponse';
  added: SyncAdded;
};

export type SyncUserEnrollmentInput = {
  userId: Scalars['String'];
};

export type SyncUserEnrollmentsResponse = {
  __typename?: 'SyncUserEnrollmentsResponse';
  errors: Array<UserEnrollmentSyncError>;
  skipped: Array<UserEnrollmentSync>;
  successes: Array<UserEnrollmentSync>;
};

export type SystemConfiguration = {
  __typename?: 'SystemConfiguration';
  businessManagers: Array<BusinessManager>;
  hrManagers: Array<AutoAssignHrManager>;
};

/** The enum name of the task completion status. */
export enum TaskCompletionStatus {
  Automatic = 'Automatic',
  Cancelled = 'Cancelled',
  Manual = 'Manual',
  Skipped = 'Skipped'
}

/** The enum name of the task. */
export enum TaskName {
  AddBankAndTaxInfo = 'AddBankAndTaxInfo',
  AddBenefits = 'AddBenefits',
  AddCompanyEin = 'AddCompanyEin',
  AddPostTaxDeductions = 'AddPostTaxDeductions',
  AddStaff = 'AddStaff',
  CheckForComplexPayrollScenarios = 'CheckForComplexPayrollScenarios',
  ConsiderGuidedPayroll = 'ConsiderGuidedPayroll',
  CreateJobDescriptions = 'CreateJobDescriptions',
  DownloadInterviewGuide = 'DownloadInterviewGuide',
  DownloadIntroductionMaterials = 'DownloadIntroductionMaterials',
  DownloadJobApplication = 'DownloadJobApplication',
  EnsureEmployeesReadyForPayroll = 'EnsureEmployeesReadyForPayroll',
  FinishAccountSetup = 'FinishAccountSetup',
  FinishBambeePlusSetup = 'FinishBambeePlusSetup',
  InviteAndEnrollEmployees = 'InviteAndEnrollEmployees',
  InviteStaffToSignPolicies = 'InviteStaffToSignPolicies',
  LearnEssentialBusinessPrep = 'LearnEssentialBusinessPrep',
  LearnHrAudit = 'LearnHrAudit',
  LearnImproveStaffCommunication = 'LearnImproveStaffCommunication',
  LearnIntroduceStaffToBambee = 'LearnIntroduceStaffToBambee',
  LearnMakeHiringEasy = 'LearnMakeHiringEasy',
  LearnOnboardingKitBasics = 'LearnOnboardingKitBasics',
  MigratePayrollData = 'MigratePayrollData',
  PayrollBasicSetup = 'PayrollBasicSetup',
  RunFirstPayroll = 'RunFirstPayroll',
  ScheduleHrmCall = 'ScheduleHrmCall',
  SchedulePayrollOverview = 'SchedulePayrollOverview',
  ScheduleTrainingDiscussion = 'ScheduleTrainingDiscussion',
  SetYourPayrollFrequency = 'SetYourPayrollFrequency',
  SetupCompanyPolicies = 'SetupCompanyPolicies',
  SetupEmployeeVoices = 'SetupEmployeeVoices',
  SetupReportCards = 'SetupReportCards',
  TakeHrAudit = 'TakeHrAudit',
  TrainingHiringLegallyForManagers = 'TrainingHiringLegallyForManagers',
  TrainingRecruitingAndInterviewingForSupervisors = 'TrainingRecruitingAndInterviewingForSupervisors',
  UploadDocuments = 'UploadDocuments'
}

export type Termination = {
  __typename?: 'Termination';
  complete: Scalars['Boolean'];
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  employee: User;
  employeeId: Scalars['String'];
  hrRequestId?: Maybe<Scalars['String']>;
  hrRequestVersion: Scalars['Boolean'];
  isLegacy: Scalars['Boolean'];
  manager: User;
  selfService: Scalars['Boolean'];
  signedFiles: Array<FileStackModel>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: TerminationStatus;
  step: TerminationStep;
  terminationDate?: Maybe<Scalars['DateTime']>;
  terminationId: Scalars['String'];
  terminationState?: Maybe<Scalars['String']>;
  user: User;
  userId: Scalars['String'];
};

export type TerminationAttachInput = {
  files: Array<FileStackInput>;
  terminationId: Scalars['String'];
};

export type TerminationCancelInput = {
  terminationId: Scalars['String'];
};

export type TerminationConfirmationInput = {
  terminationDate: Scalars['String'];
  terminationId: Scalars['String'];
};

export type TerminationCreateInput = {
  answers?: Maybe<Scalars['JSON']>;
  employeeId: Scalars['String'];
  hrRequestId?: Maybe<Scalars['String']>;
  selfService?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
  terminationDate?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TerminationDownload = {
  __typename?: 'TerminationDownload';
  file: Scalars['String'];
  terminationId: Scalars['String'];
};

export type TerminationEditDetailsInput = {
  selfService?: Maybe<Scalars['Boolean']>;
  terminationDate: Scalars['String'];
  terminationId: Scalars['String'];
};

export type TerminationExist = {
  __typename?: 'TerminationExist';
  exists: Scalars['Boolean'];
  terminationId?: Maybe<Scalars['String']>;
};

export enum TerminationStatus {
  Abandoned = 'ABANDONED',
  Active = 'ACTIVE',
  Broken = 'BROKEN',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  HrComplete = 'HR_COMPLETE',
  SelfService = 'SELF_SERVICE'
}

export enum TerminationStep {
  None = 'NONE',
  Print = 'PRINT',
  Requested = 'REQUESTED',
  UploadSigned = 'UPLOAD_SIGNED'
}

export type TextContentBlock = {
  __typename?: 'TextContentBlock';
  /** Text content */
  annotations: Array<AnnotationDto>;
  /** Text content */
  value: Scalars['String'];
};

export type TextMessage = ChatMessageInterface & {
  __typename?: 'TextMessage';
  channelId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isThreadMessage: Scalars['Boolean'];
  isThreadParent: Scalars['Boolean'];
  message: Scalars['String'];
  rawType: SendbirdMessageType;
  /** Recipieint, if a one-on-one message */
  recipient?: Maybe<CoreUser>;
  sender: CoreUser;
  threadParentId?: Maybe<Scalars['ID']>;
  type: ChatMessageTypeEnum;
};

export type ThreadHistoryInput = {
  afterId?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['ID']>;
  userId: Scalars['ID'];
};

export enum ThreadOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  LastActivityAsc = 'LAST_ACTIVITY_ASC',
  LastActivityDesc = 'LAST_ACTIVITY_DESC'
}

/** Type of real-time thread (e.g., conversation, journal) */
export enum ThreadType {
  Conversation = 'CONVERSATION',
  Journal = 'JOURNAL',
  Solution = 'SOLUTION',
  Wizard = 'WIZARD'
}

export type Ticket = {
  __typename?: 'Ticket';
  bundleId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  courseId?: Maybe<Scalars['String']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  topicId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type TicketsInput = {
  companyId: Scalars['String'];
  numTickets: Scalars['Int'];
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  /** The duration in minutes for the slot */
  duration: Scalars['Int'];
  /** The end date for the slot */
  endAt: Scalars['DateTime'];
  /** The start date for the slot */
  startAt: Scalars['DateTime'];
};

export enum TimelineEventType {
  Created = 'CREATED',
  MeetingScheduled = 'MEETING_SCHEDULED',
  Owner = 'OWNER',
  Stage = 'STAGE',
  Status = 'STATUS'
}

export type TimelineItem = {
  __typename?: 'TimelineItem';
  eventTime: Scalars['DateTime'];
  eventType: TimelineEventType;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

export type TopPerformer = {
  __typename?: 'TopPerformer';
  active: Scalars['Boolean'];
  note: Scalars['String'];
};

export type TopPerformerInput = {
  active: Scalars['Boolean'];
  note: Scalars['String'];
};

export type TopicDetailSection = {
  __typename?: 'TopicDetailSection';
  content: Array<Scalars['String']>;
  key: Scalars['String'];
  tag: NoticeTag;
  title: Scalars['String'];
};

export type TopicEnrolledTickets = {
  __typename?: 'TopicEnrolledTickets';
  certificateDownloadUrl?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  enrolledAt: Scalars['DateTime'];
  id: Scalars['ID'];
  language: Scalars['String'];
  role: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userMngId: Scalars['String'];
};

export enum TrainingBillingPeriod {
  Month = 'MONTH',
  Year = 'YEAR'
}

export type TrainingBundleDto = {
  __typename?: 'TrainingBundleDto';
  bundleId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  includedTopics: Array<Scalars['String']>;
  name: Scalars['String'];
  seatsAvailable?: Maybe<Scalars['Float']>;
  seatsUsed?: Maybe<Scalars['Float']>;
  totalCourses: Scalars['Float'];
};

export type TrainingCatalogDto = {
  __typename?: 'TrainingCatalogDto';
  availableBundles: Array<TrainingBundleDto>;
  availableTopics: Array<TrainingTopicDto>;
};

export type TrainingCertificateDto = {
  __typename?: 'TrainingCertificateDto';
  certificateCode: Scalars['String'];
  certificateId: Scalars['ID'];
  certificateUrl?: Maybe<Scalars['String']>;
  completedDate: Scalars['DateTime'];
  courseName: Scalars['String'];
  enrollmentId: Scalars['String'];
  expiryDate: Scalars['DateTime'];
  recipientName: Scalars['String'];
  topicName: Scalars['String'];
};

export type TrainingCourseDto = {
  __typename?: 'TrainingCourseDto';
  courseId: Scalars['ID'];
  duration?: Maybe<Scalars['Float']>;
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  targetAudience?: Maybe<Scalars['String']>;
};

export type TrainingDto = {
  __typename?: 'TrainingDto';
  bundleName?: Maybe<Scalars['String']>;
  courseName: Scalars['String'];
  enrollmentId: Scalars['ID'];
  isRenewal: Scalars['Boolean'];
  previousEnrollmentId?: Maybe<Scalars['String']>;
  progress: TrainingProgressDto;
  renewalDate?: Maybe<Scalars['DateTime']>;
  status: EnrollmentStatus;
  topicName: Scalars['String'];
};

export type TrainingPricesResponse = {
  __typename?: 'TrainingPricesResponse';
  bundle: Scalars['Int'];
  topic: Scalars['Int'];
};

export type TrainingProgressDto = {
  __typename?: 'TrainingProgressDto';
  completedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  progressPercentage?: Maybe<Scalars['Float']>;
  startedAt?: Maybe<Scalars['DateTime']>;
};

export type TrainingRecommendationInput = {
  /** The id of the training bundle. */
  bundleId?: Maybe<Scalars['String']>;
  /** The company id of the employee recommending training. */
  companyId: Scalars['String'];
  /** The note of the training recommendation. May be used to provide additional context or instructions */
  note?: Maybe<Scalars['String']>;
  /** The id of the training topic. */
  topicId?: Maybe<Scalars['String']>;
  /** The user id of the employee recommending training. */
  userId: Scalars['String'];
};

export type TrainingRenewalDto = {
  __typename?: 'TrainingRenewalDto';
  courseName: Scalars['String'];
  daysUntilExpiry: Scalars['Float'];
  expiresAt: Scalars['DateTime'];
};

export type TrainingRequestInput = {
  /** The id of the training bundle. */
  bundleId?: Maybe<Scalars['String']>;
  /** The company id of the employee requesting training. */
  companyId: Scalars['String'];
  /** The description of the training request. */
  description?: Maybe<Scalars['String']>;
  /** The id of the training topic. */
  topicId?: Maybe<Scalars['String']>;
  /** The user id of the employee requesting training. */
  userId: Scalars['String'];
};

export type TrainingTopicDto = {
  __typename?: 'TrainingTopicDto';
  availableCourses: Array<TrainingCourseDto>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  topicId: Scalars['ID'];
};

export type TranscriptMetadata = {
  __typename?: 'TranscriptMetadata';
  duration: Scalars['Int'];
  endTime: Scalars['DateTime'];
  messageCount: Scalars['Int'];
  participants: Array<Scalars['String']>;
  startTime: Scalars['DateTime'];
};

export enum TrialBlockingReason {
  AlreadyTrialed = 'ALREADY_TRIALED',
  NotEligible = 'NOT_ELIGIBLE',
  NotOnFreePlan = 'NOT_ON_FREE_PLAN',
  NoPaymentMethod = 'NO_PAYMENT_METHOD',
  TrialInProgress = 'TRIAL_IN_PROGRESS'
}

export type UnenrollUsersFromBundleInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type UnenrollUsersInput = {
  bundleId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  topicId?: Maybe<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type UnenrolledUsers = {
  __typename?: 'UnenrolledUsers';
  errors: Array<Maybe<Scalars['String']>>;
  id: Scalars['ID'];
  successfullyUnenrolled: Array<Maybe<Scalars['String']>>;
};

export type UpcomingCorePlanChangeInvoice = {
  __typename?: 'UpcomingCorePlanChangeInvoice';
  /** Total amount for the remaining time in the new plan */
  remainingAmount: Scalars['Float'];
  /** Tax amount charged for the invoice */
  tax: Scalars['Float'];
  /** Total amount charged for the invoice */
  total: Scalars['Float'];
  /** Total amount due now */
  totalDue: Scalars['Float'];
  /** Total amount for the unused time in the current plan */
  unusedAmount: Scalars['Float'];
};

export type UpcomingNonCoreSubscriptionBillingChange = {
  __typename?: 'UpcomingNonCoreSubscriptionBillingChange';
  /** Maximum tier number */
  maxSize?: Maybe<Scalars['Float']>;
  /** Minimum tier number */
  minSize: Scalars['Float'];
  /** The product key associated to the non-core plan object */
  productKey: ProductKey;
  /** The service key associated to the non-core plan object */
  serviceKey: ServiceKey;
  /** Monthly price of the plan */
  upcomingMonthlyPrice?: Maybe<Scalars['Float']>;
  /** Yearly price of the plan */
  upcomingYearlyPrice?: Maybe<Scalars['Float']>;
};

export type UpdateCoreCompanyInput = {
  address?: Maybe<CoreAddressInput>;
  aiOptIn?: Maybe<Scalars['Boolean']>;
  companyChallenges?: Maybe<Scalars['String']>;
  companyGoals?: Maybe<Scalars['String']>;
  dba?: Maybe<Scalars['String']>;
  employeeLocations?: Maybe<Array<EmployeeLocationInput>>;
  fein?: Maybe<Scalars['String']>;
  handsFreeActionItemActivatedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  legalAddress?: Maybe<CoreLegalAddressInput>;
  mailingAddress?: Maybe<CoreMailingAddressInput>;
  name?: Maybe<Scalars['String']>;
  numOfContractors?: Maybe<Scalars['Int']>;
  numOfFullTimeHourlyEmployees?: Maybe<Scalars['Int']>;
  numOfFullTimeSalaryEmployees?: Maybe<Scalars['Int']>;
  numOfPartTimeEmployees?: Maybe<Scalars['Int']>;
  payDayOfMonth?: Maybe<Scalars['Int']>;
  payDayOfWeek?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  successVision?: Maybe<Scalars['String']>;
  takeHrAudit?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** Edit one generated Execution document before the Execution stage is approved (BIO-2078). Company owner/admin only, scoped to the JWT company. Valid only while the cycle sits on Execution / ExecutionApproval; the mutation rejects after. The generated original is kept next to the edit (generatedBody / editedAt / editedByUserId on the document). */
export type UpdateExecutionDocumentInput = {
  /** Replacement body (markdown text; HTML/control characters rejected) */
  body: Scalars['String'];
  /** The resolution cycle owning the document */
  cycleId: Scalars['ID'];
  /** The templateKey of the document to edit (as generated) */
  templateKey: Scalars['String'];
  /** Replacement title; when present it must be non-empty */
  title?: Maybe<Scalars['String']>;
};

export type UpdateImageReferenceInput = {
  /** Description of the image */
  description?: Maybe<Scalars['String']>;
  /** Whether this image is active */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Keywords for searching */
  keywords?: Maybe<Array<Scalars['String']>>;
  /** Use cases for the image */
  useCases?: Maybe<Array<Scalars['String']>>;
};

export type UpdateJobDescriptionInput = {
  body?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type UpdateMultipleRolesForCompanyInput = {
  /** Bambee Company id */
  companyId: Scalars['ID'];
  /** Company Roles */
  roles: Array<UpdateRoleForCompanyInput>;
};

export type UpdateNoticeInput = {
  badge?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  visualization?: Maybe<VisualizationDataInput>;
};

export type UpdatePaymentSourceAddress = {
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type UpdatePaymentSourceBillingAddress = {
  address: UpdatePaymentSourceAddress;
  companyId: Scalars['String'];
  paymentSourceId: Scalars['String'];
};

export type UpdatePlanLockInput = {
  active: Scalars['Boolean'];
  companyId: Scalars['String'];
  couponId: Scalars['String'];
  plan: Scalars['String'];
  setupFee: Scalars['Float'];
  trialDuration: Scalars['Float'];
};

export type UpdateProductInterestWasAppNotificationDismissedInput = {
  /** The ID of the product interest */
  id: Scalars['ID'];
};

export type UpdateQuestionStoreInput = {
  /** The answer text to add as a new answer */
  answer?: Maybe<Scalars['String']>;
  /** Role of the user who answered (owner, admin, employee) */
  answeredByRole?: Maybe<Scalars['String']>;
  /** Date after which the question can be asked again */
  askAfter?: Maybe<Scalars['DateTime']>;
  /** Date when the question was answered */
  dateAnswered?: Maybe<Scalars['DateTime']>;
  /** The question text */
  question?: Maybe<Scalars['String']>;
  /** Source of the question (app, intercom, phone) */
  source?: Maybe<Scalars['String']>;
  /** User id who answered the question */
  userId?: Maybe<Scalars['ID']>;
};

export type UpdateRealTimeThreadInput = {
  /** Associated Case ID from task service */
  caseId?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  threadType?: Maybe<ThreadType>;
  title?: Maybe<Scalars['String']>;
  voiceType?: Maybe<Scalars['String']>;
};

export type UpdateReportCardInput = {
  /** Keyed 1–5 sub-ratings ("where specifically?") — private to manager + HR */
  dimensions?: Maybe<Array<ReportCardDimensionRatingInput>>;
  /** employee id */
  employeeId: Scalars['String'];
  /** Selected contributing-factor keys — private to manager + HR */
  factors?: Maybe<Array<Scalars['String']>>;
  /** External Employee Feedback, they see this */
  feedback?: Maybe<Scalars['String']>;
  /** employee grade value */
  grade?: Maybe<ReportCardGradeValues>;
  /** Internal Note */
  note?: Maybe<Scalars['String']>;
  /** Report Card Id */
  reportCardId: Scalars['String'];
  /** How big a deal this grade is to the employee — private to manager + HR */
  significance?: Maybe<ReportCardSignificanceValues>;
  /** Do we want to set the status of Report Card? This is independent of each employee graded status */
  status?: Maybe<ReportCardStatusValues>;
};

export type UpdateRoleForCompanyInput = {
  /** Bambee Company role id */
  id: Scalars['ID'];
  /** Bambee Core Company Role title */
  title: Scalars['String'];
};

export type UpdateWizardGroupInput = {
  description?: Maybe<Scalars['String']>;
  displayDescription?: Maybe<Scalars['String']>;
  displayTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateWizardInput = {
  allowBack?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  destination?: Maybe<WizardDestination>;
  errorMessage?: Maybe<Scalars['String']>;
  progressType?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  showProgress?: Maybe<Scalars['Boolean']>;
  source?: Maybe<WizardSource>;
  successMessage?: Maybe<Scalars['String']>;
  successTitle?: Maybe<Scalars['String']>;
  threadId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<WizardType>;
  version?: Maybe<Scalars['String']>;
  voiceInteraction?: Maybe<Scalars['Boolean']>;
};

export type UpdateWizardTemplateInput = {
  /** Description for the wizard */
  description?: Maybe<Scalars['String']>;
  /** Optional destination for the wizard */
  destination?: Maybe<WizardDestination>;
  /** Error message shown on wizard error */
  errorMessage?: Maybe<Scalars['String']>;
  /** Optional prompt for AI generation */
  prompt?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<WizardTemplateQuestionInput>>;
  /** Success message shown after wizard completion */
  successMessage?: Maybe<Scalars['String']>;
  /** Success title shown after wizard completion */
  successTitle?: Maybe<Scalars['String']>;
  /** Title for the wizard */
  title?: Maybe<Scalars['String']>;
  /** Complete wizard template data */
  wizardData?: Maybe<Scalars['JSON']>;
};

export type UpdateWorkerRoleInput = {
  isPrimary: Scalars['Boolean'];
  payType: WorkerRolePaytype;
  workerRoleId: Scalars['ID'];
};

export type UpgradeCorePlanInput = {
  companyId: Scalars['String'];
  newPlanId: Scalars['String'];
};

export type UploadFileToIntercomInput = {
  /** The base64 encoded file */
  base64File: Scalars['String'];
  /** The name of the file */
  fileName: Scalars['String'];
  /** The type of the file (e.g application/pdf) */
  fileType: Scalars['String'];
};

export type UploadFilesToConversationInput = {
  /** The files to upload */
  filesToUpload: Array<UploadFileToIntercomInput>;
  /** The Intercom ID of the conversation */
  intercomConversationId: Scalars['String'];
};

export type UploadedFileCore = {
  /** Whether the file content should be added to the thread as a hidden user message, default behavior is not to add the contents to the thread and just attach ids */
  addContentToThread?: Maybe<Scalars['Boolean']>;
  /** The base64 encoded file */
  base64: Scalars['String'];
  /** The MIME type of the file */
  fileType: Scalars['String'];
  /** The name of the file */
  name: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  error?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isContractor?: Maybe<Scalars['Boolean']>;
  language: Language;
  name?: Maybe<Scalars['String']>;
  profile?: Maybe<UserProfile>;
  role: UserRole;
  state?: Maybe<State>;
  training: UserTraining;
  userId: Scalars['String'];
  /** @deprecated This field is deprecated; Use userId instead */
  userMngId?: Maybe<Scalars['String']>;
};

export type UserContextDto = {
  __typename?: 'UserContextDto';
  company?: Maybe<CompanyContextDto>;
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  directReports?: Maybe<Array<UserContextDto>>;
  documents?: Maybe<Array<DocumentDto>>;
  email: Scalars['String'];
  employment?: Maybe<EmploymentDto>;
  feedback?: Maybe<Array<FeedbackDto>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBambeeStaff: Scalars['Boolean'];
  isCompanyOwner: Scalars['Boolean'];
  isManager: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  manager?: Maybe<UserContextDto>;
  name: Scalars['String'];
  permissions: PermissionsDto;
  pips?: Maybe<Array<PipDto>>;
  policies?: Maybe<Array<PolicyDto>>;
  primaryRole?: Maybe<Scalars['String']>;
  /** User role in the context system */
  role?: Maybe<ContextUserRole>;
  search?: Maybe<SearchResultsDto>;
  staff?: Maybe<Array<UserContextDto>>;
  training?: Maybe<EnhancedTrainingProfileDto>;
  warnings?: Maybe<WarningsDto>;
  workerRoles?: Maybe<Array<WorkerRoleDto>>;
};


export type UserContextDtoSearchArgs = {
  input?: Maybe<SearchInput>;
};

export type UserCounts = {
  __typename?: 'UserCounts';
  completed?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  inProgress?: Maybe<Scalars['Float']>;
  notStarted?: Maybe<Scalars['Float']>;
};

export type UserCourse = {
  __typename?: 'UserCourse';
  bundleId: Scalars['String'];
  bundleName: Scalars['String'];
  certificateDownloadUrl?: Maybe<Scalars['String']>;
  certificateId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  courseId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isTopicRetired: Scalars['Boolean'];
  key: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  removedAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated use key instead */
  searchTag?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  ticketId: Scalars['String'];
  topicId: Scalars['String'];
  topicName: Scalars['String'];
  topics: Array<Maybe<CourseTopic>>;
  userRole: Scalars['String'];
};

export type UserCourseTopic = {
  __typename?: 'UserCourseTopic';
  courseId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  ticketId: Scalars['ID'];
};

export type UserCoursesInput = {
  bundleId?: Maybe<Scalars['String']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  topicId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserCreatedResult = {
  __typename?: 'UserCreatedResult';
  authId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserEnrollmentSync = {
  __typename?: 'UserEnrollmentSync';
  completedAt?: Maybe<Scalars['DateTime']>;
  ticketId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserEnrollmentSyncError = {
  __typename?: 'UserEnrollmentSyncError';
  cause: Scalars['String'];
  message: Scalars['String'];
};

export type UserInput = {
  language: Language;
  role: UserRole;
  state?: Maybe<State>;
  userId: Scalars['String'];
  userMngId?: Maybe<Scalars['String']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  classification: EmployeeClassification;
  conference?: Maybe<Scalars['String']>;
  contractorBusinessName?: Maybe<Scalars['String']>;
  contractorType: EmployeeServiceContractorType;
  dob: Scalars['DateTime'];
  emergencyContact: EmergencyContact;
  employeeType: EmployeeServiceEmployeeType;
  firstName?: Maybe<Scalars['String']>;
  hoursPerWeek?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastSocial?: Maybe<Scalars['String']>;
  payDay?: Maybe<Scalars['String']>;
  payFrequency?: Maybe<Scalars['String']>;
  payRate?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateWorkIn?: Maybe<Scalars['String']>;
  supervisor?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type: PayType;
  yearsExperience?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type UserQueryInput = {
  id: Scalars['ID'];
};

export enum UserRole {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type UserTraining = {
  __typename?: 'UserTraining';
  courses: Array<Maybe<UserCourse>>;
  history: Array<Maybe<UserCourse>>;
  id: Scalars['ID'];
  userId: Scalars['String'];
};


export type UserTrainingCoursesArgs = {
  filter: UserTrainingFilterInput;
};


export type UserTrainingHistoryArgs = {
  filter: UserTrainingFilterInput;
};

export type UserTrainingFilterInput = {
  bundleId?: Maybe<Scalars['String']>;
  topicId?: Maybe<Scalars['String']>;
};

export type UserWizardAssignment = {
  __typename?: 'UserWizardAssignment';
  /** User name */
  name: Scalars['String'];
  /** Wizard status: completed, in_progress, not_started */
  status: Scalars['String'];
  /** User ID */
  userId: Scalars['ID'];
  /** Wizard ID */
  wizardId: Scalars['ID'];
};

export type ValidationRule = {
  __typename?: 'ValidationRule';
  message: Scalars['String'];
  type: ValidationRuleType;
  value?: Maybe<Scalars['JSON']>;
};

export type ValidationRuleInput = {
  message: Scalars['String'];
  type: ValidationRuleType;
  value?: Maybe<Scalars['JSON']>;
};

/** Types of validation rules */
export enum ValidationRuleType {
  Email = 'EMAIL',
  Max = 'MAX',
  MaxLength = 'MAX_LENGTH',
  Min = 'MIN',
  MinLength = 'MIN_LENGTH',
  Pattern = 'PATTERN',
  Unique = 'UNIQUE'
}

export type VerbalWarningDto = {
  __typename?: 'VerbalWarningDto';
  consequences?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  performanceConcernsInfo: Scalars['String'];
  performanceConcernsType: Scalars['String'];
  status: Scalars['String'];
};

/** Type of visual content for wizard steps */
export enum VisualType {
  Component = 'COMPONENT',
  Image = 'IMAGE',
  Visualization = 'VISUALIZATION'
}

export type VisualizationData = {
  __typename?: 'VisualizationData';
  /** Visualization data matching Chart.js or custom visualization format */
  data: Scalars['JSON'];
  /** Optional Chart.js configuration options */
  options?: Maybe<Scalars['JSON']>;
  type: VisualizationType;
};

export type VisualizationDataInput = {
  /** JSON string representation of the visualization data */
  data: Scalars['String'];
  type: VisualizationType;
};

/** The type of visualization for a notice */
export enum VisualizationType {
  Bar = 'BAR',
  Employee = 'EMPLOYEE',
  Line = 'LINE',
  None = 'NONE',
  Pie = 'PIE',
  Radar = 'RADAR',
  Timeline = 'TIMELINE',
  Trend = 'TREND'
}

export type VoicesFeedback = {
  __typename?: 'VoicesFeedback';
  anonymous: Scalars['Boolean'];
  /** This will be null if anonymous is true. The User MongoId. In the future we may deprecate this for Employee ID */
  companyPersonId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CoreUser>;
  feedback: Scalars['String'];
  id: Scalars['Float'];
  satisfactionRatingOfFive?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

export type VoidCreditsInput = {
  companyId: Scalars['ID'];
  creditIds: Array<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
};

export type WarningDocument = {
  __typename?: 'WarningDocument';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type WarningsDto = {
  __typename?: 'WarningsDto';
  totalCount: Scalars['Int'];
  verbal: Array<VerbalWarningDto>;
  written: Array<WrittenWarningDto>;
};

export type Wizard = {
  __typename?: 'Wizard';
  allowBack: Scalars['Boolean'];
  companyId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  currentStepId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  destination: WizardDestination;
  errorMessage?: Maybe<Scalars['String']>;
  furthestStepId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  progressType: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
  /** Dynamic responses keyed by question name */
  responses?: Maybe<Scalars['JSON']>;
  showProgress: Scalars['Boolean'];
  source: WizardSource;
  startedAt?: Maybe<Scalars['DateTime']>;
  steps?: Maybe<Array<WizardStep>>;
  successMessage?: Maybe<Scalars['String']>;
  successTitle?: Maybe<Scalars['String']>;
  threadId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalStepCount: Scalars['Int'];
  type?: Maybe<WizardType>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
  version: Scalars['String'];
  voiceInteraction: Scalars['Boolean'];
};

/** Intended destination/purpose of the wizard */
export enum WizardDestination {
  Dashboard = 'DASHBOARD',
  Goals = 'GOALS',
  Intro = 'INTRO',
  Notice = 'NOTICE',
  Onboarding = 'ONBOARDING'
}

export type WizardDto = {
  __typename?: 'WizardDto';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  progress?: Maybe<Scalars['Float']>;
  steps?: Maybe<Array<WizardStepDto>>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['String'];
};

export type WizardFilterInput = {
  companyId?: Maybe<Scalars['String']>;
  destination?: Maybe<WizardDestination>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  source?: Maybe<WizardSource>;
  type?: Maybe<WizardType>;
  userId?: Maybe<Scalars['String']>;
};

export type WizardGroup = {
  __typename?: 'WizardGroup';
  /** Whether this wizard group is activated for a customer (resolved field) */
  activated?: Maybe<Scalars['Boolean']>;
  /** When the wizard group was activated (resolved field) */
  activatedOn?: Maybe<Scalars['DateTime']>;
  /** List of companies that have this wizard group activated */
  companies?: Maybe<Array<WizardGroupCompany>>;
  createdAt: Scalars['DateTime'];
  /** Soft delete timestamp */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Internal description for Honey users */
  description: Scalars['String'];
  /** Customer-facing description */
  displayDescription: Scalars['String'];
  /** Customer-facing title */
  displayTitle: Scalars['String'];
  id: Scalars['ID'];
  /** Internal name for Honey users */
  name: Scalars['String'];
  /** Summary of wizard completion status for this group */
  statusSummary?: Maybe<WizardGroupStatusSummary>;
  updatedAt: Scalars['DateTime'];
  /** List of users assigned wizards in this group with their status */
  userAssignments?: Maybe<Array<UserWizardAssignment>>;
  /** IDs of wizard instances sent to users (resolved field) */
  wizardIds?: Maybe<Array<Scalars['String']>>;
  /** Wizard templates associated with this group */
  wizardTemplates?: Maybe<Array<WizardTemplate>>;
};

export type WizardGroupActivationResult = {
  __typename?: 'WizardGroupActivationResult';
  success: Scalars['Boolean'];
  wizardGroup: WizardGroup;
};

export type WizardGroupCompany = {
  __typename?: 'WizardGroupCompany';
  /** Whether this wizard group is activated for this company */
  activated?: Maybe<Scalars['Boolean']>;
  /** User ID who activated the wizard group for this company */
  activatedBy?: Maybe<Scalars['String']>;
  /** When the wizard group was activated for this company */
  activatedOn?: Maybe<Scalars['DateTime']>;
  /** The company entity */
  company: CoreCompany;
  /** The company ID */
  companyId: Scalars['ID'];
};

export type WizardGroupStatusSummary = {
  __typename?: 'WizardGroupStatusSummary';
  /** Number of completed wizards */
  completed: Scalars['Int'];
  /** Number of in-progress wizards */
  inProgress: Scalars['Int'];
  /** Number of not-started wizards */
  notStarted: Scalars['Int'];
  /** Total number of wizards */
  total: Scalars['Int'];
};

export type WizardQuestion = {
  __typename?: 'WizardQuestion';
  /** Number of columns this question should span */
  columnCount?: Maybe<Scalars['Int']>;
  conditionalRequired?: Maybe<ConditionalRequired>;
  /** Question-specific configuration based on type */
  config?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  /** Configuration for question groups (only applicable for QUESTION_GROUP type) */
  groupConfig?: Maybe<QuestionGroupConfig>;
  id: Scalars['ID'];
  label: Scalars['String'];
  labelSize?: Maybe<LabelSize>;
  labelWeight?: Maybe<LabelWeight>;
  name: Scalars['String'];
  order: Scalars['Int'];
  placeholder?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  showIf?: Maybe<Array<ShowIfCondition>>;
  type: QuestionType;
  validation?: Maybe<Array<ValidationRule>>;
};

export type WizardQuestionDto = {
  __typename?: 'WizardQuestionDto';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
  placeholder?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  type: Scalars['String'];
};

/** Status of wizard response */
export enum WizardResponseStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS'
}

export type WizardResponseUpdateInput = {
  currentStepId?: Maybe<Scalars['String']>;
  isPrefill?: Maybe<Scalars['Boolean']>;
  /** Dynamic responses keyed by question name */
  responses: Scalars['JSON'];
  status?: Maybe<WizardResponseStatus>;
};

/** The role targeted by a wizard template */
export enum WizardRole {
  Contractor = 'CONTRACTOR',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER',
  Owner = 'OWNER'
}

/** Source system that created the wizard */
export enum WizardSource {
  Brighten = 'BRIGHTEN',
  CompanyConverted = 'COMPANY_CONVERTED',
  Honey = 'HONEY',
  WizardGenerator = 'WIZARD_GENERATOR'
}

export type WizardStep = {
  __typename?: 'WizardStep';
  componentName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  layoutType: StepLayoutType;
  order: Scalars['Int'];
  questions?: Maybe<Array<WizardQuestion>>;
  showIf?: Maybe<Array<ShowIfCondition>>;
  title?: Maybe<Scalars['String']>;
  /** Total number of columns available in this step */
  totalColumns?: Maybe<Scalars['Int']>;
  visualAlt?: Maybe<Scalars['String']>;
  /** Visualization data for charts or custom visualizations */
  visualData?: Maybe<Scalars['JSON']>;
  visualSrc?: Maybe<Scalars['String']>;
  visualType?: Maybe<VisualType>;
};

export type WizardStepDto = {
  __typename?: 'WizardStepDto';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  layoutType: Scalars['String'];
  order: Scalars['Int'];
  questions?: Maybe<Array<WizardQuestionDto>>;
  title: Scalars['String'];
};

export type WizardStepInput = {
  componentName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  layoutType: StepLayoutType;
  questions: Array<QuestionInput>;
  showIf?: Maybe<Array<ShowIfConditionInput>>;
  title?: Maybe<Scalars['String']>;
  /** Total number of columns available in this step */
  totalColumns?: Maybe<Scalars['Int']>;
  visualAlt?: Maybe<Scalars['String']>;
  /** Visualization data for charts or custom visualizations */
  visualData?: Maybe<Scalars['JSON']>;
  visualSrc?: Maybe<Scalars['String']>;
  visualType?: Maybe<VisualType>;
};

export type WizardTemplate = {
  __typename?: 'WizardTemplate';
  createdAt: Scalars['DateTime'];
  /** Wizard destination */
  destination?: Maybe<WizardDestination>;
  id: Scalars['ID'];
  /** Optional prompt used for AI generation */
  prompt?: Maybe<Scalars['String']>;
  questions: Array<WizardTemplateQuestion>;
  role: WizardRole;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
  /** Complete wizard template data */
  wizardData?: Maybe<Scalars['JSON']>;
  wizardGroupId: Scalars['ID'];
};

export type WizardTemplateQuestion = {
  __typename?: 'WizardTemplateQuestion';
  id: Scalars['ID'];
  question: Scalars['String'];
  type: QuestionType;
};

export type WizardTemplateQuestionInput = {
  id: Scalars['ID'];
  question: Scalars['String'];
  type: QuestionType;
};

export type WizardTemplateStep = {
  __typename?: 'WizardTemplateStep';
  description?: Maybe<Scalars['String']>;
  layoutType: StepLayoutType;
  order: Scalars['Int'];
  questions?: Maybe<Array<WizardTemplateStepQuestion>>;
  title: Scalars['String'];
  visualAlt?: Maybe<Scalars['String']>;
  visualData?: Maybe<Scalars['JSON']>;
  visualSrc?: Maybe<Scalars['String']>;
  visualType?: Maybe<Scalars['String']>;
};

export type WizardTemplateStepQuestion = {
  __typename?: 'WizardTemplateStepQuestion';
  config?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  labelSize?: Maybe<LabelSize>;
  labelWeight?: Maybe<LabelWeight>;
  name: Scalars['String'];
  order: Scalars['Int'];
  placeholder?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  showIf?: Maybe<Scalars['JSON']>;
  type: QuestionType;
  validation?: Maybe<Scalars['JSON']>;
};

/** Type of wizard for categorization */
export enum WizardType {
  CoverageAudit = 'COVERAGE_AUDIT',
  EliteToPremiumPeopleActivation = 'ELITE_TO_PREMIUM_PEOPLE_ACTIVATION',
  Onboarding = 'ONBOARDING',
  OnboardingAdmin = 'ONBOARDING_ADMIN',
  OnboardingEmployee = 'ONBOARDING_EMPLOYEE',
  OnboardingManager = 'ONBOARDING_MANAGER',
  SmartAudit = 'SMART_AUDIT'
}

export type WorkerRole = {
  __typename?: 'WorkerRole';
  companyRole?: Maybe<CompanyRole>;
  createdAt: Scalars['DateTime'];
  /** Date of worker role deletion */
  deletedAt?: Maybe<Scalars['DateTime']>;
  employeeJobDescription?: Maybe<EmployeeJobDescription>;
  /** Bambee Worker Role id */
  id: Scalars['ID'];
  /** Determines whether or not worker role is primary */
  isPrimary: Scalars['Boolean'];
  /** Pay rate of the worker role */
  payRate: Scalars['Float'];
  /** Pay type of the worker role */
  payType: WorkerRolePaytype;
  /** Bambee User Id */
  userId: Scalars['ID'];
};

export type WorkerRoleDto = {
  __typename?: 'WorkerRoleDto';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum WorkerRolePaytype {
  Contractor = 'Contractor',
  Hourly = 'Hourly',
  Salary = 'Salary'
}

export enum WorkingSchedule {
  DayShifts = 'DayShifts',
  EveningShifts = 'EveningShifts',
  Holidays = 'Holidays',
  MondayFriday = 'MondayFriday',
  OvernightShifts = 'OvernightShifts',
  Overtime = 'Overtime',
  Weekends = 'Weekends'
}

export type WrittenWarningDto = {
  __typename?: 'WrittenWarningDto';
  createdAt: Scalars['DateTime'];
  employeeSignedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isFinal: Scalars['Boolean'];
  managerSignedAt?: Maybe<Scalars['DateTime']>;
  performanceConcernsInfo: Scalars['String'];
  performanceConcernsType: Scalars['String'];
  performanceExpectations?: Maybe<Array<Scalars['String']>>;
  status: Scalars['String'];
};

export type ChatWithAssistantMutationVariables = Exact<{
  data: AiAssistantInput;
}>;


export type ChatWithAssistantMutation = { __typename?: 'Mutation', chatWithAssistant: { __typename?: 'AIAssistantResponse', assistantId?: Maybe<string>, threadId: string, next: { __typename?: 'NextMessage', context?: Maybe<string>, sample?: Maybe<string> }, messages?: Maybe<Array<Maybe<{ __typename?: 'AIMessageDto', id: string, role: string, content: Array<{ __typename?: 'MessageContentDto', text?: Maybe<{ __typename?: 'TextContentBlock', value: string }> }>, metadata: { __typename?: 'MessageMetaDataDto', artifact?: Maybe<string>, hidden?: Maybe<string>, type?: Maybe<string>, value?: Maybe<string> } }>>>, artifact?: Maybe<{ __typename?: 'ChatArtifact', jobDescription?: Maybe<{ __typename?: 'JobDescriptionArtifact', html: string, id?: Maybe<string>, status: JobDescriptionStatus }>, summary?: Maybe<{ __typename?: 'SummaryArtifact', html: string, status: string }>, policy?: Maybe<{ __typename?: 'PolicyArtifact', html?: Maybe<string>, title?: Maybe<string>, id?: Maybe<string>, status: BestPracticeStatus }> }> } };

export type GetArtifactsByThreadQueryVariables = Exact<{
  input: GetArtifactsInput;
}>;


export type GetArtifactsByThreadQuery = { __typename?: 'Query', getArtifacts: Array<{ __typename?: 'ArtifactDto', id: string, artifactType: ArtifactType, artifactSubType?: Maybe<string>, html?: Maybe<string>, title: string, status: ArtifactStatus, threadId?: Maybe<string>, downloadUrl?: Maybe<string>, confidence?: Maybe<number>, policyId?: Maybe<string>, caseId?: Maybe<string>, hrRequestId?: Maybe<string> }> };

export type TrackMutationVariables = Exact<{
  data: AnalyticEvent;
}>;


export type TrackMutation = { __typename?: 'Mutation', track: { __typename?: 'AnalyticEventTracked', id: string, success: boolean, event: string } };

export type EmitMutationVariables = Exact<{
  data: EmittableEvent;
}>;


export type EmitMutation = { __typename?: 'Mutation', emit: { __typename?: 'EventEmitted', id: string, success: boolean } };

export type AppliedPlansPartsFragment = { __typename?: 'Plan', id: string, name: string };

export type CouponPartsFragment = { __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> };

export type SubscriptionPartsFragment = { __typename?: 'Subscription', name: string, productCode: ProductKey, amount: number, status: SubscriptionStatus, startDate: any, endDate: any, stripeId: string, stripePriceId: string, createdAt: any, isDrp: boolean, coupon?: Maybe<{ __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> }> };

export type BillingPlanPartsFragment = { __typename?: 'PlanLock', active: boolean, couponId?: Maybe<string>, plan: string, setupFee: number, trialDuration: number };

export type CompanyDelinquencyPartsFragment = { __typename?: 'CompanyDelinquency', delinquent: boolean, delinquentSince?: Maybe<any>, lockout: boolean, defaultCardVerificationStatus: CardVerificationStatus };

export type PaymentSourcePartsFragment = { __typename?: 'PaymentSource', addressCity?: Maybe<string>, addressCountry?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, addressState?: Maybe<string>, addressZip?: Maybe<string>, brand?: Maybe<string>, country?: Maybe<string>, cvcCheck?: Maybe<string>, default: boolean, dynamicLast4?: Maybe<string>, expMonth: number, expYear: number, funding?: Maybe<string>, id: string, last4?: Maybe<string>, name?: Maybe<string> };

export type BillingProductPartsFragment = { __typename?: 'Product', id: string, name?: Maybe<string>, key: ProductKey, creditBalance: number, price?: Maybe<number>, subscriptionPrice?: Maybe<number>, activeSubscription?: Maybe<boolean> };

export type ProductResultPartsFragment = { __typename?: 'PurchaseResult', createdAt: any, creditsPurchased: number, productKey: ProductKey, id: string, status: StatementStatus };

export type PaymentSourcesPartsFragment = { __typename?: 'PaymentSources', companyId: string, sources: Array<{ __typename?: 'PaymentSource', addressCity?: Maybe<string>, addressCountry?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, addressState?: Maybe<string>, addressZip?: Maybe<string>, brand?: Maybe<string>, country?: Maybe<string>, cvcCheck?: Maybe<string>, default: boolean, dynamicLast4?: Maybe<string>, expMonth: number, expYear: number, funding?: Maybe<string>, id: string, last4?: Maybe<string>, name?: Maybe<string> }> };

export type GetCouponByIdQueryVariables = Exact<{
  data: GetCouponInput;
}>;


export type GetCouponByIdQuery = { __typename?: 'Query', coupon: { __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> } };

export type GetLockedPlanQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetLockedPlanQuery = { __typename?: 'Query', getPlanLock: { __typename?: 'PlanLock', active: boolean, couponId?: Maybe<string>, plan: string, setupFee: number, trialDuration: number } };

export type GetBillingCompanySubscriptionsQueryVariables = Exact<{
  data: GetCompanySubscriptionsInput;
}>;


export type GetBillingCompanySubscriptionsQuery = { __typename?: 'Query', companySubscriptions: Array<{ __typename?: 'Subscription', name: string, productCode: ProductKey, amount: number, status: SubscriptionStatus, startDate: any, endDate: any, stripeId: string, stripePriceId: string, createdAt: any, isDrp: boolean, coupon?: Maybe<{ __typename?: 'PlanCoupon', id: string, name: string, amountOff: number, setupFeeOff: number, appliesToPlans: Array<{ __typename?: 'Plan', id: string, name: string }> }> }> };

export type MyProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProductsQuery = { __typename?: 'Query', myProducts: Array<{ __typename?: 'Product', id: string, name?: Maybe<string>, key: ProductKey, creditBalance: number, price?: Maybe<number>, subscriptionPrice?: Maybe<number>, activeSubscription?: Maybe<boolean> }> };

export type PurchaseCreditsMutationVariables = Exact<{
  data: PurchaseInput;
}>;


export type PurchaseCreditsMutation = { __typename?: 'Mutation', purchaseCredits: { __typename?: 'PurchaseResult', createdAt: any, creditsPurchased: number, productKey: ProductKey, id: string, status: StatementStatus } };

export type PurchaseSubscriptionMutationVariables = Exact<{
  data: PurchaseSubscriptionInput;
}>;


export type PurchaseSubscriptionMutation = { __typename?: 'Mutation', purchaseSubscription: { __typename?: 'PurchaseResult', createdAt: any, creditsPurchased: number, productKey: ProductKey, id: string, status: StatementStatus } };

export type GetCompanyDelinquencyQueryVariables = Exact<{
  data: GetCompanyDelinquency;
}>;


export type GetCompanyDelinquencyQuery = { __typename?: 'Query', getCompanyDelinquency: { __typename?: 'CompanyDelinquency', delinquent: boolean, delinquentSince?: Maybe<any>, lockout: boolean, defaultCardVerificationStatus: CardVerificationStatus } };

export type GetCompanySourcesQueryVariables = Exact<{
  data: GetCompanyPaymentSources;
}>;


export type GetCompanySourcesQuery = { __typename?: 'Query', getCompanySources: { __typename?: 'PaymentSources', companyId: string, sources: Array<{ __typename?: 'PaymentSource', addressCity?: Maybe<string>, addressCountry?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, addressState?: Maybe<string>, addressZip?: Maybe<string>, brand?: Maybe<string>, country?: Maybe<string>, cvcCheck?: Maybe<string>, default: boolean, dynamicLast4?: Maybe<string>, expMonth: number, expYear: number, funding?: Maybe<string>, id: string, last4?: Maybe<string>, name?: Maybe<string> }> } };

export type UpdatePaymentSourceBillingAddressMutationVariables = Exact<{
  input: UpdatePaymentSourceBillingAddress;
}>;


export type UpdatePaymentSourceBillingAddressMutation = { __typename?: 'Mutation', updatePaymentSourceBillingAddress: { __typename?: 'PaymentSource', addressCity?: Maybe<string>, addressCountry?: Maybe<string>, addressLine1?: Maybe<string>, addressLine2?: Maybe<string>, addressState?: Maybe<string>, addressZip?: Maybe<string>, brand?: Maybe<string>, country?: Maybe<string>, cvcCheck?: Maybe<string>, default: boolean, dynamicLast4?: Maybe<string>, expMonth: number, expYear: number, funding?: Maybe<string>, id: string, last4?: Maybe<string>, name?: Maybe<string> } };

export type ScratchListServiceAddonsQueryVariables = Exact<{
  input: ScratchServiceAddonListInput;
}>;


export type ScratchListServiceAddonsQuery = { __typename?: 'Query', scratchListServiceAddons: Array<{ __typename?: 'ScratchServiceAddonsModel', id: string, label: string, priceLabel: string, enabled: boolean }> };

export type ScratchToggleServiceAddonMutationVariables = Exact<{
  input: ScratchToggleServiceAddonInput;
}>;


export type ScratchToggleServiceAddonMutation = { __typename?: 'Mutation', scratchToggleServiceAddon: { __typename?: 'ScratchServiceAddonsModel', id: string, label: string, priceLabel: string, enabled: boolean } };

export type GetBillingHistoryQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetBillingHistoryQuery = { __typename?: 'Query', getBillingHistory: Array<{ __typename?: 'Statement', id: string, createdAt: any, modifiedAt?: Maybe<any>, amount: number, productKey?: Maybe<ProductKey>, statementType: StatementType, status: StatementStatus, hostedUrl?: Maybe<string>, pdfUrl?: Maybe<string>, stripeSubscriptionId?: Maybe<string> }> };

export type GetBillingInfoPaymentMethodsQueryVariables = Exact<{
  input: GetBillingInfoInput;
}>;


export type GetBillingInfoPaymentMethodsQuery = { __typename?: 'Query', getBillingInfo: { __typename?: 'BillingInfo', paymentMethods: Array<{ __typename?: 'BillingPaymentMethod', id: string, default: boolean, status: PaymentMethodStatus, type: PaymentMethodType, name: string, issueReason?: Maybe<PaymentMethodIssueReason>, nextAction?: Maybe<PaymentMethodNextAction>, expirationDate?: Maybe<any> }> } };

export type GetCorePlanAccessQueryVariables = Exact<{
  input: GetBillingInfoInput;
}>;


export type GetCorePlanAccessQuery = { __typename?: 'Query', getBillingInfo: { __typename?: 'BillingInfo', id: string, coreSubscription?: Maybe<{ __typename?: 'CoreSubscriptionModel', provider: BillingProvider, state?: Maybe<SubscriptionState>, active: boolean, plan: { __typename?: 'CorePlanModel', productKey: ProductKey, legacyProductKey?: Maybe<ProductKey> } }> } };

export type GetBillingInfoQueryVariables = Exact<{
  input: GetBillingInfoInput;
}>;


export type GetBillingInfoQuery = { __typename?: 'Query', getBillingInfo: { __typename?: 'BillingInfo', id: string, pause: { __typename?: 'Paused', id: string, isPaused: boolean, reactivatesOn?: Maybe<any> }, coreSubscription?: Maybe<{ __typename?: 'CoreSubscriptionModel', active: boolean, cancellationRequested: boolean, cancelsAt?: Maybe<any>, periodEndsAt: any, plan: { __typename?: 'CorePlanModel', name: string, productKey: ProductKey, legacyProductKey?: Maybe<ProductKey>, billingPeriod: BillingPeriod, price: number, employeeSizeMapping?: Maybe<string>, value: string }, scheduledPlanChange?: Maybe<{ __typename?: 'ScheduledCorePlanChangeModel', effectiveOn: any, newPlan: { __typename?: 'CorePlanModel', name: string } }> }>, addonSubscriptions: Array<{ __typename?: 'SubscriptionModel', active: boolean, cancelsAt?: Maybe<any>, quantity?: Maybe<number>, periodEndsAt: any, plan: { __typename?: 'PlanModel', name: string, billingPeriod: BillingPeriod, price?: Maybe<number>, serviceKey: ServiceKey } }> } };

export type GetBillingSubscriptionTermEndQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetBillingSubscriptionTermEndQuery = { __typename?: 'Query', billingSubscription?: Maybe<{ __typename?: 'BillingSubscriptionModel', currentTermEndsAt?: Maybe<any> }> };

export type ConfirmMicroDepositMutationVariables = Exact<{
  input: ConfirmMicroDepositInput;
}>;


export type ConfirmMicroDepositMutation = { __typename?: 'Mutation', confirmMicroDeposit: { __typename?: 'BillingPaymentMethod', id: string, default: boolean, status: PaymentMethodStatus, type: PaymentMethodType, name: string, expirationDate?: Maybe<any> } };

export type GetCompanySubscriptionsQueryVariables = Exact<{
  data: GetCompanySubscriptionsInput;
}>;


export type GetCompanySubscriptionsQuery = { __typename?: 'Query', companySubscriptions: Array<{ __typename?: 'Subscription', name: string, productCode: ProductKey, amount: number, status: SubscriptionStatus, startDate: any, endDate: any, stripeId: string, stripePriceId: string, createdAt: any, isDrp: boolean }> };

export type RemovePaymentMethodMutationVariables = Exact<{
  input: RemovePaymentMethodInput;
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: boolean };

export type RecurlyPaymentMethodsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type RecurlyPaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethod', id: string, kind: PaymentMethodKind, brand?: Maybe<string>, last4: string, expMonth?: Maybe<number>, expYear?: Maybe<number>, primary: boolean, backup: boolean, bankName?: Maybe<string>, accountType?: Maybe<string>, verificationStatus?: Maybe<string> }> };

export type AddRecurlyPaymentMethodMutationVariables = Exact<{
  input: AddPaymentMethodInput;
}>;


export type AddRecurlyPaymentMethodMutation = { __typename?: 'Mutation', addPaymentMethod: { __typename?: 'AddPaymentMethodResult', requiresAction: boolean, actionTokenId?: Maybe<string>, paymentMethod?: Maybe<{ __typename?: 'PaymentMethod', id: string, primary: boolean }> } };

export type SetPrimaryRecurlyPaymentMethodMutationVariables = Exact<{
  input: PaymentMethodRef;
}>;


export type SetPrimaryRecurlyPaymentMethodMutation = { __typename?: 'Mutation', setPrimaryPaymentMethod: { __typename?: 'PaymentMethod', id: string, primary: boolean } };

export type RemoveRecurlyPaymentMethodMutationVariables = Exact<{
  input: PaymentMethodRef;
}>;


export type RemoveRecurlyPaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethodV2: boolean };

export type RecurlyInvoicesQueryVariables = Exact<{
  companyId: Scalars['ID'];
  first: Scalars['Int'];
}>;


export type RecurlyInvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', hasNextPage: boolean, endCursor?: Maybe<string>, nodes: Array<{ __typename?: 'Invoice', id: string, number: string, state: string, type?: Maybe<string>, createdAt?: Maybe<any>, paidAt?: Maybe<any>, pdfUrl: string, total: { __typename?: 'Money', amount: string, currency: string }, lines?: Maybe<Array<{ __typename?: 'InvoiceLine', description?: Maybe<string>, planCode?: Maybe<string>, addOnCode?: Maybe<string>, type?: Maybe<string> }>> }> } };

export type SetDefaultBillingPaymentMethodMutationVariables = Exact<{
  input: SetDefaultPaymentMethodInput;
}>;


export type SetDefaultBillingPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: { __typename?: 'BillingPaymentMethod', id: string, default: boolean, status: PaymentMethodStatus, type: PaymentMethodType, name: string, expirationDate?: Maybe<any> } };

export type GetAvailableProductsQueryVariables = Exact<{
  data: GetAvailableProductsInput;
}>;


export type GetAvailableProductsQuery = { __typename?: 'Query', getAvailableProducts: Array<{ __typename?: 'AvailableProduct', id: string, key: ProductKey, name?: Maybe<string>, tier?: Maybe<number>, billingPeriod?: Maybe<string>, monthlyAllowance?: Maybe<number>, subscriptionPrice?: Maybe<number>, price?: Maybe<number>, allowance?: Maybe<number>, discountedPrice?: Maybe<number> }> };

export type GetCompanyCreditsQueryVariables = Exact<{
  data: GetCompanyCreditsInputV2;
}>;


export type GetCompanyCreditsQuery = { __typename?: 'Query', getCompanyCreditsV2: Array<{ __typename?: 'Credit', id: string, createdAt: any, productKey: ProductKey, creditType: ProductCreditType }> };

export type ReactivatePausedCompanyMutationVariables = Exact<{
  input: ReactivatePausedCompanyInput;
}>;


export type ReactivatePausedCompanyMutation = { __typename?: 'Mutation', reactivatePausedCompany: boolean };

export type PremiumPeopleAddonPlanForCompanyQueryVariables = Exact<{
  companyId?: Maybe<Scalars['String']>;
}>;


export type PremiumPeopleAddonPlanForCompanyQuery = { __typename?: 'Query', premiumPeopleAddonPlanForCompany: { __typename?: 'BambeeGenericPlanModel', serviceKey: ServiceKey, productKey: ProductKey, name: string, value: string, priceId: string, price?: Maybe<number>, billingPeriod: BillingPeriod, status: PlanStatuses } };

export type PremiumPeopleCorePlansQueryVariables = Exact<{
  companyId?: Maybe<Scalars['ID']>;
}>;


export type PremiumPeopleCorePlansQuery = { __typename?: 'Query', premiumPeopleCorePlans: Array<{ __typename?: 'CorePlanModel', priceId: string, productKey: ProductKey, name: string, value: string, billingPeriod: BillingPeriod, tierNumber?: Maybe<number>, minSize?: Maybe<number>, maxSize?: Maybe<number>, price: number, monthlyPrice: number, status: PlanStatuses }> };

export type CreatePremiumPeopleAddonSubscriptionMutationVariables = Exact<{
  data: CreatePremiumPeopleAddonInput;
}>;


export type CreatePremiumPeopleAddonSubscriptionMutation = { __typename?: 'Mutation', createPremiumPeopleAddonSubscription: { __typename?: 'Subscription', name: string, status: SubscriptionStatus, stripeId: string, stripePriceId: string, productCode: ProductKey, planValue: string, amount: number, startDate: any, endDate: any, isDrp: boolean } };

export type GetCancellationReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCancellationReasonsQuery = { __typename?: 'Query', activeCancellationReasonGroups: Array<{ __typename?: 'CancellationReasonGroupModel', code: string, externalText: string, reasons: Array<{ __typename?: 'CancellationReasonModel', code: number, externalText: string }> }> };

export type GetCancellationOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCancellationOffersQuery = { __typename?: 'Query', cancellationOffers: { __typename?: 'CancellationOffersModel', trialExtension: boolean, downgradePlans: Array<{ __typename?: 'CorePlanModel', productKey: ProductKey }>, pausePlan?: Maybe<{ __typename?: 'CorePlanModel', productKey: ProductKey }>, storagePlan?: Maybe<{ __typename?: 'CorePlanModel', productKey: ProductKey }> } };

export type AcceptOfferMutationVariables = Exact<{
  input: AcceptOfferInput;
}>;


export type AcceptOfferMutation = { __typename?: 'Mutation', acceptOffer: boolean };

export type AcceptTrialExtensionMutationVariables = Exact<{
  input: AcceptTrialOfferInput;
}>;


export type AcceptTrialExtensionMutation = { __typename?: 'Mutation', acceptTrialOffer: boolean };

export type SubmitCancelRequestMutationVariables = Exact<{
  input: CreateCancellationRequestInput;
}>;


export type SubmitCancelRequestMutation = { __typename?: 'Mutation', createCancellationRequest: { __typename?: 'CancellationModel', clientReasonNote: string } };

export type GetCompanySettingsQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type GetCompanySettingsQuery = { __typename?: 'Query', getCompanySettings: Array<{ __typename?: 'CompanySetting', id: number, key: CompanySettingKey, type: SettingType, value: string }> };

export type ListPracticeQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type ListPracticeQuery = { __typename?: 'Query', listPractice: Array<{ __typename?: 'Practice', id: string, companyId: string, title: string, shortDescription: string, description: string, introDescription: string, shortName: string, iconUrl: string, illustrationUrl: string, outroIllustrationUrl: string, successOutroTitle: string, status: PracticeStatuses, state: PracticeState, setupProgress: PracticeSetupProgress, survey: { __typename?: 'Survey', id: number, type: string, completedAt?: Maybe<any> } }> };

export type GetPracticeQueryVariables = Exact<{
  input: GetPracticeInput;
}>;


export type GetPracticeQuery = { __typename?: 'Query', getPractice: { __typename?: 'Practice', id: string, companyId: string, title: string, shortDescription: string, description: string, introDescription: string, shortName: string, iconUrl: string, illustrationUrl: string, outroIllustrationUrl: string, successOutroTitle: string, status: PracticeStatuses, state: PracticeState, setupProgress: PracticeSetupProgress, survey: { __typename?: 'Survey', id: number, type: string, completedAt?: Maybe<any>, questions: any, answers: any } } };

export type GetHrScoreQueryVariables = Exact<{
  companyId: Scalars['String'];
}>;


export type GetHrScoreQuery = { __typename?: 'Query', getHrScore: HrScore };

export type GetCompanySurveyQueryVariables = Exact<{
  data: GetCompanySurveyInput;
}>;


export type GetCompanySurveyQuery = { __typename?: 'Query', companySurvey: { __typename?: 'Survey', id: number, type: string, completedAt?: Maybe<any>, questions: any, answers: any } };

export type SaveCompanyAnswerMutationVariables = Exact<{
  data: SaveCompanyAnswerInput;
}>;


export type SaveCompanyAnswerMutation = { __typename?: 'Mutation', saveCompanyAnswer: { __typename?: 'Survey', id: number, type: string, completedAt?: Maybe<any>, questions: any, answers: any } };

export type CompleteCompanySurveyMutationVariables = Exact<{
  data: CompleteCompanySurveyInput;
}>;


export type CompleteCompanySurveyMutation = { __typename?: 'Mutation', completeCompanySurvey: { __typename?: 'Survey', id: number, type: string, completedAt?: Maybe<any> } };

export type CompleteCompanyPracticeMutationVariables = Exact<{
  data: CompletePracticeInput;
}>;


export type CompleteCompanyPracticeMutation = { __typename?: 'Mutation', completeCompanyPractice: { __typename?: 'Practice', id: string, status: PracticeStatuses, state: PracticeState } };

export type GetBasicCompanyInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBasicCompanyInfoQuery = { __typename?: 'Query', coreCompany: { __typename?: 'CoreCompany', id: string, name: string, industry?: Maybe<string>, phone?: Maybe<string> } };

export type UpdateBasicCompanyInfoMutationVariables = Exact<{
  data: UpdateCoreCompanyInput;
}>;


export type UpdateBasicCompanyInfoMutation = { __typename?: 'Mutation', updateCoreCompany: { __typename?: 'CoreCompany', id: string, name: string, industry?: Maybe<string>, phone?: Maybe<string> } };

export type GetSimplePolicyListQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetSimplePolicyListQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', policies: Array<{ __typename?: 'CorePolicy', id: string, name: string, isCPD: boolean, archivedAt?: Maybe<any>, status: string, step?: Maybe<PolicyStepNames> }> } };

export type SaveCompanySettingMutationVariables = Exact<{
  input: SaveCompanySettingInput;
}>;


export type SaveCompanySettingMutation = { __typename?: 'Mutation', saveCompanySetting: { __typename?: 'CompanySetting', id: number, companyId: string, key: CompanySettingKey, type: SettingType, value: string } };

export type BulkMessageStaffMutationVariables = Exact<{
  data: BulkMessageStaffInput;
}>;


export type BulkMessageStaffMutation = { __typename?: 'Mutation', bulkMessageStaff: { __typename?: 'BulkMessageStaffResult', successfulStaffIds: Array<Maybe<string>>, errors: Array<Maybe<{ __typename?: 'BulkMessageStaffError', staffId: string, errorMsg: string }>> } };

export type GetCompanyRolesQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetCompanyRolesQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', companyRoles?: Maybe<Array<{ __typename?: 'CompanyRole', id: string, title: string, createdAt: any, deletedAt?: Maybe<any>, workerRoles?: Maybe<Array<{ __typename?: 'WorkerRole', id: string }>> }>> } };

export type CreateCompanyRolesMutationVariables = Exact<{
  data: CreateMultipleRolesForCompanyInput;
}>;


export type CreateCompanyRolesMutation = { __typename?: 'Mutation', createCompanyRoles: Array<{ __typename?: 'CompanyRole', id: string, title: string, createdAt: any, deletedAt?: Maybe<any>, workerRoles?: Maybe<Array<{ __typename?: 'WorkerRole', id: string }>> }> };

export type UpdateCompanyRolesMutationVariables = Exact<{
  data: UpdateMultipleRolesForCompanyInput;
}>;


export type UpdateCompanyRolesMutation = { __typename?: 'Mutation', updateCompanyRoles: Array<{ __typename?: 'CompanyRole', id: string, title: string, createdAt: any, deletedAt?: Maybe<any>, workerRoles?: Maybe<Array<{ __typename?: 'WorkerRole', id: string }>> }> };

export type DeleteCompanyRolesMutationVariables = Exact<{
  data: DeleteCompanyRolesInput;
}>;


export type DeleteCompanyRolesMutation = { __typename?: 'Mutation', deleteCompanyRolesById?: Maybe<Array<{ __typename?: 'CompanyRole', id: string, title: string, deletedAt?: Maybe<any> }>> };

export type GetPendingHotlineCallsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingHotlineCallsQuery = { __typename?: 'Query', pendingHotlineCall?: Maybe<{ __typename?: 'HotlineCall', id: string, status: HotlineCallStatus, summary?: Maybe<string> }> };

export type GetHotlineCallsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHotlineCallsQuery = { __typename?: 'Query', hotlineCalls: Array<{ __typename?: 'HotlineCall', id: string, createdAt: any, callPlacedAt?: Maybe<any>, callDuration?: Maybe<number>, status: HotlineCallStatus, summary?: Maybe<string>, agent?: Maybe<{ __typename?: 'HotlineCallAgent', id: string, avatarUrl?: Maybe<string>, name?: Maybe<string> }> }> };

export type CancelPendingHotlineCallMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelPendingHotlineCallMutation = { __typename?: 'Mutation', cancelPendingHotlineCall: boolean };

export type EnqueueHotlineCallMutationVariables = Exact<{
  data: EnqueueHotlineCallInput;
}>;


export type EnqueueHotlineCallMutation = { __typename?: 'Mutation', enqueueHotlineCall: boolean };

export type VoicesFeedbackPartsFragment = { __typename?: 'VoicesFeedback', id: number, companyPersonId?: Maybe<string>, feedback: string, anonymous: boolean, satisfactionRatingOfFive?: Maybe<number>, createdAt: any, updatedAt: any };

export type GetMyVoicesFeedbackListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyVoicesFeedbackListQuery = { __typename?: 'Query', getMyVoicesFeedbackList: Array<{ __typename?: 'VoicesFeedback', id: number, companyPersonId?: Maybe<string>, feedback: string, anonymous: boolean, satisfactionRatingOfFive?: Maybe<number>, createdAt: any, updatedAt: any }> };

export type CreateVoicesFeedbackMutationVariables = Exact<{
  input: CreateVoicesFeedbackInput;
}>;


export type CreateVoicesFeedbackMutation = { __typename?: 'Mutation', createVoicesFeedback: { __typename?: 'VoicesFeedback', id: number, companyPersonId?: Maybe<string>, feedback: string, anonymous: boolean, satisfactionRatingOfFive?: Maybe<number>, createdAt: any, updatedAt: any } };

export type GetMyCompanyVoicesFeedbackListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCompanyVoicesFeedbackListQuery = { __typename?: 'Query', getMyCompanyVoicesFeedbackList: Array<{ __typename?: 'VoicesFeedback', id: number, companyPersonId?: Maybe<string>, feedback: string, anonymous: boolean, satisfactionRatingOfFive?: Maybe<number>, createdAt: any, updatedAt: any }> };

export type TerminationPartsFragment = { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } };

export type TerminationDownloadPartsFragment = { __typename?: 'TerminationDownload', file: string, terminationId: string };

export type GetTerminationListQueryVariables = Exact<{
  data: GetTerminationsInput;
}>;


export type GetTerminationListQuery = { __typename?: 'Query', terminationList: Array<{ __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } }> };

export type GetTerminationInfoQueryVariables = Exact<{
  data: GetTerminationInput;
}>;


export type GetTerminationInfoQuery = { __typename?: 'Query', terminationInfo: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type TerminationDownloadQueryVariables = Exact<{
  data: GetTerminationInput;
}>;


export type TerminationDownloadQuery = { __typename?: 'Query', terminationDownload: { __typename?: 'TerminationDownload', file: string, terminationId: string } };

export type CancelTerminationMutationVariables = Exact<{
  data: TerminationCancelInput;
}>;


export type CancelTerminationMutation = { __typename?: 'Mutation', cancelTermination: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ConfirmTerminationMutationVariables = Exact<{
  data: TerminationConfirmationInput;
}>;


export type ConfirmTerminationMutation = { __typename?: 'Mutation', confirmTermination: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type EditTerminationDetailsMutationVariables = Exact<{
  data: TerminationEditDetailsInput;
}>;


export type EditTerminationDetailsMutation = { __typename?: 'Mutation', editTerminationDetails: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type AttachTerminationFilesMutationVariables = Exact<{
  data: TerminationAttachInput;
}>;


export type AttachTerminationFilesMutation = { __typename?: 'Mutation', attachTerminationFiles: { __typename?: 'Termination', complete: boolean, createdAt: any, employeeId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, terminationId: string, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ResignationPartsFragment = { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } };

export type GetResignationListQueryVariables = Exact<{
  data: GetResignationsInput;
}>;


export type GetResignationListQuery = { __typename?: 'Query', resignationList: Array<{ __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } }> };

export type ResignationDownloadPartsFragment = { __typename?: 'ResignationDownload', file: string, resignationId: string };

export type AttachResignationFilesMutationVariables = Exact<{
  data: ResignationAttachInput;
}>;


export type AttachResignationFilesMutation = { __typename?: 'Mutation', attachResignationFiles: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ResignationInfoQueryVariables = Exact<{
  data: GetResignationInput;
}>;


export type ResignationInfoQuery = { __typename?: 'Query', resignationInfo: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ResignationDownloadQueryVariables = Exact<{
  data: GetResignationInput;
}>;


export type ResignationDownloadQuery = { __typename?: 'Query', resignationDownload: { __typename?: 'ResignationDownload', file: string, resignationId: string } };

export type CancelResignationMutationVariables = Exact<{
  data: ResignationCancelInput;
}>;


export type CancelResignationMutation = { __typename?: 'Mutation', cancelResignation: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type ConfirmResignationMutationVariables = Exact<{
  data: ResignationConfirmationInput;
}>;


export type ConfirmResignationMutation = { __typename?: 'Mutation', confirmResignation: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type EditResignationMutationVariables = Exact<{
  data: ResignationEditDetailsInput;
}>;


export type EditResignationMutation = { __typename?: 'Mutation', editResignationDetails: { __typename?: 'Resignation', complete: boolean, confirmed: boolean, createdAt: any, employeeId: string, hrRequestVersion: boolean, resignationDate?: Maybe<any>, resignationId: string, resignationState?: Maybe<string>, startDate?: Maybe<any>, status: ResignationStatus, step: ResignationStep, userId: string, employee: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, manager: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> }, signedFiles: Array<{ __typename?: 'FileStackModel', filename: string, name: string, url: string }>, user: { __typename?: 'User', id: string, isContractor?: Maybe<boolean>, name?: Maybe<string>, profile?: Maybe<{ __typename?: 'UserProfile', firstName?: Maybe<string>, lastName?: Maybe<string>, role?: Maybe<string>, stateWorkIn?: Maybe<string> }> } } };

export type WarningDocumentsQueryVariables = Exact<{
  data: GetUserWarningDocumentsInput;
}>;


export type WarningDocumentsQuery = { __typename?: 'Query', warningDocuments: Array<{ __typename?: 'WarningDocument', createdAt: any, name: string, type: string, id: string }> };

export type JobDescriptionPartsFragment = { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> };

export type EmployeeJobDescriptionPartsFragment = { __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type CreateJobDescriptionMutationVariables = Exact<{
  data: CreateJobDescriptionInput;
}>;


export type CreateJobDescriptionMutation = { __typename?: 'Mutation', createJobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type UpdateJobDescriptionMutationVariables = Exact<{
  data: UpdateJobDescriptionInput;
}>;


export type UpdateJobDescriptionMutation = { __typename?: 'Mutation', updateJobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type CompleteJobDescriptionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompleteJobDescriptionMutation = { __typename?: 'Mutation', completeJobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type GenerateAiJobDescriptionMutationVariables = Exact<{
  data: GenerateAiJobDescriptionInput;
}>;


export type GenerateAiJobDescriptionMutation = { __typename?: 'Mutation', generateAiJobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type GenerateAiJobDescriptionV2MutationVariables = Exact<{
  data: GenerateAiJobDescriptionInputV2;
}>;


export type GenerateAiJobDescriptionV2Mutation = { __typename?: 'Mutation', generateAiJobDescriptionV2: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } };

export type SendJobDescriptionToEmployeeMutationVariables = Exact<{
  data: SendJobDescriptionToEmployeeInput;
}>;


export type SendJobDescriptionToEmployeeMutation = { __typename?: 'Mutation', sendJobDescriptionToEmployee: { __typename?: 'EmployeeJobDescription', id: string, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } } };

export type GetEmployeeJobDescriptionQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetEmployeeJobDescriptionQuery = { __typename?: 'Query', getEmployeeJobDescription?: Maybe<{ __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } }> };

export type SignEmployeeJobDescriptionMutationVariables = Exact<{
  signEmployeeJobDescriptionId: Scalars['String'];
}>;


export type SignEmployeeJobDescriptionMutation = { __typename?: 'Mutation', signEmployeeJobDescription: { __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } } };

export type GetJobDescriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobDescriptionsQuery = { __typename?: 'Query', jobDescriptions: Array<{ __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> }> };

export type GetStaffJobDescriptionsQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type GetStaffJobDescriptionsQuery = { __typename?: 'Query', getMyCoreUser: { __typename?: 'CoreUser', id: string, company?: Maybe<{ __typename?: 'CoreCompany', id: string, paginatedEmployees: { __typename?: 'PaginatedCoreUsers', id: string, page: number, totalPages: number, totalCount: number, result: Array<{ __typename?: 'CoreUser', id: string, active: boolean, profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, title?: Maybe<string>, workerRoles: Array<{ __typename?: 'WorkerRole', id: string, userId: string, isPrimary: boolean, employeeJobDescription?: Maybe<{ __typename?: 'EmployeeJobDescription', id: string, signedAt?: Maybe<any>, createdAt: any, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } }> }> }> }> } }> } };

export type GetMfaEnrollmentsQueryVariables = Exact<{
  includeUnconfirmed?: Maybe<Scalars['Boolean']>;
}>;


export type GetMfaEnrollmentsQuery = { __typename?: 'Query', getMyMfaEnrollments: Array<{ __typename?: 'AuthMfaConfig', id: string, mfaType: AuthMfaType, createdAt: any, lastChallengedAt?: Maybe<any> }> };

export type CreateMfaChallengeMutationVariables = Exact<{
  reason: Scalars['String'];
  type: AuthMfaType;
}>;


export type CreateMfaChallengeMutation = { __typename?: 'Mutation', createChallenge: { __typename?: 'AuthMfaChallenge', nonce: string, metadata?: Maybe<{ __typename?: 'AuthMfaMetadata', phoneLast4?: Maybe<string> }> } };

export type EnrollMfaDeviceMutationVariables = Exact<{
  input: AuthMfaSmsEnrollmentInput;
}>;


export type EnrollMfaDeviceMutation = { __typename?: 'Mutation', enrollMfaDevice: { __typename?: 'AuthMfaChallenge', nonce: string, metadata?: Maybe<{ __typename?: 'AuthMfaMetadata', phoneLast4?: Maybe<string> }> } };

export type ResendChallengeMutationVariables = Exact<{
  nonceId: Scalars['String'];
  reason: Scalars['String'];
  type: AuthMfaType;
}>;


export type ResendChallengeMutation = { __typename?: 'Mutation', resendChallenge: { __typename?: 'AuthMfaChallenge', nonce: string, metadata?: Maybe<{ __typename?: 'AuthMfaMetadata', phoneLast4?: Maybe<string> }> } };

export type ConfirmUserMfaEnrollmentMutationVariables = Exact<{
  input: AuthMfaChallengeResponseInput;
}>;


export type ConfirmUserMfaEnrollmentMutation = { __typename?: 'Mutation', confirmUserMfaEnrollment: { __typename?: 'AuthMfaConfig', id: string, mfaType: AuthMfaType } };

export type GetMigrationPricingQueryVariables = Exact<{
  tierNumber: Scalars['Float'];
  input: ActivePlanFilters;
}>;


export type GetMigrationPricingQuery = { __typename?: 'Query', getLatestPricingPackagesForTier: { __typename?: 'PricingPackageResponse', packages: Array<{ __typename?: 'PricingPackage', productKey: ProductKey, plans: Array<Maybe<{ __typename?: 'CorePlanModel', productKey: ProductKey, name: string, value: string, priceId: string, price: number, monthlyPrice: number, billingPeriod: BillingPeriod, tierNumber?: Maybe<number>, collectTax: boolean }>> }> } };

export type GetMigrationHeadcountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMigrationHeadcountQuery = { __typename?: 'Query', coreCompany: { __typename?: 'CoreCompany', id: string, name: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string }> } };

export type SelectMigrationPlanMutationVariables = Exact<{
  input: SelectMigrationPlanInput;
}>;


export type SelectMigrationPlanMutation = { __typename?: 'Mutation', selectMigrationPlan: { __typename?: 'BillingMigrationRecord', id: string, level: BillingMigrationLevel, selectedProductKey: ProductKey, recommendedProductKey: ProductKey, originalProductKey: ProductKey, isExplicitSelection: boolean, confirmedAt?: Maybe<any>, tierNumber: number, employeeCount: number, monthlyAmount: number, planValue: string } };

export type MyNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyNotificationsQuery = { __typename?: 'Query', myNotifications: Array<{ __typename?: 'Notification', id: string, level: NotificationLevel, subject?: Maybe<string>, body: string, dismissible: boolean, dismissedAt?: Maybe<any>, createdAt: any, targets: Array<{ __typename?: 'NotificationTarget', id: string, type: NotificationTargetType }>, actions?: Maybe<Array<{ __typename?: 'NotificationAction', id: string, label: string, type: NotificationActionType, value: string }>> }> };

export type DismissNotificationMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DismissNotificationMutation = { __typename?: 'Mutation', dismissNotification: { __typename?: 'Notification', id: string, dismissedAt?: Maybe<any> } };

export type ClickedOnNotificationActionMutationVariables = Exact<{
  actionId: Scalars['String'];
}>;


export type ClickedOnNotificationActionMutation = { __typename?: 'Mutation', clickedOnNotificationAction: boolean };

export type IsEventScheduledForUserQueryVariables = Exact<{
  email: Scalars['String'];
  eventSlug: Scalars['String'];
}>;


export type IsEventScheduledForUserQuery = { __typename?: 'Query', isEventScheduledForUser: { __typename?: 'IsEventScheduledForUser', email: string, eventSlug: string, isScheduled: boolean } };

export type FindOnboardingStatusQueryVariables = Exact<{
  data: CoreOnboardingKeys;
}>;


export type FindOnboardingStatusQuery = { __typename?: 'Query', findOnboarding?: Maybe<{ __typename?: 'CoreOnboarding', id: string, status: OnboardingStatus, data: { __typename?: 'CoreOnboardingData', id: string, progress?: Maybe<number>, callEventId?: Maybe<string> } }> };

export type UpsertEmployerOnboardingMutationVariables = Exact<{
  data: CoreOnboardingInput;
}>;


export type UpsertEmployerOnboardingMutation = { __typename?: 'Mutation', upsertOnboarding: { __typename?: 'CoreOnboarding', id: string, status: OnboardingStatus, data: { __typename?: 'CoreOnboardingData', id: string, progress?: Maybe<number>, callEventId?: Maybe<string> } } };

export type FindOnboardingQueryVariables = Exact<{
  data: CoreOnboardingKeys;
  id: Scalars['ID'];
}>;


export type FindOnboardingQuery = { __typename?: 'Query', findOnboarding?: Maybe<{ __typename?: 'CoreOnboarding', id: string, status: OnboardingStatus, version: number, data: { __typename?: 'CoreOnboardingData', id: string, progress?: Maybe<number>, callEventId?: Maybe<string>, companyLegalName?: Maybe<string>, fein?: Maybe<string>, discussionTopics?: Maybe<Array<Maybe<DiscussionTopic>>>, nextAction?: Maybe<NextOnboardingAction>, numOfEmployees?: Maybe<number>, numOfContractors?: Maybe<number>, hasRemoteEmployees?: Maybe<boolean>, remoteWorkerStates?: Maybe<Array<Maybe<StateAbbreviation>>>, address?: Maybe<{ __typename?: 'CoreAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zipCode?: Maybe<string> }> } }>, coreCompany: { __typename?: 'CoreCompany', name: string, whatBroughtYouToBambee?: Maybe<LeadReason> } };

export type AssignUserToPolicyMutationVariables = Exact<{
  data: AssignUserToPoliciesInput;
}>;


export type AssignUserToPolicyMutation = { __typename?: 'Mutation', assignUserToPolicies: Array<{ __typename?: 'CoreDocument', id: string, name: string, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }> };

export type AssignUsersToPoliciesMutationVariables = Exact<{
  data: AssignUsersToPoliciesInput;
}>;


export type AssignUsersToPoliciesMutation = { __typename?: 'Mutation', assignUsersToPolicies: Array<{ __typename?: 'CoreUser', id: string, documents?: Maybe<Array<{ __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }>> }> };

export type ReaffirmEmployeeDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type ReaffirmEmployeeDocumentMutation = { __typename?: 'Mutation', reaffirmDocument: { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>> } };

export type ArchivePolicyMutationVariables = Exact<{
  input: ArchivePolicyInput;
}>;


export type ArchivePolicyMutation = { __typename?: 'Mutation', archivePolicy?: Maybe<{ __typename?: 'CorePolicy', id: string }> };

export type CoreDocumentSignaturePartsFragment = { __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> };

export type CoreDocumentPartsFragment = { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> };

export type CoreUserStatesPartsFragment = { __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean };

export type CoreUserPartsFragment = { __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> };

export type CorePolicyPartsFragment = { __typename?: 'CorePolicy', id: string, isCPD: boolean, name: string, icon: string, status: string, isContractor: boolean, step?: Maybe<PolicyStepNames>, recipients: Array<{ __typename?: 'CorePolicyRecipient', id: string, document: { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }, employee: { __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> } }>, notSentTo: Array<{ __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> }> };

export type GetPolicyQueryVariables = Exact<{
  input: GetPolicy;
}>;


export type GetPolicyQuery = { __typename?: 'Query', getPolicy?: Maybe<{ __typename?: 'CorePolicy', id: string, isCPD: boolean, name: string, icon: string, status: string, isContractor: boolean, step?: Maybe<PolicyStepNames>, recipients: Array<{ __typename?: 'CorePolicyRecipient', id: string, document: { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }, employee: { __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> } }>, notSentTo: Array<{ __typename?: 'CoreUser', id: string, active: boolean, roles: Array<string>, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, states?: Maybe<{ __typename?: 'CoreUserStates', id: string, emailNotification: boolean, onboardRequest: boolean, onboarded: boolean, terminationRequest: boolean, terminated: boolean, selfSignupRegistered: boolean, selfSignupActivated: boolean, resignationLastDate?: Maybe<any>, resignationStatus?: Maybe<string>, viewedOnboardingInstructions?: Maybe<CoreUserViewedOnboardingInstructions>, viewedInsuranceIntroduction: boolean, interestedInPersonalInsurance: boolean, viewedPersonalInsurance: boolean, viewedCovid: boolean, viewedTaskCenter: boolean, viewedVideoTourBusinessHealth: boolean, viewedVideoTourCabinet: boolean, viewedVideoTourPolicy: boolean, viewedVideoTourReportCards: boolean, viewedVideoTourStaffFolder: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string>, isContractor?: Maybe<boolean> }>, permissions?: Maybe<{ __typename?: 'CoreUserPermissions', manager: boolean, approver: boolean }> }> }> };

export type ReaffirmDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type ReaffirmDocumentMutation = { __typename?: 'Mutation', reaffirmDocument: { __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> } };

export type GetCompanyPoliciesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyPoliciesQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', policies: Array<{ __typename?: 'CorePolicy', id: string, name: string, icon: string, isCPD: boolean, archivedAt?: Maybe<any>, status: string, step?: Maybe<PolicyStepNames> }> } };

export type AssignUserToPoliciesMutationVariables = Exact<{
  data: AssignUserToPoliciesInput;
}>;


export type AssignUserToPoliciesMutation = { __typename?: 'Mutation', assignUserToPolicies: Array<{ __typename?: 'CoreDocument', id: string, name: string }> };

export type PolicyDataTableQueryVariables = Exact<{
  page: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type PolicyDataTableQuery = { __typename?: 'Query', getMyCoreUser: { __typename?: 'CoreUser', id: string, company?: Maybe<{ __typename?: 'CoreCompany', id: string, policies: Array<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any>, isCPD: boolean, createdAt?: Maybe<any>, status: string, recipients: Array<{ __typename?: 'CorePolicyRecipient', id: string, document: { __typename?: 'CoreDocument', reaffirmations?: Maybe<Array<any>>, id: string, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, signedAt: any }> } }> }> }> } };

export type GetPricingPackagesQueryVariables = Exact<{
  input: PricingPackageFilterInput;
}>;


export type GetPricingPackagesQuery = { __typename?: 'Query', getPricingPackages: { __typename?: 'PricingPackageResponse', packages: Array<{ __typename?: 'PricingPackage', productKey: ProductKey, plans: Array<Maybe<{ __typename?: 'CorePlanModel', name: string, productKey: ProductKey, value: string, tierNumber?: Maybe<number>, monthlyPrice: number, price: number, billingPeriod: BillingPeriod, version: string }>> }> } };

export type GetUpgradeOptionsQueryVariables = Exact<{
  input: GetCoreUpgradeOptionsInput;
}>;


export type GetUpgradeOptionsQuery = { __typename?: 'Query', coreUpgradeOptions: Array<{ __typename?: 'PreviewCorePlanChangeModel', plan: { __typename?: 'CorePlanModel', name: string, productKey: ProductKey, value: string, tierNumber?: Maybe<number>, monthlyPrice: number, price: number, billingPeriod: BillingPeriod, version: string }, upcoming: { __typename?: 'UpcomingCorePlanChangeInvoice', total: number, totalDue: number, remainingAmount: number, tax: number, unusedAmount: number } }> };

export type UpgradeCorePlanMutationVariables = Exact<{
  input: UpgradeCorePlanInput;
}>;


export type UpgradeCorePlanMutation = { __typename?: 'Mutation', upgradeCorePlan: { __typename?: 'Subscription', name: string, status: SubscriptionStatus, startDate: any, endDate: any, stripeId: string, stripePriceId: string, isDrp: boolean } };

export type GetProductInterestQueryVariables = Exact<{
  input: GetProductInterestInput;
}>;


export type GetProductInterestQuery = { __typename?: 'Query', productInterest: Array<{ __typename?: 'ProductInterest', id: string }> };

export type TrackProductInterestMutationVariables = Exact<{
  data: ProductInterestInput;
}>;


export type TrackProductInterestMutation = { __typename?: 'Mutation', trackProductInterest: string };

export type CreateReportCardMutationVariables = Exact<{
  data: CreateReportCardInput;
}>;


export type CreateReportCardMutation = { __typename?: 'Mutation', createReportCard: { __typename: 'NewReportCard', existing: boolean, report: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } } };

export type UpdateReportCardMutationVariables = Exact<{
  data: UpdateReportCardInput;
}>;


export type UpdateReportCardMutation = { __typename?: 'Mutation', updateReportCard: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } };

export type CompleteReportCardMutationVariables = Exact<{
  data: CompleteReportCardInput;
}>;


export type CompleteReportCardMutation = { __typename?: 'Mutation', completeReportCard: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } };

export type ReportCardUserPartsFragment = { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> };

export type ReportCardEmployeeGradePartsFragment = { __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } };

export type ManagedReportPartsFragment = { __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } };

export type ReportCardPartsFragment = { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> };

export type NewReportCardPartsFragment = { __typename: 'NewReportCard', existing: boolean, report: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } };

export type GetReportCardListQueryVariables = Exact<{
  data: ListReportCardsInput;
}>;


export type GetReportCardListQuery = { __typename?: 'Query', listReportCards: Array<{ __typename?: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, employees: Array<{ __typename?: 'ReportCardEmployeeGrade', id: string, grade: string }> }> };

export type GetReportCardQueryVariables = Exact<{
  data: GetReportCardInput;
}>;


export type GetReportCardQuery = { __typename?: 'Query', getReportCard: { __typename: 'ReportCard', id: string, cadence: string, createdAt: any, status: ReportCardStatusValues, directReports?: Maybe<Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>>, employees: Array<{ __typename: 'ReportCardEmployeeGrade', id: string, feedback: string, grade: string, note: string, status: string, employee: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }, gradedBy: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>, managerReports?: Maybe<Array<{ __typename: 'ManagedReport', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> }>, manager: { __typename?: 'CoreUser', id: string, role: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean> }> } }>> } };

export type CompleteSolutionMutationVariables = Exact<{
  input: CompleteSolutionInput;
}>;


export type CompleteSolutionMutation = { __typename?: 'Mutation', completeSolution: { __typename?: 'Solution', id: string, completedAt?: Maybe<any>, completedBy?: Maybe<string> } };

export type GetSolutionsQueryVariables = Exact<{
  input: GetSolutionsInput;
}>;


export type GetSolutionsQuery = { __typename?: 'Query', getSolutions: Array<{ __typename?: 'Solution', id: string, slug: string, completedAt?: Maybe<any>, destination: string, action?: Maybe<any> }> };

export type GetFullStaffQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetFullStaffQuery = { __typename?: 'Query', getCoreCompany: { __typename?: 'CoreCompany', id: string, employees: Array<{ __typename?: 'CoreUser', id: string, active: boolean, employment?: Maybe<{ __typename?: 'CoreUserEmployment', id: string, contractorBusinessName?: Maybe<string>, isContractor?: Maybe<boolean>, contractorType?: Maybe<CoreContractorType>, employeeType?: Maybe<CoreEmployeeType>, payRate?: Maybe<string>, payType?: Maybe<CoreEmployeePaytype>, startDate?: Maybe<string>, title?: Maybe<string> }>, profile?: Maybe<{ __typename?: 'CoreUserProfile', id: string, firstName: string, lastName: string, dob?: Maybe<any>, phone?: Maybe<string>, email: string, address?: Maybe<{ __typename?: 'CoreAddress', city?: Maybe<string>, line1?: Maybe<string>, line2?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string> }> }> }> } };

export type GetUserEditInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserEditInfoQuery = { __typename?: 'Query', getCoreUserById: { __typename?: 'CoreUser', id: string, profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, email: string, phone?: Maybe<string>, dob?: Maybe<any>, address?: Maybe<{ __typename?: 'CoreAddress', line1?: Maybe<string>, line2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zipCode?: Maybe<string> }> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', isContractor?: Maybe<boolean>, contractorBusinessName?: Maybe<string>, contractorType?: Maybe<CoreContractorType>, employeeType?: Maybe<CoreEmployeeType>, startDate?: Maybe<string>, stateWorksIn?: Maybe<string>, workerRoles: Array<{ __typename?: 'WorkerRole', id: string, isPrimary: boolean, payRate: number, payType: WorkerRolePaytype, companyRole?: Maybe<{ __typename?: 'CompanyRole', title: string }> }> }> } };

export type GetUserRolesQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetUserRolesQuery = { __typename?: 'Query', getCoreUserById: { __typename?: 'CoreUser', id: string, employment?: Maybe<{ __typename?: 'CoreUserEmployment', workerRoles: Array<{ __typename?: 'WorkerRole', id: string, isPrimary: boolean, payRate: number, payType: WorkerRolePaytype, companyRole?: Maybe<{ __typename?: 'CompanyRole', id: string, title: string }> }> }> } };

export type AssignWorkerRolesMutationVariables = Exact<{
  input: AssignWorkerRolesInput;
}>;


export type AssignWorkerRolesMutation = { __typename?: 'Mutation', assignWorkerRoles: { __typename?: 'CoreUser', id: string } };

export type CreateHrRequestMutationVariables = Exact<{
  input: CreateHrRequestInput;
}>;


export type CreateHrRequestMutation = { __typename?: 'Mutation', createHrRequest: { __typename?: 'HrRequest', id: string, intercomConversationId?: Maybe<string>, caseId: string } };

export type ReplyToConversationMutationVariables = Exact<{
  input: ReplyToConversationInput;
}>;


export type ReplyToConversationMutation = { __typename?: 'Mutation', replyToConversation: { __typename?: 'Conversation', id: string, intercomConversationId: string, messages: Array<{ __typename?: 'ConversationMessage', body?: Maybe<string>, createdAt: any, inBound: boolean, attachments?: Maybe<Array<{ __typename?: 'ConversationMessageAttachment', contentType: string, name: string, type: string, url: string }>> }> } };

export type CancelScheduledEventMutationVariables = Exact<{
  input: CancelScheduledEventInput;
}>;


export type CancelScheduledEventMutation = { __typename?: 'Mutation', cancelScheduledEvent: { __typename?: 'ScheduledEvent', calendlyEventId: string, id: string, cancelled?: Maybe<boolean> } };

export type UploadFilesToConversationMutationVariables = Exact<{
  input: UploadFilesToConversationInput;
}>;


export type UploadFilesToConversationMutation = { __typename?: 'Mutation', uploadFilesToConversation: { __typename?: 'Conversation', id: string, intercomConversationId: string, subject: string, messages: Array<{ __typename?: 'ConversationMessage', body?: Maybe<string>, createdAt: any, inBound: boolean, attachments?: Maybe<Array<{ __typename?: 'ConversationMessageAttachment', contentType: string, name: string, type: string, url: string }>> }> } };

export type StartTaskMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type StartTaskMutation = { __typename?: 'Mutation', startTask: { __typename?: 'CoreTask', id: string, name: TaskName, label: string, startedAt?: Maybe<any>, completionStatus?: Maybe<TaskCompletionStatus> } };

export type CompleteTaskMutationVariables = Exact<{
  data: CompleteTaskInput;
}>;


export type CompleteTaskMutation = { __typename?: 'Mutation', completeTask?: Maybe<{ __typename?: 'CoreTask', id: string, name: TaskName, label: string, completedAt?: Maybe<any>, completionStatus?: Maybe<TaskCompletionStatus> }> };

export type CompleteGoalMutationVariables = Exact<{
  data: CompleteGoalInput;
}>;


export type CompleteGoalMutation = { __typename?: 'Mutation', completeGoal: { __typename?: 'CoreGoal', id: string, name: GoalName, label: string, completedAt?: Maybe<any>, completionStatus?: Maybe<GoalCompletionStatus> } };

export type GetHrRequestOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHrRequestOptionsQuery = { __typename?: 'Query', getHrRequestOptions: { __typename?: 'HrRequestOptionsResponse', groups: Array<{ __typename?: 'HrRequestGroup', key: HrRequestGroupKey, icon: string, title: string }>, options: Array<{ __typename?: 'HrRequestOption', title: string, description: string, groupKey: HrRequestGroupKey, type: HrRequestType, subType?: Maybe<HrRequestSubType>, slug: HrRequestSlug, audience: Array<HrRequestAudience>, requiresPrimaryHrm: boolean, keywords: Array<string>, unlisted?: Maybe<boolean>, popular?: Maybe<{ __typename?: 'HrRequestOptionPopular', order: number, title?: Maybe<string>, description?: Maybe<string> }>, expectation?: Maybe<{ __typename?: 'HrRequestExpectation', cycleTime: string, description?: Maybe<string> }> }> } };

export type GetHrRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHrRequestsQuery = { __typename?: 'Query', getHrRequests: { __typename?: 'ListHrRequestsResponse', hrRequests: Array<Maybe<{ __typename?: 'HrRequest', id: string }>> } };

export type HrRequestQueryVariables = Exact<{
  input: GetHrRequestByIdInput;
}>;


export type HrRequestQuery = { __typename?: 'Query', hrRequest: { __typename?: 'HrRequest', id: string, conversation?: Maybe<{ __typename?: 'Conversation', id: string, intercomConversationId: string, subject: string, messages: Array<{ __typename?: 'ConversationMessage', body?: Maybe<string>, inBound: boolean }> }> } };

export type HrRequestAiInformationQueryVariables = Exact<{
  input: GetHrRequestByIdInput;
}>;


export type HrRequestAiInformationQuery = { __typename?: 'Query', hrRequest: { __typename?: 'HrRequest', id: string, caseId: string, aiGenerated?: Maybe<string>, aiArtifacts?: Maybe<Array<Maybe<string>>>, threadId?: Maybe<string> } };

export type GetOnboardingCalendlyConfigQueryVariables = Exact<{
  input: OnboardingCalendlyConfigInput;
}>;


export type GetOnboardingCalendlyConfigQuery = { __typename?: 'Query', getOnboardingCalendlyConfig: { __typename?: 'OnboardingCalendlyConfig', link: string, tierNumber: number, zone: SchedulerZone } };

export type GetConversationByIntercomIdQueryVariables = Exact<{
  input: GetConversationByIntercomIdInput;
}>;


export type GetConversationByIntercomIdQuery = { __typename?: 'Query', getConversationByIntercomId: { __typename?: 'Conversation', id: string, intercomConversationId: string, subject: string, createdAt: any, inBound: boolean, messages: Array<{ __typename?: 'ConversationMessage', createdAt: any, body?: Maybe<string>, inBound: boolean, attachments?: Maybe<Array<{ __typename?: 'ConversationMessageAttachment', type: string, name: string, contentType: string, url: string }>> }> } };

export type GetHrRequestListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHrRequestListQuery = { __typename?: 'Query', hrRequestList: { __typename?: 'ListHrRequestDetails', hrRequests: Array<Maybe<{ __typename?: 'HrRequestDetail', caseId: string, caseNumber?: Maybe<string>, completionDate?: Maybe<any>, createdDate?: Maybe<any>, description?: Maybe<string>, expectationDate?: Maybe<any>, hrRequestSurveyAnswers?: Maybe<any>, intercomId?: Maybe<string>, isComplete?: Maybe<boolean>, isOverdue?: Maybe<boolean>, lastModifiedDate?: Maybe<any>, status: CaseStatus, subType?: Maybe<string>, subject?: Maybe<string>, type?: Maybe<CaseType>, aiMetadata?: Maybe<string> }>> } };

export type GetScheduledEventsQueryVariables = Exact<{
  input: GetScheduledEventsForUserInput;
}>;


export type GetScheduledEventsQuery = { __typename?: 'Query', getScheduledEventsForUser: Array<{ __typename?: 'ScheduledEvent', id: string, attendeeEmails?: Maybe<Array<string>>, missedCallFeeStatus?: Maybe<MissedCallFeeStatus>, title: string, calendlyEventId: string, startTime: any, endTime: any, eventLocation: SchedulerEventLocation, videoConferenceLink?: Maybe<string>, phoneNumber?: Maybe<string>, calendlyInviteeId: string, cancelled?: Maybe<boolean>, kind: string, agent?: Maybe<{ __typename?: 'CallAgent', avatarUrl?: Maybe<string>, id: string, name?: Maybe<string>, role?: Maybe<string> }>, callSummaries: Array<{ __typename?: 'CallSummary', actionItems?: Maybe<string>, approvedAt?: Maybe<any>, callDurationInMinutes?: Maybe<number>, createdAt: any, followUps?: Maybe<string>, isApproved?: Maybe<boolean>, summary?: Maybe<string>, agent?: Maybe<{ __typename?: 'CallAgent', avatarUrl?: Maybe<string>, id: string, name?: Maybe<string>, role?: Maybe<string> }> }> }> };

export type GetRescheduleLinkQueryVariables = Exact<{
  input: GetCalendlyRescheduleLinkInput;
}>;


export type GetRescheduleLinkQuery = { __typename?: 'Query', getRescheduleLink: string };

export type HrRequestExtendedDetailQueryVariables = Exact<{
  input: GetHrRequestExtendedDetailByIdInput;
}>;


export type HrRequestExtendedDetailQuery = { __typename?: 'Query', hrRequestExtendedDetail: { __typename?: 'HrRequestExtendedDetail', caseId: string, intercomId?: Maybe<string>, caseNumber?: Maybe<string>, type?: Maybe<CaseType>, subType?: Maybe<string>, status: CaseStatus, expectationDate?: Maybe<any>, lastModifiedDate?: Maybe<any>, createdDate?: Maybe<any>, completionDate?: Maybe<any>, isComplete?: Maybe<boolean>, isOverdue?: Maybe<boolean>, subject?: Maybe<string>, description?: Maybe<string>, hrRequestSurveyAnswers?: Maybe<any>, createdBy?: Maybe<string>, summary?: Maybe<string>, ownerId?: Maybe<string>, companyId: string, aiSummary?: Maybe<string>, aiMetadata?: Maybe<string>, agent?: Maybe<{ __typename?: 'CallAgent', id: string, name?: Maybe<string>, avatarUrl?: Maybe<string>, role?: Maybe<string> }>, timeline: Array<{ __typename?: 'TimelineItem', eventType: TimelineEventType, eventTime: any, oldValue?: Maybe<string>, newValue?: Maybe<string> }>, scheduledEvents: Array<{ __typename?: 'ScheduledEvent', id: string, calendlyEventId: string }>, policies?: Maybe<Array<{ __typename?: 'HrRequestPolicy', id: string, name: string, displayName: string, description: string, icon: string, step: string, status: PolicyStatus, createdAt: any }>>, relatedCases?: Maybe<Array<{ __typename?: 'RelatedCase', caseId: string, subject: string }>> } };

export type GetAskNicelyWebSurveyInfoQueryVariables = Exact<{
  input: GetAskNicelyWebSurveyInfoInput;
}>;


export type GetAskNicelyWebSurveyInfoQuery = { __typename?: 'Query', getAskNicelyWebSurveyInfo: { __typename?: 'AskNicelySurveyInfo', emailHash?: Maybe<string>, force: boolean, show: boolean } };

export type GetMyCompanyGoalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCompanyGoalsQuery = { __typename?: 'Query', getMyCompanyGoals: Array<{ __typename?: 'CoreGoal', id: string, name: GoalName, label: string, completionStatus?: Maybe<GoalCompletionStatus>, completedAt?: Maybe<any>, taskNames: Array<TaskName>, copy: { __typename?: 'CoreGoalCopy', cta: string, description: string, estimated: string }, tasks: Array<{ __typename?: 'CoreTask', id: string, name: TaskName, label: string, completionStatus?: Maybe<TaskCompletionStatus>, completedAt?: Maybe<any>, startedAt?: Maybe<any>, copy: { __typename?: 'CoreTaskCopy', cta?: Maybe<string>, confirmCta?: Maybe<string>, denyCta?: Maybe<string>, estimated?: Maybe<string> } }> }> };

export type CloseHrRequestMutationVariables = Exact<{
  input: CloseHrRequestInput;
}>;


export type CloseHrRequestMutation = { __typename?: 'Mutation', closeHrRequest: { __typename?: 'HrRequest', id: string, caseId: string, conversationId?: Maybe<string>, intercomConversationId?: Maybe<string>, customerCompanyId: string, createdAt: any, aiGenerated?: Maybe<string>, aiArtifacts?: Maybe<Array<Maybe<string>>>, threadId?: Maybe<string> } };

export type SetCaseStatusMutationVariables = Exact<{
  input: SetCaseStatusInput;
}>;


export type SetCaseStatusMutation = { __typename?: 'Mutation', setCaseStatus: { __typename?: 'HrRequest', id: string, caseId: string, conversationId?: Maybe<string>, intercomConversationId?: Maybe<string>, customerCompanyId: string, createdAt: any, aiGenerated?: Maybe<string>, aiArtifacts?: Maybe<Array<Maybe<string>>>, threadId?: Maybe<string> } };

export type CreateTerminationMutationVariables = Exact<{
  data: TerminationCreateInput;
}>;


export type CreateTerminationMutation = { __typename?: 'Mutation', createTermination: { __typename?: 'Termination', terminationId: string, employeeId: string, userId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, startDate?: Maybe<any>, confirmed: boolean, terminationState?: Maybe<string>, createdAt: any, complete: boolean } };

export type CreateResignationMutationVariables = Exact<{
  data: ResignationCreateInput;
}>;


export type CreateResignationMutation = { __typename?: 'Mutation', createResignation: { __typename?: 'Resignation', resignationId: string, employeeId: string, userId: string, status: ResignationStatus, step: ResignationStep, resignationDate?: Maybe<any>, resignationState?: Maybe<string>, confirmed: boolean, selfService: boolean, hrRequestId?: Maybe<string>, createdAt: any, complete: boolean } };

export type GetTerminationByHrRequestQueryVariables = Exact<{
  data: GetTerminationHrRequestInput;
}>;


export type GetTerminationByHrRequestQuery = { __typename?: 'Query', getTerminationByHrRequest: { __typename?: 'Termination', terminationId: string, employeeId: string, userId: string, status: TerminationStatus, step: TerminationStep, terminationDate?: Maybe<any>, startDate?: Maybe<any>, confirmed: boolean, selfService: boolean, terminationState?: Maybe<string>, createdAt: any } };

export type GetResignationByHrRequestQueryVariables = Exact<{
  data: GetResignationHrRequestInput;
}>;


export type GetResignationByHrRequestQuery = { __typename?: 'Query', getResignationByHrRequest: { __typename?: 'Resignation', resignationId: string, employeeId: string, userId: string, status: ResignationStatus, step: ResignationStep, resignationDate?: Maybe<any>, startDate?: Maybe<any>, confirmed: boolean, selfService: boolean, resignationState?: Maybe<string>, createdAt: any } };

export type BulkPurchaseSeatsMutationVariables = Exact<{
  data: BulkPurchaseSeatsInput;
}>;


export type BulkPurchaseSeatsMutation = { __typename?: 'Mutation', bulkPurchaseSeats: Array<{ __typename?: 'PurchaseSeatsResponse', bundleId?: Maybe<string>, error?: Maybe<string>, id: string, numPurchased: number, topicId?: Maybe<string>, totalSeats: number }> };

export type EnrollmentResponsePartsFragment = { __typename?: 'EnrollUsersResponse', id: string, companyId: string, enrolled: boolean, userIds: Array<string>, topicId?: Maybe<string>, bundleId?: Maybe<string>, errors?: Maybe<Array<string>> };

export type BulkEnrollUsersResponsePartsFragment = { __typename?: 'BulkEnrollUsersResponse', enrolledUsers: Array<{ __typename?: 'EnrollUsersResponse', id: string, companyId: string, enrolled: boolean, userIds: Array<string>, topicId?: Maybe<string>, bundleId?: Maybe<string>, errors?: Maybe<Array<string>> }>, errors: Array<{ __typename?: 'EnrollUsersError', message: string, userIds?: Maybe<Array<string>>, topicId?: Maybe<string>, bundleId?: Maybe<string> }> };

export type BulkEnrollUsersMutationVariables = Exact<{
  data: BulkEnrollUsersInput;
}>;


export type BulkEnrollUsersMutation = { __typename?: 'Mutation', bulkEnrollUsers: { __typename?: 'BulkEnrollUsersResponse', enrolledUsers: Array<{ __typename?: 'EnrollUsersResponse', id: string, companyId: string, enrolled: boolean, userIds: Array<string>, topicId?: Maybe<string>, bundleId?: Maybe<string>, errors?: Maybe<Array<string>> }>, errors: Array<{ __typename?: 'EnrollUsersError', message: string, userIds?: Maybe<Array<string>>, topicId?: Maybe<string>, bundleId?: Maybe<string> }> } };

export type EnrollUsersMutationVariables = Exact<{
  data: EnrollUsersInput;
}>;


export type EnrollUsersMutation = { __typename?: 'Mutation', enrollUsers: { __typename?: 'EnrollUsersResponse', id: string, companyId: string, enrolled: boolean, userIds: Array<string>, topicId?: Maybe<string>, bundleId?: Maybe<string>, errors?: Maybe<Array<string>> } };

export type PurchaseSeatsForBundleMutationVariables = Exact<{
  data: PurchaseBundleSeatsInput;
}>;


export type PurchaseSeatsForBundleMutation = { __typename?: 'Mutation', purchaseSeatsForBundle: { __typename?: 'PurchaseSeatsResponse', numPurchased: number, totalSeats: number } };

export type RemoveSeatsFromBundleMutationVariables = Exact<{
  data: RemoveBundleSeatsInput;
}>;


export type RemoveSeatsFromBundleMutation = { __typename?: 'Mutation', removeSeatsFromBundle: { __typename?: 'RemoveSeatsResponse', numRemoved: number, totalSeats: number } };

export type PurchaseSeatsMutationVariables = Exact<{
  data: PurchaseSeatsInput;
}>;


export type PurchaseSeatsMutation = { __typename?: 'Mutation', purchaseSeats: { __typename?: 'PurchaseSeatsResponse', numPurchased: number, totalSeats: number } };

export type UnenrollUsersMutationVariables = Exact<{
  data: UnenrollUsersInput;
}>;


export type UnenrollUsersMutation = { __typename?: 'Mutation', unenrollUsers: { __typename?: 'UnenrolledUsers', id: string, successfullyUnenrolled: Array<Maybe<string>>, errors: Array<Maybe<string>> } };

export type SelfUnenrollRetiredMutationVariables = Exact<{
  data: SelfUnenrollRetiredInput;
}>;


export type SelfUnenrollRetiredMutation = { __typename?: 'Mutation', selfUnenrollRetired: { __typename?: 'UnenrolledUsers', id: string, successfullyUnenrolled: Array<Maybe<string>>, errors: Array<Maybe<string>> } };

export type MakeTrainingRequestMutationVariables = Exact<{
  data: TrainingRequestInput;
}>;


export type MakeTrainingRequestMutation = { __typename?: 'Mutation', trainingRequest: { __typename?: 'CoreRequest', id: string, status: RequestStatus, resourceId: string, resourceType: RequestResourceType, createdAt: any, updatedAt: any } };

export type CancelTrainingRequestMutationVariables = Exact<{
  data: RequestCancelInput;
}>;


export type CancelTrainingRequestMutation = { __typename?: 'Mutation', cancelRequest: { __typename?: 'CoreRequest', id: string, status: RequestStatus, updatedAt: any } };

export type ApproveTrainingRequestMutationVariables = Exact<{
  data: RequestApprovalInput;
}>;


export type ApproveTrainingRequestMutation = { __typename?: 'Mutation', approveRequest: { __typename?: 'CoreRequest', id: string, status: RequestStatus, updatedAt: any } };

export type RejectTrainingRequestMutationVariables = Exact<{
  data: RequestRejectionInput;
}>;


export type RejectTrainingRequestMutation = { __typename?: 'Mutation', rejectRequest: { __typename?: 'CoreRequest', id: string, status: RequestStatus, updatedAt: any } };

export type UserCoursePartsFragment = { __typename?: 'UserCourse', id: string, courseId: string, ticketId: string, name: string, description?: Maybe<string>, topicName: string, topicId: string, bundleName: string, bundleId: string, state?: Maybe<string>, status: string, startedAt?: Maybe<any>, removedAt?: Maybe<any>, completedAt?: Maybe<any>, enrolledAt?: Maybe<any>, certificateId?: Maybe<string>, certificateDownloadUrl?: Maybe<string>, searchTag?: Maybe<string>, language?: Maybe<string>, userRole: string, isTopicRetired: boolean };

export type TopicPartsFragment = { __typename?: 'PurchasedTopic', name: string, topicId: string, isRetired: boolean, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> };

export type FullCompanyPartsFragment = { __typename?: 'Company', companyId?: Maybe<string>, companyMngId?: Maybe<string>, users: Array<{ __typename?: 'User', language: Language, role: UserRole, state?: Maybe<State>, userId: string, userMngId?: Maybe<string> }>, availableProducts: { __typename?: 'AvailableProducts', bundles: Array<{ __typename?: 'BundleResponse', id: string, name: string, price?: Maybe<number>, topics: Array<Maybe<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }>> }>, topics: Array<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }> }, purchasedProducts: { __typename?: 'PurchasedProducts', topics: Array<Maybe<{ __typename?: 'PurchasedTopic', id: string, name: string, topicId: string, isRetired: boolean, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>>, bundles: Array<Maybe<{ __typename?: 'PurchasedBundle', id: string, name: string, bundleId: string, description?: Maybe<string>, totalSeats: number, unfilledSeats: number, counts: { __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }, topics: Array<Maybe<{ __typename?: 'PurchasedTopic', name: string, topicId: string, isRetired: boolean, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>> }>> } };

export type ShortCompanyPartsFragment = { __typename?: 'Company', companyId?: Maybe<string>, companyMngId?: Maybe<string>, purchasedProducts: { __typename?: 'PurchasedProducts', bundles: Array<Maybe<{ __typename?: 'PurchasedBundle', bundleId: string, name: string, totalSeats: number, unfilledSeats: number }>> } };

export type GetTrainingCompanyQueryVariables = Exact<{
  data: GetCompanyInput;
}>;


export type GetTrainingCompanyQuery = { __typename?: 'Query', company: { __typename?: 'Company', companyId?: Maybe<string>, companyMngId?: Maybe<string>, users: Array<{ __typename?: 'User', language: Language, role: UserRole, state?: Maybe<State>, userId: string, userMngId?: Maybe<string> }>, availableProducts: { __typename?: 'AvailableProducts', bundles: Array<{ __typename?: 'BundleResponse', id: string, name: string, price?: Maybe<number>, topics: Array<Maybe<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }>> }>, topics: Array<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }> }, purchasedProducts: { __typename?: 'PurchasedProducts', topics: Array<Maybe<{ __typename?: 'PurchasedTopic', id: string, name: string, topicId: string, isRetired: boolean, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>>, bundles: Array<Maybe<{ __typename?: 'PurchasedBundle', id: string, name: string, bundleId: string, description?: Maybe<string>, totalSeats: number, unfilledSeats: number, counts: { __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }, topics: Array<Maybe<{ __typename?: 'PurchasedTopic', name: string, topicId: string, isRetired: boolean, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>> }>> } } };

export type GetCompanyVerboseQueryVariables = Exact<{
  data: GetCompanyInput;
}>;


export type GetCompanyVerboseQuery = { __typename?: 'Query', company: { __typename?: 'Company', companyId?: Maybe<string>, companyMngId?: Maybe<string>, users: Array<{ __typename?: 'User', language: Language, role: UserRole, state?: Maybe<State>, userId: string, userMngId?: Maybe<string> }>, availableProducts: { __typename?: 'AvailableProducts', bundles: Array<{ __typename?: 'BundleResponse', id: string, name: string, price?: Maybe<number>, topics: Array<Maybe<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }>> }>, topics: Array<{ __typename?: 'CourseTopic', id: string, name: string, price?: Maybe<number> }> }, purchasedProducts: { __typename?: 'PurchasedProducts', topics: Array<Maybe<{ __typename?: 'PurchasedTopic', id: string, name: string, topicId: string, isRetired: boolean, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>>, bundles: Array<Maybe<{ __typename?: 'PurchasedBundle', id: string, name: string, bundleId: string, description?: Maybe<string>, totalSeats: number, unfilledSeats: number, counts: { __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }, topics: Array<Maybe<{ __typename?: 'PurchasedTopic', name: string, topicId: string, isRetired: boolean, totalSeats?: Maybe<number>, unfilledSeats?: Maybe<number>, counts?: Maybe<{ __typename?: 'UserCounts', id: string, completed?: Maybe<number>, inProgress?: Maybe<number>, notStarted?: Maybe<number> }>, enrollments: Array<Maybe<{ __typename?: 'TopicEnrolledTickets', certificateDownloadUrl?: Maybe<string>, completedAt?: Maybe<any>, enrolledAt: any, language: string, role: string, startedAt?: Maybe<any>, state?: Maybe<string>, userId: string, userMngId: string }>> }>> }>> } } };

export type GetUserCoursesQueryVariables = Exact<{
  data: UserCoursesInput;
}>;


export type GetUserCoursesQuery = { __typename?: 'Query', userCourses: Array<{ __typename?: 'UserCourse', id: string, courseId: string, ticketId: string, name: string, description?: Maybe<string>, topicName: string, topicId: string, bundleName: string, bundleId: string, state?: Maybe<string>, status: string, startedAt?: Maybe<any>, removedAt?: Maybe<any>, completedAt?: Maybe<any>, enrolledAt?: Maybe<any>, certificateId?: Maybe<string>, certificateDownloadUrl?: Maybe<string>, searchTag?: Maybe<string>, language?: Maybe<string>, userRole: string, isTopicRetired: boolean }> };

export type GetTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopicsQuery = { __typename?: 'Query', getTopics: Array<{ __typename?: 'CourseTopic', id: string, name: string, searchTag?: Maybe<string> }> };

export type GetCompanyTicketsQueryVariables = Exact<{
  data: ListTicketsInput;
}>;


export type GetCompanyTicketsQuery = { __typename?: 'Query', getTickets: { __typename?: 'ListTicketsResponse', totalTickets: number, tickets: Array<Maybe<{ __typename?: 'Ticket', id: string, topicId: string, bundleId: string, courseId?: Maybe<string>, userId?: Maybe<string>, stripeInvoiceId?: Maybe<string>, enrolledAt?: Maybe<any>, startedAt?: Maybe<any>, completedAt?: Maybe<any> }>> } };

export type GetTrainingPricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrainingPricesQuery = { __typename?: 'Query', getTrainingPrices: { __typename?: 'TrainingPricesResponse', bundle: number, topic: number } };

export type GetTrainingUserHistoryQueryVariables = Exact<{
  data: UserQueryInput;
  filter: UserTrainingFilterInput;
}>;


export type GetTrainingUserHistoryQuery = { __typename?: 'Query', user: { __typename?: 'User', training: { __typename?: 'UserTraining', history: Array<Maybe<{ __typename?: 'UserCourse', id: string, courseId: string, ticketId: string, name: string, description?: Maybe<string>, topicName: string, topicId: string, bundleName: string, bundleId: string, state?: Maybe<string>, status: string, startedAt?: Maybe<any>, removedAt?: Maybe<any>, completedAt?: Maybe<any>, enrolledAt?: Maybe<any>, certificateId?: Maybe<string>, certificateDownloadUrl?: Maybe<string>, searchTag?: Maybe<string>, language?: Maybe<string>, userRole: string, isTopicRetired: boolean }>> } } };

export type GetTrainingRecommendationsQueryVariables = Exact<{
  data: MyTrainingRecommendationFilterInput;
}>;


export type GetTrainingRecommendationsQuery = { __typename?: 'Query', myTrainingRecommendations?: Maybe<Array<{ __typename?: 'CoreRecommendation', id: string, status: RecommendationStatus, note?: Maybe<string>, resourceId: string, resourceType: string, scope: RecommendationScope, recommendedAt: Array<string>, createdAt: any, updatedAt: any, targets: Array<string> }>> };

export type GetMyTrainingRequestsQueryVariables = Exact<{
  data: MyRequestFilterInput;
}>;


export type GetMyTrainingRequestsQuery = { __typename?: 'Query', myRequests?: Maybe<Array<{ __typename?: 'CoreRequest', id: string, status: RequestStatus, resourceId: string, resourceType: RequestResourceType, createdAt: any, updatedAt: any, approvalCriteria: number, approverRoles?: Maybe<Array<Maybe<AuthRole>>>, rejectionCriteria: number, companyId: string, userId: string }>> };

export type GetTrainingRequestsQueryVariables = Exact<{
  data: RequestFilterInput;
}>;


export type GetTrainingRequestsQuery = { __typename?: 'Query', requests?: Maybe<Array<{ __typename?: 'CoreRequest', id: string, status: RequestStatus, resourceId: string, resourceType: RequestResourceType, createdAt: any, updatedAt: any, approvalCriteria: number, approverRoles?: Maybe<Array<Maybe<AuthRole>>>, rejectionCriteria: number, companyId: string, userId: string, requestedAt: Array<any>, user: { __typename?: 'CoreUser', profile?: Maybe<{ __typename?: 'CoreUserProfile', firstName: string, lastName: string, avatarUrl?: Maybe<string> }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', title?: Maybe<string> }> } }>> };

export type GetCompanyTrainingStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCompanyTrainingStatusQuery = { __typename?: 'Query', company: { __typename?: 'Company', hasTraining: boolean } };

export type GetNonCoreSubscriptionBillingChangesQueryVariables = Exact<{
  data: GetCompanyUpcomingBillingChangesInput;
}>;


export type GetNonCoreSubscriptionBillingChangesQuery = { __typename?: 'Query', getNonCoreSubscriptionBillingChanges: Array<{ __typename?: 'UpcomingNonCoreSubscriptionBillingChange', minSize: number, maxSize?: Maybe<number>, productKey: ProductKey, serviceKey: ServiceKey, upcomingMonthlyPrice?: Maybe<number>, upcomingYearlyPrice?: Maybe<number> }> };

export type UpdateCoreUserStateMutationVariables = Exact<{
  input: CoreUserStatesInput;
}>;


export type UpdateCoreUserStateMutation = { __typename?: 'Mutation', updateCoreUserState: { __typename?: 'CoreUserStates', viewedBciToHrPracticeModal: boolean, viewedBciToHrPracticeReportCardModal: boolean, viewedInAppUpgradeModal: boolean } };

export type UpdateCoreUserProfileMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CoreUserProfileInput;
}>;


export type UpdateCoreUserProfileMutation = { __typename?: 'Mutation', updateCoreUserProfile: { __typename?: 'CoreUserProfile', id: string, firstName: string, lastName: string, phone?: Maybe<string>, topPerformer?: Maybe<{ __typename?: 'TopPerformer', active: boolean, note: string }> } };

export type MakeUserAdminMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type MakeUserAdminMutation = { __typename?: 'Mutation', makeUserAdmin: boolean };

export type RemoveUserAdminMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type RemoveUserAdminMutation = { __typename?: 'Mutation', removeUserAdmin: boolean };

export type CoreUserStatePartsFragment = { __typename?: 'CoreUserStates', viewedBciToHrPracticeModal: boolean, viewedBciToHrPracticeReportCardModal: boolean, viewedInAppUpgradeModal: boolean };

export type CoreUserEmploymentPartsFragment = { __typename?: 'CoreUserEmployment', workerRoles: Array<{ __typename?: 'WorkerRole', isPrimary: boolean, employeeJobDescription?: Maybe<{ __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } }> }> };

export type GetMyCoreUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCoreUserQuery = { __typename?: 'Query', getMyCoreUser: { __typename?: 'CoreUser', id: string, role: string, documents?: Maybe<Array<{ __typename?: 'CoreDocument', id: string, name: string, reaffirmations?: Maybe<Array<any>>, policy?: Maybe<{ __typename?: 'CorePolicy', id: string, name: string, archivedAt?: Maybe<any> }>, signature?: Maybe<{ __typename?: 'CoreDocumentSignature', id: string, requestedAt: any, signedAt: any, signingOrder?: Maybe<number> }> }>>, states?: Maybe<{ __typename?: 'CoreUserStates', viewedBciToHrPracticeModal: boolean, viewedBciToHrPracticeReportCardModal: boolean, viewedInAppUpgradeModal: boolean }>, employment?: Maybe<{ __typename?: 'CoreUserEmployment', workerRoles: Array<{ __typename?: 'WorkerRole', isPrimary: boolean, employeeJobDescription?: Maybe<{ __typename?: 'EmployeeJobDescription', id: string, createdAt: any, signedAt?: Maybe<any>, documentId?: Maybe<string>, jobDescription: { __typename?: 'JobDescription', aiGeneratedId?: Maybe<string>, body: any, html?: Maybe<string>, completedAt?: Maybe<any>, deletedAt?: Maybe<any>, deletedBy?: Maybe<string>, id: string, title: string, aiGenerated?: Maybe<{ __typename?: 'AiGenerated', id: string, body?: Maybe<any>, createdAt: any }> } }> }> }> } };

export type GetWizardsByDestinationQueryVariables = Exact<{
  filter?: Maybe<WizardFilterInput>;
}>;


export type GetWizardsByDestinationQuery = { __typename?: 'Query', wizards: Array<{ __typename?: 'Wizard', id: string, type?: Maybe<WizardType>, userId?: Maybe<string>, deletedAt?: Maybe<any>, completedAt?: Maybe<any>, title: string, description?: Maybe<string>, successMessage?: Maybe<string>, startedAt?: Maybe<any>, currentStepId?: Maybe<string>, totalStepCount: number, createdAt: any, companyId: string, steps?: Maybe<Array<{ __typename?: 'WizardStep', id: string, title?: Maybe<string>, order: number }>> }> };

export const AppliedPlansPartsFragmentDoc = gql`
    fragment AppliedPlansParts on Plan {
  id
  name
}
    `;
export const CouponPartsFragmentDoc = gql`
    fragment CouponParts on PlanCoupon {
  id
  name
  amountOff
  appliesToPlans {
    ...AppliedPlansParts
  }
  setupFeeOff
}
    ${AppliedPlansPartsFragmentDoc}`;
export const SubscriptionPartsFragmentDoc = gql`
    fragment SubscriptionParts on Subscription {
  name
  productCode
  amount
  status
  coupon {
    ...CouponParts
  }
  startDate
  endDate
  stripeId
  stripePriceId
  createdAt
  isDrp
}
    ${CouponPartsFragmentDoc}`;
export const BillingPlanPartsFragmentDoc = gql`
    fragment BillingPlanParts on PlanLock {
  active
  couponId
  plan
  setupFee
  trialDuration
}
    `;
export const CompanyDelinquencyPartsFragmentDoc = gql`
    fragment CompanyDelinquencyParts on CompanyDelinquency {
  delinquent
  delinquentSince
  lockout
  defaultCardVerificationStatus
}
    `;
export const BillingProductPartsFragmentDoc = gql`
    fragment BillingProductParts on Product {
  id
  name
  key
  creditBalance
  price
  subscriptionPrice
  activeSubscription
}
    `;
export const ProductResultPartsFragmentDoc = gql`
    fragment ProductResultParts on PurchaseResult {
  createdAt
  creditsPurchased
  productKey
  id
  status
}
    `;
export const PaymentSourcePartsFragmentDoc = gql`
    fragment PaymentSourceParts on PaymentSource {
  addressCity
  addressCountry
  addressLine1
  addressLine2
  addressState
  addressZip
  brand
  country
  cvcCheck
  default
  dynamicLast4
  expMonth
  expYear
  funding
  id
  last4
  name
}
    `;
export const PaymentSourcesPartsFragmentDoc = gql`
    fragment PaymentSourcesParts on PaymentSources {
  companyId
  sources {
    ...PaymentSourceParts
  }
}
    ${PaymentSourcePartsFragmentDoc}`;
export const VoicesFeedbackPartsFragmentDoc = gql`
    fragment VoicesFeedbackParts on VoicesFeedback {
  id
  companyPersonId
  feedback
  anonymous
  satisfactionRatingOfFive
  createdAt
  updatedAt
}
    `;
export const TerminationPartsFragmentDoc = gql`
    fragment TerminationParts on Termination {
  complete
  createdAt
  employee {
    id
    isContractor
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  employeeId
  manager {
    id
    isContractor
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  status
  step
  terminationDate
  terminationId
  user {
    id
    isContractor
    name
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  userId
}
    `;
export const TerminationDownloadPartsFragmentDoc = gql`
    fragment TerminationDownloadParts on TerminationDownload {
  file
  terminationId
}
    `;
export const ResignationPartsFragmentDoc = gql`
    fragment ResignationParts on Resignation {
  complete
  confirmed
  createdAt
  employee {
    id
    isContractor
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  employeeId
  hrRequestVersion
  manager {
    id
    isContractor
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  resignationDate
  resignationId
  resignationState
  signedFiles {
    filename
    name
    url
  }
  startDate
  status
  step
  user {
    id
    isContractor
    name
    profile {
      firstName
      lastName
      role
      stateWorkIn
    }
  }
  userId
}
    `;
export const ResignationDownloadPartsFragmentDoc = gql`
    fragment ResignationDownloadParts on ResignationDownload {
  file
  resignationId
}
    `;
export const CoreDocumentSignaturePartsFragmentDoc = gql`
    fragment CoreDocumentSignatureParts on CoreDocumentSignature {
  id
  requestedAt
  signedAt
  signingOrder
}
    `;
export const CoreDocumentPartsFragmentDoc = gql`
    fragment CoreDocumentParts on CoreDocument {
  id
  name
  reaffirmations
  policy {
    id
    name
    archivedAt
  }
  signature {
    ...CoreDocumentSignatureParts
  }
  reaffirmations
}
    ${CoreDocumentSignaturePartsFragmentDoc}`;
export const CoreUserStatesPartsFragmentDoc = gql`
    fragment CoreUserStatesParts on CoreUserStates {
  id
  emailNotification
  onboardRequest
  onboarded
  terminationRequest
  terminated
  selfSignupRegistered
  selfSignupActivated
  resignationLastDate
  resignationStatus
  viewedOnboardingInstructions
  viewedInsuranceIntroduction
  interestedInPersonalInsurance
  viewedPersonalInsurance
  viewedCovid
  viewedTaskCenter
  viewedVideoTourBusinessHealth
  viewedVideoTourCabinet
  viewedVideoTourPolicy
  viewedVideoTourReportCards
  viewedVideoTourStaffFolder
}
    `;
export const CoreUserPartsFragmentDoc = gql`
    fragment CoreUserParts on CoreUser {
  id
  active
  roles
  role
  profile {
    firstName
    lastName
    avatarUrl
  }
  states {
    ...CoreUserStatesParts
  }
  employment {
    title
    isContractor
  }
  permissions {
    manager
    approver
  }
}
    ${CoreUserStatesPartsFragmentDoc}`;
export const CorePolicyPartsFragmentDoc = gql`
    fragment CorePolicyParts on CorePolicy {
  id
  isCPD
  name
  icon
  status
  isContractor
  step
  recipients {
    id
    document {
      ...CoreDocumentParts
    }
    employee {
      ...CoreUserParts
    }
  }
  notSentTo {
    ...CoreUserParts
  }
}
    ${CoreDocumentPartsFragmentDoc}
${CoreUserPartsFragmentDoc}`;
export const ReportCardUserPartsFragmentDoc = gql`
    fragment ReportCardUserParts on CoreUser {
  id
  profile {
    firstName
    lastName
    avatarUrl
  }
  role
  employment {
    isContractor
  }
}
    `;
export const ReportCardEmployeeGradePartsFragmentDoc = gql`
    fragment ReportCardEmployeeGradeParts on ReportCardEmployeeGrade {
  id
  __typename
  employee {
    ...ReportCardUserParts
  }
  feedback
  grade
  gradedBy {
    ...ReportCardUserParts
  }
  note
  status
}
    ${ReportCardUserPartsFragmentDoc}`;
export const ManagedReportPartsFragmentDoc = gql`
    fragment ManagedReportParts on ManagedReport {
  id
  __typename
  employees {
    ...ReportCardUserParts
  }
  manager {
    ...ReportCardUserParts
  }
}
    ${ReportCardUserPartsFragmentDoc}`;
export const ReportCardPartsFragmentDoc = gql`
    fragment ReportCardParts on ReportCard {
  __typename
  id
  cadence
  createdAt
  directReports {
    ...ReportCardUserParts
  }
  employees {
    ...ReportCardEmployeeGradeParts
  }
  managerReports {
    ...ManagedReportParts
  }
  status
}
    ${ReportCardUserPartsFragmentDoc}
${ReportCardEmployeeGradePartsFragmentDoc}
${ManagedReportPartsFragmentDoc}`;
export const NewReportCardPartsFragmentDoc = gql`
    fragment NewReportCardParts on NewReportCard {
  __typename
  existing
  report {
    ...ReportCardParts
  }
}
    ${ReportCardPartsFragmentDoc}`;
export const EnrollmentResponsePartsFragmentDoc = gql`
    fragment EnrollmentResponseParts on EnrollUsersResponse {
  id
  companyId
  enrolled
  userIds
  topicId
  bundleId
  errors
}
    `;
export const BulkEnrollUsersResponsePartsFragmentDoc = gql`
    fragment BulkEnrollUsersResponseParts on BulkEnrollUsersResponse {
  enrolledUsers {
    ...EnrollmentResponseParts
  }
  errors {
    message
    userIds
    topicId
    bundleId
  }
}
    ${EnrollmentResponsePartsFragmentDoc}`;
export const UserCoursePartsFragmentDoc = gql`
    fragment UserCourseParts on UserCourse {
  id
  courseId
  ticketId
  name
  description
  topicName
  topicId
  bundleName
  bundleId
  state
  status
  startedAt
  removedAt
  completedAt
  enrolledAt
  certificateId
  certificateDownloadUrl
  searchTag
  language
  userRole
  isTopicRetired
}
    `;
export const TopicPartsFragmentDoc = gql`
    fragment TopicParts on PurchasedTopic {
  name
  topicId
  isRetired
  totalSeats
  unfilledSeats
  counts {
    id
    completed
    inProgress
    notStarted
  }
  enrollments {
    certificateDownloadUrl
    completedAt
    enrolledAt
    language
    role
    startedAt
    state
    userId
    userMngId
  }
}
    `;
export const FullCompanyPartsFragmentDoc = gql`
    fragment FullCompanyParts on Company {
  companyId
  companyMngId
  users {
    language
    role
    state
    userId
    userMngId
  }
  availableProducts {
    bundles {
      id
      name
      price
      topics {
        id
        name
        price
      }
    }
    topics {
      id
      name
      price
    }
  }
  purchasedProducts {
    topics {
      id
      ...TopicParts
    }
    bundles {
      id
      name
      bundleId
      description
      counts {
        id
        completed
        inProgress
        notStarted
      }
      topics {
        ...TopicParts
      }
      totalSeats
      unfilledSeats
    }
  }
}
    ${TopicPartsFragmentDoc}`;
export const ShortCompanyPartsFragmentDoc = gql`
    fragment ShortCompanyParts on Company {
  companyId
  companyMngId
  purchasedProducts {
    bundles {
      bundleId
      name
      totalSeats
      unfilledSeats
    }
  }
}
    `;
export const CoreUserStatePartsFragmentDoc = gql`
    fragment CoreUserStateParts on CoreUserStates {
  viewedBciToHrPracticeModal
  viewedBciToHrPracticeReportCardModal
  viewedInAppUpgradeModal
}
    `;
export const JobDescriptionPartsFragmentDoc = gql`
    fragment JobDescriptionParts on JobDescription {
  aiGeneratedId
  body
  html
  completedAt
  deletedAt
  deletedBy
  id
  title
  aiGenerated {
    id
    body
    createdAt
  }
}
    `;
export const EmployeeJobDescriptionPartsFragmentDoc = gql`
    fragment EmployeeJobDescriptionParts on EmployeeJobDescription {
  id
  createdAt
  signedAt
  documentId
  jobDescription {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;
export const CoreUserEmploymentPartsFragmentDoc = gql`
    fragment CoreUserEmploymentParts on CoreUserEmployment {
  workerRoles {
    isPrimary
    employeeJobDescription {
      ...EmployeeJobDescriptionParts
    }
  }
}
    ${EmployeeJobDescriptionPartsFragmentDoc}`;
export const ChatWithAssistantDocument = gql`
    mutation ChatWithAssistant($data: AIAssistantInput!) {
  chatWithAssistant(data: $data) {
    assistantId
    threadId
    next {
      context
      sample
    }
    messages {
      id
      role
      content {
        text {
          value
        }
      }
      metadata {
        artifact
        hidden
        type
        value
      }
    }
    artifact {
      jobDescription {
        html
        id
        status
      }
      summary {
        html
        status
      }
      policy {
        html
        title
        id
        status
      }
    }
  }
}
    `;

/**
 * __useChatWithAssistantMutation__
 *
 * To run a mutation, you first call `useChatWithAssistantMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChatWithAssistantMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChatWithAssistantMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useChatWithAssistantMutation(options: VueApolloComposable.UseMutationOptions<ChatWithAssistantMutation, ChatWithAssistantMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChatWithAssistantMutation, ChatWithAssistantMutationVariables>>) {
  return VueApolloComposable.useMutation<ChatWithAssistantMutation, ChatWithAssistantMutationVariables>(ChatWithAssistantDocument, options);
}
export type ChatWithAssistantMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChatWithAssistantMutation, ChatWithAssistantMutationVariables>;
export const GetArtifactsByThreadDocument = gql`
    query GetArtifactsByThread($input: GetArtifactsInput!) {
  getArtifacts(input: $input) {
    id
    artifactType
    artifactSubType
    html
    title
    status
    threadId
    downloadUrl
    confidence
    policyId
    caseId
    hrRequestId
  }
}
    `;

/**
 * __useGetArtifactsByThreadQuery__
 *
 * To run a query within a Vue component, call `useGetArtifactsByThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtifactsByThreadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArtifactsByThreadQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetArtifactsByThreadQuery(variables: GetArtifactsByThreadQueryVariables | VueCompositionApi.Ref<GetArtifactsByThreadQueryVariables> | ReactiveFunction<GetArtifactsByThreadQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArtifactsByThreadQuery, GetArtifactsByThreadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArtifactsByThreadQuery, GetArtifactsByThreadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArtifactsByThreadQuery, GetArtifactsByThreadQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArtifactsByThreadQuery, GetArtifactsByThreadQueryVariables>(GetArtifactsByThreadDocument, variables, options);
}
export type GetArtifactsByThreadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArtifactsByThreadQuery, GetArtifactsByThreadQueryVariables>;
export const TrackDocument = gql`
    mutation Track($data: AnalyticEvent!) {
  track(data: $data) {
    id
    success
    event
  }
}
    `;

/**
 * __useTrackMutation__
 *
 * To run a mutation, you first call `useTrackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTrackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTrackMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useTrackMutation(options: VueApolloComposable.UseMutationOptions<TrackMutation, TrackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrackMutation, TrackMutationVariables>>) {
  return VueApolloComposable.useMutation<TrackMutation, TrackMutationVariables>(TrackDocument, options);
}
export type TrackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrackMutation, TrackMutationVariables>;
export const EmitDocument = gql`
    mutation Emit($data: EmittableEvent!) {
  emit(data: $data) {
    id
    success
  }
}
    `;

/**
 * __useEmitMutation__
 *
 * To run a mutation, you first call `useEmitMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEmitMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEmitMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEmitMutation(options: VueApolloComposable.UseMutationOptions<EmitMutation, EmitMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EmitMutation, EmitMutationVariables>>) {
  return VueApolloComposable.useMutation<EmitMutation, EmitMutationVariables>(EmitDocument, options);
}
export type EmitMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EmitMutation, EmitMutationVariables>;
export const GetCouponByIdDocument = gql`
    query GetCouponById($data: GetCouponInput!) {
  coupon(data: $data) {
    ...CouponParts
  }
}
    ${CouponPartsFragmentDoc}`;

/**
 * __useGetCouponByIdQuery__
 *
 * To run a query within a Vue component, call `useGetCouponByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCouponByIdQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCouponByIdQuery(variables: GetCouponByIdQueryVariables | VueCompositionApi.Ref<GetCouponByIdQueryVariables> | ReactiveFunction<GetCouponByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCouponByIdQuery, GetCouponByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCouponByIdQuery, GetCouponByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCouponByIdQuery, GetCouponByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCouponByIdQuery, GetCouponByIdQueryVariables>(GetCouponByIdDocument, variables, options);
}
export type GetCouponByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCouponByIdQuery, GetCouponByIdQueryVariables>;
export const GetLockedPlanDocument = gql`
    query getLockedPlan($companyId: String!) {
  getPlanLock(companyId: $companyId) {
    ...BillingPlanParts
  }
}
    ${BillingPlanPartsFragmentDoc}`;

/**
 * __useGetLockedPlanQuery__
 *
 * To run a query within a Vue component, call `useGetLockedPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLockedPlanQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLockedPlanQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetLockedPlanQuery(variables: GetLockedPlanQueryVariables | VueCompositionApi.Ref<GetLockedPlanQueryVariables> | ReactiveFunction<GetLockedPlanQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLockedPlanQuery, GetLockedPlanQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLockedPlanQuery, GetLockedPlanQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLockedPlanQuery, GetLockedPlanQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLockedPlanQuery, GetLockedPlanQueryVariables>(GetLockedPlanDocument, variables, options);
}
export type GetLockedPlanQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLockedPlanQuery, GetLockedPlanQueryVariables>;
export const GetBillingCompanySubscriptionsDocument = gql`
    query GetBillingCompanySubscriptions($data: GetCompanySubscriptionsInput!) {
  companySubscriptions(data: $data) {
    ...SubscriptionParts
  }
}
    ${SubscriptionPartsFragmentDoc}`;

/**
 * __useGetBillingCompanySubscriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetBillingCompanySubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingCompanySubscriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingCompanySubscriptionsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetBillingCompanySubscriptionsQuery(variables: GetBillingCompanySubscriptionsQueryVariables | VueCompositionApi.Ref<GetBillingCompanySubscriptionsQueryVariables> | ReactiveFunction<GetBillingCompanySubscriptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables>(GetBillingCompanySubscriptionsDocument, variables, options);
}
export type GetBillingCompanySubscriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingCompanySubscriptionsQuery, GetBillingCompanySubscriptionsQueryVariables>;
export const MyProductsDocument = gql`
    query myProducts {
  myProducts {
    ...BillingProductParts
  }
}
    ${BillingProductPartsFragmentDoc}`;

/**
 * __useMyProductsQuery__
 *
 * To run a query within a Vue component, call `useMyProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyProductsQuery();
 */
export function useMyProductsQuery(options: VueApolloComposable.UseQueryOptions<MyProductsQuery, MyProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyProductsQuery, MyProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyProductsQuery, MyProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyProductsQuery, MyProductsQueryVariables>(MyProductsDocument, {}, options);
}
export type MyProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyProductsQuery, MyProductsQueryVariables>;
export const PurchaseCreditsDocument = gql`
    mutation purchaseCredits($data: PurchaseInput!) {
  purchaseCredits(data: $data) {
    ...ProductResultParts
  }
}
    ${ProductResultPartsFragmentDoc}`;

/**
 * __usePurchaseCreditsMutation__
 *
 * To run a mutation, you first call `usePurchaseCreditsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseCreditsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseCreditsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseCreditsMutation(options: VueApolloComposable.UseMutationOptions<PurchaseCreditsMutation, PurchaseCreditsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseCreditsMutation, PurchaseCreditsMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseCreditsMutation, PurchaseCreditsMutationVariables>(PurchaseCreditsDocument, options);
}
export type PurchaseCreditsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseCreditsMutation, PurchaseCreditsMutationVariables>;
export const PurchaseSubscriptionDocument = gql`
    mutation purchaseSubscription($data: PurchaseSubscriptionInput!) {
  purchaseSubscription(data: $data) {
    ...ProductResultParts
  }
}
    ${ProductResultPartsFragmentDoc}`;

/**
 * __usePurchaseSubscriptionMutation__
 *
 * To run a mutation, you first call `usePurchaseSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseSubscriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>(PurchaseSubscriptionDocument, options);
}
export type PurchaseSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>;
export const GetCompanyDelinquencyDocument = gql`
    query GetCompanyDelinquency($data: GetCompanyDelinquency!) {
  getCompanyDelinquency(data: $data) {
    ...CompanyDelinquencyParts
  }
}
    ${CompanyDelinquencyPartsFragmentDoc}`;

/**
 * __useGetCompanyDelinquencyQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyDelinquencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDelinquencyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyDelinquencyQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanyDelinquencyQuery(variables: GetCompanyDelinquencyQueryVariables | VueCompositionApi.Ref<GetCompanyDelinquencyQueryVariables> | ReactiveFunction<GetCompanyDelinquencyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables>(GetCompanyDelinquencyDocument, variables, options);
}
export type GetCompanyDelinquencyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyDelinquencyQuery, GetCompanyDelinquencyQueryVariables>;
export const GetCompanySourcesDocument = gql`
    query GetCompanySources($data: GetCompanyPaymentSources!) {
  getCompanySources(data: $data) {
    ...PaymentSourcesParts
  }
}
    ${PaymentSourcesPartsFragmentDoc}`;

/**
 * __useGetCompanySourcesQuery__
 *
 * To run a query within a Vue component, call `useGetCompanySourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySourcesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanySourcesQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanySourcesQuery(variables: GetCompanySourcesQueryVariables | VueCompositionApi.Ref<GetCompanySourcesQueryVariables> | ReactiveFunction<GetCompanySourcesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanySourcesQuery, GetCompanySourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanySourcesQuery, GetCompanySourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanySourcesQuery, GetCompanySourcesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanySourcesQuery, GetCompanySourcesQueryVariables>(GetCompanySourcesDocument, variables, options);
}
export type GetCompanySourcesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanySourcesQuery, GetCompanySourcesQueryVariables>;
export const UpdatePaymentSourceBillingAddressDocument = gql`
    mutation UpdatePaymentSourceBillingAddress($input: UpdatePaymentSourceBillingAddress!) {
  updatePaymentSourceBillingAddress(input: $input) {
    ...PaymentSourceParts
  }
}
    ${PaymentSourcePartsFragmentDoc}`;

/**
 * __useUpdatePaymentSourceBillingAddressMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentSourceBillingAddressMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentSourceBillingAddressMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePaymentSourceBillingAddressMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentSourceBillingAddressMutation(options: VueApolloComposable.UseMutationOptions<UpdatePaymentSourceBillingAddressMutation, UpdatePaymentSourceBillingAddressMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePaymentSourceBillingAddressMutation, UpdatePaymentSourceBillingAddressMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdatePaymentSourceBillingAddressMutation, UpdatePaymentSourceBillingAddressMutationVariables>(UpdatePaymentSourceBillingAddressDocument, options);
}
export type UpdatePaymentSourceBillingAddressMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePaymentSourceBillingAddressMutation, UpdatePaymentSourceBillingAddressMutationVariables>;
export const ScratchListServiceAddonsDocument = gql`
    query ScratchListServiceAddons($input: ScratchServiceAddonListInput!) {
  scratchListServiceAddons(input: $input) {
    id
    label
    priceLabel
    enabled
  }
}
    `;

/**
 * __useScratchListServiceAddonsQuery__
 *
 * To run a query within a Vue component, call `useScratchListServiceAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScratchListServiceAddonsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useScratchListServiceAddonsQuery({
 *   input: // value for 'input'
 * });
 */
export function useScratchListServiceAddonsQuery(variables: ScratchListServiceAddonsQueryVariables | VueCompositionApi.Ref<ScratchListServiceAddonsQueryVariables> | ReactiveFunction<ScratchListServiceAddonsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables>(ScratchListServiceAddonsDocument, variables, options);
}
export type ScratchListServiceAddonsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ScratchListServiceAddonsQuery, ScratchListServiceAddonsQueryVariables>;
export const ScratchToggleServiceAddonDocument = gql`
    mutation ScratchToggleServiceAddon($input: ScratchToggleServiceAddonInput!) {
  scratchToggleServiceAddon(input: $input) {
    id
    label
    priceLabel
    enabled
  }
}
    `;

/**
 * __useScratchToggleServiceAddonMutation__
 *
 * To run a mutation, you first call `useScratchToggleServiceAddonMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useScratchToggleServiceAddonMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useScratchToggleServiceAddonMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useScratchToggleServiceAddonMutation(options: VueApolloComposable.UseMutationOptions<ScratchToggleServiceAddonMutation, ScratchToggleServiceAddonMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ScratchToggleServiceAddonMutation, ScratchToggleServiceAddonMutationVariables>>) {
  return VueApolloComposable.useMutation<ScratchToggleServiceAddonMutation, ScratchToggleServiceAddonMutationVariables>(ScratchToggleServiceAddonDocument, options);
}
export type ScratchToggleServiceAddonMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ScratchToggleServiceAddonMutation, ScratchToggleServiceAddonMutationVariables>;
export const GetBillingHistoryDocument = gql`
    query GetBillingHistory($companyId: String!) {
  getBillingHistory(companyId: $companyId) {
    id
    createdAt
    modifiedAt
    amount
    productKey
    statementType
    status
    hostedUrl
    pdfUrl
    stripeSubscriptionId
  }
}
    `;

/**
 * __useGetBillingHistoryQuery__
 *
 * To run a query within a Vue component, call `useGetBillingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingHistoryQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetBillingHistoryQuery(variables: GetBillingHistoryQueryVariables | VueCompositionApi.Ref<GetBillingHistoryQueryVariables> | ReactiveFunction<GetBillingHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingHistoryQuery, GetBillingHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingHistoryQuery, GetBillingHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingHistoryQuery, GetBillingHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingHistoryQuery, GetBillingHistoryQueryVariables>(GetBillingHistoryDocument, variables, options);
}
export type GetBillingHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingHistoryQuery, GetBillingHistoryQueryVariables>;
export const GetBillingInfoPaymentMethodsDocument = gql`
    query GetBillingInfoPaymentMethods($input: GetBillingInfoInput!) {
  getBillingInfo(input: $input) {
    paymentMethods {
      id
      default
      status
      type
      name
      issueReason
      nextAction
      expirationDate
    }
  }
}
    `;

/**
 * __useGetBillingInfoPaymentMethodsQuery__
 *
 * To run a query within a Vue component, call `useGetBillingInfoPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingInfoPaymentMethodsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingInfoPaymentMethodsQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetBillingInfoPaymentMethodsQuery(variables: GetBillingInfoPaymentMethodsQueryVariables | VueCompositionApi.Ref<GetBillingInfoPaymentMethodsQueryVariables> | ReactiveFunction<GetBillingInfoPaymentMethodsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables>(GetBillingInfoPaymentMethodsDocument, variables, options);
}
export type GetBillingInfoPaymentMethodsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingInfoPaymentMethodsQuery, GetBillingInfoPaymentMethodsQueryVariables>;
export const GetCorePlanAccessDocument = gql`
    query GetCorePlanAccess($input: GetBillingInfoInput!) {
  getBillingInfo(input: $input) {
    id
    coreSubscription {
      provider
      state
      active
      plan {
        productKey
        legacyProductKey
      }
    }
  }
}
    `;

/**
 * __useGetCorePlanAccessQuery__
 *
 * To run a query within a Vue component, call `useGetCorePlanAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorePlanAccessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCorePlanAccessQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetCorePlanAccessQuery(variables: GetCorePlanAccessQueryVariables | VueCompositionApi.Ref<GetCorePlanAccessQueryVariables> | ReactiveFunction<GetCorePlanAccessQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCorePlanAccessQuery, GetCorePlanAccessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCorePlanAccessQuery, GetCorePlanAccessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCorePlanAccessQuery, GetCorePlanAccessQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCorePlanAccessQuery, GetCorePlanAccessQueryVariables>(GetCorePlanAccessDocument, variables, options);
}
export type GetCorePlanAccessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCorePlanAccessQuery, GetCorePlanAccessQueryVariables>;
export const GetBillingInfoDocument = gql`
    query GetBillingInfo($input: GetBillingInfoInput!) {
  getBillingInfo(input: $input) {
    id
    pause {
      id
      isPaused
      reactivatesOn
    }
    coreSubscription {
      active
      cancellationRequested
      cancelsAt
      periodEndsAt
      plan {
        name
        productKey
        legacyProductKey
        billingPeriod
        price
        employeeSizeMapping
        value
      }
      scheduledPlanChange {
        effectiveOn
        newPlan {
          name
        }
      }
    }
    addonSubscriptions {
      active
      cancelsAt
      quantity
      plan {
        name
        billingPeriod
        price
        serviceKey
      }
      periodEndsAt
    }
  }
}
    `;

/**
 * __useGetBillingInfoQuery__
 *
 * To run a query within a Vue component, call `useGetBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingInfoQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetBillingInfoQuery(variables: GetBillingInfoQueryVariables | VueCompositionApi.Ref<GetBillingInfoQueryVariables> | ReactiveFunction<GetBillingInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingInfoQuery, GetBillingInfoQueryVariables>(GetBillingInfoDocument, variables, options);
}
export type GetBillingInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingInfoQuery, GetBillingInfoQueryVariables>;
export const GetBillingSubscriptionTermEndDocument = gql`
    query GetBillingSubscriptionTermEnd($companyId: ID!) {
  billingSubscription(companyId: $companyId) {
    currentTermEndsAt
  }
}
    `;

/**
 * __useGetBillingSubscriptionTermEndQuery__
 *
 * To run a query within a Vue component, call `useGetBillingSubscriptionTermEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingSubscriptionTermEndQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingSubscriptionTermEndQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetBillingSubscriptionTermEndQuery(variables: GetBillingSubscriptionTermEndQueryVariables | VueCompositionApi.Ref<GetBillingSubscriptionTermEndQueryVariables> | ReactiveFunction<GetBillingSubscriptionTermEndQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingSubscriptionTermEndQuery, GetBillingSubscriptionTermEndQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingSubscriptionTermEndQuery, GetBillingSubscriptionTermEndQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingSubscriptionTermEndQuery, GetBillingSubscriptionTermEndQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingSubscriptionTermEndQuery, GetBillingSubscriptionTermEndQueryVariables>(GetBillingSubscriptionTermEndDocument, variables, options);
}
export type GetBillingSubscriptionTermEndQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingSubscriptionTermEndQuery, GetBillingSubscriptionTermEndQueryVariables>;
export const ConfirmMicroDepositDocument = gql`
    mutation ConfirmMicroDeposit($input: ConfirmMicroDepositInput!) {
  confirmMicroDeposit(input: $input) {
    id
    default
    status
    type
    name
    expirationDate
  }
}
    `;

/**
 * __useConfirmMicroDepositMutation__
 *
 * To run a mutation, you first call `useConfirmMicroDepositMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMicroDepositMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmMicroDepositMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConfirmMicroDepositMutation(options: VueApolloComposable.UseMutationOptions<ConfirmMicroDepositMutation, ConfirmMicroDepositMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmMicroDepositMutation, ConfirmMicroDepositMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfirmMicroDepositMutation, ConfirmMicroDepositMutationVariables>(ConfirmMicroDepositDocument, options);
}
export type ConfirmMicroDepositMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmMicroDepositMutation, ConfirmMicroDepositMutationVariables>;
export const GetCompanySubscriptionsDocument = gql`
    query GetCompanySubscriptions($data: GetCompanySubscriptionsInput!) {
  companySubscriptions(data: $data) {
    name
    productCode
    amount
    status
    startDate
    endDate
    stripeId
    stripePriceId
    createdAt
    isDrp
  }
}
    `;

/**
 * __useGetCompanySubscriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanySubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySubscriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanySubscriptionsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanySubscriptionsQuery(variables: GetCompanySubscriptionsQueryVariables | VueCompositionApi.Ref<GetCompanySubscriptionsQueryVariables> | ReactiveFunction<GetCompanySubscriptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables>(GetCompanySubscriptionsDocument, variables, options);
}
export type GetCompanySubscriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables>;
export const RemovePaymentMethodDocument = gql`
    mutation RemovePaymentMethod($input: RemovePaymentMethodInput!) {
  removePaymentMethod(input: $input)
}
    `;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePaymentMethodMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(options: VueApolloComposable.UseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>>) {
  return VueApolloComposable.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options);
}
export type RemovePaymentMethodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const RecurlyPaymentMethodsDocument = gql`
    query RecurlyPaymentMethods($companyId: ID!) {
  paymentMethods(companyId: $companyId) {
    id
    kind
    brand
    last4
    expMonth
    expYear
    primary
    backup
    bankName
    accountType
    verificationStatus
  }
}
    `;

/**
 * __useRecurlyPaymentMethodsQuery__
 *
 * To run a query within a Vue component, call `useRecurlyPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurlyPaymentMethodsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRecurlyPaymentMethodsQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useRecurlyPaymentMethodsQuery(variables: RecurlyPaymentMethodsQueryVariables | VueCompositionApi.Ref<RecurlyPaymentMethodsQueryVariables> | ReactiveFunction<RecurlyPaymentMethodsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RecurlyPaymentMethodsQuery, RecurlyPaymentMethodsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RecurlyPaymentMethodsQuery, RecurlyPaymentMethodsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RecurlyPaymentMethodsQuery, RecurlyPaymentMethodsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RecurlyPaymentMethodsQuery, RecurlyPaymentMethodsQueryVariables>(RecurlyPaymentMethodsDocument, variables, options);
}
export type RecurlyPaymentMethodsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RecurlyPaymentMethodsQuery, RecurlyPaymentMethodsQueryVariables>;
export const AddRecurlyPaymentMethodDocument = gql`
    mutation AddRecurlyPaymentMethod($input: AddPaymentMethodInput!) {
  addPaymentMethod(input: $input) {
    requiresAction
    actionTokenId
    paymentMethod {
      id
      primary
    }
  }
}
    `;

/**
 * __useAddRecurlyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddRecurlyPaymentMethodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddRecurlyPaymentMethodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddRecurlyPaymentMethodMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddRecurlyPaymentMethodMutation(options: VueApolloComposable.UseMutationOptions<AddRecurlyPaymentMethodMutation, AddRecurlyPaymentMethodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddRecurlyPaymentMethodMutation, AddRecurlyPaymentMethodMutationVariables>>) {
  return VueApolloComposable.useMutation<AddRecurlyPaymentMethodMutation, AddRecurlyPaymentMethodMutationVariables>(AddRecurlyPaymentMethodDocument, options);
}
export type AddRecurlyPaymentMethodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddRecurlyPaymentMethodMutation, AddRecurlyPaymentMethodMutationVariables>;
export const SetPrimaryRecurlyPaymentMethodDocument = gql`
    mutation SetPrimaryRecurlyPaymentMethod($input: PaymentMethodRef!) {
  setPrimaryPaymentMethod(input: $input) {
    id
    primary
  }
}
    `;

/**
 * __useSetPrimaryRecurlyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetPrimaryRecurlyPaymentMethodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryRecurlyPaymentMethodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetPrimaryRecurlyPaymentMethodMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetPrimaryRecurlyPaymentMethodMutation(options: VueApolloComposable.UseMutationOptions<SetPrimaryRecurlyPaymentMethodMutation, SetPrimaryRecurlyPaymentMethodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetPrimaryRecurlyPaymentMethodMutation, SetPrimaryRecurlyPaymentMethodMutationVariables>>) {
  return VueApolloComposable.useMutation<SetPrimaryRecurlyPaymentMethodMutation, SetPrimaryRecurlyPaymentMethodMutationVariables>(SetPrimaryRecurlyPaymentMethodDocument, options);
}
export type SetPrimaryRecurlyPaymentMethodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetPrimaryRecurlyPaymentMethodMutation, SetPrimaryRecurlyPaymentMethodMutationVariables>;
export const RemoveRecurlyPaymentMethodDocument = gql`
    mutation RemoveRecurlyPaymentMethod($input: PaymentMethodRef!) {
  removePaymentMethodV2(input: $input)
}
    `;

/**
 * __useRemoveRecurlyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemoveRecurlyPaymentMethodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRecurlyPaymentMethodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveRecurlyPaymentMethodMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveRecurlyPaymentMethodMutation(options: VueApolloComposable.UseMutationOptions<RemoveRecurlyPaymentMethodMutation, RemoveRecurlyPaymentMethodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveRecurlyPaymentMethodMutation, RemoveRecurlyPaymentMethodMutationVariables>>) {
  return VueApolloComposable.useMutation<RemoveRecurlyPaymentMethodMutation, RemoveRecurlyPaymentMethodMutationVariables>(RemoveRecurlyPaymentMethodDocument, options);
}
export type RemoveRecurlyPaymentMethodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveRecurlyPaymentMethodMutation, RemoveRecurlyPaymentMethodMutationVariables>;
export const RecurlyInvoicesDocument = gql`
    query RecurlyInvoices($companyId: ID!, $first: Int!) {
  invoices(companyId: $companyId, first: $first) {
    hasNextPage
    endCursor
    nodes {
      id
      number
      state
      type
      createdAt
      paidAt
      total {
        amount
        currency
      }
      pdfUrl
      lines {
        description
        planCode
        addOnCode
        type
      }
    }
  }
}
    `;

/**
 * __useRecurlyInvoicesQuery__
 *
 * To run a query within a Vue component, call `useRecurlyInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurlyInvoicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRecurlyInvoicesQuery({
 *   companyId: // value for 'companyId'
 *   first: // value for 'first'
 * });
 */
export function useRecurlyInvoicesQuery(variables: RecurlyInvoicesQueryVariables | VueCompositionApi.Ref<RecurlyInvoicesQueryVariables> | ReactiveFunction<RecurlyInvoicesQueryVariables>, options: VueApolloComposable.UseQueryOptions<RecurlyInvoicesQuery, RecurlyInvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RecurlyInvoicesQuery, RecurlyInvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RecurlyInvoicesQuery, RecurlyInvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RecurlyInvoicesQuery, RecurlyInvoicesQueryVariables>(RecurlyInvoicesDocument, variables, options);
}
export type RecurlyInvoicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RecurlyInvoicesQuery, RecurlyInvoicesQueryVariables>;
export const SetDefaultBillingPaymentMethodDocument = gql`
    mutation SetDefaultBillingPaymentMethod($input: SetDefaultPaymentMethodInput!) {
  setDefaultPaymentMethod(input: $input) {
    id
    default
    status
    type
    name
    expirationDate
  }
}
    `;

/**
 * __useSetDefaultBillingPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultBillingPaymentMethodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultBillingPaymentMethodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetDefaultBillingPaymentMethodMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultBillingPaymentMethodMutation(options: VueApolloComposable.UseMutationOptions<SetDefaultBillingPaymentMethodMutation, SetDefaultBillingPaymentMethodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetDefaultBillingPaymentMethodMutation, SetDefaultBillingPaymentMethodMutationVariables>>) {
  return VueApolloComposable.useMutation<SetDefaultBillingPaymentMethodMutation, SetDefaultBillingPaymentMethodMutationVariables>(SetDefaultBillingPaymentMethodDocument, options);
}
export type SetDefaultBillingPaymentMethodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetDefaultBillingPaymentMethodMutation, SetDefaultBillingPaymentMethodMutationVariables>;
export const GetAvailableProductsDocument = gql`
    query GetAvailableProducts($data: GetAvailableProductsInput!) {
  getAvailableProducts(data: $data) {
    id
    key
    name
    tier
    billingPeriod
    monthlyAllowance
    subscriptionPrice
    price
    allowance
    discountedPrice
  }
}
    `;

/**
 * __useGetAvailableProductsQuery__
 *
 * To run a query within a Vue component, call `useGetAvailableProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailableProductsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetAvailableProductsQuery(variables: GetAvailableProductsQueryVariables | VueCompositionApi.Ref<GetAvailableProductsQueryVariables> | ReactiveFunction<GetAvailableProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAvailableProductsQuery, GetAvailableProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailableProductsQuery, GetAvailableProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailableProductsQuery, GetAvailableProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAvailableProductsQuery, GetAvailableProductsQueryVariables>(GetAvailableProductsDocument, variables, options);
}
export type GetAvailableProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAvailableProductsQuery, GetAvailableProductsQueryVariables>;
export const GetCompanyCreditsDocument = gql`
    query GetCompanyCredits($data: GetCompanyCreditsInputV2!) {
  getCompanyCreditsV2(data: $data) {
    id
    createdAt
    productKey
    creditType
  }
}
    `;

/**
 * __useGetCompanyCreditsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyCreditsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyCreditsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanyCreditsQuery(variables: GetCompanyCreditsQueryVariables | VueCompositionApi.Ref<GetCompanyCreditsQueryVariables> | ReactiveFunction<GetCompanyCreditsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables>(GetCompanyCreditsDocument, variables, options);
}
export type GetCompanyCreditsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyCreditsQuery, GetCompanyCreditsQueryVariables>;
export const ReactivatePausedCompanyDocument = gql`
    mutation ReactivatePausedCompany($input: ReactivatePausedCompanyInput!) {
  reactivatePausedCompany(input: $input)
}
    `;

/**
 * __useReactivatePausedCompanyMutation__
 *
 * To run a mutation, you first call `useReactivatePausedCompanyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReactivatePausedCompanyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReactivatePausedCompanyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReactivatePausedCompanyMutation(options: VueApolloComposable.UseMutationOptions<ReactivatePausedCompanyMutation, ReactivatePausedCompanyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReactivatePausedCompanyMutation, ReactivatePausedCompanyMutationVariables>>) {
  return VueApolloComposable.useMutation<ReactivatePausedCompanyMutation, ReactivatePausedCompanyMutationVariables>(ReactivatePausedCompanyDocument, options);
}
export type ReactivatePausedCompanyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReactivatePausedCompanyMutation, ReactivatePausedCompanyMutationVariables>;
export const PremiumPeopleAddonPlanForCompanyDocument = gql`
    query PremiumPeopleAddonPlanForCompany($companyId: String) {
  premiumPeopleAddonPlanForCompany(companyId: $companyId) {
    serviceKey
    productKey
    name
    value
    priceId
    price
    billingPeriod
    status
  }
}
    `;

/**
 * __usePremiumPeopleAddonPlanForCompanyQuery__
 *
 * To run a query within a Vue component, call `usePremiumPeopleAddonPlanForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremiumPeopleAddonPlanForCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePremiumPeopleAddonPlanForCompanyQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function usePremiumPeopleAddonPlanForCompanyQuery(variables: PremiumPeopleAddonPlanForCompanyQueryVariables | VueCompositionApi.Ref<PremiumPeopleAddonPlanForCompanyQueryVariables> | ReactiveFunction<PremiumPeopleAddonPlanForCompanyQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PremiumPeopleAddonPlanForCompanyQuery, PremiumPeopleAddonPlanForCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PremiumPeopleAddonPlanForCompanyQuery, PremiumPeopleAddonPlanForCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PremiumPeopleAddonPlanForCompanyQuery, PremiumPeopleAddonPlanForCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PremiumPeopleAddonPlanForCompanyQuery, PremiumPeopleAddonPlanForCompanyQueryVariables>(PremiumPeopleAddonPlanForCompanyDocument, variables, options);
}
export type PremiumPeopleAddonPlanForCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PremiumPeopleAddonPlanForCompanyQuery, PremiumPeopleAddonPlanForCompanyQueryVariables>;
export const PremiumPeopleCorePlansDocument = gql`
    query PremiumPeopleCorePlans($companyId: ID) {
  premiumPeopleCorePlans(companyId: $companyId) {
    priceId
    productKey
    name
    value
    billingPeriod
    tierNumber
    minSize
    maxSize
    price
    monthlyPrice
    status
  }
}
    `;

/**
 * __usePremiumPeopleCorePlansQuery__
 *
 * To run a query within a Vue component, call `usePremiumPeopleCorePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremiumPeopleCorePlansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePremiumPeopleCorePlansQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function usePremiumPeopleCorePlansQuery(variables: PremiumPeopleCorePlansQueryVariables | VueCompositionApi.Ref<PremiumPeopleCorePlansQueryVariables> | ReactiveFunction<PremiumPeopleCorePlansQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PremiumPeopleCorePlansQuery, PremiumPeopleCorePlansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PremiumPeopleCorePlansQuery, PremiumPeopleCorePlansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PremiumPeopleCorePlansQuery, PremiumPeopleCorePlansQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PremiumPeopleCorePlansQuery, PremiumPeopleCorePlansQueryVariables>(PremiumPeopleCorePlansDocument, variables, options);
}
export type PremiumPeopleCorePlansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PremiumPeopleCorePlansQuery, PremiumPeopleCorePlansQueryVariables>;
export const CreatePremiumPeopleAddonSubscriptionDocument = gql`
    mutation CreatePremiumPeopleAddonSubscription($data: CreatePremiumPeopleAddonInput!) {
  createPremiumPeopleAddonSubscription(data: $data) {
    name
    status
    stripeId
    stripePriceId
    productCode
    planValue
    amount
    startDate
    endDate
    isDrp
  }
}
    `;

/**
 * __useCreatePremiumPeopleAddonSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreatePremiumPeopleAddonSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePremiumPeopleAddonSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePremiumPeopleAddonSubscriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreatePremiumPeopleAddonSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<CreatePremiumPeopleAddonSubscriptionMutation, CreatePremiumPeopleAddonSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePremiumPeopleAddonSubscriptionMutation, CreatePremiumPeopleAddonSubscriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<CreatePremiumPeopleAddonSubscriptionMutation, CreatePremiumPeopleAddonSubscriptionMutationVariables>(CreatePremiumPeopleAddonSubscriptionDocument, options);
}
export type CreatePremiumPeopleAddonSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePremiumPeopleAddonSubscriptionMutation, CreatePremiumPeopleAddonSubscriptionMutationVariables>;
export const GetCancellationReasonsDocument = gql`
    query GetCancellationReasons {
  activeCancellationReasonGroups {
    code
    externalText
    reasons {
      code
      externalText
    }
  }
}
    `;

/**
 * __useGetCancellationReasonsQuery__
 *
 * To run a query within a Vue component, call `useGetCancellationReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationReasonsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCancellationReasonsQuery();
 */
export function useGetCancellationReasonsQuery(options: VueApolloComposable.UseQueryOptions<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables>(GetCancellationReasonsDocument, {}, options);
}
export type GetCancellationReasonsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables>;
export const GetCancellationOffersDocument = gql`
    query GetCancellationOffers {
  cancellationOffers {
    trialExtension
    downgradePlans {
      productKey
    }
    pausePlan {
      productKey
    }
    storagePlan {
      productKey
    }
  }
}
    `;

/**
 * __useGetCancellationOffersQuery__
 *
 * To run a query within a Vue component, call `useGetCancellationOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationOffersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCancellationOffersQuery();
 */
export function useGetCancellationOffersQuery(options: VueApolloComposable.UseQueryOptions<GetCancellationOffersQuery, GetCancellationOffersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCancellationOffersQuery, GetCancellationOffersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCancellationOffersQuery, GetCancellationOffersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCancellationOffersQuery, GetCancellationOffersQueryVariables>(GetCancellationOffersDocument, {}, options);
}
export type GetCancellationOffersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCancellationOffersQuery, GetCancellationOffersQueryVariables>;
export const AcceptOfferDocument = gql`
    mutation AcceptOffer($input: AcceptOfferInput!) {
  acceptOffer(input: $input)
}
    `;

/**
 * __useAcceptOfferMutation__
 *
 * To run a mutation, you first call `useAcceptOfferMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOfferMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptOfferMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAcceptOfferMutation(options: VueApolloComposable.UseMutationOptions<AcceptOfferMutation, AcceptOfferMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptOfferMutation, AcceptOfferMutationVariables>>) {
  return VueApolloComposable.useMutation<AcceptOfferMutation, AcceptOfferMutationVariables>(AcceptOfferDocument, options);
}
export type AcceptOfferMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptOfferMutation, AcceptOfferMutationVariables>;
export const AcceptTrialExtensionDocument = gql`
    mutation AcceptTrialExtension($input: AcceptTrialOfferInput!) {
  acceptTrialOffer(input: $input)
}
    `;

/**
 * __useAcceptTrialExtensionMutation__
 *
 * To run a mutation, you first call `useAcceptTrialExtensionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTrialExtensionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptTrialExtensionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAcceptTrialExtensionMutation(options: VueApolloComposable.UseMutationOptions<AcceptTrialExtensionMutation, AcceptTrialExtensionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptTrialExtensionMutation, AcceptTrialExtensionMutationVariables>>) {
  return VueApolloComposable.useMutation<AcceptTrialExtensionMutation, AcceptTrialExtensionMutationVariables>(AcceptTrialExtensionDocument, options);
}
export type AcceptTrialExtensionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptTrialExtensionMutation, AcceptTrialExtensionMutationVariables>;
export const SubmitCancelRequestDocument = gql`
    mutation SubmitCancelRequest($input: CreateCancellationRequestInput!) {
  createCancellationRequest(input: $input) {
    clientReasonNote
  }
}
    `;

/**
 * __useSubmitCancelRequestMutation__
 *
 * To run a mutation, you first call `useSubmitCancelRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCancelRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitCancelRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCancelRequestMutation(options: VueApolloComposable.UseMutationOptions<SubmitCancelRequestMutation, SubmitCancelRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SubmitCancelRequestMutation, SubmitCancelRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<SubmitCancelRequestMutation, SubmitCancelRequestMutationVariables>(SubmitCancelRequestDocument, options);
}
export type SubmitCancelRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SubmitCancelRequestMutation, SubmitCancelRequestMutationVariables>;
export const GetCompanySettingsDocument = gql`
    query GetCompanySettings($data: String!) {
  getCompanySettings(companyId: $data) {
    id
    key
    type
    value
  }
}
    `;

/**
 * __useGetCompanySettingsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanySettingsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanySettingsQuery(variables: GetCompanySettingsQueryVariables | VueCompositionApi.Ref<GetCompanySettingsQueryVariables> | ReactiveFunction<GetCompanySettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(GetCompanySettingsDocument, variables, options);
}
export type GetCompanySettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>;
export const ListPracticeDocument = gql`
    query ListPractice($companyId: String!) {
  listPractice(companyId: $companyId) {
    id
    companyId
    title
    shortDescription
    description
    introDescription
    shortName
    iconUrl
    illustrationUrl
    outroIllustrationUrl
    successOutroTitle
    status
    state
    setupProgress
    survey {
      id
      type
      completedAt
    }
  }
}
    `;

/**
 * __useListPracticeQuery__
 *
 * To run a query within a Vue component, call `useListPracticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPracticeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListPracticeQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useListPracticeQuery(variables: ListPracticeQueryVariables | VueCompositionApi.Ref<ListPracticeQueryVariables> | ReactiveFunction<ListPracticeQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListPracticeQuery, ListPracticeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListPracticeQuery, ListPracticeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListPracticeQuery, ListPracticeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListPracticeQuery, ListPracticeQueryVariables>(ListPracticeDocument, variables, options);
}
export type ListPracticeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListPracticeQuery, ListPracticeQueryVariables>;
export const GetPracticeDocument = gql`
    query GetPractice($input: GetPracticeInput!) {
  getPractice(input: $input) {
    id
    companyId
    title
    shortDescription
    description
    introDescription
    shortName
    iconUrl
    illustrationUrl
    outroIllustrationUrl
    successOutroTitle
    status
    state
    setupProgress
    survey {
      id
      type
      completedAt
      questions
      answers
    }
  }
}
    `;

/**
 * __useGetPracticeQuery__
 *
 * To run a query within a Vue component, call `useGetPracticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPracticeQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetPracticeQuery(variables: GetPracticeQueryVariables | VueCompositionApi.Ref<GetPracticeQueryVariables> | ReactiveFunction<GetPracticeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPracticeQuery, GetPracticeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPracticeQuery, GetPracticeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPracticeQuery, GetPracticeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPracticeQuery, GetPracticeQueryVariables>(GetPracticeDocument, variables, options);
}
export type GetPracticeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPracticeQuery, GetPracticeQueryVariables>;
export const GetHrScoreDocument = gql`
    query GetHrScore($companyId: String!) {
  getHrScore(companyId: $companyId)
}
    `;

/**
 * __useGetHrScoreQuery__
 *
 * To run a query within a Vue component, call `useGetHrScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrScoreQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHrScoreQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetHrScoreQuery(variables: GetHrScoreQueryVariables | VueCompositionApi.Ref<GetHrScoreQueryVariables> | ReactiveFunction<GetHrScoreQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetHrScoreQuery, GetHrScoreQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHrScoreQuery, GetHrScoreQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHrScoreQuery, GetHrScoreQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHrScoreQuery, GetHrScoreQueryVariables>(GetHrScoreDocument, variables, options);
}
export type GetHrScoreQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHrScoreQuery, GetHrScoreQueryVariables>;
export const GetCompanySurveyDocument = gql`
    query GetCompanySurvey($data: GetCompanySurveyInput!) {
  companySurvey(data: $data) {
    id
    type
    completedAt
    questions
    answers
  }
}
    `;

/**
 * __useGetCompanySurveyQuery__
 *
 * To run a query within a Vue component, call `useGetCompanySurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySurveyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanySurveyQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanySurveyQuery(variables: GetCompanySurveyQueryVariables | VueCompositionApi.Ref<GetCompanySurveyQueryVariables> | ReactiveFunction<GetCompanySurveyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanySurveyQuery, GetCompanySurveyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanySurveyQuery, GetCompanySurveyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanySurveyQuery, GetCompanySurveyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanySurveyQuery, GetCompanySurveyQueryVariables>(GetCompanySurveyDocument, variables, options);
}
export type GetCompanySurveyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanySurveyQuery, GetCompanySurveyQueryVariables>;
export const SaveCompanyAnswerDocument = gql`
    mutation SaveCompanyAnswer($data: SaveCompanyAnswerInput!) {
  saveCompanyAnswer(data: $data) {
    id
    type
    completedAt
    questions
    answers
  }
}
    `;

/**
 * __useSaveCompanyAnswerMutation__
 *
 * To run a mutation, you first call `useSaveCompanyAnswerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompanyAnswerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveCompanyAnswerMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSaveCompanyAnswerMutation(options: VueApolloComposable.UseMutationOptions<SaveCompanyAnswerMutation, SaveCompanyAnswerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveCompanyAnswerMutation, SaveCompanyAnswerMutationVariables>>) {
  return VueApolloComposable.useMutation<SaveCompanyAnswerMutation, SaveCompanyAnswerMutationVariables>(SaveCompanyAnswerDocument, options);
}
export type SaveCompanyAnswerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveCompanyAnswerMutation, SaveCompanyAnswerMutationVariables>;
export const CompleteCompanySurveyDocument = gql`
    mutation CompleteCompanySurvey($data: CompleteCompanySurveyInput!) {
  completeCompanySurvey(data: $data) {
    id
    type
    completedAt
  }
}
    `;

/**
 * __useCompleteCompanySurveyMutation__
 *
 * To run a mutation, you first call `useCompleteCompanySurveyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCompanySurveyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCompanySurveyMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteCompanySurveyMutation(options: VueApolloComposable.UseMutationOptions<CompleteCompanySurveyMutation, CompleteCompanySurveyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteCompanySurveyMutation, CompleteCompanySurveyMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteCompanySurveyMutation, CompleteCompanySurveyMutationVariables>(CompleteCompanySurveyDocument, options);
}
export type CompleteCompanySurveyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteCompanySurveyMutation, CompleteCompanySurveyMutationVariables>;
export const CompleteCompanyPracticeDocument = gql`
    mutation CompleteCompanyPractice($data: CompletePracticeInput!) {
  completeCompanyPractice(data: $data) {
    id
    status
    state
  }
}
    `;

/**
 * __useCompleteCompanyPracticeMutation__
 *
 * To run a mutation, you first call `useCompleteCompanyPracticeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCompanyPracticeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCompanyPracticeMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteCompanyPracticeMutation(options: VueApolloComposable.UseMutationOptions<CompleteCompanyPracticeMutation, CompleteCompanyPracticeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteCompanyPracticeMutation, CompleteCompanyPracticeMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteCompanyPracticeMutation, CompleteCompanyPracticeMutationVariables>(CompleteCompanyPracticeDocument, options);
}
export type CompleteCompanyPracticeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteCompanyPracticeMutation, CompleteCompanyPracticeMutationVariables>;
export const GetBasicCompanyInfoDocument = gql`
    query GetBasicCompanyInfo($id: ID!) {
  coreCompany(id: $id) {
    id
    name
    industry
    phone
  }
}
    `;

/**
 * __useGetBasicCompanyInfoQuery__
 *
 * To run a query within a Vue component, call `useGetBasicCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicCompanyInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBasicCompanyInfoQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetBasicCompanyInfoQuery(variables: GetBasicCompanyInfoQueryVariables | VueCompositionApi.Ref<GetBasicCompanyInfoQueryVariables> | ReactiveFunction<GetBasicCompanyInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables>(GetBasicCompanyInfoDocument, variables, options);
}
export type GetBasicCompanyInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBasicCompanyInfoQuery, GetBasicCompanyInfoQueryVariables>;
export const UpdateBasicCompanyInfoDocument = gql`
    mutation UpdateBasicCompanyInfo($data: UpdateCoreCompanyInput!) {
  updateCoreCompany(data: $data) {
    id
    name
    industry
    phone
  }
}
    `;

/**
 * __useUpdateBasicCompanyInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBasicCompanyInfoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasicCompanyInfoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBasicCompanyInfoMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBasicCompanyInfoMutation(options: VueApolloComposable.UseMutationOptions<UpdateBasicCompanyInfoMutation, UpdateBasicCompanyInfoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBasicCompanyInfoMutation, UpdateBasicCompanyInfoMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateBasicCompanyInfoMutation, UpdateBasicCompanyInfoMutationVariables>(UpdateBasicCompanyInfoDocument, options);
}
export type UpdateBasicCompanyInfoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBasicCompanyInfoMutation, UpdateBasicCompanyInfoMutationVariables>;
export const GetSimplePolicyListDocument = gql`
    query GetSimplePolicyList($companyId: ID!) {
  getCoreCompany(id: $companyId) {
    policies(limit: 200, page: 1, status: ["in-progress", "approved", "complete"]) {
      id
      name
      isCPD
      archivedAt
      status
      step
    }
  }
}
    `;

/**
 * __useGetSimplePolicyListQuery__
 *
 * To run a query within a Vue component, call `useGetSimplePolicyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimplePolicyListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSimplePolicyListQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetSimplePolicyListQuery(variables: GetSimplePolicyListQueryVariables | VueCompositionApi.Ref<GetSimplePolicyListQueryVariables> | ReactiveFunction<GetSimplePolicyListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables>(GetSimplePolicyListDocument, variables, options);
}
export type GetSimplePolicyListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSimplePolicyListQuery, GetSimplePolicyListQueryVariables>;
export const SaveCompanySettingDocument = gql`
    mutation SaveCompanySetting($input: SaveCompanySettingInput!) {
  saveCompanySetting(input: $input) {
    id
    companyId
    key
    type
    value
  }
}
    `;

/**
 * __useSaveCompanySettingMutation__
 *
 * To run a mutation, you first call `useSaveCompanySettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompanySettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveCompanySettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveCompanySettingMutation(options: VueApolloComposable.UseMutationOptions<SaveCompanySettingMutation, SaveCompanySettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveCompanySettingMutation, SaveCompanySettingMutationVariables>>) {
  return VueApolloComposable.useMutation<SaveCompanySettingMutation, SaveCompanySettingMutationVariables>(SaveCompanySettingDocument, options);
}
export type SaveCompanySettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveCompanySettingMutation, SaveCompanySettingMutationVariables>;
export const BulkMessageStaffDocument = gql`
    mutation BulkMessageStaff($data: BulkMessageStaffInput!) {
  bulkMessageStaff(data: $data) {
    successfulStaffIds
    errors {
      staffId
      errorMsg
    }
  }
}
    `;

/**
 * __useBulkMessageStaffMutation__
 *
 * To run a mutation, you first call `useBulkMessageStaffMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkMessageStaffMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkMessageStaffMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useBulkMessageStaffMutation(options: VueApolloComposable.UseMutationOptions<BulkMessageStaffMutation, BulkMessageStaffMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkMessageStaffMutation, BulkMessageStaffMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkMessageStaffMutation, BulkMessageStaffMutationVariables>(BulkMessageStaffDocument, options);
}
export type BulkMessageStaffMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkMessageStaffMutation, BulkMessageStaffMutationVariables>;
export const GetCompanyRolesDocument = gql`
    query GetCompanyRoles($companyId: ID!) {
  getCoreCompany(id: $companyId) {
    companyRoles {
      id
      title
      createdAt
      deletedAt
      workerRoles {
        id
      }
    }
  }
}
    `;

/**
 * __useGetCompanyRolesQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyRolesQuery({
 *   companyId: // value for 'companyId'
 * });
 */
export function useGetCompanyRolesQuery(variables: GetCompanyRolesQueryVariables | VueCompositionApi.Ref<GetCompanyRolesQueryVariables> | ReactiveFunction<GetCompanyRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyRolesQuery, GetCompanyRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyRolesQuery, GetCompanyRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyRolesQuery, GetCompanyRolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyRolesQuery, GetCompanyRolesQueryVariables>(GetCompanyRolesDocument, variables, options);
}
export type GetCompanyRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyRolesQuery, GetCompanyRolesQueryVariables>;
export const CreateCompanyRolesDocument = gql`
    mutation CreateCompanyRoles($data: CreateMultipleRolesForCompanyInput!) {
  createCompanyRoles(data: $data) {
    id
    title
    createdAt
    deletedAt
    workerRoles {
      id
    }
  }
}
    `;

/**
 * __useCreateCompanyRolesMutation__
 *
 * To run a mutation, you first call `useCreateCompanyRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCompanyRolesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateCompanyRolesMutation(options: VueApolloComposable.UseMutationOptions<CreateCompanyRolesMutation, CreateCompanyRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCompanyRolesMutation, CreateCompanyRolesMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateCompanyRolesMutation, CreateCompanyRolesMutationVariables>(CreateCompanyRolesDocument, options);
}
export type CreateCompanyRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCompanyRolesMutation, CreateCompanyRolesMutationVariables>;
export const UpdateCompanyRolesDocument = gql`
    mutation UpdateCompanyRoles($data: UpdateMultipleRolesForCompanyInput!) {
  updateCompanyRoles(data: $data) {
    id
    title
    createdAt
    deletedAt
    workerRoles {
      id
    }
  }
}
    `;

/**
 * __useUpdateCompanyRolesMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCompanyRolesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompanyRolesMutation(options: VueApolloComposable.UseMutationOptions<UpdateCompanyRolesMutation, UpdateCompanyRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCompanyRolesMutation, UpdateCompanyRolesMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateCompanyRolesMutation, UpdateCompanyRolesMutationVariables>(UpdateCompanyRolesDocument, options);
}
export type UpdateCompanyRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCompanyRolesMutation, UpdateCompanyRolesMutationVariables>;
export const DeleteCompanyRolesDocument = gql`
    mutation DeleteCompanyRoles($data: DeleteCompanyRolesInput!) {
  deleteCompanyRolesById(data: $data) {
    id
    title
    deletedAt
  }
}
    `;

/**
 * __useDeleteCompanyRolesMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCompanyRolesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCompanyRolesMutation(options: VueApolloComposable.UseMutationOptions<DeleteCompanyRolesMutation, DeleteCompanyRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCompanyRolesMutation, DeleteCompanyRolesMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteCompanyRolesMutation, DeleteCompanyRolesMutationVariables>(DeleteCompanyRolesDocument, options);
}
export type DeleteCompanyRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCompanyRolesMutation, DeleteCompanyRolesMutationVariables>;
export const GetPendingHotlineCallsDocument = gql`
    query GetPendingHotlineCalls {
  pendingHotlineCall {
    id
    status
    summary
  }
}
    `;

/**
 * __useGetPendingHotlineCallsQuery__
 *
 * To run a query within a Vue component, call `useGetPendingHotlineCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingHotlineCallsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPendingHotlineCallsQuery();
 */
export function useGetPendingHotlineCallsQuery(options: VueApolloComposable.UseQueryOptions<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables>(GetPendingHotlineCallsDocument, {}, options);
}
export type GetPendingHotlineCallsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPendingHotlineCallsQuery, GetPendingHotlineCallsQueryVariables>;
export const GetHotlineCallsDocument = gql`
    query GetHotlineCalls {
  hotlineCalls {
    id
    createdAt
    callPlacedAt
    callDuration
    status
    summary
    agent {
      id
      avatarUrl
      name
    }
  }
}
    `;

/**
 * __useGetHotlineCallsQuery__
 *
 * To run a query within a Vue component, call `useGetHotlineCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotlineCallsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHotlineCallsQuery();
 */
export function useGetHotlineCallsQuery(options: VueApolloComposable.UseQueryOptions<GetHotlineCallsQuery, GetHotlineCallsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHotlineCallsQuery, GetHotlineCallsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHotlineCallsQuery, GetHotlineCallsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHotlineCallsQuery, GetHotlineCallsQueryVariables>(GetHotlineCallsDocument, {}, options);
}
export type GetHotlineCallsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHotlineCallsQuery, GetHotlineCallsQueryVariables>;
export const CancelPendingHotlineCallDocument = gql`
    mutation CancelPendingHotlineCall {
  cancelPendingHotlineCall
}
    `;

/**
 * __useCancelPendingHotlineCallMutation__
 *
 * To run a mutation, you first call `useCancelPendingHotlineCallMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelPendingHotlineCallMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelPendingHotlineCallMutation();
 */
export function useCancelPendingHotlineCallMutation(options: VueApolloComposable.UseMutationOptions<CancelPendingHotlineCallMutation, CancelPendingHotlineCallMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelPendingHotlineCallMutation, CancelPendingHotlineCallMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelPendingHotlineCallMutation, CancelPendingHotlineCallMutationVariables>(CancelPendingHotlineCallDocument, options);
}
export type CancelPendingHotlineCallMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelPendingHotlineCallMutation, CancelPendingHotlineCallMutationVariables>;
export const EnqueueHotlineCallDocument = gql`
    mutation EnqueueHotlineCall($data: EnqueueHotlineCallInput!) {
  enqueueHotlineCall(data: $data)
}
    `;

/**
 * __useEnqueueHotlineCallMutation__
 *
 * To run a mutation, you first call `useEnqueueHotlineCallMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnqueueHotlineCallMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnqueueHotlineCallMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEnqueueHotlineCallMutation(options: VueApolloComposable.UseMutationOptions<EnqueueHotlineCallMutation, EnqueueHotlineCallMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnqueueHotlineCallMutation, EnqueueHotlineCallMutationVariables>>) {
  return VueApolloComposable.useMutation<EnqueueHotlineCallMutation, EnqueueHotlineCallMutationVariables>(EnqueueHotlineCallDocument, options);
}
export type EnqueueHotlineCallMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EnqueueHotlineCallMutation, EnqueueHotlineCallMutationVariables>;
export const GetMyVoicesFeedbackListDocument = gql`
    query GetMyVoicesFeedbackList {
  getMyVoicesFeedbackList {
    ...VoicesFeedbackParts
  }
}
    ${VoicesFeedbackPartsFragmentDoc}`;

/**
 * __useGetMyVoicesFeedbackListQuery__
 *
 * To run a query within a Vue component, call `useGetMyVoicesFeedbackListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVoicesFeedbackListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyVoicesFeedbackListQuery();
 */
export function useGetMyVoicesFeedbackListQuery(options: VueApolloComposable.UseQueryOptions<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables>(GetMyVoicesFeedbackListDocument, {}, options);
}
export type GetMyVoicesFeedbackListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyVoicesFeedbackListQuery, GetMyVoicesFeedbackListQueryVariables>;
export const CreateVoicesFeedbackDocument = gql`
    mutation CreateVoicesFeedback($input: CreateVoicesFeedbackInput!) {
  createVoicesFeedback(input: $input) {
    ...VoicesFeedbackParts
  }
}
    ${VoicesFeedbackPartsFragmentDoc}`;

/**
 * __useCreateVoicesFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateVoicesFeedbackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoicesFeedbackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVoicesFeedbackMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateVoicesFeedbackMutation(options: VueApolloComposable.UseMutationOptions<CreateVoicesFeedbackMutation, CreateVoicesFeedbackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateVoicesFeedbackMutation, CreateVoicesFeedbackMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateVoicesFeedbackMutation, CreateVoicesFeedbackMutationVariables>(CreateVoicesFeedbackDocument, options);
}
export type CreateVoicesFeedbackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateVoicesFeedbackMutation, CreateVoicesFeedbackMutationVariables>;
export const GetMyCompanyVoicesFeedbackListDocument = gql`
    query GetMyCompanyVoicesFeedbackList {
  getMyCompanyVoicesFeedbackList {
    ...VoicesFeedbackParts
  }
}
    ${VoicesFeedbackPartsFragmentDoc}`;

/**
 * __useGetMyCompanyVoicesFeedbackListQuery__
 *
 * To run a query within a Vue component, call `useGetMyCompanyVoicesFeedbackListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCompanyVoicesFeedbackListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyCompanyVoicesFeedbackListQuery();
 */
export function useGetMyCompanyVoicesFeedbackListQuery(options: VueApolloComposable.UseQueryOptions<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables>(GetMyCompanyVoicesFeedbackListDocument, {}, options);
}
export type GetMyCompanyVoicesFeedbackListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyCompanyVoicesFeedbackListQuery, GetMyCompanyVoicesFeedbackListQueryVariables>;
export const GetTerminationListDocument = gql`
    query GetTerminationList($data: GetTerminationsInput!) {
  terminationList(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useGetTerminationListQuery__
 *
 * To run a query within a Vue component, call `useGetTerminationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminationListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTerminationListQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTerminationListQuery(variables: GetTerminationListQueryVariables | VueCompositionApi.Ref<GetTerminationListQueryVariables> | ReactiveFunction<GetTerminationListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTerminationListQuery, GetTerminationListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTerminationListQuery, GetTerminationListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTerminationListQuery, GetTerminationListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTerminationListQuery, GetTerminationListQueryVariables>(GetTerminationListDocument, variables, options);
}
export type GetTerminationListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTerminationListQuery, GetTerminationListQueryVariables>;
export const GetTerminationInfoDocument = gql`
    query GetTerminationInfo($data: GetTerminationInput!) {
  terminationInfo(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useGetTerminationInfoQuery__
 *
 * To run a query within a Vue component, call `useGetTerminationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminationInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTerminationInfoQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTerminationInfoQuery(variables: GetTerminationInfoQueryVariables | VueCompositionApi.Ref<GetTerminationInfoQueryVariables> | ReactiveFunction<GetTerminationInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTerminationInfoQuery, GetTerminationInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTerminationInfoQuery, GetTerminationInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTerminationInfoQuery, GetTerminationInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTerminationInfoQuery, GetTerminationInfoQueryVariables>(GetTerminationInfoDocument, variables, options);
}
export type GetTerminationInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTerminationInfoQuery, GetTerminationInfoQueryVariables>;
export const TerminationDownloadDocument = gql`
    query TerminationDownload($data: GetTerminationInput!) {
  terminationDownload(data: $data) {
    ...TerminationDownloadParts
  }
}
    ${TerminationDownloadPartsFragmentDoc}`;

/**
 * __useTerminationDownloadQuery__
 *
 * To run a query within a Vue component, call `useTerminationDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerminationDownloadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTerminationDownloadQuery({
 *   data: // value for 'data'
 * });
 */
export function useTerminationDownloadQuery(variables: TerminationDownloadQueryVariables | VueCompositionApi.Ref<TerminationDownloadQueryVariables> | ReactiveFunction<TerminationDownloadQueryVariables>, options: VueApolloComposable.UseQueryOptions<TerminationDownloadQuery, TerminationDownloadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TerminationDownloadQuery, TerminationDownloadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TerminationDownloadQuery, TerminationDownloadQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TerminationDownloadQuery, TerminationDownloadQueryVariables>(TerminationDownloadDocument, variables, options);
}
export type TerminationDownloadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TerminationDownloadQuery, TerminationDownloadQueryVariables>;
export const CancelTerminationDocument = gql`
    mutation CancelTermination($data: TerminationCancelInput!) {
  cancelTermination(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useCancelTerminationMutation__
 *
 * To run a mutation, you first call `useCancelTerminationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelTerminationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelTerminationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCancelTerminationMutation(options: VueApolloComposable.UseMutationOptions<CancelTerminationMutation, CancelTerminationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelTerminationMutation, CancelTerminationMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelTerminationMutation, CancelTerminationMutationVariables>(CancelTerminationDocument, options);
}
export type CancelTerminationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelTerminationMutation, CancelTerminationMutationVariables>;
export const ConfirmTerminationDocument = gql`
    mutation ConfirmTermination($data: TerminationConfirmationInput!) {
  confirmTermination(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useConfirmTerminationMutation__
 *
 * To run a mutation, you first call `useConfirmTerminationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTerminationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmTerminationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useConfirmTerminationMutation(options: VueApolloComposable.UseMutationOptions<ConfirmTerminationMutation, ConfirmTerminationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmTerminationMutation, ConfirmTerminationMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfirmTerminationMutation, ConfirmTerminationMutationVariables>(ConfirmTerminationDocument, options);
}
export type ConfirmTerminationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmTerminationMutation, ConfirmTerminationMutationVariables>;
export const EditTerminationDetailsDocument = gql`
    mutation EditTerminationDetails($data: TerminationEditDetailsInput!) {
  editTerminationDetails(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useEditTerminationDetailsMutation__
 *
 * To run a mutation, you first call `useEditTerminationDetailsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditTerminationDetailsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditTerminationDetailsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEditTerminationDetailsMutation(options: VueApolloComposable.UseMutationOptions<EditTerminationDetailsMutation, EditTerminationDetailsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditTerminationDetailsMutation, EditTerminationDetailsMutationVariables>>) {
  return VueApolloComposable.useMutation<EditTerminationDetailsMutation, EditTerminationDetailsMutationVariables>(EditTerminationDetailsDocument, options);
}
export type EditTerminationDetailsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditTerminationDetailsMutation, EditTerminationDetailsMutationVariables>;
export const AttachTerminationFilesDocument = gql`
    mutation AttachTerminationFiles($data: TerminationAttachInput!) {
  attachTerminationFiles(data: $data) {
    ...TerminationParts
  }
}
    ${TerminationPartsFragmentDoc}`;

/**
 * __useAttachTerminationFilesMutation__
 *
 * To run a mutation, you first call `useAttachTerminationFilesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachTerminationFilesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachTerminationFilesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAttachTerminationFilesMutation(options: VueApolloComposable.UseMutationOptions<AttachTerminationFilesMutation, AttachTerminationFilesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AttachTerminationFilesMutation, AttachTerminationFilesMutationVariables>>) {
  return VueApolloComposable.useMutation<AttachTerminationFilesMutation, AttachTerminationFilesMutationVariables>(AttachTerminationFilesDocument, options);
}
export type AttachTerminationFilesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AttachTerminationFilesMutation, AttachTerminationFilesMutationVariables>;
export const GetResignationListDocument = gql`
    query GetResignationList($data: GetResignationsInput!) {
  resignationList(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useGetResignationListQuery__
 *
 * To run a query within a Vue component, call `useGetResignationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResignationListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetResignationListQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetResignationListQuery(variables: GetResignationListQueryVariables | VueCompositionApi.Ref<GetResignationListQueryVariables> | ReactiveFunction<GetResignationListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetResignationListQuery, GetResignationListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetResignationListQuery, GetResignationListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetResignationListQuery, GetResignationListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetResignationListQuery, GetResignationListQueryVariables>(GetResignationListDocument, variables, options);
}
export type GetResignationListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetResignationListQuery, GetResignationListQueryVariables>;
export const AttachResignationFilesDocument = gql`
    mutation AttachResignationFiles($data: ResignationAttachInput!) {
  attachResignationFiles(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useAttachResignationFilesMutation__
 *
 * To run a mutation, you first call `useAttachResignationFilesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachResignationFilesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachResignationFilesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAttachResignationFilesMutation(options: VueApolloComposable.UseMutationOptions<AttachResignationFilesMutation, AttachResignationFilesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AttachResignationFilesMutation, AttachResignationFilesMutationVariables>>) {
  return VueApolloComposable.useMutation<AttachResignationFilesMutation, AttachResignationFilesMutationVariables>(AttachResignationFilesDocument, options);
}
export type AttachResignationFilesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AttachResignationFilesMutation, AttachResignationFilesMutationVariables>;
export const ResignationInfoDocument = gql`
    query ResignationInfo($data: GetResignationInput!) {
  resignationInfo(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useResignationInfoQuery__
 *
 * To run a query within a Vue component, call `useResignationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useResignationInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResignationInfoQuery({
 *   data: // value for 'data'
 * });
 */
export function useResignationInfoQuery(variables: ResignationInfoQueryVariables | VueCompositionApi.Ref<ResignationInfoQueryVariables> | ReactiveFunction<ResignationInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResignationInfoQuery, ResignationInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResignationInfoQuery, ResignationInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResignationInfoQuery, ResignationInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResignationInfoQuery, ResignationInfoQueryVariables>(ResignationInfoDocument, variables, options);
}
export type ResignationInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResignationInfoQuery, ResignationInfoQueryVariables>;
export const ResignationDownloadDocument = gql`
    query ResignationDownload($data: GetResignationInput!) {
  resignationDownload(data: $data) {
    ...ResignationDownloadParts
  }
}
    ${ResignationDownloadPartsFragmentDoc}`;

/**
 * __useResignationDownloadQuery__
 *
 * To run a query within a Vue component, call `useResignationDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useResignationDownloadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResignationDownloadQuery({
 *   data: // value for 'data'
 * });
 */
export function useResignationDownloadQuery(variables: ResignationDownloadQueryVariables | VueCompositionApi.Ref<ResignationDownloadQueryVariables> | ReactiveFunction<ResignationDownloadQueryVariables>, options: VueApolloComposable.UseQueryOptions<ResignationDownloadQuery, ResignationDownloadQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ResignationDownloadQuery, ResignationDownloadQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ResignationDownloadQuery, ResignationDownloadQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ResignationDownloadQuery, ResignationDownloadQueryVariables>(ResignationDownloadDocument, variables, options);
}
export type ResignationDownloadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ResignationDownloadQuery, ResignationDownloadQueryVariables>;
export const CancelResignationDocument = gql`
    mutation CancelResignation($data: ResignationCancelInput!) {
  cancelResignation(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useCancelResignationMutation__
 *
 * To run a mutation, you first call `useCancelResignationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelResignationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelResignationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCancelResignationMutation(options: VueApolloComposable.UseMutationOptions<CancelResignationMutation, CancelResignationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelResignationMutation, CancelResignationMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelResignationMutation, CancelResignationMutationVariables>(CancelResignationDocument, options);
}
export type CancelResignationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelResignationMutation, CancelResignationMutationVariables>;
export const ConfirmResignationDocument = gql`
    mutation ConfirmResignation($data: ResignationConfirmationInput!) {
  confirmResignation(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useConfirmResignationMutation__
 *
 * To run a mutation, you first call `useConfirmResignationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmResignationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmResignationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useConfirmResignationMutation(options: VueApolloComposable.UseMutationOptions<ConfirmResignationMutation, ConfirmResignationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmResignationMutation, ConfirmResignationMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfirmResignationMutation, ConfirmResignationMutationVariables>(ConfirmResignationDocument, options);
}
export type ConfirmResignationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmResignationMutation, ConfirmResignationMutationVariables>;
export const EditResignationDocument = gql`
    mutation EditResignation($data: ResignationEditDetailsInput!) {
  editResignationDetails(data: $data) {
    ...ResignationParts
  }
}
    ${ResignationPartsFragmentDoc}`;

/**
 * __useEditResignationMutation__
 *
 * To run a mutation, you first call `useEditResignationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditResignationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditResignationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEditResignationMutation(options: VueApolloComposable.UseMutationOptions<EditResignationMutation, EditResignationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditResignationMutation, EditResignationMutationVariables>>) {
  return VueApolloComposable.useMutation<EditResignationMutation, EditResignationMutationVariables>(EditResignationDocument, options);
}
export type EditResignationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditResignationMutation, EditResignationMutationVariables>;
export const WarningDocumentsDocument = gql`
    query WarningDocuments($data: GetUserWarningDocumentsInput!) {
  warningDocuments(data: $data) {
    createdAt
    name
    type
    id
  }
}
    `;

/**
 * __useWarningDocumentsQuery__
 *
 * To run a query within a Vue component, call `useWarningDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarningDocumentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWarningDocumentsQuery({
 *   data: // value for 'data'
 * });
 */
export function useWarningDocumentsQuery(variables: WarningDocumentsQueryVariables | VueCompositionApi.Ref<WarningDocumentsQueryVariables> | ReactiveFunction<WarningDocumentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<WarningDocumentsQuery, WarningDocumentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WarningDocumentsQuery, WarningDocumentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WarningDocumentsQuery, WarningDocumentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WarningDocumentsQuery, WarningDocumentsQueryVariables>(WarningDocumentsDocument, variables, options);
}
export type WarningDocumentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WarningDocumentsQuery, WarningDocumentsQueryVariables>;
export const CreateJobDescriptionDocument = gql`
    mutation CreateJobDescription($data: CreateJobDescriptionInput!) {
  createJobDescription(data: $data) {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useCreateJobDescriptionMutation__
 *
 * To run a mutation, you first call `useCreateJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateJobDescriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<CreateJobDescriptionMutation, CreateJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateJobDescriptionMutation, CreateJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateJobDescriptionMutation, CreateJobDescriptionMutationVariables>(CreateJobDescriptionDocument, options);
}
export type CreateJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateJobDescriptionMutation, CreateJobDescriptionMutationVariables>;
export const UpdateJobDescriptionDocument = gql`
    mutation UpdateJobDescription($data: UpdateJobDescriptionInput!) {
  updateJobDescription(data: $data) {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useUpdateJobDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateJobDescriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<UpdateJobDescriptionMutation, UpdateJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateJobDescriptionMutation, UpdateJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateJobDescriptionMutation, UpdateJobDescriptionMutationVariables>(UpdateJobDescriptionDocument, options);
}
export type UpdateJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateJobDescriptionMutation, UpdateJobDescriptionMutationVariables>;
export const CompleteJobDescriptionDocument = gql`
    mutation CompleteJobDescription($id: String!) {
  completeJobDescription(id: $id) {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useCompleteJobDescriptionMutation__
 *
 * To run a mutation, you first call `useCompleteJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteJobDescriptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCompleteJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<CompleteJobDescriptionMutation, CompleteJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteJobDescriptionMutation, CompleteJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteJobDescriptionMutation, CompleteJobDescriptionMutationVariables>(CompleteJobDescriptionDocument, options);
}
export type CompleteJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteJobDescriptionMutation, CompleteJobDescriptionMutationVariables>;
export const GenerateAiJobDescriptionDocument = gql`
    mutation GenerateAiJobDescription($data: GenerateAiJobDescriptionInput!) {
  generateAiJobDescription(data: $data) {
    aiGeneratedId
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useGenerateAiJobDescriptionMutation__
 *
 * To run a mutation, you first call `useGenerateAiJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateAiJobDescriptionMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useGenerateAiJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<GenerateAiJobDescriptionMutation, GenerateAiJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateAiJobDescriptionMutation, GenerateAiJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateAiJobDescriptionMutation, GenerateAiJobDescriptionMutationVariables>(GenerateAiJobDescriptionDocument, options);
}
export type GenerateAiJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateAiJobDescriptionMutation, GenerateAiJobDescriptionMutationVariables>;
export const GenerateAiJobDescriptionV2Document = gql`
    mutation GenerateAiJobDescriptionV2($data: GenerateAiJobDescriptionInputV2!) {
  generateAiJobDescriptionV2(data: $data) {
    aiGeneratedId
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useGenerateAiJobDescriptionV2Mutation__
 *
 * To run a mutation, you first call `useGenerateAiJobDescriptionV2Mutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiJobDescriptionV2Mutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateAiJobDescriptionV2Mutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useGenerateAiJobDescriptionV2Mutation(options: VueApolloComposable.UseMutationOptions<GenerateAiJobDescriptionV2Mutation, GenerateAiJobDescriptionV2MutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateAiJobDescriptionV2Mutation, GenerateAiJobDescriptionV2MutationVariables>>) {
  return VueApolloComposable.useMutation<GenerateAiJobDescriptionV2Mutation, GenerateAiJobDescriptionV2MutationVariables>(GenerateAiJobDescriptionV2Document, options);
}
export type GenerateAiJobDescriptionV2MutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateAiJobDescriptionV2Mutation, GenerateAiJobDescriptionV2MutationVariables>;
export const SendJobDescriptionToEmployeeDocument = gql`
    mutation SendJobDescriptionToEmployee($data: SendJobDescriptionToEmployeeInput!) {
  sendJobDescriptionToEmployee(data: $data) {
    id
    jobDescription {
      ...JobDescriptionParts
    }
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useSendJobDescriptionToEmployeeMutation__
 *
 * To run a mutation, you first call `useSendJobDescriptionToEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendJobDescriptionToEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendJobDescriptionToEmployeeMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSendJobDescriptionToEmployeeMutation(options: VueApolloComposable.UseMutationOptions<SendJobDescriptionToEmployeeMutation, SendJobDescriptionToEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendJobDescriptionToEmployeeMutation, SendJobDescriptionToEmployeeMutationVariables>>) {
  return VueApolloComposable.useMutation<SendJobDescriptionToEmployeeMutation, SendJobDescriptionToEmployeeMutationVariables>(SendJobDescriptionToEmployeeDocument, options);
}
export type SendJobDescriptionToEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendJobDescriptionToEmployeeMutation, SendJobDescriptionToEmployeeMutationVariables>;
export const GetEmployeeJobDescriptionDocument = gql`
    query GetEmployeeJobDescription($userId: String!) {
  getEmployeeJobDescription(id: $userId) {
    ...EmployeeJobDescriptionParts
  }
}
    ${EmployeeJobDescriptionPartsFragmentDoc}`;

/**
 * __useGetEmployeeJobDescriptionQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeeJobDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeJobDescriptionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeeJobDescriptionQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useGetEmployeeJobDescriptionQuery(variables: GetEmployeeJobDescriptionQueryVariables | VueCompositionApi.Ref<GetEmployeeJobDescriptionQueryVariables> | ReactiveFunction<GetEmployeeJobDescriptionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables>(GetEmployeeJobDescriptionDocument, variables, options);
}
export type GetEmployeeJobDescriptionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeeJobDescriptionQuery, GetEmployeeJobDescriptionQueryVariables>;
export const SignEmployeeJobDescriptionDocument = gql`
    mutation SignEmployeeJobDescription($signEmployeeJobDescriptionId: String!) {
  signEmployeeJobDescription(id: $signEmployeeJobDescriptionId) {
    ...EmployeeJobDescriptionParts
  }
}
    ${EmployeeJobDescriptionPartsFragmentDoc}`;

/**
 * __useSignEmployeeJobDescriptionMutation__
 *
 * To run a mutation, you first call `useSignEmployeeJobDescriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignEmployeeJobDescriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignEmployeeJobDescriptionMutation({
 *   variables: {
 *     signEmployeeJobDescriptionId: // value for 'signEmployeeJobDescriptionId'
 *   },
 * });
 */
export function useSignEmployeeJobDescriptionMutation(options: VueApolloComposable.UseMutationOptions<SignEmployeeJobDescriptionMutation, SignEmployeeJobDescriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignEmployeeJobDescriptionMutation, SignEmployeeJobDescriptionMutationVariables>>) {
  return VueApolloComposable.useMutation<SignEmployeeJobDescriptionMutation, SignEmployeeJobDescriptionMutationVariables>(SignEmployeeJobDescriptionDocument, options);
}
export type SignEmployeeJobDescriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignEmployeeJobDescriptionMutation, SignEmployeeJobDescriptionMutationVariables>;
export const GetJobDescriptionsDocument = gql`
    query GetJobDescriptions {
  jobDescriptions {
    ...JobDescriptionParts
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useGetJobDescriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetJobDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobDescriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetJobDescriptionsQuery();
 */
export function useGetJobDescriptionsQuery(options: VueApolloComposable.UseQueryOptions<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables>(GetJobDescriptionsDocument, {}, options);
}
export type GetJobDescriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetJobDescriptionsQuery, GetJobDescriptionsQueryVariables>;
export const GetStaffJobDescriptionsDocument = gql`
    query GetStaffJobDescriptions($page: Float!, $limit: Float!) {
  getMyCoreUser {
    id
    company {
      id
      paginatedEmployees(active: true, page: $page, limit: $limit) {
        id
        page
        totalPages
        totalCount
        result {
          id
          active
          profile {
            id
            firstName
            lastName
            avatarUrl
          }
          employment {
            id
            title
            workerRoles {
              id
              userId
              isPrimary
              employeeJobDescription {
                id
                signedAt
                createdAt
                jobDescription {
                  ...JobDescriptionParts
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${JobDescriptionPartsFragmentDoc}`;

/**
 * __useGetStaffJobDescriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetStaffJobDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffJobDescriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStaffJobDescriptionsQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetStaffJobDescriptionsQuery(variables: GetStaffJobDescriptionsQueryVariables | VueCompositionApi.Ref<GetStaffJobDescriptionsQueryVariables> | ReactiveFunction<GetStaffJobDescriptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables>(GetStaffJobDescriptionsDocument, variables, options);
}
export type GetStaffJobDescriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStaffJobDescriptionsQuery, GetStaffJobDescriptionsQueryVariables>;
export const GetMfaEnrollmentsDocument = gql`
    query GetMfaEnrollments($includeUnconfirmed: Boolean) {
  getMyMfaEnrollments(includeUnconfirmed: $includeUnconfirmed) {
    id
    mfaType
    createdAt
    lastChallengedAt
  }
}
    `;

/**
 * __useGetMfaEnrollmentsQuery__
 *
 * To run a query within a Vue component, call `useGetMfaEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfaEnrollmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMfaEnrollmentsQuery({
 *   includeUnconfirmed: // value for 'includeUnconfirmed'
 * });
 */
export function useGetMfaEnrollmentsQuery(variables: GetMfaEnrollmentsQueryVariables | VueCompositionApi.Ref<GetMfaEnrollmentsQueryVariables> | ReactiveFunction<GetMfaEnrollmentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>(GetMfaEnrollmentsDocument, variables, options);
}
export type GetMfaEnrollmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMfaEnrollmentsQuery, GetMfaEnrollmentsQueryVariables>;
export const CreateMfaChallengeDocument = gql`
    mutation CreateMfaChallenge($reason: String!, $type: AuthMfaType!) {
  createChallenge(reason: $reason, type: $type) {
    nonce
    metadata {
      phoneLast4
    }
  }
}
    `;

/**
 * __useCreateMfaChallengeMutation__
 *
 * To run a mutation, you first call `useCreateMfaChallengeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMfaChallengeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMfaChallengeMutation({
 *   variables: {
 *     reason: // value for 'reason'
 *     type: // value for 'type'
 *   },
 * });
 */
export function useCreateMfaChallengeMutation(options: VueApolloComposable.UseMutationOptions<CreateMfaChallengeMutation, CreateMfaChallengeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMfaChallengeMutation, CreateMfaChallengeMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateMfaChallengeMutation, CreateMfaChallengeMutationVariables>(CreateMfaChallengeDocument, options);
}
export type CreateMfaChallengeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMfaChallengeMutation, CreateMfaChallengeMutationVariables>;
export const EnrollMfaDeviceDocument = gql`
    mutation EnrollMfaDevice($input: AuthMfaSmsEnrollmentInput!) {
  enrollMfaDevice(input: $input) {
    nonce
    metadata {
      phoneLast4
    }
  }
}
    `;

/**
 * __useEnrollMfaDeviceMutation__
 *
 * To run a mutation, you first call `useEnrollMfaDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnrollMfaDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnrollMfaDeviceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEnrollMfaDeviceMutation(options: VueApolloComposable.UseMutationOptions<EnrollMfaDeviceMutation, EnrollMfaDeviceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnrollMfaDeviceMutation, EnrollMfaDeviceMutationVariables>>) {
  return VueApolloComposable.useMutation<EnrollMfaDeviceMutation, EnrollMfaDeviceMutationVariables>(EnrollMfaDeviceDocument, options);
}
export type EnrollMfaDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EnrollMfaDeviceMutation, EnrollMfaDeviceMutationVariables>;
export const ResendChallengeDocument = gql`
    mutation ResendChallenge($nonceId: String!, $reason: String!, $type: AuthMfaType!) {
  resendChallenge(nonceId: $nonceId, reason: $reason, type: $type) {
    nonce
    metadata {
      phoneLast4
    }
  }
}
    `;

/**
 * __useResendChallengeMutation__
 *
 * To run a mutation, you first call `useResendChallengeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResendChallengeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResendChallengeMutation({
 *   variables: {
 *     nonceId: // value for 'nonceId'
 *     reason: // value for 'reason'
 *     type: // value for 'type'
 *   },
 * });
 */
export function useResendChallengeMutation(options: VueApolloComposable.UseMutationOptions<ResendChallengeMutation, ResendChallengeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResendChallengeMutation, ResendChallengeMutationVariables>>) {
  return VueApolloComposable.useMutation<ResendChallengeMutation, ResendChallengeMutationVariables>(ResendChallengeDocument, options);
}
export type ResendChallengeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResendChallengeMutation, ResendChallengeMutationVariables>;
export const ConfirmUserMfaEnrollmentDocument = gql`
    mutation ConfirmUserMfaEnrollment($input: AuthMfaChallengeResponseInput!) {
  confirmUserMfaEnrollment(input: $input) {
    id
    mfaType
  }
}
    `;

/**
 * __useConfirmUserMfaEnrollmentMutation__
 *
 * To run a mutation, you first call `useConfirmUserMfaEnrollmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUserMfaEnrollmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmUserMfaEnrollmentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConfirmUserMfaEnrollmentMutation(options: VueApolloComposable.UseMutationOptions<ConfirmUserMfaEnrollmentMutation, ConfirmUserMfaEnrollmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmUserMfaEnrollmentMutation, ConfirmUserMfaEnrollmentMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfirmUserMfaEnrollmentMutation, ConfirmUserMfaEnrollmentMutationVariables>(ConfirmUserMfaEnrollmentDocument, options);
}
export type ConfirmUserMfaEnrollmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmUserMfaEnrollmentMutation, ConfirmUserMfaEnrollmentMutationVariables>;
export const GetMigrationPricingDocument = gql`
    query GetMigrationPricing($tierNumber: Float!, $input: ActivePlanFilters!) {
  getLatestPricingPackagesForTier(tierNumber: $tierNumber, input: $input) {
    packages {
      productKey
      plans {
        productKey
        name
        value
        priceId
        price
        monthlyPrice
        billingPeriod
        tierNumber
        collectTax
      }
    }
  }
}
    `;

/**
 * __useGetMigrationPricingQuery__
 *
 * To run a query within a Vue component, call `useGetMigrationPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMigrationPricingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMigrationPricingQuery({
 *   tierNumber: // value for 'tierNumber'
 *   input: // value for 'input'
 * });
 */
export function useGetMigrationPricingQuery(variables: GetMigrationPricingQueryVariables | VueCompositionApi.Ref<GetMigrationPricingQueryVariables> | ReactiveFunction<GetMigrationPricingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMigrationPricingQuery, GetMigrationPricingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMigrationPricingQuery, GetMigrationPricingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMigrationPricingQuery, GetMigrationPricingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMigrationPricingQuery, GetMigrationPricingQueryVariables>(GetMigrationPricingDocument, variables, options);
}
export type GetMigrationPricingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMigrationPricingQuery, GetMigrationPricingQueryVariables>;
export const GetMigrationHeadcountDocument = gql`
    query GetMigrationHeadcount($id: ID!) {
  coreCompany(id: $id) {
    id
    name
    employees(active: true) {
      id
      role
    }
  }
}
    `;

/**
 * __useGetMigrationHeadcountQuery__
 *
 * To run a query within a Vue component, call `useGetMigrationHeadcountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMigrationHeadcountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMigrationHeadcountQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMigrationHeadcountQuery(variables: GetMigrationHeadcountQueryVariables | VueCompositionApi.Ref<GetMigrationHeadcountQueryVariables> | ReactiveFunction<GetMigrationHeadcountQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMigrationHeadcountQuery, GetMigrationHeadcountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMigrationHeadcountQuery, GetMigrationHeadcountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMigrationHeadcountQuery, GetMigrationHeadcountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMigrationHeadcountQuery, GetMigrationHeadcountQueryVariables>(GetMigrationHeadcountDocument, variables, options);
}
export type GetMigrationHeadcountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMigrationHeadcountQuery, GetMigrationHeadcountQueryVariables>;
export const SelectMigrationPlanDocument = gql`
    mutation SelectMigrationPlan($input: SelectMigrationPlanInput!) {
  selectMigrationPlan(input: $input) {
    id
    level
    selectedProductKey
    recommendedProductKey
    originalProductKey
    isExplicitSelection
    confirmedAt
    tierNumber
    employeeCount
    monthlyAmount
    planValue
  }
}
    `;

/**
 * __useSelectMigrationPlanMutation__
 *
 * To run a mutation, you first call `useSelectMigrationPlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSelectMigrationPlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSelectMigrationPlanMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSelectMigrationPlanMutation(options: VueApolloComposable.UseMutationOptions<SelectMigrationPlanMutation, SelectMigrationPlanMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SelectMigrationPlanMutation, SelectMigrationPlanMutationVariables>>) {
  return VueApolloComposable.useMutation<SelectMigrationPlanMutation, SelectMigrationPlanMutationVariables>(SelectMigrationPlanDocument, options);
}
export type SelectMigrationPlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SelectMigrationPlanMutation, SelectMigrationPlanMutationVariables>;
export const MyNotificationsDocument = gql`
    query MyNotifications {
  myNotifications {
    id
    level
    subject
    body
    dismissible
    dismissedAt
    targets {
      id
      type
    }
    actions {
      id
      label
      type
      value
    }
    createdAt
  }
}
    `;

/**
 * __useMyNotificationsQuery__
 *
 * To run a query within a Vue component, call `useMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyNotificationsQuery();
 */
export function useMyNotificationsQuery(options: VueApolloComposable.UseQueryOptions<MyNotificationsQuery, MyNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyNotificationsQuery, MyNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyNotificationsQuery, MyNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyNotificationsQuery, MyNotificationsQueryVariables>(MyNotificationsDocument, {}, options);
}
export type MyNotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyNotificationsQuery, MyNotificationsQueryVariables>;
export const DismissNotificationDocument = gql`
    mutation DismissNotification($input: String!) {
  dismissNotification(id: $input) {
    id
    dismissedAt
  }
}
    `;

/**
 * __useDismissNotificationMutation__
 *
 * To run a mutation, you first call `useDismissNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDismissNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDismissNotificationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDismissNotificationMutation(options: VueApolloComposable.UseMutationOptions<DismissNotificationMutation, DismissNotificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DismissNotificationMutation, DismissNotificationMutationVariables>>) {
  return VueApolloComposable.useMutation<DismissNotificationMutation, DismissNotificationMutationVariables>(DismissNotificationDocument, options);
}
export type DismissNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DismissNotificationMutation, DismissNotificationMutationVariables>;
export const ClickedOnNotificationActionDocument = gql`
    mutation ClickedOnNotificationAction($actionId: String!) {
  clickedOnNotificationAction(actionId: $actionId)
}
    `;

/**
 * __useClickedOnNotificationActionMutation__
 *
 * To run a mutation, you first call `useClickedOnNotificationActionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClickedOnNotificationActionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClickedOnNotificationActionMutation({
 *   variables: {
 *     actionId: // value for 'actionId'
 *   },
 * });
 */
export function useClickedOnNotificationActionMutation(options: VueApolloComposable.UseMutationOptions<ClickedOnNotificationActionMutation, ClickedOnNotificationActionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClickedOnNotificationActionMutation, ClickedOnNotificationActionMutationVariables>>) {
  return VueApolloComposable.useMutation<ClickedOnNotificationActionMutation, ClickedOnNotificationActionMutationVariables>(ClickedOnNotificationActionDocument, options);
}
export type ClickedOnNotificationActionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClickedOnNotificationActionMutation, ClickedOnNotificationActionMutationVariables>;
export const IsEventScheduledForUserDocument = gql`
    query IsEventScheduledForUser($email: String!, $eventSlug: String!) {
  isEventScheduledForUser(input: {email: $email, eventSlug: $eventSlug}) {
    email
    eventSlug
    isScheduled
  }
}
    `;

/**
 * __useIsEventScheduledForUserQuery__
 *
 * To run a query within a Vue component, call `useIsEventScheduledForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEventScheduledForUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIsEventScheduledForUserQuery({
 *   email: // value for 'email'
 *   eventSlug: // value for 'eventSlug'
 * });
 */
export function useIsEventScheduledForUserQuery(variables: IsEventScheduledForUserQueryVariables | VueCompositionApi.Ref<IsEventScheduledForUserQueryVariables> | ReactiveFunction<IsEventScheduledForUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables>(IsEventScheduledForUserDocument, variables, options);
}
export type IsEventScheduledForUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IsEventScheduledForUserQuery, IsEventScheduledForUserQueryVariables>;
export const FindOnboardingStatusDocument = gql`
    query FindOnboardingStatus($data: CoreOnboardingKeys!) {
  findOnboarding(data: $data) {
    id
    status
    data {
      id
      progress
      callEventId
    }
  }
}
    `;

/**
 * __useFindOnboardingStatusQuery__
 *
 * To run a query within a Vue component, call `useFindOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOnboardingStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindOnboardingStatusQuery({
 *   data: // value for 'data'
 * });
 */
export function useFindOnboardingStatusQuery(variables: FindOnboardingStatusQueryVariables | VueCompositionApi.Ref<FindOnboardingStatusQueryVariables> | ReactiveFunction<FindOnboardingStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables>(FindOnboardingStatusDocument, variables, options);
}
export type FindOnboardingStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindOnboardingStatusQuery, FindOnboardingStatusQueryVariables>;
export const UpsertEmployerOnboardingDocument = gql`
    mutation UpsertEmployerOnboarding($data: CoreOnboardingInput!) {
  upsertOnboarding(data: $data) {
    id
    status
    data {
      id
      progress
      callEventId
    }
  }
}
    `;

/**
 * __useUpsertEmployerOnboardingMutation__
 *
 * To run a mutation, you first call `useUpsertEmployerOnboardingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmployerOnboardingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertEmployerOnboardingMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpsertEmployerOnboardingMutation(options: VueApolloComposable.UseMutationOptions<UpsertEmployerOnboardingMutation, UpsertEmployerOnboardingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertEmployerOnboardingMutation, UpsertEmployerOnboardingMutationVariables>>) {
  return VueApolloComposable.useMutation<UpsertEmployerOnboardingMutation, UpsertEmployerOnboardingMutationVariables>(UpsertEmployerOnboardingDocument, options);
}
export type UpsertEmployerOnboardingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertEmployerOnboardingMutation, UpsertEmployerOnboardingMutationVariables>;
export const FindOnboardingDocument = gql`
    query FindOnboarding($data: CoreOnboardingKeys!, $id: ID!) {
  findOnboarding(data: $data) {
    id
    status
    version
    data {
      id
      progress
      callEventId
      companyLegalName
      fein
      address {
        line1
        line2
        city
        state
        zipCode
      }
      discussionTopics
      nextAction
      numOfEmployees
      numOfContractors
      hasRemoteEmployees
      remoteWorkerStates
    }
  }
  coreCompany(id: $id) {
    name
    whatBroughtYouToBambee
  }
}
    `;

/**
 * __useFindOnboardingQuery__
 *
 * To run a query within a Vue component, call `useFindOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOnboardingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindOnboardingQuery({
 *   data: // value for 'data'
 *   id: // value for 'id'
 * });
 */
export function useFindOnboardingQuery(variables: FindOnboardingQueryVariables | VueCompositionApi.Ref<FindOnboardingQueryVariables> | ReactiveFunction<FindOnboardingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindOnboardingQuery, FindOnboardingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindOnboardingQuery, FindOnboardingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindOnboardingQuery, FindOnboardingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindOnboardingQuery, FindOnboardingQueryVariables>(FindOnboardingDocument, variables, options);
}
export type FindOnboardingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindOnboardingQuery, FindOnboardingQueryVariables>;
export const AssignUserToPolicyDocument = gql`
    mutation AssignUserToPolicy($data: AssignUserToPoliciesInput!) {
  assignUserToPolicies(data: $data) {
    id
    name
    signature {
      id
      requestedAt
      signedAt
      signingOrder
    }
  }
}
    `;

/**
 * __useAssignUserToPolicyMutation__
 *
 * To run a mutation, you first call `useAssignUserToPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserToPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignUserToPolicyMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAssignUserToPolicyMutation(options: VueApolloComposable.UseMutationOptions<AssignUserToPolicyMutation, AssignUserToPolicyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignUserToPolicyMutation, AssignUserToPolicyMutationVariables>>) {
  return VueApolloComposable.useMutation<AssignUserToPolicyMutation, AssignUserToPolicyMutationVariables>(AssignUserToPolicyDocument, options);
}
export type AssignUserToPolicyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignUserToPolicyMutation, AssignUserToPolicyMutationVariables>;
export const AssignUsersToPoliciesDocument = gql`
    mutation AssignUsersToPolicies($data: AssignUsersToPoliciesInput!) {
  assignUsersToPolicies(data: $data) {
    id
    documents {
      ...CoreDocumentParts
    }
  }
}
    ${CoreDocumentPartsFragmentDoc}`;

/**
 * __useAssignUsersToPoliciesMutation__
 *
 * To run a mutation, you first call `useAssignUsersToPoliciesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignUsersToPoliciesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignUsersToPoliciesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAssignUsersToPoliciesMutation(options: VueApolloComposable.UseMutationOptions<AssignUsersToPoliciesMutation, AssignUsersToPoliciesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignUsersToPoliciesMutation, AssignUsersToPoliciesMutationVariables>>) {
  return VueApolloComposable.useMutation<AssignUsersToPoliciesMutation, AssignUsersToPoliciesMutationVariables>(AssignUsersToPoliciesDocument, options);
}
export type AssignUsersToPoliciesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignUsersToPoliciesMutation, AssignUsersToPoliciesMutationVariables>;
export const ReaffirmEmployeeDocumentDocument = gql`
    mutation ReaffirmEmployeeDocument($documentId: ID!) {
  reaffirmDocument(id: $documentId) {
    id
    name
    reaffirmations
  }
}
    `;

/**
 * __useReaffirmEmployeeDocumentMutation__
 *
 * To run a mutation, you first call `useReaffirmEmployeeDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReaffirmEmployeeDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReaffirmEmployeeDocumentMutation({
 *   variables: {
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useReaffirmEmployeeDocumentMutation(options: VueApolloComposable.UseMutationOptions<ReaffirmEmployeeDocumentMutation, ReaffirmEmployeeDocumentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReaffirmEmployeeDocumentMutation, ReaffirmEmployeeDocumentMutationVariables>>) {
  return VueApolloComposable.useMutation<ReaffirmEmployeeDocumentMutation, ReaffirmEmployeeDocumentMutationVariables>(ReaffirmEmployeeDocumentDocument, options);
}
export type ReaffirmEmployeeDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReaffirmEmployeeDocumentMutation, ReaffirmEmployeeDocumentMutationVariables>;
export const ArchivePolicyDocument = gql`
    mutation ArchivePolicy($input: ArchivePolicyInput!) {
  archivePolicy(input: $input) {
    id
  }
}
    `;

/**
 * __useArchivePolicyMutation__
 *
 * To run a mutation, you first call `useArchivePolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useArchivePolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useArchivePolicyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useArchivePolicyMutation(options: VueApolloComposable.UseMutationOptions<ArchivePolicyMutation, ArchivePolicyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ArchivePolicyMutation, ArchivePolicyMutationVariables>>) {
  return VueApolloComposable.useMutation<ArchivePolicyMutation, ArchivePolicyMutationVariables>(ArchivePolicyDocument, options);
}
export type ArchivePolicyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ArchivePolicyMutation, ArchivePolicyMutationVariables>;
export const GetPolicyDocument = gql`
    query GetPolicy($input: GetPolicy!) {
  getPolicy(input: $input) {
    ...CorePolicyParts
  }
}
    ${CorePolicyPartsFragmentDoc}`;

/**
 * __useGetPolicyQuery__
 *
 * To run a query within a Vue component, call `useGetPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPolicyQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetPolicyQuery(variables: GetPolicyQueryVariables | VueCompositionApi.Ref<GetPolicyQueryVariables> | ReactiveFunction<GetPolicyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPolicyQuery, GetPolicyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPolicyQuery, GetPolicyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPolicyQuery, GetPolicyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPolicyQuery, GetPolicyQueryVariables>(GetPolicyDocument, variables, options);
}
export type GetPolicyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPolicyQuery, GetPolicyQueryVariables>;
export const ReaffirmDocumentDocument = gql`
    mutation ReaffirmDocument($documentId: ID!) {
  reaffirmDocument(id: $documentId) {
    ...CoreDocumentParts
  }
}
    ${CoreDocumentPartsFragmentDoc}`;

/**
 * __useReaffirmDocumentMutation__
 *
 * To run a mutation, you first call `useReaffirmDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReaffirmDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReaffirmDocumentMutation({
 *   variables: {
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useReaffirmDocumentMutation(options: VueApolloComposable.UseMutationOptions<ReaffirmDocumentMutation, ReaffirmDocumentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReaffirmDocumentMutation, ReaffirmDocumentMutationVariables>>) {
  return VueApolloComposable.useMutation<ReaffirmDocumentMutation, ReaffirmDocumentMutationVariables>(ReaffirmDocumentDocument, options);
}
export type ReaffirmDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReaffirmDocumentMutation, ReaffirmDocumentMutationVariables>;
export const GetCompanyPoliciesDocument = gql`
    query GetCompanyPolicies($id: ID!) {
  getCoreCompany(id: $id) {
    policies(limit: 200, page: 1, status: ["in-progress", "approved", "complete"]) {
      id
      name
      icon
      isCPD
      archivedAt
      status
      step
    }
  }
}
    `;

/**
 * __useGetCompanyPoliciesQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPoliciesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyPoliciesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyPoliciesQuery(variables: GetCompanyPoliciesQueryVariables | VueCompositionApi.Ref<GetCompanyPoliciesQueryVariables> | ReactiveFunction<GetCompanyPoliciesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables>(GetCompanyPoliciesDocument, variables, options);
}
export type GetCompanyPoliciesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyPoliciesQuery, GetCompanyPoliciesQueryVariables>;
export const AssignUserToPoliciesDocument = gql`
    mutation AssignUserToPolicies($data: AssignUserToPoliciesInput!) {
  assignUserToPolicies(data: $data) {
    id
    name
  }
}
    `;

/**
 * __useAssignUserToPoliciesMutation__
 *
 * To run a mutation, you first call `useAssignUserToPoliciesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserToPoliciesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignUserToPoliciesMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useAssignUserToPoliciesMutation(options: VueApolloComposable.UseMutationOptions<AssignUserToPoliciesMutation, AssignUserToPoliciesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignUserToPoliciesMutation, AssignUserToPoliciesMutationVariables>>) {
  return VueApolloComposable.useMutation<AssignUserToPoliciesMutation, AssignUserToPoliciesMutationVariables>(AssignUserToPoliciesDocument, options);
}
export type AssignUserToPoliciesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignUserToPoliciesMutation, AssignUserToPoliciesMutationVariables>;
export const PolicyDataTableDocument = gql`
    query PolicyDataTable($page: Int!, $limit: Int!) {
  getMyCoreUser {
    id
    company {
      id
      policies(
        page: $page
        limit: $limit
        status: ["in-progress", "ready", "sent", "complete", "ready", "qa", "created", "uploaded", "declined", "approved"]
      ) {
        id
        name
        archivedAt
        isCPD
        createdAt
        status
        recipients {
          id
          document {
            reaffirmations
            id
            signature {
              id
              signedAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePolicyDataTableQuery__
 *
 * To run a query within a Vue component, call `usePolicyDataTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyDataTableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePolicyDataTableQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function usePolicyDataTableQuery(variables: PolicyDataTableQueryVariables | VueCompositionApi.Ref<PolicyDataTableQueryVariables> | ReactiveFunction<PolicyDataTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<PolicyDataTableQuery, PolicyDataTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PolicyDataTableQuery, PolicyDataTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PolicyDataTableQuery, PolicyDataTableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PolicyDataTableQuery, PolicyDataTableQueryVariables>(PolicyDataTableDocument, variables, options);
}
export type PolicyDataTableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PolicyDataTableQuery, PolicyDataTableQueryVariables>;
export const GetPricingPackagesDocument = gql`
    query GetPricingPackages($input: PricingPackageFilterInput!) {
  getPricingPackages(input: $input) {
    packages {
      productKey
      plans {
        name
        productKey
        value
        tierNumber
        monthlyPrice
        price
        billingPeriod
        version
      }
    }
  }
}
    `;

/**
 * __useGetPricingPackagesQuery__
 *
 * To run a query within a Vue component, call `useGetPricingPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingPackagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPricingPackagesQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetPricingPackagesQuery(variables: GetPricingPackagesQueryVariables | VueCompositionApi.Ref<GetPricingPackagesQueryVariables> | ReactiveFunction<GetPricingPackagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPricingPackagesQuery, GetPricingPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPricingPackagesQuery, GetPricingPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPricingPackagesQuery, GetPricingPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPricingPackagesQuery, GetPricingPackagesQueryVariables>(GetPricingPackagesDocument, variables, options);
}
export type GetPricingPackagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPricingPackagesQuery, GetPricingPackagesQueryVariables>;
export const GetUpgradeOptionsDocument = gql`
    query GetUpgradeOptions($input: GetCoreUpgradeOptionsInput!) {
  coreUpgradeOptions(input: $input) {
    plan {
      name
      productKey
      value
      tierNumber
      monthlyPrice
      price
      billingPeriod
      version
    }
    upcoming {
      total
      totalDue
      remainingAmount
      tax
      unusedAmount
    }
  }
}
    `;

/**
 * __useGetUpgradeOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetUpgradeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpgradeOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUpgradeOptionsQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetUpgradeOptionsQuery(variables: GetUpgradeOptionsQueryVariables | VueCompositionApi.Ref<GetUpgradeOptionsQueryVariables> | ReactiveFunction<GetUpgradeOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables>(GetUpgradeOptionsDocument, variables, options);
}
export type GetUpgradeOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUpgradeOptionsQuery, GetUpgradeOptionsQueryVariables>;
export const UpgradeCorePlanDocument = gql`
    mutation UpgradeCorePlan($input: UpgradeCorePlanInput!) {
  upgradeCorePlan(input: $input) {
    name
    status
    startDate
    endDate
    stripeId
    stripePriceId
    isDrp
  }
}
    `;

/**
 * __useUpgradeCorePlanMutation__
 *
 * To run a mutation, you first call `useUpgradeCorePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeCorePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpgradeCorePlanMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpgradeCorePlanMutation(options: VueApolloComposable.UseMutationOptions<UpgradeCorePlanMutation, UpgradeCorePlanMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpgradeCorePlanMutation, UpgradeCorePlanMutationVariables>>) {
  return VueApolloComposable.useMutation<UpgradeCorePlanMutation, UpgradeCorePlanMutationVariables>(UpgradeCorePlanDocument, options);
}
export type UpgradeCorePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpgradeCorePlanMutation, UpgradeCorePlanMutationVariables>;
export const GetProductInterestDocument = gql`
    query GetProductInterest($input: GetProductInterestInput!) {
  productInterest(input: $input) {
    id
  }
}
    `;

/**
 * __useGetProductInterestQuery__
 *
 * To run a query within a Vue component, call `useGetProductInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductInterestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProductInterestQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetProductInterestQuery(variables: GetProductInterestQueryVariables | VueCompositionApi.Ref<GetProductInterestQueryVariables> | ReactiveFunction<GetProductInterestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductInterestQuery, GetProductInterestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductInterestQuery, GetProductInterestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductInterestQuery, GetProductInterestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProductInterestQuery, GetProductInterestQueryVariables>(GetProductInterestDocument, variables, options);
}
export type GetProductInterestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProductInterestQuery, GetProductInterestQueryVariables>;
export const TrackProductInterestDocument = gql`
    mutation TrackProductInterest($data: ProductInterestInput!) {
  trackProductInterest(data: $data)
}
    `;

/**
 * __useTrackProductInterestMutation__
 *
 * To run a mutation, you first call `useTrackProductInterestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTrackProductInterestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTrackProductInterestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useTrackProductInterestMutation(options: VueApolloComposable.UseMutationOptions<TrackProductInterestMutation, TrackProductInterestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrackProductInterestMutation, TrackProductInterestMutationVariables>>) {
  return VueApolloComposable.useMutation<TrackProductInterestMutation, TrackProductInterestMutationVariables>(TrackProductInterestDocument, options);
}
export type TrackProductInterestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrackProductInterestMutation, TrackProductInterestMutationVariables>;
export const CreateReportCardDocument = gql`
    mutation CreateReportCard($data: CreateReportCardInput!) {
  createReportCard(data: $data) {
    ...NewReportCardParts
  }
}
    ${NewReportCardPartsFragmentDoc}`;

/**
 * __useCreateReportCardMutation__
 *
 * To run a mutation, you first call `useCreateReportCardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportCardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateReportCardMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportCardMutation(options: VueApolloComposable.UseMutationOptions<CreateReportCardMutation, CreateReportCardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateReportCardMutation, CreateReportCardMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateReportCardMutation, CreateReportCardMutationVariables>(CreateReportCardDocument, options);
}
export type CreateReportCardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateReportCardMutation, CreateReportCardMutationVariables>;
export const UpdateReportCardDocument = gql`
    mutation UpdateReportCard($data: UpdateReportCardInput!) {
  updateReportCard(data: $data) {
    ...ReportCardParts
  }
}
    ${ReportCardPartsFragmentDoc}`;

/**
 * __useUpdateReportCardMutation__
 *
 * To run a mutation, you first call `useUpdateReportCardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportCardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReportCardMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReportCardMutation(options: VueApolloComposable.UseMutationOptions<UpdateReportCardMutation, UpdateReportCardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateReportCardMutation, UpdateReportCardMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateReportCardMutation, UpdateReportCardMutationVariables>(UpdateReportCardDocument, options);
}
export type UpdateReportCardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateReportCardMutation, UpdateReportCardMutationVariables>;
export const CompleteReportCardDocument = gql`
    mutation CompleteReportCard($data: CompleteReportCardInput!) {
  completeReportCard(data: $data) {
    ...ReportCardParts
  }
}
    ${ReportCardPartsFragmentDoc}`;

/**
 * __useCompleteReportCardMutation__
 *
 * To run a mutation, you first call `useCompleteReportCardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteReportCardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteReportCardMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteReportCardMutation(options: VueApolloComposable.UseMutationOptions<CompleteReportCardMutation, CompleteReportCardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteReportCardMutation, CompleteReportCardMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteReportCardMutation, CompleteReportCardMutationVariables>(CompleteReportCardDocument, options);
}
export type CompleteReportCardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteReportCardMutation, CompleteReportCardMutationVariables>;
export const GetReportCardListDocument = gql`
    query GetReportCardList($data: ListReportCardsInput!) {
  listReportCards(data: $data) {
    id
    cadence
    createdAt
    status
    employees {
      id
      grade
    }
  }
}
    `;

/**
 * __useGetReportCardListQuery__
 *
 * To run a query within a Vue component, call `useGetReportCardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportCardListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReportCardListQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetReportCardListQuery(variables: GetReportCardListQueryVariables | VueCompositionApi.Ref<GetReportCardListQueryVariables> | ReactiveFunction<GetReportCardListQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReportCardListQuery, GetReportCardListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReportCardListQuery, GetReportCardListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReportCardListQuery, GetReportCardListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetReportCardListQuery, GetReportCardListQueryVariables>(GetReportCardListDocument, variables, options);
}
export type GetReportCardListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetReportCardListQuery, GetReportCardListQueryVariables>;
export const GetReportCardDocument = gql`
    query GetReportCard($data: GetReportCardInput!) {
  getReportCard(data: $data) {
    ...ReportCardParts
  }
}
    ${ReportCardPartsFragmentDoc}`;

/**
 * __useGetReportCardQuery__
 *
 * To run a query within a Vue component, call `useGetReportCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportCardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReportCardQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetReportCardQuery(variables: GetReportCardQueryVariables | VueCompositionApi.Ref<GetReportCardQueryVariables> | ReactiveFunction<GetReportCardQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetReportCardQuery, GetReportCardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetReportCardQuery, GetReportCardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetReportCardQuery, GetReportCardQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetReportCardQuery, GetReportCardQueryVariables>(GetReportCardDocument, variables, options);
}
export type GetReportCardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetReportCardQuery, GetReportCardQueryVariables>;
export const CompleteSolutionDocument = gql`
    mutation CompleteSolution($input: CompleteSolutionInput!) {
  completeSolution(input: $input) {
    id
    completedAt
    completedBy
  }
}
    `;

/**
 * __useCompleteSolutionMutation__
 *
 * To run a mutation, you first call `useCompleteSolutionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSolutionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteSolutionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCompleteSolutionMutation(options: VueApolloComposable.UseMutationOptions<CompleteSolutionMutation, CompleteSolutionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteSolutionMutation, CompleteSolutionMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteSolutionMutation, CompleteSolutionMutationVariables>(CompleteSolutionDocument, options);
}
export type CompleteSolutionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteSolutionMutation, CompleteSolutionMutationVariables>;
export const GetSolutionsDocument = gql`
    query GetSolutions($input: GetSolutionsInput!) {
  getSolutions(input: $input) {
    id
    slug
    completedAt
    destination
    action
  }
}
    `;

/**
 * __useGetSolutionsQuery__
 *
 * To run a query within a Vue component, call `useGetSolutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSolutionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSolutionsQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetSolutionsQuery(variables: GetSolutionsQueryVariables | VueCompositionApi.Ref<GetSolutionsQueryVariables> | ReactiveFunction<GetSolutionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSolutionsQuery, GetSolutionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSolutionsQuery, GetSolutionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSolutionsQuery, GetSolutionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSolutionsQuery, GetSolutionsQueryVariables>(GetSolutionsDocument, variables, options);
}
export type GetSolutionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSolutionsQuery, GetSolutionsQueryVariables>;
export const GetFullStaffDocument = gql`
    query GetFullStaff($id: ID!) {
  getCoreCompany(id: $id) {
    id
    employees {
      id
      active
      employment {
        id
        contractorBusinessName
        isContractor
        contractorType
        employeeType
        payRate
        payType
        startDate
        title
      }
      profile {
        id
        firstName
        lastName
        dob
        phone
        email
        address {
          city
          line1
          line2
          state
          zip: zipCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetFullStaffQuery__
 *
 * To run a query within a Vue component, call `useGetFullStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullStaffQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFullStaffQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetFullStaffQuery(variables: GetFullStaffQueryVariables | VueCompositionApi.Ref<GetFullStaffQueryVariables> | ReactiveFunction<GetFullStaffQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetFullStaffQuery, GetFullStaffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetFullStaffQuery, GetFullStaffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetFullStaffQuery, GetFullStaffQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetFullStaffQuery, GetFullStaffQueryVariables>(GetFullStaffDocument, variables, options);
}
export type GetFullStaffQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetFullStaffQuery, GetFullStaffQueryVariables>;
export const GetUserEditInfoDocument = gql`
    query GetUserEditInfo($id: ID!) {
  getCoreUserById(id: $id) {
    id
    profile {
      firstName
      lastName
      email
      phone
      dob
      address {
        line1
        line2
        city
        state
        zipCode
      }
    }
    employment {
      isContractor
      contractorBusinessName
      contractorType
      employeeType
      startDate
      stateWorksIn
      workerRoles {
        id
        isPrimary
        payRate
        payType
        companyRole {
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserEditInfoQuery__
 *
 * To run a query within a Vue component, call `useGetUserEditInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEditInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserEditInfoQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetUserEditInfoQuery(variables: GetUserEditInfoQueryVariables | VueCompositionApi.Ref<GetUserEditInfoQueryVariables> | ReactiveFunction<GetUserEditInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserEditInfoQuery, GetUserEditInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserEditInfoQuery, GetUserEditInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserEditInfoQuery, GetUserEditInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserEditInfoQuery, GetUserEditInfoQueryVariables>(GetUserEditInfoDocument, variables, options);
}
export type GetUserEditInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserEditInfoQuery, GetUserEditInfoQueryVariables>;
export const GetUserRolesDocument = gql`
    query GetUserRoles($userId: ID!) {
  getCoreUserById(id: $userId) {
    id
    employment {
      workerRoles {
        id
        isPrimary
        payRate
        payType
        companyRole {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a Vue component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserRolesQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useGetUserRolesQuery(variables: GetUserRolesQueryVariables | VueCompositionApi.Ref<GetUserRolesQueryVariables> | ReactiveFunction<GetUserRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserRolesQuery, GetUserRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserRolesQuery, GetUserRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserRolesQuery, GetUserRolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, variables, options);
}
export type GetUserRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserRolesQuery, GetUserRolesQueryVariables>;
export const AssignWorkerRolesDocument = gql`
    mutation AssignWorkerRoles($input: AssignWorkerRolesInput!) {
  assignWorkerRoles(input: $input) {
    id
  }
}
    `;

/**
 * __useAssignWorkerRolesMutation__
 *
 * To run a mutation, you first call `useAssignWorkerRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignWorkerRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignWorkerRolesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAssignWorkerRolesMutation(options: VueApolloComposable.UseMutationOptions<AssignWorkerRolesMutation, AssignWorkerRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignWorkerRolesMutation, AssignWorkerRolesMutationVariables>>) {
  return VueApolloComposable.useMutation<AssignWorkerRolesMutation, AssignWorkerRolesMutationVariables>(AssignWorkerRolesDocument, options);
}
export type AssignWorkerRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignWorkerRolesMutation, AssignWorkerRolesMutationVariables>;
export const CreateHrRequestDocument = gql`
    mutation CreateHrRequest($input: CreateHrRequestInput!) {
  createHrRequest(input: $input) {
    id
    intercomConversationId
    caseId
  }
}
    `;

/**
 * __useCreateHrRequestMutation__
 *
 * To run a mutation, you first call `useCreateHrRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateHrRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateHrRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateHrRequestMutation(options: VueApolloComposable.UseMutationOptions<CreateHrRequestMutation, CreateHrRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateHrRequestMutation, CreateHrRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateHrRequestMutation, CreateHrRequestMutationVariables>(CreateHrRequestDocument, options);
}
export type CreateHrRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateHrRequestMutation, CreateHrRequestMutationVariables>;
export const ReplyToConversationDocument = gql`
    mutation ReplyToConversation($input: ReplyToConversationInput!) {
  replyToConversation(input: $input) {
    id
    intercomConversationId
    messages {
      attachments {
        contentType
        name
        type
        url
      }
      body
      createdAt
      inBound
    }
  }
}
    `;

/**
 * __useReplyToConversationMutation__
 *
 * To run a mutation, you first call `useReplyToConversationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplyToConversationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplyToConversationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReplyToConversationMutation(options: VueApolloComposable.UseMutationOptions<ReplyToConversationMutation, ReplyToConversationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplyToConversationMutation, ReplyToConversationMutationVariables>>) {
  return VueApolloComposable.useMutation<ReplyToConversationMutation, ReplyToConversationMutationVariables>(ReplyToConversationDocument, options);
}
export type ReplyToConversationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplyToConversationMutation, ReplyToConversationMutationVariables>;
export const CancelScheduledEventDocument = gql`
    mutation CancelScheduledEvent($input: CancelScheduledEventInput!) {
  cancelScheduledEvent(input: $input) {
    calendlyEventId
    id
    cancelled
  }
}
    `;

/**
 * __useCancelScheduledEventMutation__
 *
 * To run a mutation, you first call `useCancelScheduledEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelScheduledEventMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCancelScheduledEventMutation(options: VueApolloComposable.UseMutationOptions<CancelScheduledEventMutation, CancelScheduledEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelScheduledEventMutation, CancelScheduledEventMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelScheduledEventMutation, CancelScheduledEventMutationVariables>(CancelScheduledEventDocument, options);
}
export type CancelScheduledEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelScheduledEventMutation, CancelScheduledEventMutationVariables>;
export const UploadFilesToConversationDocument = gql`
    mutation UploadFilesToConversation($input: UploadFilesToConversationInput!) {
  uploadFilesToConversation(input: $input) {
    id
    intercomConversationId
    messages {
      attachments {
        contentType
        name
        type
        url
      }
      body
      createdAt
      inBound
    }
    subject
  }
}
    `;

/**
 * __useUploadFilesToConversationMutation__
 *
 * To run a mutation, you first call `useUploadFilesToConversationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadFilesToConversationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadFilesToConversationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUploadFilesToConversationMutation(options: VueApolloComposable.UseMutationOptions<UploadFilesToConversationMutation, UploadFilesToConversationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadFilesToConversationMutation, UploadFilesToConversationMutationVariables>>) {
  return VueApolloComposable.useMutation<UploadFilesToConversationMutation, UploadFilesToConversationMutationVariables>(UploadFilesToConversationDocument, options);
}
export type UploadFilesToConversationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadFilesToConversationMutation, UploadFilesToConversationMutationVariables>;
export const StartTaskDocument = gql`
    mutation StartTask($id: String!) {
  startTask(id: $id) {
    id
    name
    label
    startedAt
    completionStatus
  }
}
    `;

/**
 * __useStartTaskMutation__
 *
 * To run a mutation, you first call `useStartTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartTaskMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useStartTaskMutation(options: VueApolloComposable.UseMutationOptions<StartTaskMutation, StartTaskMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartTaskMutation, StartTaskMutationVariables>>) {
  return VueApolloComposable.useMutation<StartTaskMutation, StartTaskMutationVariables>(StartTaskDocument, options);
}
export type StartTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StartTaskMutation, StartTaskMutationVariables>;
export const CompleteTaskDocument = gql`
    mutation CompleteTask($data: CompleteTaskInput!) {
  completeTask(data: $data) {
    id
    name
    label
    completedAt
    completionStatus
  }
}
    `;

/**
 * __useCompleteTaskMutation__
 *
 * To run a mutation, you first call `useCompleteTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteTaskMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteTaskMutation(options: VueApolloComposable.UseMutationOptions<CompleteTaskMutation, CompleteTaskMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteTaskMutation, CompleteTaskMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteTaskMutation, CompleteTaskMutationVariables>(CompleteTaskDocument, options);
}
export type CompleteTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteTaskMutation, CompleteTaskMutationVariables>;
export const CompleteGoalDocument = gql`
    mutation CompleteGoal($data: CompleteGoalInput!) {
  completeGoal(data: $data) {
    id
    name
    label
    completedAt
    completionStatus
  }
}
    `;

/**
 * __useCompleteGoalMutation__
 *
 * To run a mutation, you first call `useCompleteGoalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteGoalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteGoalMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCompleteGoalMutation(options: VueApolloComposable.UseMutationOptions<CompleteGoalMutation, CompleteGoalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteGoalMutation, CompleteGoalMutationVariables>>) {
  return VueApolloComposable.useMutation<CompleteGoalMutation, CompleteGoalMutationVariables>(CompleteGoalDocument, options);
}
export type CompleteGoalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteGoalMutation, CompleteGoalMutationVariables>;
export const GetHrRequestOptionsDocument = gql`
    query GetHrRequestOptions {
  getHrRequestOptions {
    groups {
      key
      icon
      title
    }
    options {
      title
      description
      popular {
        order
        title
        description
      }
      groupKey
      type
      subType
      slug
      audience
      requiresPrimaryHrm
      expectation {
        cycleTime
        description
      }
      keywords
      unlisted
    }
  }
}
    `;

/**
 * __useGetHrRequestOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetHrRequestOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrRequestOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHrRequestOptionsQuery();
 */
export function useGetHrRequestOptionsQuery(options: VueApolloComposable.UseQueryOptions<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables>(GetHrRequestOptionsDocument, {}, options);
}
export type GetHrRequestOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHrRequestOptionsQuery, GetHrRequestOptionsQueryVariables>;
export const GetHrRequestsDocument = gql`
    query GetHrRequests {
  getHrRequests {
    hrRequests {
      id
    }
  }
}
    `;

/**
 * __useGetHrRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetHrRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHrRequestsQuery();
 */
export function useGetHrRequestsQuery(options: VueApolloComposable.UseQueryOptions<GetHrRequestsQuery, GetHrRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHrRequestsQuery, GetHrRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHrRequestsQuery, GetHrRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHrRequestsQuery, GetHrRequestsQueryVariables>(GetHrRequestsDocument, {}, options);
}
export type GetHrRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHrRequestsQuery, GetHrRequestsQueryVariables>;
export const HrRequestDocument = gql`
    query HrRequest($input: GetHrRequestByIdInput!) {
  hrRequest(input: $input) {
    id
    conversation {
      id
      intercomConversationId
      subject
      messages {
        body
        inBound
      }
    }
  }
}
    `;

/**
 * __useHrRequestQuery__
 *
 * To run a query within a Vue component, call `useHrRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHrRequestQuery({
 *   input: // value for 'input'
 * });
 */
export function useHrRequestQuery(variables: HrRequestQueryVariables | VueCompositionApi.Ref<HrRequestQueryVariables> | ReactiveFunction<HrRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<HrRequestQuery, HrRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HrRequestQuery, HrRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HrRequestQuery, HrRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HrRequestQuery, HrRequestQueryVariables>(HrRequestDocument, variables, options);
}
export type HrRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HrRequestQuery, HrRequestQueryVariables>;
export const HrRequestAiInformationDocument = gql`
    query HrRequestAiInformation($input: GetHrRequestByIdInput!) {
  hrRequest(input: $input) {
    id
    caseId
    aiGenerated
    aiArtifacts
    threadId
  }
}
    `;

/**
 * __useHrRequestAiInformationQuery__
 *
 * To run a query within a Vue component, call `useHrRequestAiInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrRequestAiInformationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHrRequestAiInformationQuery({
 *   input: // value for 'input'
 * });
 */
export function useHrRequestAiInformationQuery(variables: HrRequestAiInformationQueryVariables | VueCompositionApi.Ref<HrRequestAiInformationQueryVariables> | ReactiveFunction<HrRequestAiInformationQueryVariables>, options: VueApolloComposable.UseQueryOptions<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables>(HrRequestAiInformationDocument, variables, options);
}
export type HrRequestAiInformationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HrRequestAiInformationQuery, HrRequestAiInformationQueryVariables>;
export const GetOnboardingCalendlyConfigDocument = gql`
    query GetOnboardingCalendlyConfig($input: OnboardingCalendlyConfigInput!) {
  getOnboardingCalendlyConfig(input: $input) {
    link
    tierNumber
    zone
  }
}
    `;

/**
 * __useGetOnboardingCalendlyConfigQuery__
 *
 * To run a query within a Vue component, call `useGetOnboardingCalendlyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingCalendlyConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOnboardingCalendlyConfigQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetOnboardingCalendlyConfigQuery(variables: GetOnboardingCalendlyConfigQueryVariables | VueCompositionApi.Ref<GetOnboardingCalendlyConfigQueryVariables> | ReactiveFunction<GetOnboardingCalendlyConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables>(GetOnboardingCalendlyConfigDocument, variables, options);
}
export type GetOnboardingCalendlyConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOnboardingCalendlyConfigQuery, GetOnboardingCalendlyConfigQueryVariables>;
export const GetConversationByIntercomIdDocument = gql`
    query GetConversationByIntercomId($input: GetConversationByIntercomIdInput!) {
  getConversationByIntercomId(input: $input) {
    id
    intercomConversationId
    messages {
      createdAt
      body
      inBound
      attachments {
        type
        name
        contentType
        url
      }
    }
    subject
    createdAt
    inBound
  }
}
    `;

/**
 * __useGetConversationByIntercomIdQuery__
 *
 * To run a query within a Vue component, call `useGetConversationByIntercomIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationByIntercomIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConversationByIntercomIdQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetConversationByIntercomIdQuery(variables: GetConversationByIntercomIdQueryVariables | VueCompositionApi.Ref<GetConversationByIntercomIdQueryVariables> | ReactiveFunction<GetConversationByIntercomIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables>(GetConversationByIntercomIdDocument, variables, options);
}
export type GetConversationByIntercomIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConversationByIntercomIdQuery, GetConversationByIntercomIdQueryVariables>;
export const GetHrRequestListDocument = gql`
    query GetHrRequestList {
  hrRequestList {
    hrRequests {
      caseId
      caseNumber
      completionDate
      createdDate
      description
      expectationDate
      hrRequestSurveyAnswers
      intercomId
      isComplete
      isOverdue
      lastModifiedDate
      status
      subType
      subject
      type
      aiMetadata
    }
  }
}
    `;

/**
 * __useGetHrRequestListQuery__
 *
 * To run a query within a Vue component, call `useGetHrRequestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrRequestListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetHrRequestListQuery();
 */
export function useGetHrRequestListQuery(options: VueApolloComposable.UseQueryOptions<GetHrRequestListQuery, GetHrRequestListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetHrRequestListQuery, GetHrRequestListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetHrRequestListQuery, GetHrRequestListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetHrRequestListQuery, GetHrRequestListQueryVariables>(GetHrRequestListDocument, {}, options);
}
export type GetHrRequestListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetHrRequestListQuery, GetHrRequestListQueryVariables>;
export const GetScheduledEventsDocument = gql`
    query GetScheduledEvents($input: GetScheduledEventsForUserInput!) {
  getScheduledEventsForUser(input: $input) {
    id
    agent {
      avatarUrl
      id
      name
      role
    }
    attendeeEmails
    missedCallFeeStatus
    title
    calendlyEventId
    startTime
    endTime
    eventLocation
    videoConferenceLink
    phoneNumber
    calendlyInviteeId
    videoConferenceLink
    cancelled
    kind
    callSummaries {
      actionItems
      agent {
        avatarUrl
        id
        name
        role
      }
      approvedAt
      callDurationInMinutes
      createdAt
      followUps
      isApproved
      summary
    }
  }
}
    `;

/**
 * __useGetScheduledEventsQuery__
 *
 * To run a query within a Vue component, call `useGetScheduledEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetScheduledEventsQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetScheduledEventsQuery(variables: GetScheduledEventsQueryVariables | VueCompositionApi.Ref<GetScheduledEventsQueryVariables> | ReactiveFunction<GetScheduledEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetScheduledEventsQuery, GetScheduledEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetScheduledEventsQuery, GetScheduledEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetScheduledEventsQuery, GetScheduledEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetScheduledEventsQuery, GetScheduledEventsQueryVariables>(GetScheduledEventsDocument, variables, options);
}
export type GetScheduledEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetScheduledEventsQuery, GetScheduledEventsQueryVariables>;
export const GetRescheduleLinkDocument = gql`
    query GetRescheduleLink($input: GetCalendlyRescheduleLinkInput!) {
  getRescheduleLink(input: $input)
}
    `;

/**
 * __useGetRescheduleLinkQuery__
 *
 * To run a query within a Vue component, call `useGetRescheduleLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRescheduleLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRescheduleLinkQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetRescheduleLinkQuery(variables: GetRescheduleLinkQueryVariables | VueCompositionApi.Ref<GetRescheduleLinkQueryVariables> | ReactiveFunction<GetRescheduleLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables>(GetRescheduleLinkDocument, variables, options);
}
export type GetRescheduleLinkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRescheduleLinkQuery, GetRescheduleLinkQueryVariables>;
export const HrRequestExtendedDetailDocument = gql`
    query HrRequestExtendedDetail($input: GetHrRequestExtendedDetailByIdInput!) {
  hrRequestExtendedDetail(input: $input) {
    caseId
    intercomId
    caseNumber
    type
    subType
    status
    expectationDate
    lastModifiedDate
    createdDate
    completionDate
    isComplete
    isOverdue
    subject
    description
    hrRequestSurveyAnswers
    createdBy
    summary
    agent {
      id
      name
      avatarUrl
      role
    }
    ownerId
    timeline {
      eventType
      eventTime
      oldValue
      newValue
    }
    scheduledEvents {
      id
      calendlyEventId
    }
    companyId
    policies {
      id
      name
      displayName
      description
      icon
      step
      status
      createdAt
    }
    aiSummary
    aiMetadata
    relatedCases {
      caseId
      subject
    }
  }
}
    `;

/**
 * __useHrRequestExtendedDetailQuery__
 *
 * To run a query within a Vue component, call `useHrRequestExtendedDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrRequestExtendedDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHrRequestExtendedDetailQuery({
 *   input: // value for 'input'
 * });
 */
export function useHrRequestExtendedDetailQuery(variables: HrRequestExtendedDetailQueryVariables | VueCompositionApi.Ref<HrRequestExtendedDetailQueryVariables> | ReactiveFunction<HrRequestExtendedDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables>(HrRequestExtendedDetailDocument, variables, options);
}
export type HrRequestExtendedDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HrRequestExtendedDetailQuery, HrRequestExtendedDetailQueryVariables>;
export const GetAskNicelyWebSurveyInfoDocument = gql`
    query GetAskNicelyWebSurveyInfo($input: GetAskNicelyWebSurveyInfoInput!) {
  getAskNicelyWebSurveyInfo(input: $input) {
    emailHash
    force
    show
  }
}
    `;

/**
 * __useGetAskNicelyWebSurveyInfoQuery__
 *
 * To run a query within a Vue component, call `useGetAskNicelyWebSurveyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAskNicelyWebSurveyInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAskNicelyWebSurveyInfoQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetAskNicelyWebSurveyInfoQuery(variables: GetAskNicelyWebSurveyInfoQueryVariables | VueCompositionApi.Ref<GetAskNicelyWebSurveyInfoQueryVariables> | ReactiveFunction<GetAskNicelyWebSurveyInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables>(GetAskNicelyWebSurveyInfoDocument, variables, options);
}
export type GetAskNicelyWebSurveyInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAskNicelyWebSurveyInfoQuery, GetAskNicelyWebSurveyInfoQueryVariables>;
export const GetMyCompanyGoalsDocument = gql`
    query GetMyCompanyGoals {
  getMyCompanyGoals {
    id
    name
    label
    completionStatus
    completedAt
    taskNames
    copy {
      cta
      description
      estimated
    }
    tasks {
      id
      name
      label
      completionStatus
      completedAt
      startedAt
      copy {
        cta
        confirmCta
        denyCta
        estimated
      }
    }
  }
}
    `;

/**
 * __useGetMyCompanyGoalsQuery__
 *
 * To run a query within a Vue component, call `useGetMyCompanyGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCompanyGoalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyCompanyGoalsQuery();
 */
export function useGetMyCompanyGoalsQuery(options: VueApolloComposable.UseQueryOptions<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables>(GetMyCompanyGoalsDocument, {}, options);
}
export type GetMyCompanyGoalsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyCompanyGoalsQuery, GetMyCompanyGoalsQueryVariables>;
export const CloseHrRequestDocument = gql`
    mutation CloseHrRequest($input: CloseHrRequestInput!) {
  closeHrRequest(input: $input) {
    id
    caseId
    conversationId
    intercomConversationId
    customerCompanyId
    createdAt
    aiGenerated
    aiArtifacts
    threadId
  }
}
    `;

/**
 * __useCloseHrRequestMutation__
 *
 * To run a mutation, you first call `useCloseHrRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloseHrRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloseHrRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCloseHrRequestMutation(options: VueApolloComposable.UseMutationOptions<CloseHrRequestMutation, CloseHrRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloseHrRequestMutation, CloseHrRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<CloseHrRequestMutation, CloseHrRequestMutationVariables>(CloseHrRequestDocument, options);
}
export type CloseHrRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloseHrRequestMutation, CloseHrRequestMutationVariables>;
export const SetCaseStatusDocument = gql`
    mutation SetCaseStatus($input: SetCaseStatusInput!) {
  setCaseStatus(input: $input) {
    id
    caseId
    conversationId
    intercomConversationId
    customerCompanyId
    createdAt
    aiGenerated
    aiArtifacts
    threadId
  }
}
    `;

/**
 * __useSetCaseStatusMutation__
 *
 * To run a mutation, you first call `useSetCaseStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCaseStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCaseStatusMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetCaseStatusMutation(options: VueApolloComposable.UseMutationOptions<SetCaseStatusMutation, SetCaseStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetCaseStatusMutation, SetCaseStatusMutationVariables>>) {
  return VueApolloComposable.useMutation<SetCaseStatusMutation, SetCaseStatusMutationVariables>(SetCaseStatusDocument, options);
}
export type SetCaseStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetCaseStatusMutation, SetCaseStatusMutationVariables>;
export const CreateTerminationDocument = gql`
    mutation CreateTermination($data: TerminationCreateInput!) {
  createTermination(data: $data) {
    terminationId
    employeeId
    userId
    status
    step
    terminationDate
    startDate
    confirmed
    terminationState
    createdAt
    complete
  }
}
    `;

/**
 * __useCreateTerminationMutation__
 *
 * To run a mutation, you first call `useCreateTerminationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTerminationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTerminationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateTerminationMutation(options: VueApolloComposable.UseMutationOptions<CreateTerminationMutation, CreateTerminationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateTerminationMutation, CreateTerminationMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateTerminationMutation, CreateTerminationMutationVariables>(CreateTerminationDocument, options);
}
export type CreateTerminationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateTerminationMutation, CreateTerminationMutationVariables>;
export const CreateResignationDocument = gql`
    mutation CreateResignation($data: ResignationCreateInput!) {
  createResignation(data: $data) {
    resignationId
    employeeId
    userId
    status
    step
    resignationDate
    resignationState
    confirmed
    selfService
    hrRequestId
    createdAt
    complete
  }
}
    `;

/**
 * __useCreateResignationMutation__
 *
 * To run a mutation, you first call `useCreateResignationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateResignationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateResignationMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateResignationMutation(options: VueApolloComposable.UseMutationOptions<CreateResignationMutation, CreateResignationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateResignationMutation, CreateResignationMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateResignationMutation, CreateResignationMutationVariables>(CreateResignationDocument, options);
}
export type CreateResignationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateResignationMutation, CreateResignationMutationVariables>;
export const GetTerminationByHrRequestDocument = gql`
    query GetTerminationByHrRequest($data: GetTerminationHrRequestInput!) {
  getTerminationByHrRequest(data: $data) {
    terminationId
    employeeId
    userId
    status
    step
    terminationDate
    startDate
    confirmed
    selfService
    terminationState
    createdAt
  }
}
    `;

/**
 * __useGetTerminationByHrRequestQuery__
 *
 * To run a query within a Vue component, call `useGetTerminationByHrRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminationByHrRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTerminationByHrRequestQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTerminationByHrRequestQuery(variables: GetTerminationByHrRequestQueryVariables | VueCompositionApi.Ref<GetTerminationByHrRequestQueryVariables> | ReactiveFunction<GetTerminationByHrRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables>(GetTerminationByHrRequestDocument, variables, options);
}
export type GetTerminationByHrRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTerminationByHrRequestQuery, GetTerminationByHrRequestQueryVariables>;
export const GetResignationByHrRequestDocument = gql`
    query GetResignationByHrRequest($data: GetResignationHrRequestInput!) {
  getResignationByHrRequest(data: $data) {
    resignationId
    employeeId
    userId
    status
    step
    resignationDate
    startDate
    confirmed
    selfService
    resignationState
    createdAt
  }
}
    `;

/**
 * __useGetResignationByHrRequestQuery__
 *
 * To run a query within a Vue component, call `useGetResignationByHrRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResignationByHrRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetResignationByHrRequestQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetResignationByHrRequestQuery(variables: GetResignationByHrRequestQueryVariables | VueCompositionApi.Ref<GetResignationByHrRequestQueryVariables> | ReactiveFunction<GetResignationByHrRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables>(GetResignationByHrRequestDocument, variables, options);
}
export type GetResignationByHrRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetResignationByHrRequestQuery, GetResignationByHrRequestQueryVariables>;
export const BulkPurchaseSeatsDocument = gql`
    mutation bulkPurchaseSeats($data: BulkPurchaseSeatsInput!) {
  bulkPurchaseSeats(data: $data) {
    bundleId
    error
    id
    numPurchased
    topicId
    totalSeats
  }
}
    `;

/**
 * __useBulkPurchaseSeatsMutation__
 *
 * To run a mutation, you first call `useBulkPurchaseSeatsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkPurchaseSeatsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkPurchaseSeatsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useBulkPurchaseSeatsMutation(options: VueApolloComposable.UseMutationOptions<BulkPurchaseSeatsMutation, BulkPurchaseSeatsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkPurchaseSeatsMutation, BulkPurchaseSeatsMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkPurchaseSeatsMutation, BulkPurchaseSeatsMutationVariables>(BulkPurchaseSeatsDocument, options);
}
export type BulkPurchaseSeatsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkPurchaseSeatsMutation, BulkPurchaseSeatsMutationVariables>;
export const BulkEnrollUsersDocument = gql`
    mutation bulkEnrollUsers($data: BulkEnrollUsersInput!) {
  bulkEnrollUsers(data: $data) {
    ...BulkEnrollUsersResponseParts
  }
}
    ${BulkEnrollUsersResponsePartsFragmentDoc}`;

/**
 * __useBulkEnrollUsersMutation__
 *
 * To run a mutation, you first call `useBulkEnrollUsersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkEnrollUsersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkEnrollUsersMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useBulkEnrollUsersMutation(options: VueApolloComposable.UseMutationOptions<BulkEnrollUsersMutation, BulkEnrollUsersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkEnrollUsersMutation, BulkEnrollUsersMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkEnrollUsersMutation, BulkEnrollUsersMutationVariables>(BulkEnrollUsersDocument, options);
}
export type BulkEnrollUsersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkEnrollUsersMutation, BulkEnrollUsersMutationVariables>;
export const EnrollUsersDocument = gql`
    mutation enrollUsers($data: EnrollUsersInput!) {
  enrollUsers(data: $data) {
    ...EnrollmentResponseParts
  }
}
    ${EnrollmentResponsePartsFragmentDoc}`;

/**
 * __useEnrollUsersMutation__
 *
 * To run a mutation, you first call `useEnrollUsersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnrollUsersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnrollUsersMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useEnrollUsersMutation(options: VueApolloComposable.UseMutationOptions<EnrollUsersMutation, EnrollUsersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnrollUsersMutation, EnrollUsersMutationVariables>>) {
  return VueApolloComposable.useMutation<EnrollUsersMutation, EnrollUsersMutationVariables>(EnrollUsersDocument, options);
}
export type EnrollUsersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EnrollUsersMutation, EnrollUsersMutationVariables>;
export const PurchaseSeatsForBundleDocument = gql`
    mutation PurchaseSeatsForBundle($data: PurchaseBundleSeatsInput!) {
  purchaseSeatsForBundle(data: $data) {
    numPurchased
    totalSeats
  }
}
    `;

/**
 * __usePurchaseSeatsForBundleMutation__
 *
 * To run a mutation, you first call `usePurchaseSeatsForBundleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSeatsForBundleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseSeatsForBundleMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseSeatsForBundleMutation(options: VueApolloComposable.UseMutationOptions<PurchaseSeatsForBundleMutation, PurchaseSeatsForBundleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseSeatsForBundleMutation, PurchaseSeatsForBundleMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseSeatsForBundleMutation, PurchaseSeatsForBundleMutationVariables>(PurchaseSeatsForBundleDocument, options);
}
export type PurchaseSeatsForBundleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseSeatsForBundleMutation, PurchaseSeatsForBundleMutationVariables>;
export const RemoveSeatsFromBundleDocument = gql`
    mutation RemoveSeatsFromBundle($data: RemoveBundleSeatsInput!) {
  removeSeatsFromBundle(data: $data) {
    numRemoved
    totalSeats
  }
}
    `;

/**
 * __useRemoveSeatsFromBundleMutation__
 *
 * To run a mutation, you first call `useRemoveSeatsFromBundleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSeatsFromBundleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveSeatsFromBundleMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useRemoveSeatsFromBundleMutation(options: VueApolloComposable.UseMutationOptions<RemoveSeatsFromBundleMutation, RemoveSeatsFromBundleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveSeatsFromBundleMutation, RemoveSeatsFromBundleMutationVariables>>) {
  return VueApolloComposable.useMutation<RemoveSeatsFromBundleMutation, RemoveSeatsFromBundleMutationVariables>(RemoveSeatsFromBundleDocument, options);
}
export type RemoveSeatsFromBundleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveSeatsFromBundleMutation, RemoveSeatsFromBundleMutationVariables>;
export const PurchaseSeatsDocument = gql`
    mutation PurchaseSeats($data: PurchaseSeatsInput!) {
  purchaseSeats(data: $data) {
    numPurchased
    totalSeats
  }
}
    `;

/**
 * __usePurchaseSeatsMutation__
 *
 * To run a mutation, you first call `usePurchaseSeatsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSeatsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseSeatsMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function usePurchaseSeatsMutation(options: VueApolloComposable.UseMutationOptions<PurchaseSeatsMutation, PurchaseSeatsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseSeatsMutation, PurchaseSeatsMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchaseSeatsMutation, PurchaseSeatsMutationVariables>(PurchaseSeatsDocument, options);
}
export type PurchaseSeatsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseSeatsMutation, PurchaseSeatsMutationVariables>;
export const UnenrollUsersDocument = gql`
    mutation UnenrollUsers($data: UnenrollUsersInput!) {
  unenrollUsers(data: $data) {
    id
    successfullyUnenrolled
    errors
  }
}
    `;

/**
 * __useUnenrollUsersMutation__
 *
 * To run a mutation, you first call `useUnenrollUsersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollUsersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnenrollUsersMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUnenrollUsersMutation(options: VueApolloComposable.UseMutationOptions<UnenrollUsersMutation, UnenrollUsersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnenrollUsersMutation, UnenrollUsersMutationVariables>>) {
  return VueApolloComposable.useMutation<UnenrollUsersMutation, UnenrollUsersMutationVariables>(UnenrollUsersDocument, options);
}
export type UnenrollUsersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnenrollUsersMutation, UnenrollUsersMutationVariables>;
export const SelfUnenrollRetiredDocument = gql`
    mutation SelfUnenrollRetired($data: SelfUnenrollRetiredInput!) {
  selfUnenrollRetired(data: $data) {
    id
    successfullyUnenrolled
    errors
  }
}
    `;

/**
 * __useSelfUnenrollRetiredMutation__
 *
 * To run a mutation, you first call `useSelfUnenrollRetiredMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSelfUnenrollRetiredMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSelfUnenrollRetiredMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSelfUnenrollRetiredMutation(options: VueApolloComposable.UseMutationOptions<SelfUnenrollRetiredMutation, SelfUnenrollRetiredMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SelfUnenrollRetiredMutation, SelfUnenrollRetiredMutationVariables>>) {
  return VueApolloComposable.useMutation<SelfUnenrollRetiredMutation, SelfUnenrollRetiredMutationVariables>(SelfUnenrollRetiredDocument, options);
}
export type SelfUnenrollRetiredMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SelfUnenrollRetiredMutation, SelfUnenrollRetiredMutationVariables>;
export const MakeTrainingRequestDocument = gql`
    mutation MakeTrainingRequest($data: TrainingRequestInput!) {
  trainingRequest(data: $data) {
    id
    status
    resourceId
    resourceType
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMakeTrainingRequestMutation__
 *
 * To run a mutation, you first call `useMakeTrainingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMakeTrainingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMakeTrainingRequestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useMakeTrainingRequestMutation(options: VueApolloComposable.UseMutationOptions<MakeTrainingRequestMutation, MakeTrainingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MakeTrainingRequestMutation, MakeTrainingRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<MakeTrainingRequestMutation, MakeTrainingRequestMutationVariables>(MakeTrainingRequestDocument, options);
}
export type MakeTrainingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MakeTrainingRequestMutation, MakeTrainingRequestMutationVariables>;
export const CancelTrainingRequestDocument = gql`
    mutation CancelTrainingRequest($data: RequestCancelInput!) {
  cancelRequest(data: $data) {
    id
    status
    updatedAt
  }
}
    `;

/**
 * __useCancelTrainingRequestMutation__
 *
 * To run a mutation, you first call `useCancelTrainingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelTrainingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelTrainingRequestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCancelTrainingRequestMutation(options: VueApolloComposable.UseMutationOptions<CancelTrainingRequestMutation, CancelTrainingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelTrainingRequestMutation, CancelTrainingRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<CancelTrainingRequestMutation, CancelTrainingRequestMutationVariables>(CancelTrainingRequestDocument, options);
}
export type CancelTrainingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelTrainingRequestMutation, CancelTrainingRequestMutationVariables>;
export const ApproveTrainingRequestDocument = gql`
    mutation ApproveTrainingRequest($data: RequestApprovalInput!) {
  approveRequest(data: $data) {
    id
    status
    updatedAt
  }
}
    `;

/**
 * __useApproveTrainingRequestMutation__
 *
 * To run a mutation, you first call `useApproveTrainingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveTrainingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveTrainingRequestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useApproveTrainingRequestMutation(options: VueApolloComposable.UseMutationOptions<ApproveTrainingRequestMutation, ApproveTrainingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveTrainingRequestMutation, ApproveTrainingRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<ApproveTrainingRequestMutation, ApproveTrainingRequestMutationVariables>(ApproveTrainingRequestDocument, options);
}
export type ApproveTrainingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveTrainingRequestMutation, ApproveTrainingRequestMutationVariables>;
export const RejectTrainingRequestDocument = gql`
    mutation RejectTrainingRequest($data: RequestRejectionInput!) {
  rejectRequest(data: $data) {
    id
    status
    updatedAt
  }
}
    `;

/**
 * __useRejectTrainingRequestMutation__
 *
 * To run a mutation, you first call `useRejectTrainingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectTrainingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectTrainingRequestMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useRejectTrainingRequestMutation(options: VueApolloComposable.UseMutationOptions<RejectTrainingRequestMutation, RejectTrainingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectTrainingRequestMutation, RejectTrainingRequestMutationVariables>>) {
  return VueApolloComposable.useMutation<RejectTrainingRequestMutation, RejectTrainingRequestMutationVariables>(RejectTrainingRequestDocument, options);
}
export type RejectTrainingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectTrainingRequestMutation, RejectTrainingRequestMutationVariables>;
export const GetTrainingCompanyDocument = gql`
    query GetTrainingCompany($data: GetCompanyInput!) {
  company(data: $data) {
    ...FullCompanyParts
  }
}
    ${FullCompanyPartsFragmentDoc}`;

/**
 * __useGetTrainingCompanyQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingCompanyQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTrainingCompanyQuery(variables: GetTrainingCompanyQueryVariables | VueCompositionApi.Ref<GetTrainingCompanyQueryVariables> | ReactiveFunction<GetTrainingCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables>(GetTrainingCompanyDocument, variables, options);
}
export type GetTrainingCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingCompanyQuery, GetTrainingCompanyQueryVariables>;
export const GetCompanyVerboseDocument = gql`
    query GetCompanyVerbose($data: GetCompanyInput!) {
  company(data: $data) {
    ...FullCompanyParts
  }
}
    ${FullCompanyPartsFragmentDoc}`;

/**
 * __useGetCompanyVerboseQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyVerboseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyVerboseQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyVerboseQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanyVerboseQuery(variables: GetCompanyVerboseQueryVariables | VueCompositionApi.Ref<GetCompanyVerboseQueryVariables> | ReactiveFunction<GetCompanyVerboseQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables>(GetCompanyVerboseDocument, variables, options);
}
export type GetCompanyVerboseQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyVerboseQuery, GetCompanyVerboseQueryVariables>;
export const GetUserCoursesDocument = gql`
    query GetUserCourses($data: UserCoursesInput!) {
  userCourses(data: $data) {
    ...UserCourseParts
  }
}
    ${UserCoursePartsFragmentDoc}`;

/**
 * __useGetUserCoursesQuery__
 *
 * To run a query within a Vue component, call `useGetUserCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCoursesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserCoursesQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetUserCoursesQuery(variables: GetUserCoursesQueryVariables | VueCompositionApi.Ref<GetUserCoursesQueryVariables> | ReactiveFunction<GetUserCoursesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetUserCoursesQuery, GetUserCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserCoursesQuery, GetUserCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserCoursesQuery, GetUserCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserCoursesQuery, GetUserCoursesQueryVariables>(GetUserCoursesDocument, variables, options);
}
export type GetUserCoursesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserCoursesQuery, GetUserCoursesQueryVariables>;
export const GetTopicsDocument = gql`
    query GetTopics {
  getTopics {
    id
    name
    searchTag
  }
}
    `;

/**
 * __useGetTopicsQuery__
 *
 * To run a query within a Vue component, call `useGetTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTopicsQuery();
 */
export function useGetTopicsQuery(options: VueApolloComposable.UseQueryOptions<GetTopicsQuery, GetTopicsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTopicsQuery, GetTopicsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTopicsQuery, GetTopicsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTopicsQuery, GetTopicsQueryVariables>(GetTopicsDocument, {}, options);
}
export type GetTopicsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTopicsQuery, GetTopicsQueryVariables>;
export const GetCompanyTicketsDocument = gql`
    query GetCompanyTickets($data: ListTicketsInput!) {
  getTickets(data: $data) {
    totalTickets
    tickets {
      id
      topicId
      bundleId
      courseId
      userId
      stripeInvoiceId
      enrolledAt
      startedAt
      completedAt
    }
  }
}
    `;

/**
 * __useGetCompanyTicketsQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyTicketsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyTicketsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetCompanyTicketsQuery(variables: GetCompanyTicketsQueryVariables | VueCompositionApi.Ref<GetCompanyTicketsQueryVariables> | ReactiveFunction<GetCompanyTicketsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables>(GetCompanyTicketsDocument, variables, options);
}
export type GetCompanyTicketsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyTicketsQuery, GetCompanyTicketsQueryVariables>;
export const GetTrainingPricesDocument = gql`
    query GetTrainingPrices {
  getTrainingPrices {
    bundle
    topic
  }
}
    `;

/**
 * __useGetTrainingPricesQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingPricesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingPricesQuery();
 */
export function useGetTrainingPricesQuery(options: VueApolloComposable.UseQueryOptions<GetTrainingPricesQuery, GetTrainingPricesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingPricesQuery, GetTrainingPricesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingPricesQuery, GetTrainingPricesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingPricesQuery, GetTrainingPricesQueryVariables>(GetTrainingPricesDocument, {}, options);
}
export type GetTrainingPricesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingPricesQuery, GetTrainingPricesQueryVariables>;
export const GetTrainingUserHistoryDocument = gql`
    query GetTrainingUserHistory($data: UserQueryInput!, $filter: UserTrainingFilterInput!) {
  user(data: $data) {
    training {
      history(filter: $filter) {
        ...UserCourseParts
      }
    }
  }
}
    ${UserCoursePartsFragmentDoc}`;

/**
 * __useGetTrainingUserHistoryQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingUserHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingUserHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingUserHistoryQuery({
 *   data: // value for 'data'
 *   filter: // value for 'filter'
 * });
 */
export function useGetTrainingUserHistoryQuery(variables: GetTrainingUserHistoryQueryVariables | VueCompositionApi.Ref<GetTrainingUserHistoryQueryVariables> | ReactiveFunction<GetTrainingUserHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables>(GetTrainingUserHistoryDocument, variables, options);
}
export type GetTrainingUserHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingUserHistoryQuery, GetTrainingUserHistoryQueryVariables>;
export const GetTrainingRecommendationsDocument = gql`
    query GetTrainingRecommendations($data: MyTrainingRecommendationFilterInput!) {
  myTrainingRecommendations(data: $data) {
    id
    status
    note
    resourceId
    resourceType
    scope
    recommendedAt
    createdAt
    updatedAt
    targets
  }
}
    `;

/**
 * __useGetTrainingRecommendationsQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingRecommendationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingRecommendationsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTrainingRecommendationsQuery(variables: GetTrainingRecommendationsQueryVariables | VueCompositionApi.Ref<GetTrainingRecommendationsQueryVariables> | ReactiveFunction<GetTrainingRecommendationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables>(GetTrainingRecommendationsDocument, variables, options);
}
export type GetTrainingRecommendationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingRecommendationsQuery, GetTrainingRecommendationsQueryVariables>;
export const GetMyTrainingRequestsDocument = gql`
    query GetMyTrainingRequests($data: MyRequestFilterInput!) {
  myRequests(data: $data) {
    id
    status
    resourceId
    resourceType
    createdAt
    updatedAt
    approvalCriteria
    approverRoles
    rejectionCriteria
    companyId
    userId
  }
}
    `;

/**
 * __useGetMyTrainingRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetMyTrainingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTrainingRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyTrainingRequestsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetMyTrainingRequestsQuery(variables: GetMyTrainingRequestsQueryVariables | VueCompositionApi.Ref<GetMyTrainingRequestsQueryVariables> | ReactiveFunction<GetMyTrainingRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables>(GetMyTrainingRequestsDocument, variables, options);
}
export type GetMyTrainingRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyTrainingRequestsQuery, GetMyTrainingRequestsQueryVariables>;
export const GetTrainingRequestsDocument = gql`
    query GetTrainingRequests($data: RequestFilterInput!) {
  requests(data: $data) {
    id
    status
    resourceId
    resourceType
    createdAt
    updatedAt
    approvalCriteria
    approverRoles
    rejectionCriteria
    companyId
    userId
    requestedAt
    user {
      profile {
        firstName
        lastName
        avatarUrl
      }
      employment {
        title
      }
    }
  }
}
    `;

/**
 * __useGetTrainingRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetTrainingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTrainingRequestsQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetTrainingRequestsQuery(variables: GetTrainingRequestsQueryVariables | VueCompositionApi.Ref<GetTrainingRequestsQueryVariables> | ReactiveFunction<GetTrainingRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables>(GetTrainingRequestsDocument, variables, options);
}
export type GetTrainingRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTrainingRequestsQuery, GetTrainingRequestsQueryVariables>;
export const GetCompanyTrainingStatusDocument = gql`
    query GetCompanyTrainingStatus($id: String!) {
  company(data: {companyId: $id}) {
    hasTraining
  }
}
    `;

/**
 * __useGetCompanyTrainingStatusQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyTrainingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyTrainingStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyTrainingStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyTrainingStatusQuery(variables: GetCompanyTrainingStatusQueryVariables | VueCompositionApi.Ref<GetCompanyTrainingStatusQueryVariables> | ReactiveFunction<GetCompanyTrainingStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables>(GetCompanyTrainingStatusDocument, variables, options);
}
export type GetCompanyTrainingStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyTrainingStatusQuery, GetCompanyTrainingStatusQueryVariables>;
export const GetNonCoreSubscriptionBillingChangesDocument = gql`
    query GetNonCoreSubscriptionBillingChanges($data: GetCompanyUpcomingBillingChangesInput!) {
  getNonCoreSubscriptionBillingChanges(data: $data) {
    minSize
    maxSize
    productKey
    serviceKey
    upcomingMonthlyPrice
    upcomingYearlyPrice
  }
}
    `;

/**
 * __useGetNonCoreSubscriptionBillingChangesQuery__
 *
 * To run a query within a Vue component, call `useGetNonCoreSubscriptionBillingChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonCoreSubscriptionBillingChangesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNonCoreSubscriptionBillingChangesQuery({
 *   data: // value for 'data'
 * });
 */
export function useGetNonCoreSubscriptionBillingChangesQuery(variables: GetNonCoreSubscriptionBillingChangesQueryVariables | VueCompositionApi.Ref<GetNonCoreSubscriptionBillingChangesQueryVariables> | ReactiveFunction<GetNonCoreSubscriptionBillingChangesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables>(GetNonCoreSubscriptionBillingChangesDocument, variables, options);
}
export type GetNonCoreSubscriptionBillingChangesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetNonCoreSubscriptionBillingChangesQuery, GetNonCoreSubscriptionBillingChangesQueryVariables>;
export const UpdateCoreUserStateDocument = gql`
    mutation updateCoreUserState($input: CoreUserStatesInput!) {
  updateCoreUserState(input: $input) {
    ...CoreUserStateParts
  }
}
    ${CoreUserStatePartsFragmentDoc}`;

/**
 * __useUpdateCoreUserStateMutation__
 *
 * To run a mutation, you first call `useUpdateCoreUserStateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoreUserStateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCoreUserStateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoreUserStateMutation(options: VueApolloComposable.UseMutationOptions<UpdateCoreUserStateMutation, UpdateCoreUserStateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCoreUserStateMutation, UpdateCoreUserStateMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateCoreUserStateMutation, UpdateCoreUserStateMutationVariables>(UpdateCoreUserStateDocument, options);
}
export type UpdateCoreUserStateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCoreUserStateMutation, UpdateCoreUserStateMutationVariables>;
export const UpdateCoreUserProfileDocument = gql`
    mutation updateCoreUserProfile($id: ID!, $input: CoreUserProfileInput!) {
  updateCoreUserProfile(id: $id, input: $input) {
    id
    firstName
    lastName
    phone
    topPerformer {
      active
      note
    }
  }
}
    `;

/**
 * __useUpdateCoreUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateCoreUserProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoreUserProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCoreUserProfileMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoreUserProfileMutation(options: VueApolloComposable.UseMutationOptions<UpdateCoreUserProfileMutation, UpdateCoreUserProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCoreUserProfileMutation, UpdateCoreUserProfileMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateCoreUserProfileMutation, UpdateCoreUserProfileMutationVariables>(UpdateCoreUserProfileDocument, options);
}
export type UpdateCoreUserProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCoreUserProfileMutation, UpdateCoreUserProfileMutationVariables>;
export const MakeUserAdminDocument = gql`
    mutation makeUserAdmin($userId: ID!) {
  makeUserAdmin(userId: $userId)
}
    `;

/**
 * __useMakeUserAdminMutation__
 *
 * To run a mutation, you first call `useMakeUserAdminMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMakeUserAdminMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMakeUserAdminMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useMakeUserAdminMutation(options: VueApolloComposable.UseMutationOptions<MakeUserAdminMutation, MakeUserAdminMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MakeUserAdminMutation, MakeUserAdminMutationVariables>>) {
  return VueApolloComposable.useMutation<MakeUserAdminMutation, MakeUserAdminMutationVariables>(MakeUserAdminDocument, options);
}
export type MakeUserAdminMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MakeUserAdminMutation, MakeUserAdminMutationVariables>;
export const RemoveUserAdminDocument = gql`
    mutation removeUserAdmin($userId: ID!) {
  removeUserAdmin(userId: $userId)
}
    `;

/**
 * __useRemoveUserAdminMutation__
 *
 * To run a mutation, you first call `useRemoveUserAdminMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserAdminMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveUserAdminMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserAdminMutation(options: VueApolloComposable.UseMutationOptions<RemoveUserAdminMutation, RemoveUserAdminMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveUserAdminMutation, RemoveUserAdminMutationVariables>>) {
  return VueApolloComposable.useMutation<RemoveUserAdminMutation, RemoveUserAdminMutationVariables>(RemoveUserAdminDocument, options);
}
export type RemoveUserAdminMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveUserAdminMutation, RemoveUserAdminMutationVariables>;
export const GetMyCoreUserDocument = gql`
    query GetMyCoreUser {
  getMyCoreUser {
    id
    role
    documents {
      ...CoreDocumentParts
    }
    states {
      ...CoreUserStateParts
    }
    employment {
      ...CoreUserEmploymentParts
    }
  }
}
    ${CoreDocumentPartsFragmentDoc}
${CoreUserStatePartsFragmentDoc}
${CoreUserEmploymentPartsFragmentDoc}`;

/**
 * __useGetMyCoreUserQuery__
 *
 * To run a query within a Vue component, call `useGetMyCoreUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCoreUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyCoreUserQuery();
 */
export function useGetMyCoreUserQuery(options: VueApolloComposable.UseQueryOptions<GetMyCoreUserQuery, GetMyCoreUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyCoreUserQuery, GetMyCoreUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyCoreUserQuery, GetMyCoreUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyCoreUserQuery, GetMyCoreUserQueryVariables>(GetMyCoreUserDocument, {}, options);
}
export type GetMyCoreUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyCoreUserQuery, GetMyCoreUserQueryVariables>;
export const GetWizardsByDestinationDocument = gql`
    query GetWizardsByDestination($filter: WizardFilterInput) {
  wizards(filter: $filter) {
    id
    type
    userId
    deletedAt
    completedAt
    title
    description
    successMessage
    startedAt
    currentStepId
    totalStepCount
    createdAt
    companyId
    steps {
      id
      title
      order
    }
  }
}
    `;

/**
 * __useGetWizardsByDestinationQuery__
 *
 * To run a query within a Vue component, call `useGetWizardsByDestinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWizardsByDestinationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWizardsByDestinationQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useGetWizardsByDestinationQuery(variables: GetWizardsByDestinationQueryVariables | VueCompositionApi.Ref<GetWizardsByDestinationQueryVariables> | ReactiveFunction<GetWizardsByDestinationQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetWizardsByDestinationQuery, GetWizardsByDestinationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWizardsByDestinationQuery, GetWizardsByDestinationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWizardsByDestinationQuery, GetWizardsByDestinationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetWizardsByDestinationQuery, GetWizardsByDestinationQueryVariables>(GetWizardsByDestinationDocument, variables, options);
}
export type GetWizardsByDestinationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetWizardsByDestinationQuery, GetWizardsByDestinationQueryVariables>;
export const namedOperations = {
  Query: {
    GetArtifactsByThread: 'GetArtifactsByThread',
    GetCouponById: 'GetCouponById',
    getLockedPlan: 'getLockedPlan',
    GetBillingCompanySubscriptions: 'GetBillingCompanySubscriptions',
    myProducts: 'myProducts',
    GetCompanyDelinquency: 'GetCompanyDelinquency',
    GetCompanySources: 'GetCompanySources',
    ScratchListServiceAddons: 'ScratchListServiceAddons',
    GetBillingHistory: 'GetBillingHistory',
    GetBillingInfoPaymentMethods: 'GetBillingInfoPaymentMethods',
    GetCorePlanAccess: 'GetCorePlanAccess',
    GetBillingInfo: 'GetBillingInfo',
    GetBillingSubscriptionTermEnd: 'GetBillingSubscriptionTermEnd',
    GetCompanySubscriptions: 'GetCompanySubscriptions',
    RecurlyPaymentMethods: 'RecurlyPaymentMethods',
    RecurlyInvoices: 'RecurlyInvoices',
    GetAvailableProducts: 'GetAvailableProducts',
    GetCompanyCredits: 'GetCompanyCredits',
    PremiumPeopleAddonPlanForCompany: 'PremiumPeopleAddonPlanForCompany',
    PremiumPeopleCorePlans: 'PremiumPeopleCorePlans',
    GetCancellationReasons: 'GetCancellationReasons',
    GetCancellationOffers: 'GetCancellationOffers',
    GetCompanySettings: 'GetCompanySettings',
    ListPractice: 'ListPractice',
    GetPractice: 'GetPractice',
    GetHrScore: 'GetHrScore',
    GetCompanySurvey: 'GetCompanySurvey',
    GetBasicCompanyInfo: 'GetBasicCompanyInfo',
    GetSimplePolicyList: 'GetSimplePolicyList',
    GetCompanyRoles: 'GetCompanyRoles',
    GetPendingHotlineCalls: 'GetPendingHotlineCalls',
    GetHotlineCalls: 'GetHotlineCalls',
    GetMyVoicesFeedbackList: 'GetMyVoicesFeedbackList',
    GetMyCompanyVoicesFeedbackList: 'GetMyCompanyVoicesFeedbackList',
    GetTerminationList: 'GetTerminationList',
    GetTerminationInfo: 'GetTerminationInfo',
    TerminationDownload: 'TerminationDownload',
    GetResignationList: 'GetResignationList',
    ResignationInfo: 'ResignationInfo',
    ResignationDownload: 'ResignationDownload',
    WarningDocuments: 'WarningDocuments',
    GetEmployeeJobDescription: 'GetEmployeeJobDescription',
    GetJobDescriptions: 'GetJobDescriptions',
    GetStaffJobDescriptions: 'GetStaffJobDescriptions',
    GetMfaEnrollments: 'GetMfaEnrollments',
    GetMigrationPricing: 'GetMigrationPricing',
    GetMigrationHeadcount: 'GetMigrationHeadcount',
    MyNotifications: 'MyNotifications',
    IsEventScheduledForUser: 'IsEventScheduledForUser',
    FindOnboardingStatus: 'FindOnboardingStatus',
    FindOnboarding: 'FindOnboarding',
    GetPolicy: 'GetPolicy',
    GetCompanyPolicies: 'GetCompanyPolicies',
    PolicyDataTable: 'PolicyDataTable',
    GetPricingPackages: 'GetPricingPackages',
    GetUpgradeOptions: 'GetUpgradeOptions',
    GetProductInterest: 'GetProductInterest',
    GetReportCardList: 'GetReportCardList',
    GetReportCard: 'GetReportCard',
    GetSolutions: 'GetSolutions',
    GetFullStaff: 'GetFullStaff',
    GetUserEditInfo: 'GetUserEditInfo',
    GetUserRoles: 'GetUserRoles',
    GetHrRequestOptions: 'GetHrRequestOptions',
    GetHrRequests: 'GetHrRequests',
    HrRequest: 'HrRequest',
    HrRequestAiInformation: 'HrRequestAiInformation',
    GetOnboardingCalendlyConfig: 'GetOnboardingCalendlyConfig',
    GetConversationByIntercomId: 'GetConversationByIntercomId',
    GetHrRequestList: 'GetHrRequestList',
    GetScheduledEvents: 'GetScheduledEvents',
    GetRescheduleLink: 'GetRescheduleLink',
    HrRequestExtendedDetail: 'HrRequestExtendedDetail',
    GetAskNicelyWebSurveyInfo: 'GetAskNicelyWebSurveyInfo',
    GetMyCompanyGoals: 'GetMyCompanyGoals',
    GetTerminationByHrRequest: 'GetTerminationByHrRequest',
    GetResignationByHrRequest: 'GetResignationByHrRequest',
    GetTrainingCompany: 'GetTrainingCompany',
    GetCompanyVerbose: 'GetCompanyVerbose',
    GetUserCourses: 'GetUserCourses',
    GetTopics: 'GetTopics',
    GetCompanyTickets: 'GetCompanyTickets',
    GetTrainingPrices: 'GetTrainingPrices',
    GetTrainingUserHistory: 'GetTrainingUserHistory',
    GetTrainingRecommendations: 'GetTrainingRecommendations',
    GetMyTrainingRequests: 'GetMyTrainingRequests',
    GetTrainingRequests: 'GetTrainingRequests',
    GetCompanyTrainingStatus: 'GetCompanyTrainingStatus',
    GetNonCoreSubscriptionBillingChanges: 'GetNonCoreSubscriptionBillingChanges',
    GetMyCoreUser: 'GetMyCoreUser',
    GetWizardsByDestination: 'GetWizardsByDestination'
  },
  Mutation: {
    ChatWithAssistant: 'ChatWithAssistant',
    Track: 'Track',
    Emit: 'Emit',
    purchaseCredits: 'purchaseCredits',
    purchaseSubscription: 'purchaseSubscription',
    UpdatePaymentSourceBillingAddress: 'UpdatePaymentSourceBillingAddress',
    ScratchToggleServiceAddon: 'ScratchToggleServiceAddon',
    ConfirmMicroDeposit: 'ConfirmMicroDeposit',
    RemovePaymentMethod: 'RemovePaymentMethod',
    AddRecurlyPaymentMethod: 'AddRecurlyPaymentMethod',
    SetPrimaryRecurlyPaymentMethod: 'SetPrimaryRecurlyPaymentMethod',
    RemoveRecurlyPaymentMethod: 'RemoveRecurlyPaymentMethod',
    SetDefaultBillingPaymentMethod: 'SetDefaultBillingPaymentMethod',
    ReactivatePausedCompany: 'ReactivatePausedCompany',
    CreatePremiumPeopleAddonSubscription: 'CreatePremiumPeopleAddonSubscription',
    AcceptOffer: 'AcceptOffer',
    AcceptTrialExtension: 'AcceptTrialExtension',
    SubmitCancelRequest: 'SubmitCancelRequest',
    SaveCompanyAnswer: 'SaveCompanyAnswer',
    CompleteCompanySurvey: 'CompleteCompanySurvey',
    CompleteCompanyPractice: 'CompleteCompanyPractice',
    UpdateBasicCompanyInfo: 'UpdateBasicCompanyInfo',
    SaveCompanySetting: 'SaveCompanySetting',
    BulkMessageStaff: 'BulkMessageStaff',
    CreateCompanyRoles: 'CreateCompanyRoles',
    UpdateCompanyRoles: 'UpdateCompanyRoles',
    DeleteCompanyRoles: 'DeleteCompanyRoles',
    CancelPendingHotlineCall: 'CancelPendingHotlineCall',
    EnqueueHotlineCall: 'EnqueueHotlineCall',
    CreateVoicesFeedback: 'CreateVoicesFeedback',
    CancelTermination: 'CancelTermination',
    ConfirmTermination: 'ConfirmTermination',
    EditTerminationDetails: 'EditTerminationDetails',
    AttachTerminationFiles: 'AttachTerminationFiles',
    AttachResignationFiles: 'AttachResignationFiles',
    CancelResignation: 'CancelResignation',
    ConfirmResignation: 'ConfirmResignation',
    EditResignation: 'EditResignation',
    CreateJobDescription: 'CreateJobDescription',
    UpdateJobDescription: 'UpdateJobDescription',
    CompleteJobDescription: 'CompleteJobDescription',
    GenerateAiJobDescription: 'GenerateAiJobDescription',
    GenerateAiJobDescriptionV2: 'GenerateAiJobDescriptionV2',
    SendJobDescriptionToEmployee: 'SendJobDescriptionToEmployee',
    SignEmployeeJobDescription: 'SignEmployeeJobDescription',
    CreateMfaChallenge: 'CreateMfaChallenge',
    EnrollMfaDevice: 'EnrollMfaDevice',
    ResendChallenge: 'ResendChallenge',
    ConfirmUserMfaEnrollment: 'ConfirmUserMfaEnrollment',
    SelectMigrationPlan: 'SelectMigrationPlan',
    DismissNotification: 'DismissNotification',
    ClickedOnNotificationAction: 'ClickedOnNotificationAction',
    UpsertEmployerOnboarding: 'UpsertEmployerOnboarding',
    AssignUserToPolicy: 'AssignUserToPolicy',
    AssignUsersToPolicies: 'AssignUsersToPolicies',
    ReaffirmEmployeeDocument: 'ReaffirmEmployeeDocument',
    ArchivePolicy: 'ArchivePolicy',
    ReaffirmDocument: 'ReaffirmDocument',
    AssignUserToPolicies: 'AssignUserToPolicies',
    UpgradeCorePlan: 'UpgradeCorePlan',
    TrackProductInterest: 'TrackProductInterest',
    CreateReportCard: 'CreateReportCard',
    UpdateReportCard: 'UpdateReportCard',
    CompleteReportCard: 'CompleteReportCard',
    CompleteSolution: 'CompleteSolution',
    AssignWorkerRoles: 'AssignWorkerRoles',
    CreateHrRequest: 'CreateHrRequest',
    ReplyToConversation: 'ReplyToConversation',
    CancelScheduledEvent: 'CancelScheduledEvent',
    UploadFilesToConversation: 'UploadFilesToConversation',
    StartTask: 'StartTask',
    CompleteTask: 'CompleteTask',
    CompleteGoal: 'CompleteGoal',
    CloseHrRequest: 'CloseHrRequest',
    SetCaseStatus: 'SetCaseStatus',
    CreateTermination: 'CreateTermination',
    CreateResignation: 'CreateResignation',
    bulkPurchaseSeats: 'bulkPurchaseSeats',
    bulkEnrollUsers: 'bulkEnrollUsers',
    enrollUsers: 'enrollUsers',
    PurchaseSeatsForBundle: 'PurchaseSeatsForBundle',
    RemoveSeatsFromBundle: 'RemoveSeatsFromBundle',
    PurchaseSeats: 'PurchaseSeats',
    UnenrollUsers: 'UnenrollUsers',
    SelfUnenrollRetired: 'SelfUnenrollRetired',
    MakeTrainingRequest: 'MakeTrainingRequest',
    CancelTrainingRequest: 'CancelTrainingRequest',
    ApproveTrainingRequest: 'ApproveTrainingRequest',
    RejectTrainingRequest: 'RejectTrainingRequest',
    updateCoreUserState: 'updateCoreUserState',
    updateCoreUserProfile: 'updateCoreUserProfile',
    makeUserAdmin: 'makeUserAdmin',
    removeUserAdmin: 'removeUserAdmin'
  },
  Fragment: {
    AppliedPlansParts: 'AppliedPlansParts',
    CouponParts: 'CouponParts',
    SubscriptionParts: 'SubscriptionParts',
    BillingPlanParts: 'BillingPlanParts',
    CompanyDelinquencyParts: 'CompanyDelinquencyParts',
    PaymentSourceParts: 'PaymentSourceParts',
    BillingProductParts: 'BillingProductParts',
    ProductResultParts: 'ProductResultParts',
    PaymentSourcesParts: 'PaymentSourcesParts',
    VoicesFeedbackParts: 'VoicesFeedbackParts',
    TerminationParts: 'TerminationParts',
    TerminationDownloadParts: 'TerminationDownloadParts',
    ResignationParts: 'ResignationParts',
    ResignationDownloadParts: 'ResignationDownloadParts',
    JobDescriptionParts: 'JobDescriptionParts',
    EmployeeJobDescriptionParts: 'EmployeeJobDescriptionParts',
    CoreDocumentSignatureParts: 'CoreDocumentSignatureParts',
    CoreDocumentParts: 'CoreDocumentParts',
    CoreUserStatesParts: 'CoreUserStatesParts',
    CoreUserParts: 'CoreUserParts',
    CorePolicyParts: 'CorePolicyParts',
    ReportCardUserParts: 'ReportCardUserParts',
    ReportCardEmployeeGradeParts: 'ReportCardEmployeeGradeParts',
    ManagedReportParts: 'ManagedReportParts',
    ReportCardParts: 'ReportCardParts',
    NewReportCardParts: 'NewReportCardParts',
    EnrollmentResponseParts: 'EnrollmentResponseParts',
    BulkEnrollUsersResponseParts: 'BulkEnrollUsersResponseParts',
    UserCourseParts: 'UserCourseParts',
    TopicParts: 'TopicParts',
    FullCompanyParts: 'FullCompanyParts',
    ShortCompanyParts: 'ShortCompanyParts',
    CoreUserStateParts: 'CoreUserStateParts',
    CoreUserEmploymentParts: 'CoreUserEmploymentParts'
  }
}